/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Where the caller's own workspace stands against this calendar month's AI request limit.
 *
 * Read-only projection of ``AIRequestLimitVerdict``. Safe to expose because it only ever describes
 * the caller's own workspace — unlike the 429 body, which travels on an error path.
 */
export interface AIRateLimitStatus {
  readonly limit: number | null;
  readonly overLimit: boolean;
  /** @format date-time */
  readonly resetsAt: string;
  readonly used: number;
}

export interface AIRequestLimitReached {
  readonly code: string;
  readonly detail: string;
}

export interface AcceptInvitation {
  key: string;
  /**
   * * `en` - English
   * * `sk` - Slovak
   * * `de` - German
   * * `fr` - French
   * * `it` - Italian
   * * `cs` - Czech
   * * `es` - Spain
   */
  language?: LanguageEnum;
  marketingPurposes?: boolean;
}

export interface Address {
  city?: string | null;
  contacts?: AddressContact[];
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  readonly createdBy: UserGeneralInfo;
  readonly id: number;
  /** @maxLength 50 */
  name?: string;
  /** @maxLength 20 */
  postCode?: string;
  /** @maxLength 100 */
  street?: string;
  /** IANA time zone */
  readonly timezone: string;
  readonly workspace: WorkspaceGeneralInfo;
}

export interface AddressContact {
  addressId?: number;
  email?: (string | null)[];
  /**
   * Contact Person Name
   * @maxLength 50
   */
  name?: string;
  phone?: (string | null)[];
}

/** The same row under its own name, so the deactivation preview's paged schema does not clash. */
export interface AddressDeactivationImpact {
  readonly booking: BookingImpactNested;
  readonly id: number;
  readonly reasons: BookingImpactReasonEnum[];
}

export interface AddressList {
  city?: string | null;
  contacts?: AddressContact[];
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  readonly createdBy: UserGeneralInfo;
  readonly id: number;
  /** @maxLength 50 */
  name?: string;
  /** @maxLength 20 */
  postCode?: string;
  /** @maxLength 100 */
  street?: string;
  readonly timeSlotsEnabled: boolean;
  /** IANA time zone */
  readonly timezone: string;
  readonly workspace: WorkspaceGeneralInfo;
}

/** The response shape of every settings endpoint. Writes go through the write serializer. */
export interface AddressTimeSlotSettings {
  readonly autoApproveBookings: boolean;
  readonly defaultSlotDurationMinutes: number;
  readonly id: number;
  readonly isEnabled: boolean;
  readonly isSetUp: boolean;
  readonly slotDurationMode: SlotDurationModeEnum;
  readonly timeZone: string;
  readonly vehicleTypeConfigs: AddressVehicleTypeSlotConfig[];
}

export interface AddressTimeSlotSettingsWrite {
  /**
   * @min 5
   * @max 1440
   */
  defaultSlotDurationMinutes: number;
  /**
   * * `GLOBAL` - Global
   * * `PER_VEHICLE_TYPE` - Per vehicle type
   */
  slotDurationMode: SlotDurationModeEnum;
  vehicleTypeRules: AddressVehicleTypeRuleWrite[];
}

export interface AddressTimeline {
  readonly address: BookingAddressNested;
  readonly axis: TimelineInterval | null;
  readonly blocks: TimelineBlock[];
  /** @format date-time */
  readonly dayEndAt: string;
  /** @format date-time */
  readonly dayStartAt: string;
  readonly gates: TimelineGateRow[];
  readonly timezoneName: string;
}

export interface AddressVehicleTypeRuleWrite {
  isEnabled?: boolean;
  /**
   * @min 5
   * @max 1440
   */
  slotDurationMinutes?: number | null;
  vehicleTypeId: number;
}

/** One resolved row of the address card - every workspace type appears, configured or not. */
export interface AddressVehicleTypeSlotConfig {
  effectiveSlotDurationMinutes: number;
  id: number | null;
  isEnabled: boolean;
  slotDurationMinutes: number | null;
  vehicleType: VehicleTypeNested;
}

export type AddressesAvailableSlotsListError = Record<string, any>;

export interface AddressesAvailableSlotsListParams {
  addressPk: number;
  /** @format date */
  date: string;
  excludeBooking?: number | null;
  gate?: number | null;
  /** @default false */
  includeConflicts?: boolean;
  vehicleType?: number | null;
  waypoint?: number | null;
}

export interface AddressesDestroyParams {
  /** A unique integer value identifying this Address. */
  id: number;
}

export interface AddressesExceptionsCreateImpactParams {
  addressPk: number;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
}

export interface AddressesExceptionsCreateParams {
  addressPk: number;
}

export interface AddressesExceptionsDeleteImpactParams {
  addressPk: number;
  /** A unique integer value identifying this Operating Hours Exception. */
  id: number;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
}

export interface AddressesExceptionsDestroyParams {
  addressPk: number;
  /** A unique integer value identifying this Operating Hours Exception. */
  id: number;
}

export interface AddressesExceptionsListParams {
  addressPk: number;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
}

export interface AddressesExceptionsUpdateImpactParams {
  addressPk: number;
  /** A unique integer value identifying this Operating Hours Exception. */
  id: number;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
}

export interface AddressesExceptionsUpdateParams {
  addressPk: number;
  /** A unique integer value identifying this Operating Hours Exception. */
  id: number;
}

export interface AddressesGatesBulkImpactParams {
  addressPk: number;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
}

export interface AddressesGatesBulkUpdateParams {
  addressPk: number;
}

export interface AddressesGatesListParams {
  addressPk: number;
}

export enum AddressesListOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueName = "-name",
  CreatedAt = "created_at",
  Name = "name",
}

export interface AddressesListParams {
  city?: string;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country?: CountryEnum;
  name?: string;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `name` - Name
   * * `-name` - Name (descending)
   */
  order?: AddressesListOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  postCode?: string;
  /** A search term. */
  search?: string;
  street?: string;
  /** Time slots enabled */
  timeSlotsEnabled?: boolean;
}

export interface AddressesOperatingHoursBulkImpactParams {
  addressPk: number;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
}

export interface AddressesOperatingHoursBulkUpdateParams {
  addressPk: number;
}

export interface AddressesOperatingHoursListParams {
  addressPk: number;
}

export interface AddressesPartialUpdateParams {
  /** A unique integer value identifying this Address. */
  id: number;
}

export interface AddressesRetrieveParams {
  /** A unique integer value identifying this Address. */
  id: number;
}

export interface AddressesTimeSlotSettingsCreateParams {
  addressPk: number;
}

export interface AddressesTimeSlotSettingsDeactivationPreviewParams {
  addressPk: number;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
}

export interface AddressesTimeSlotSettingsImpactParams {
  addressPk: number;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
}

export interface AddressesTimeSlotSettingsListParams {
  addressPk: number;
}

export interface AddressesTimeSlotSettingsSetupCreateParams {
  addressPk: number;
}

export interface AddressesTimeSlotSettingsTurnOffParams {
  addressPk: number;
}

export interface AddressesTimeSlotSettingsTurnOnParams {
  addressPk: number;
}

export interface AddressesTimeSlotSettingsUpdateParams {
  addressPk: number;
}

export interface AddressesUpdateParams {
  /** A unique integer value identifying this Address. */
  id: number;
}

export type AiExtractRequestDataFromDocumentCreateError = AIRequestLimitReached;

export interface AirVehicleDetails {
  /** @maxLength 255 */
  airWaybillNumber?: string;
  /** @maxLength 255 */
  airline?: string;
  /** @maxLength 255 */
  flightNumber?: string;
  /** @maxLength 255 */
  fromPlace?: string;
  /** @format date-time */
  sta?: string | null;
  /** @format date-time */
  std?: string | null;
  /** @maxLength 255 */
  toPlace?: string;
  readonly transportationMode: TransportationModeEnum;
}

export interface AppInfo {
  readonly build: string;
  readonly commit: string;
  readonly deployment: string;
  readonly release: string;
  readonly time: number;
}

/** Serializer for Auction model. It's used for listing auctions for user and carrier. */
export interface Auction {
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly autoSelectLimit: string | null;
  readonly autoSelectLimitCurrency: CurrencyEnum | null;
  /** @format date-time */
  readonly biddingFinishedAt: string | null;
  readonly bidsInfo: AuctionBidsInfo;
  /** @format date-time */
  readonly canceledAt: string | null;
  /** @format date-time */
  readonly createdAt: string;
  readonly currency: CurrencyEnum;
  /** @format date-time */
  readonly deletedAt: string | null;
  readonly duration: string | null;
  /** @format date-time */
  readonly finishingAt: string;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  readonly invitedContactsIds: number[];
  readonly isAutoSelect: boolean;
  readonly isBiddingAllowed: boolean;
  /** Demo data */
  readonly isDemo: boolean;
  readonly mergedFromIds: number[];
  readonly mergedIntoIds: number[];
  readonly mergedIntoInfo: MergedAuction[];
  readonly note: string;
  /** @format date-time */
  readonly publishedAt: string | null;
  /** @format date-time */
  readonly restoredAt: string | null;
  readonly savingAvg: Saving;
  readonly savingSecondCheapest: Saving;
  readonly status: AuctionStatusEnum;
  /** @format int32 */
  readonly transportId: number;
  readonly transportRequest: TransportRequestWithAddressState;
  readonly transportType: TransportTypeEnum | null;
  /** @format date-time */
  readonly updatedAt: string;
  readonly workspace: WorkspaceGeneralInfo;
}

export interface AuctionBid {
  readonly carrier: AuctionBidCarrier;
  readonly carrierNote: string;
  readonly id: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly offeredPrice: string;
  readonly offeredPriceCurrency: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly priceWorkspace: string;
  readonly priceWorkspaceCurrency: string;
}

export interface AuctionBidCarrier {
  readonly name: string;
}

export enum AuctionBidsHistoryListOrderEnum {
  ValueCreatedAt = "-created_at",
  ValuePrice = "-price",
  CreatedAt = "created_at",
  Price = "price",
}

export interface AuctionBidsHistoryListParams {
  auctionPk: number;
  /** Carrier */
  carrierId?: number;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `price` - Price
   * * `-price` - Price (descending)
   */
  order?: AuctionBidsHistoryListOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface AuctionBidsInfo {
  readonly confirmed: AuctionBid;
  readonly latest: AuctionBid;
  readonly lowest: AuctionBid;
  readonly placedCount: number;
  readonly rejectedByCarrier: AuctionBid;
  readonly winning: AuctionBid;
}

export interface AuctionByEmail {
  readonly bidsInfo: BidsInfoByHash;
  readonly billingDetailsCandidate: CarrierByHashBillingDetails;
  readonly carrier: AuctionParticipantByEmail;
  readonly contactHash: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly duration: string;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  readonly isBiddingAllowed: boolean;
  /** @format date-time */
  readonly publishedAt: string;
  readonly status: AuctionStatusEnum;
  readonly transport: TransportByHashList | null;
  readonly transportRequest: TransportRequestByEmail;
  readonly workspace: WorkspaceGeneralInfo;
}

export interface AuctionByHash {
  readonly bidsInfo: BidsInfoByHash;
  readonly carrier: AuctionParticipantByHash;
  readonly currency: CurrencyEnum;
  readonly differences: Record<string, any> | null;
  readonly duration: string | null;
  readonly feeConfig: FeeConfig;
  /** @format date-time */
  readonly finishingAt: string;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  readonly isBiddingAllowed: boolean;
  /** @format date-time */
  readonly publishedAt: string | null;
  /** @format double */
  readonly serviceFee: number;
  readonly status: AuctionStatusEnum;
  readonly transport: TransportByHash | null;
  readonly transportRequest: TransportRequestByHash;
  readonly workspace: WorkspaceByHash;
}

export interface AuctionChangePaymentMethod {
  /**
   * * `INVOICE` - Invoice
   * * `CREDIT_CARD` - Credit card
   */
  paymentMethod: PaymentMethodEnum;
}

export enum AuctionFilterStatusEnum {
  DRAFT = "DRAFT",
  MERGED = "MERGED",
  ACTIVE = "ACTIVE",
  INSTANT_ORDER = "INSTANT_ORDER",
  BIDDING_FINISHED = "BIDDING_FINISHED",
  WAITING_FOR_CARRIER = "WAITING_FOR_CARRIER",
  REJECTED = "REJECTED",
  CONFIRMED = "CONFIRMED",
  CANCELED = "CANCELED",
  OTHER = "OTHER",
}

export interface AuctionList {
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly autoSelectLimit: string;
  readonly autoSelectLimitCurrency: string;
  readonly bidsInfo: AuctionListBidsInfo;
  /** @format date-time */
  readonly createdAt: string;
  readonly duration: string;
  readonly hash: string;
  readonly id: number;
  readonly invitedParticipantsCount: number;
  readonly isAutoSelect: boolean;
  readonly mergedFromIds: number[];
  readonly mergedIntoIds: number[];
  /** @format date-time */
  readonly publishedAt: string;
  readonly savingAvg: Saving;
  readonly savingSecondCheapest: Saving;
  readonly status: AuctionStatusEnum;
  /** @format int32 */
  readonly transportId: number;
  readonly transportRequest: TransportRequestList;
  readonly transportType: TransportTypeEnum | null;
}

export interface AuctionListBid {
  readonly carrier: AuctionListBidCarrier;
  readonly id: number;
  readonly isInstantOrder: boolean;
  readonly isRejected: boolean;
  readonly metadata: BidMetadata;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly offeredPrice: string;
  readonly offeredPriceCurrency: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly priceWorkspace: string;
  readonly priceWorkspaceCurrency: string;
}

export interface AuctionListBidCarrier {
  readonly name: string;
}

export interface AuctionListBidsInfo {
  readonly confirmed: AuctionListBid;
  readonly latest: AuctionListBid;
  readonly lowest: AuctionListBid;
  readonly placedCount: number;
  readonly rejectedByCarrier: AuctionListBid;
  readonly winning: AuctionListBid;
}

export interface AuctionOverviewStats {
  /** @format double */
  averageCarriersCount: number;
  /** @format double */
  averageParticipationRate: number;
  /** @format double */
  averageSavings: number;
  /** @format double */
  averageSavingsPercent: number;
  avgComparisonByInterval: TotalByIntervalStats[];
  countByInterval: CountByIntervalStats[];
  /**
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency: CurrencyEnum;
  secondBestComparisonByInterval: TotalByIntervalStats[];
  /** @format double */
  secondCheapestSavings: number;
  /** @format double */
  secondCheapestSavingsPercent: number;
  /** @format double */
  successRate: number;
  winningBidByInterval: TotalByIntervalStats[];
}

export interface AuctionParticipant {
  readonly carrier: AuctionParticipantCarrier;
  readonly contacts: AuctionParticipantContact[];
  readonly id: number;
  readonly messagesCount: number;
  readonly status: AuctionParticipantStatusEnum;
  /** @format date-time */
  readonly statusChangedAt: string;
}

export interface AuctionParticipantByEmail {
  readonly id: number;
  readonly status: AuctionParticipantStatusEnum;
}

export interface AuctionParticipantByHash {
  readonly carrier: AuctionParticipantCarrierByHash;
  readonly id: number;
  readonly otherEmails: string[];
  readonly status: AuctionParticipantStatusEnum;
}

export interface AuctionParticipantCarrier {
  readonly id: number;
  /**
   * Active
   * Designates whether this carrier should be treated as active. Unselect this instead of deleting carriers.
   */
  readonly isActive: boolean;
  /**
   * Blocked
   * Blocked by support because of unpaid invoices, manually or via a blocked VAT ID record.
   */
  readonly isBlocked: boolean;
  readonly isDeleted: boolean;
  /**
   * Title
   * @maxLength 100
   */
  readonly name: string;
}

export interface AuctionParticipantCarrierByHash {
  readonly contact: ContactGeneralInfo;
  readonly id: number;
  /**
   * Active
   * Designates whether this carrier should be treated as active. Unselect this instead of deleting carriers.
   */
  readonly isActive: boolean;
  /**
   * Title
   * @maxLength 100
   */
  readonly name: string;
}

export interface AuctionParticipantContact {
  readonly consentStatuses: ConsentInfo[];
  /**
   * Contact email
   * @format email
   * @maxLength 254
   */
  email: string;
  readonly emailInfo: EmailInfo;
  readonly id: number;
}

export interface AuctionParticipantResendInvitation {
  emails: string[];
}

/**
 * * `ACTIVE` - Active
 * * `REMOVED` - Removed
 * * `REJECTED` - Rejected
 */
export enum AuctionParticipantStatusEnum {
  ACTIVE = "ACTIVE",
  REMOVED = "REMOVED",
  REJECTED = "REJECTED",
}

export interface AuctionSetParticipantStatus {
  status: AuctionParticipantStatusEnum;
}

export enum AuctionStatsOverviewRetrieveOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  ValueSavingAvg = "-saving_avg",
  ValueSavingSecondCheapest = "-saving_second_cheapest",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
  SavingAvg = "saving_avg",
  SavingSecondCheapest = "saving_second_cheapest",
}

export interface AuctionStatsOverviewRetrieveParams {
  maxVolumeM3?: number;
  minVolumeM3?: number;
  /** Auction ID */
  auctionId?: number;
  /**
   * Auction status
   *
   * * `DRAFT` - Draft
   * * `MERGED` - Merged
   * * `ACTIVE` - Active auction
   * * `INSTANT_ORDER` - Instant order
   * * `BIDDING_FINISHED` - Finished auction
   * * `WAITING_FOR_CARRIER` - Waiting for carrier
   * * `REJECTED` - Rejected
   * * `CONFIRMED` - Confirmed
   * * `CANCELED` - Canceled
   * * `OTHER` - Other
   */
  auctionStatus?: AuctionFilterStatusEnum;
  /** Carrier id */
  carrierId?: number;
  /** Winning carrier */
  carrierName?: string;
  costCenter?: string;
  /** @format date-time */
  createdAtAfter?: string;
  /** @format date-time */
  createdAtBefore?: string;
  createdBy?: number;
  /**
   * Currency
   *
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  deliveryCity?: string;
  deliveryCountry?: string;
  /** @format date-time */
  deliveryDateAfter?: string;
  /** @format date-time */
  deliveryDateBefore?: string;
  deliveryName?: string;
  deliveryPostCode?: string;
  deliveryReference?: string;
  deliveryStreet?: string;
  /**
   * Incoterms
   *
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  interval?: IntervalEnum;
  /**
   * Load type
   *
   * * `FTL` - Full Truck Load
   * * `LTL` - Less than Truck Load
   * * `FCL` - Full Container Load
   * * `LCL` - Less than Container Load
   * * `PARCEL` - Parcel
   * * `NOT_SPECIFIED` - Not specified
   */
  loadType?: CargoLoadTypeEnum[];
  maxWeightKg?: number;
  minWeightKg?: number;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   * * `saving_avg` - Saving avg
   * * `-saving_avg` - Saving avg (descending)
   * * `saving_second_cheapest` - Saving second cheapest
   * * `-saving_second_cheapest` - Saving second cheapest (descending)
   */
  order?: AuctionStatsOverviewRetrieveOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  pickupCity?: string;
  pickupCountry?: string;
  /** @format date-time */
  pickupDateAfter?: string;
  /** @format date-time */
  pickupDateBefore?: string;
  pickupName?: string;
  pickupPostCode?: string;
  pickupReference?: string;
  pickupStreet?: string;
  /** @format date-time */
  publishedAtAfter?: string;
  /** @format date-time */
  publishedAtBefore?: string;
  reference?: string;
  /**
   * Request type
   *
   * * `REFRIGERATED_GOODS` - Refrigerated goods
   * * `FROZEN_GOODS` - Frozen goods
   * * `METAL_GOODS` - Metal goods
   * * `OVERSIZED_LOAD` - Oversized load
   * * `BULK_MATERIAL` - Bulk material
   * * `LOOSE_MATERIAL` - Loose material
   * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
   * * `LIQUIDS` - Liquids
   * * `VEHICLES` - Vehicles
   * * `ADR` - ADR
   * * `OTHER` - Other
   * * `NOT_SPECIFIED` - Not specified
   */
  requestType?: CargoTypeEnum;
  responsibleUser?: number;
  /**
   * Route type
   *
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
  /** A search term. */
  search?: string;
  /** Multiple values may be separated by commas. */
  tag?: string[];
  /**
   * Transport type
   *
   * * `SPOT` - Spot transport
   * * `CONTRACTED` - Contracted transport
   */
  transportType?: TransportTypeEnum;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
}

/**
 * * `DRAFT` - Draft
 * * `MERGED` - Merged
 * * `ACTIVE` - Active
 * * `INSTANT_ORDER` - Instant order
 * * `BIDDING_FINISHED` - Bidding finished
 * * `CONFIRMED` - Confirmed
 * * `CANCELED` - Canceled
 * * `OTHER` - Other
 */
export enum AuctionStatusEnum {
  DRAFT = "DRAFT",
  MERGED = "MERGED",
  ACTIVE = "ACTIVE",
  INSTANT_ORDER = "INSTANT_ORDER",
  BIDDING_FINISHED = "BIDDING_FINISHED",
  CONFIRMED = "CONFIRMED",
  CANCELED = "CANCELED",
  OTHER = "OTHER",
}

export interface AuctionTakeInstantOrder {
  /**
   * * `INVOICE` - Invoice
   * * `CREDIT_CARD` - Credit card
   */
  paymentMethod: PaymentMethodEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  price: string;
}

export interface AuctionUnlinkMerged {
  auctions: number[];
}

export interface AuctionUpdate {
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  autoSelectLimit?: string;
  duration?: string;
  invitedContacts?: number[];
  isAutoSelect?: boolean;
}

export interface AuctionsBidsExcludeFromStatsCreateParams {
  auctionPk: number;
  /** A unique integer value identifying this bid. */
  id: number;
}

export interface AuctionsBidsHistoryBiddersListParams {
  auctionPk: number;
}

export interface AuctionsBidsIncludeInStatsCreateParams {
  auctionPk: number;
  /** A unique integer value identifying this bid. */
  id: number;
}

export enum AuctionsBidsListOrderEnum {
  ValueCreatedAt = "-created_at",
  ValuePrice = "-price",
  CreatedAt = "created_at",
  Price = "price",
}

export interface AuctionsBidsListParams {
  auctionPk: number;
  /** Carrier */
  carrierId?: number;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `price` - Price
   * * `-price` - Price (descending)
   */
  order?: AuctionsBidsListOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
}

export interface AuctionsBidsPartialUpdateParams {
  auctionPk: number;
  /** A unique integer value identifying this bid. */
  id: number;
}

export interface AuctionsBidsRetrieveParams {
  auctionPk: number;
  /** A unique integer value identifying this bid. */
  id: number;
}

export interface AuctionsBidsUpdateParams {
  auctionPk: number;
  /** A unique integer value identifying this bid. */
  id: number;
}

export interface AuctionsCancelCreateParams {
  /** A unique integer value identifying this auction. */
  id: number;
}

export interface AuctionsChangePaymentMethodCreateParams {
  /** A unique integer value identifying this auction. */
  id: number;
}

export interface AuctionsContractOptionRetrieveParams {
  /** A unique integer value identifying this auction. */
  id: number;
}

export interface AuctionsDestroyParams {
  /** A unique integer value identifying this auction. */
  id: number;
  includeMerged?: boolean;
}

export interface AuctionsDocumentsListParams {
  auctionPk: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export enum AuctionsExportRetrieveOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  ValueSavingAvg = "-saving_avg",
  ValueSavingSecondCheapest = "-saving_second_cheapest",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
  SavingAvg = "saving_avg",
  SavingSecondCheapest = "saving_second_cheapest",
}

export interface AuctionsExportRetrieveParams {
  maxVolumeM3?: number;
  minVolumeM3?: number;
  /** Auction ID */
  auctionId?: number;
  /**
   * Auction status
   *
   * * `DRAFT` - Draft
   * * `MERGED` - Merged
   * * `ACTIVE` - Active auction
   * * `INSTANT_ORDER` - Instant order
   * * `BIDDING_FINISHED` - Finished auction
   * * `WAITING_FOR_CARRIER` - Waiting for carrier
   * * `REJECTED` - Rejected
   * * `CONFIRMED` - Confirmed
   * * `CANCELED` - Canceled
   * * `OTHER` - Other
   */
  auctionStatus?: AuctionFilterStatusEnum;
  /** Carrier id */
  carrierId?: number;
  /** Winning carrier */
  carrierName?: string;
  costCenter?: string;
  /** @format date-time */
  createdAtAfter?: string;
  /** @format date-time */
  createdAtBefore?: string;
  createdBy?: number;
  /**
   * Currency
   *
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  deliveryCity?: string;
  deliveryCountry?: string;
  /** @format date-time */
  deliveryDateAfter?: string;
  /** @format date-time */
  deliveryDateBefore?: string;
  deliveryName?: string;
  deliveryPostCode?: string;
  deliveryReference?: string;
  deliveryStreet?: string;
  /**
   * Incoterms
   *
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  /**
   * Load type
   *
   * * `FTL` - Full Truck Load
   * * `LTL` - Less than Truck Load
   * * `FCL` - Full Container Load
   * * `LCL` - Less than Container Load
   * * `PARCEL` - Parcel
   * * `NOT_SPECIFIED` - Not specified
   */
  loadType?: CargoLoadTypeEnum[];
  maxWeightKg?: number;
  minWeightKg?: number;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   * * `saving_avg` - Saving avg
   * * `-saving_avg` - Saving avg (descending)
   * * `saving_second_cheapest` - Saving second cheapest
   * * `-saving_second_cheapest` - Saving second cheapest (descending)
   */
  order?: AuctionsExportRetrieveOrderEnum[];
  pickupCity?: string;
  pickupCountry?: string;
  /** @format date-time */
  pickupDateAfter?: string;
  /** @format date-time */
  pickupDateBefore?: string;
  pickupName?: string;
  pickupPostCode?: string;
  pickupReference?: string;
  pickupStreet?: string;
  /** @format date-time */
  publishedAtAfter?: string;
  /** @format date-time */
  publishedAtBefore?: string;
  reference?: string;
  /**
   * Request type
   *
   * * `REFRIGERATED_GOODS` - Refrigerated goods
   * * `FROZEN_GOODS` - Frozen goods
   * * `METAL_GOODS` - Metal goods
   * * `OVERSIZED_LOAD` - Oversized load
   * * `BULK_MATERIAL` - Bulk material
   * * `LOOSE_MATERIAL` - Loose material
   * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
   * * `LIQUIDS` - Liquids
   * * `VEHICLES` - Vehicles
   * * `ADR` - ADR
   * * `OTHER` - Other
   * * `NOT_SPECIFIED` - Not specified
   */
  requestType?: CargoTypeEnum;
  responsibleUser?: number;
  /**
   * Route type
   *
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
  /** A search term. */
  search?: string;
  /** Multiple values may be separated by commas. */
  tag?: string[];
  /**
   * Transport type
   *
   * * `SPOT` - Spot transport
   * * `CONTRACTED` - Contracted transport
   */
  transportType?: TransportTypeEnum;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
}

export enum AuctionsListOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  ValueSavingAvg = "-saving_avg",
  ValueSavingSecondCheapest = "-saving_second_cheapest",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
  SavingAvg = "saving_avg",
  SavingSecondCheapest = "saving_second_cheapest",
}

export interface AuctionsListParams {
  maxVolumeM3?: number;
  minVolumeM3?: number;
  /** Auction ID */
  auctionId?: number;
  /**
   * Auction status
   *
   * * `DRAFT` - Draft
   * * `MERGED` - Merged
   * * `ACTIVE` - Active auction
   * * `INSTANT_ORDER` - Instant order
   * * `BIDDING_FINISHED` - Finished auction
   * * `WAITING_FOR_CARRIER` - Waiting for carrier
   * * `REJECTED` - Rejected
   * * `CONFIRMED` - Confirmed
   * * `CANCELED` - Canceled
   * * `OTHER` - Other
   */
  auctionStatus?: AuctionFilterStatusEnum;
  /** Carrier id */
  carrierId?: number;
  /** Winning carrier */
  carrierName?: string;
  costCenter?: string;
  /** @format date-time */
  createdAtAfter?: string;
  /** @format date-time */
  createdAtBefore?: string;
  createdBy?: number;
  /**
   * Currency
   *
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  deliveryCity?: string;
  deliveryCountry?: string;
  /** @format date-time */
  deliveryDateAfter?: string;
  /** @format date-time */
  deliveryDateBefore?: string;
  deliveryName?: string;
  deliveryPostCode?: string;
  deliveryReference?: string;
  deliveryStreet?: string;
  /**
   * Incoterms
   *
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  /**
   * Load type
   *
   * * `FTL` - Full Truck Load
   * * `LTL` - Less than Truck Load
   * * `FCL` - Full Container Load
   * * `LCL` - Less than Container Load
   * * `PARCEL` - Parcel
   * * `NOT_SPECIFIED` - Not specified
   */
  loadType?: CargoLoadTypeEnum[];
  maxWeightKg?: number;
  minWeightKg?: number;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   * * `saving_avg` - Saving avg
   * * `-saving_avg` - Saving avg (descending)
   * * `saving_second_cheapest` - Saving second cheapest
   * * `-saving_second_cheapest` - Saving second cheapest (descending)
   */
  order?: AuctionsListOrderEnum[];
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  pickupCity?: string;
  pickupCountry?: string;
  /** @format date-time */
  pickupDateAfter?: string;
  /** @format date-time */
  pickupDateBefore?: string;
  pickupName?: string;
  pickupPostCode?: string;
  pickupReference?: string;
  pickupStreet?: string;
  /** @format date-time */
  publishedAtAfter?: string;
  /** @format date-time */
  publishedAtBefore?: string;
  reference?: string;
  /**
   * Request type
   *
   * * `REFRIGERATED_GOODS` - Refrigerated goods
   * * `FROZEN_GOODS` - Frozen goods
   * * `METAL_GOODS` - Metal goods
   * * `OVERSIZED_LOAD` - Oversized load
   * * `BULK_MATERIAL` - Bulk material
   * * `LOOSE_MATERIAL` - Loose material
   * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
   * * `LIQUIDS` - Liquids
   * * `VEHICLES` - Vehicles
   * * `ADR` - ADR
   * * `OTHER` - Other
   * * `NOT_SPECIFIED` - Not specified
   */
  requestType?: CargoTypeEnum;
  responsibleUser?: number;
  /**
   * Route type
   *
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
  /** A search term. */
  search?: string;
  /** Multiple values may be separated by commas. */
  tag?: string[];
  /**
   * Transport type
   *
   * * `SPOT` - Spot transport
   * * `CONTRACTED` - Contracted transport
   */
  transportType?: TransportTypeEnum;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
}

export enum AuctionsListToMergeListOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  ValueSavingAvg = "-saving_avg",
  ValueSavingSecondCheapest = "-saving_second_cheapest",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
  SavingAvg = "saving_avg",
  SavingSecondCheapest = "saving_second_cheapest",
}

export interface AuctionsListToMergeListParams {
  maxVolumeM3?: number;
  minVolumeM3?: number;
  /** Auction ID */
  auctionId?: number;
  /**
   * Auction status
   *
   * * `DRAFT` - Draft
   * * `MERGED` - Merged
   * * `ACTIVE` - Active auction
   * * `INSTANT_ORDER` - Instant order
   * * `BIDDING_FINISHED` - Finished auction
   * * `WAITING_FOR_CARRIER` - Waiting for carrier
   * * `REJECTED` - Rejected
   * * `CONFIRMED` - Confirmed
   * * `CANCELED` - Canceled
   * * `OTHER` - Other
   */
  auctionStatus?: AuctionFilterStatusEnum;
  /** Carrier id */
  carrierId?: number;
  /** Winning carrier */
  carrierName?: string;
  costCenter?: string;
  /** @format date-time */
  createdAtAfter?: string;
  /** @format date-time */
  createdAtBefore?: string;
  createdBy?: number;
  /**
   * Currency
   *
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  deliveryCity?: string;
  deliveryCountry?: string;
  /** @format date-time */
  deliveryDateAfter?: string;
  /** @format date-time */
  deliveryDateBefore?: string;
  deliveryName?: string;
  deliveryPostCode?: string;
  deliveryReference?: string;
  deliveryStreet?: string;
  ids?: string[];
  /**
   * Incoterms
   *
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  /**
   * Load type
   *
   * * `FTL` - Full Truck Load
   * * `LTL` - Less than Truck Load
   * * `FCL` - Full Container Load
   * * `LCL` - Less than Container Load
   * * `PARCEL` - Parcel
   * * `NOT_SPECIFIED` - Not specified
   */
  loadType?: CargoLoadTypeEnum[];
  maxWeightKg?: number;
  minWeightKg?: number;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   * * `saving_avg` - Saving avg
   * * `-saving_avg` - Saving avg (descending)
   * * `saving_second_cheapest` - Saving second cheapest
   * * `-saving_second_cheapest` - Saving second cheapest (descending)
   */
  order?: AuctionsListToMergeListOrderEnum[];
  pickupCity?: string;
  pickupCountry?: string;
  /** @format date-time */
  pickupDateAfter?: string;
  /** @format date-time */
  pickupDateBefore?: string;
  pickupName?: string;
  pickupPostCode?: string;
  pickupReference?: string;
  pickupStreet?: string;
  /** @format date-time */
  publishedAtAfter?: string;
  /** @format date-time */
  publishedAtBefore?: string;
  reference?: string;
  /**
   * Request type
   *
   * * `REFRIGERATED_GOODS` - Refrigerated goods
   * * `FROZEN_GOODS` - Frozen goods
   * * `METAL_GOODS` - Metal goods
   * * `OVERSIZED_LOAD` - Oversized load
   * * `BULK_MATERIAL` - Bulk material
   * * `LOOSE_MATERIAL` - Loose material
   * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
   * * `LIQUIDS` - Liquids
   * * `VEHICLES` - Vehicles
   * * `ADR` - ADR
   * * `OTHER` - Other
   * * `NOT_SPECIFIED` - Not specified
   */
  requestType?: CargoTypeEnum;
  responsibleUser?: number;
  /**
   * Route type
   *
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
  /** A search term. */
  search?: string;
  /** Multiple values may be separated by commas. */
  tag?: string[];
  /**
   * Transport type
   *
   * * `SPOT` - Spot transport
   * * `CONTRACTED` - Contracted transport
   */
  transportType?: TransportTypeEnum;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
}

export enum AuctionsMergedListOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  ValueSavingAvg = "-saving_avg",
  ValueSavingSecondCheapest = "-saving_second_cheapest",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
  SavingAvg = "saving_avg",
  SavingSecondCheapest = "saving_second_cheapest",
}

export interface AuctionsMergedListParams {
  maxVolumeM3?: number;
  minVolumeM3?: number;
  /** Auction ID */
  auctionId?: number;
  /**
   * Auction status
   *
   * * `DRAFT` - Draft
   * * `MERGED` - Merged
   * * `ACTIVE` - Active auction
   * * `INSTANT_ORDER` - Instant order
   * * `BIDDING_FINISHED` - Finished auction
   * * `WAITING_FOR_CARRIER` - Waiting for carrier
   * * `REJECTED` - Rejected
   * * `CONFIRMED` - Confirmed
   * * `CANCELED` - Canceled
   * * `OTHER` - Other
   */
  auctionStatus?: AuctionFilterStatusEnum;
  /** Carrier id */
  carrierId?: number;
  /** Winning carrier */
  carrierName?: string;
  costCenter?: string;
  /** @format date-time */
  createdAtAfter?: string;
  /** @format date-time */
  createdAtBefore?: string;
  createdBy?: number;
  /**
   * Currency
   *
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  deliveryCity?: string;
  deliveryCountry?: string;
  /** @format date-time */
  deliveryDateAfter?: string;
  /** @format date-time */
  deliveryDateBefore?: string;
  deliveryName?: string;
  deliveryPostCode?: string;
  deliveryReference?: string;
  deliveryStreet?: string;
  /** A unique integer value identifying this auction. */
  id: number;
  /**
   * Incoterms
   *
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  /**
   * Load type
   *
   * * `FTL` - Full Truck Load
   * * `LTL` - Less than Truck Load
   * * `FCL` - Full Container Load
   * * `LCL` - Less than Container Load
   * * `PARCEL` - Parcel
   * * `NOT_SPECIFIED` - Not specified
   */
  loadType?: CargoLoadTypeEnum[];
  maxWeightKg?: number;
  minWeightKg?: number;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   * * `saving_avg` - Saving avg
   * * `-saving_avg` - Saving avg (descending)
   * * `saving_second_cheapest` - Saving second cheapest
   * * `-saving_second_cheapest` - Saving second cheapest (descending)
   */
  order?: AuctionsMergedListOrderEnum[];
  pickupCity?: string;
  pickupCountry?: string;
  /** @format date-time */
  pickupDateAfter?: string;
  /** @format date-time */
  pickupDateBefore?: string;
  pickupName?: string;
  pickupPostCode?: string;
  pickupReference?: string;
  pickupStreet?: string;
  /** @format date-time */
  publishedAtAfter?: string;
  /** @format date-time */
  publishedAtBefore?: string;
  reference?: string;
  /**
   * Request type
   *
   * * `REFRIGERATED_GOODS` - Refrigerated goods
   * * `FROZEN_GOODS` - Frozen goods
   * * `METAL_GOODS` - Metal goods
   * * `OVERSIZED_LOAD` - Oversized load
   * * `BULK_MATERIAL` - Bulk material
   * * `LOOSE_MATERIAL` - Loose material
   * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
   * * `LIQUIDS` - Liquids
   * * `VEHICLES` - Vehicles
   * * `ADR` - ADR
   * * `OTHER` - Other
   * * `NOT_SPECIFIED` - Not specified
   */
  requestType?: CargoTypeEnum;
  responsibleUser?: number;
  /**
   * Route type
   *
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
  /** A search term. */
  search?: string;
  /** Multiple values may be separated by commas. */
  tag?: string[];
  /**
   * Transport type
   *
   * * `SPOT` - Spot transport
   * * `CONTRACTED` - Contracted transport
   */
  transportType?: TransportTypeEnum;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
}

export interface AuctionsMessagesCreateParams {
  auctionPk: number;
}

export interface AuctionsMessagesListParams {
  auctionPk: number;
  carrier?: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface AuctionsMessagesMarkAsReadCreateParams {
  auctionPk: number;
}

export interface AuctionsPartialUpdateParams {
  /** A unique integer value identifying this auction. */
  id: number;
}

export interface AuctionsParticipantsListParams {
  auctionPk: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
}

export interface AuctionsParticipantsResendInvitationCreateParams {
  auctionPk: number;
  /** A unique integer value identifying this auction participant. */
  id: number;
}

export interface AuctionsParticipantsRetrieveParams {
  auctionPk: number;
  /** A unique integer value identifying this auction participant. */
  id: number;
}

export interface AuctionsParticipantsStatusCreateParams {
  auctionPk: number;
  /** A unique integer value identifying this auction participant. */
  id: number;
}

export interface AuctionsPublishCreateParams {
  /** A unique integer value identifying this auction. */
  id: number;
}

export interface AuctionsRetrieveParams {
  /** A unique integer value identifying this auction. */
  id: number;
}

export interface AuctionsTakeInstantOrderCreateParams {
  /** A unique integer value identifying this auction. */
  id: number;
}

export interface AuctionsUnlinkMergedCreateParams {
  /** A unique integer value identifying this auction. */
  id: number;
}

export interface AuctionsUpdateParams {
  /** A unique integer value identifying this auction. */
  id: number;
}

export interface AutocompleteRequest {
  field: string;
  term: string;
}

export interface AutocompleteResponse {
  readonly values: string[];
}

/** ``many=False`` because drf-spectacular array-wraps a ``list`` action's response otherwise. */
export interface AvailableSlots {
  /** @format date */
  readonly date: string;
  readonly options: SlotOption[];
  readonly slotDurationMinutes: number;
  readonly timezoneName: string;
  readonly timezoneResolved: boolean;
}

/**
 * Base serializer for Bid model. Should not expose any sensitive data.
 * Could be used for minimum information about bid.
 */
export interface Bid {
  readonly carrier: number;
  readonly carrierNote: string;
  readonly carrierStatus: BidStatusEnum;
  /** @format date-time */
  readonly carrierStatusChangedAt: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly id: number;
  readonly isAutoSelect: boolean;
  readonly isConfirmedByShipper: boolean;
  isInstantOrder?: boolean;
  readonly isManuallyExcluded: boolean;
  readonly isRejected: boolean;
  readonly isWinning: boolean;
  metadata?: BidMetadata | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  offeredPrice?: string;
  readonly offeredPriceCurrency: CurrencyEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  priceWorkspace?: string;
  readonly priceWorkspaceCurrency: CurrencyEnum;
  shipperNote?: string;
  /**
   * * `CONFIRMED` - Confirmed
   * * `REJECTED` - Rejected
   * * `NOT_DECIDED` - Not decided
   */
  shipperStatus?: BidStatusEnum;
  /** @format date-time */
  readonly shipperStatusChangedAt: string;
}

/**
 * Base serializer for Bid model. Should not expose any sensitive data.
 * Could be used for minimum information about bid.
 */
export interface BidByHash {
  readonly carrier: number;
  carrierNote?: string;
  /**
   * * `CONFIRMED` - Confirmed
   * * `REJECTED` - Rejected
   * * `NOT_DECIDED` - Not decided
   */
  carrierStatus?: BidStatusEnum;
  readonly comparison: BidComparisonEnum;
  /** @format date-time */
  readonly createdAt: string;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  readonly isConfirmedByShipper: boolean;
  readonly isRejected: boolean;
  readonly isWinning: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  offeredPrice: string;
  readonly offeredPriceCurrency: CurrencyEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  priceWorkspace?: string;
  readonly priceWorkspaceCurrency: CurrencyEnum;
  readonly shipperNote: string;
  readonly shipperStatus: BidStatusEnum;
}

/**
 * * `EXCELLENT` - Excellent price
 * * `GOOD` - Good price
 * * `AVERAGE` - Average price
 * * `BAD` - A bit overpriced
 * * `VERY_BAD` - Too expensive
 */
export enum BidComparisonEnum {
  EXCELLENT = "EXCELLENT",
  GOOD = "GOOD",
  AVERAGE = "AVERAGE",
  BAD = "BAD",
  VERY_BAD = "VERY_BAD",
}

/** Read-only row for the shipper's bidding history. */
export interface BidHistory {
  readonly carrier: BidHistoryCarrier;
  /** @format date-time */
  readonly createdAt: string;
  readonly id: number;
  readonly isManuallyExcluded: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly offeredPrice: string;
  readonly offeredPriceCurrency: CurrencyEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly priceWorkspace: string;
  readonly priceWorkspaceCurrency: CurrencyEnum;
  readonly state: StateEnum;
}

/** Minimal carrier option for the bidding-history carrier filter (distinct carriers that bid). */
export interface BidHistoryBidder {
  readonly id: number;
  /**
   * Title
   * @maxLength 100
   */
  name: string;
}

/**
 * Carrier representation for bidding-history rows, including the carrier's participation status in this auction
 * so the frontend can label removed carriers/bids without loading the participants separately.
 */
export interface BidHistoryCarrier {
  readonly id: number;
  /**
   * Title
   * @maxLength 100
   */
  name: string;
  readonly participantStatus: AuctionParticipantStatusEnum | null;
}

export interface BidMetadata {
  /** @format date-time */
  readonly paidAt: string;
  readonly shipperPaymentMethod: PaymentMethodEnum;
}

/**
 * * `CONFIRMED` - Confirmed
 * * `REJECTED` - Rejected
 * * `NOT_DECIDED` - Not decided
 */
export enum BidStatusEnum {
  CONFIRMED = "CONFIRMED",
  REJECTED = "REJECTED",
  NOT_DECIDED = "NOT_DECIDED",
}

export interface BidsInfoByHash {
  readonly confirmed: BidByHash;
  readonly latest: BidByHash;
  readonly placedCountAll: number;
  readonly rejectedByCarrier: BidByHash;
  readonly winning: BidByHash;
}

export interface BillingDetails {
  city?: string | null;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  readonly id: number;
  readonly isApproved: boolean;
  /** @maxLength 100 */
  name: string;
  /** @maxLength 20 */
  postCode?: string;
  registrationNumber?: string | null;
  readonly status: BillingDetailsStatusEnum;
  /** @maxLength 100 */
  street?: string;
  taxNumber?: string | null;
  vatNumber?: string | null;
}

export interface BillingDetailsLimited {
  readonly id: number;
  readonly isApproved: boolean;
  registrationNumber?: string | null;
  taxNumber?: string | null;
  vatNumber?: string | null;
}

/**
 * * `WAITING_FOR_APPROVAL` - Waiting for approval
 * * `WAITING_FOR_MANUAL_APPROVAL` - Waiting for manual approval
 * * `APPROVED_MANUALLY` - Approved manually
 * * `REJECTED_MANUALLY` - Rejected manually
 * * `APPROVED_AUTOMATICALLY` - Approved automatically
 * * `REJECTED_AUTOMATICALLY` - Rejected automatically
 */
export enum BillingDetailsStatusEnum {
  WAITING_FOR_APPROVAL = "WAITING_FOR_APPROVAL",
  WAITING_FOR_MANUAL_APPROVAL = "WAITING_FOR_MANUAL_APPROVAL",
  APPROVED_MANUALLY = "APPROVED_MANUALLY",
  REJECTED_MANUALLY = "REJECTED_MANUALLY",
  APPROVED_AUTOMATICALLY = "APPROVED_AUTOMATICALLY",
  REJECTED_AUTOMATICALLY = "REJECTED_AUTOMATICALLY",
}

export interface BookingAddressGateOption {
  /** @maxLength 100 */
  readonly city: string;
  readonly gates: GateNested[];
  readonly id: number;
  readonly isDeleted: boolean;
  /** @maxLength 50 */
  readonly name: string;
  /** @maxLength 100 */
  readonly street: string;
}

export interface BookingAddressNested {
  /** @maxLength 100 */
  city?: string;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  readonly id: number;
  readonly isDeleted: boolean;
  /** @maxLength 50 */
  name?: string;
  /** @maxLength 20 */
  postCode?: string;
  /** @maxLength 100 */
  street?: string;
}

/**
 * Who made the booking: a shipper user, a carrier contact or a booking link, flattened to one shape.
 *
 * A contact reports its carrier's company name, matching how the rest of the portal names it; a link
 * reports its carrier and the e-mail it was sent to.
 */
export interface BookingAuthorNested {
  readonly email: string;
  readonly name: string;
  readonly phoneNumber: string;
}

export interface BookingCargoItemNested {
  /** @maxLength 255 */
  description?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  height?: string | null;
  readonly id: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  length?: string | null;
  /**
   * * `m` - m
   * * `cm` - cm
   * * `mm` - mm
   */
  lengthUnit?: LengthUnitEnum;
  /**
   * @min 0
   * @max 10000
   */
  quantity: number;
  readonly transportCargoItem: number | null;
  readonly unit: CargoItemUnitNested | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  volume?: string | null;
  /**
   * * `l` - L
   * * `m3` - m³
   */
  volumeUnit?: VolumeUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  weight?: string | null;
  /**
   * * `kg` - kg
   * * `t` - t
   */
  weightUnit?: WeightUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  width?: string | null;
}

export interface BookingCargoItemWaypointAssignmentNested {
  deliveryWaypoint: number;
  readonly id: number;
  pickupWaypoint: number;
  /**
   * @min 1
   * @max 10000
   */
  quantity: number;
}

/** The booking id is repeated as ``id`` so the FE can de-duplicate rows across pages. */
export interface BookingImpact {
  readonly booking: BookingImpactNested;
  readonly id: number;
  readonly reasons: BookingImpactReasonEnum[];
}

/** A booking in a confirmation dialog; no transport and no link means "Outside 4Shipper". */
export interface BookingImpactNested {
  readonly bookingLink: BookingLinkReferenceNested | null;
  readonly carrierName: string;
  /** @format date-time */
  readonly endAt: string;
  readonly gate: GateNested;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  /** @format date-time */
  readonly startAt: string;
  readonly status: TimeSlotBookingListStatusEnum;
  readonly timeZone: string;
  readonly transport: BookingTransportNested | null;
  readonly vehicleType: VehicleTypeNested | null;
}

/**
 * * `DURATION_CHANGED` - Slot duration changed
 * * `VEHICLE_TYPE_NOT_OFFERED` - Vehicle type no longer offered
 * * `GATE_REJECTS_VEHICLE_TYPE` - Gate no longer accepts the vehicle type
 * * `GATE_INACTIVE` - Gate inactive
 * * `OUTSIDE_OPERATING_HOURS` - Outside operating hours
 * * `TIME_SLOTS_DISABLED` - Time slots turned off
 * * `GATE_DELETED` - Gate deleted
 * * `ADDRESS_DELETED` - Address deleted
 * * `WAYPOINT_REMOVED` - Waypoint removed
 * * `WAYPOINT_ADDRESS_CHANGED` - Waypoint address changed
 */
export enum BookingImpactReasonEnum {
  DURATION_CHANGED = "DURATION_CHANGED",
  VEHICLE_TYPE_NOT_OFFERED = "VEHICLE_TYPE_NOT_OFFERED",
  GATE_REJECTS_VEHICLE_TYPE = "GATE_REJECTS_VEHICLE_TYPE",
  GATE_INACTIVE = "GATE_INACTIVE",
  OUTSIDE_OPERATING_HOURS = "OUTSIDE_OPERATING_HOURS",
  TIME_SLOTS_DISABLED = "TIME_SLOTS_DISABLED",
  GATE_DELETED = "GATE_DELETED",
  ADDRESS_DELETED = "ADDRESS_DELETED",
  WAYPOINT_REMOVED = "WAYPOINT_REMOVED",
  WAYPOINT_ADDRESS_CHANGED = "WAYPOINT_ADDRESS_CHANGED",
}

/**
 * What the carrier sends from the link's booking form. ``carrier_name`` is ignored while locked and
 * required otherwise; ``vehicle_type`` is required while the address offers any and empty when it offers none.
 */
export interface BookingLinkBookingCreate {
  cargoDescription?: string;
  cargoItems?: BookingLinkCargoItemWrite[];
  /** @maxLength 100 */
  carrierName?: string;
  /**
   * @format email
   * @maxLength 254
   */
  contactPersonEmail: string;
  /** @maxLength 200 */
  contactPersonName?: string;
  /** @maxLength 50 */
  contactPersonPhone?: string;
  /** @format date */
  date: string;
  /** @format time */
  time: string;
  vehicleType?: number | null;
  vehicles?: TimeSlotBookingVehicleWrite[];
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

/** The slot a booking holds, as every booking shape reports it: bounds plus the address clock. */
export interface BookingLinkBookingNested {
  /** @format date-time */
  readonly endAt: string;
  readonly gate: GateNested;
  readonly id: number;
  /** @format date-time */
  readonly startAt: string;
  readonly status: TimeSlotBookingListStatusEnum;
  readonly timeZone: string;
  readonly vehicleType: VehicleTypeNested | null;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

/**
 * What the carrier sends when editing the pending booking it made through the link: the whole form again.
 * ``vehicles`` and ``cargo_items`` are replaced by the payload, so both lists are required and clearing them
 * takes an explicit ``[]``.
 */
export interface BookingLinkBookingUpdate {
  cargoDescription?: string;
  cargoItems: BookingLinkCargoItemWrite[];
  /** @maxLength 100 */
  carrierName?: string;
  /**
   * @format email
   * @maxLength 254
   */
  contactPersonEmail: string;
  /** @maxLength 200 */
  contactPersonName?: string;
  /** @maxLength 50 */
  contactPersonPhone?: string;
  /** @format date */
  date: string;
  /** @format time */
  time: string;
  vehicleType?: number | null;
  vehicles: TimeSlotBookingVehicleWrite[];
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

/** The link's status and expiry, with ``prefill`` while it is ``SENT`` or ``BOOKED`` and null otherwise. */
export interface BookingLinkByHash {
  /** @format date-time */
  readonly expiresAt: string;
  readonly prefill: BookingLinkPrefill | null;
  readonly status: BookingLinkStatusEnum;
}

/** No transport cargo to take a unit from, so every item names its own. */
export interface BookingLinkCargoItemWrite {
  /** @maxLength 255 */
  description?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  height?: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  length?: string | null;
  /**
   * * `m` - m
   * * `cm` - cm
   * * `mm` - mm
   */
  lengthUnit?: LengthUnitEnum;
  /**
   * @min 0
   * @max 10000
   */
  quantity: number;
  unit: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  volume?: string | null;
  /**
   * * `l` - L
   * * `m3` - m³
   */
  volumeUnit?: VolumeUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  weight?: string | null;
  /**
   * * `kg` - kg
   * * `t` - t
   */
  weightUnit?: WeightUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  width?: string | null;
}

export interface BookingLinkCounts {
  expired: number;
}

/**
 * ``carrier`` and ``carrier_name`` are the shipper's pick for an e-mail the directory does not
 * know; for a known one the usecase binds the contact's carrier regardless, so neither is
 * required here. Workspace scoping cannot bind at class definition (no user yet), so the address
 * is checked in ``validate_address`` and the carrier field scopes itself.
 */
export interface BookingLinkCreate {
  address: number;
  carrier?: number | null;
  /** @maxLength 100 */
  carrierName?: string;
  /** @maxLength 200 */
  contactName?: string;
  /** @maxLength 50 */
  contactPhone?: string;
  /**
   * @format email
   * @maxLength 254
   */
  recipientEmail: string;
}

export interface BookingLinkList {
  readonly address: BookingAddressNested;
  readonly booking: BookingLinkBookingNested | null;
  readonly carrierName: string;
  /** @maxLength 200 */
  readonly contactName: string;
  /** @maxLength 50 */
  readonly contactPhone: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly createdBy: UserGeneralInfo;
  readonly displayId: string;
  /** @format date-time */
  readonly expiresAt: string;
  readonly id: number;
  /**
   * @format email
   * @maxLength 254
   */
  readonly recipientEmail: string;
  /** @format date-time */
  readonly revokedAt: string | null;
  readonly sendLimitReached: boolean;
  readonly status: BookingLinkStatusEnum;
}

export interface BookingLinkOfferedVehicleType {
  readonly id: number;
  readonly name: string;
  readonly slotDurationMinutes: number;
}

/** The booking form's starting point. ``carrier_name`` is read-only while ``carrier_name_locked``. */
export interface BookingLinkPrefill {
  readonly address: BookingAddressNested;
  readonly carrierName: string;
  readonly carrierNameLocked: boolean;
  readonly contactName: string;
  readonly contactPhone: string;
  readonly defaultSlotDurationMinutes: number;
  readonly preselectedVehicleType: number | null;
  /** @format email */
  readonly recipientEmail: string;
  readonly shipper: WorkspaceGeneralInfo;
  readonly timeZone: string;
  readonly vehicleTypes: BookingLinkOfferedVehicleType[];
}

/** The booking link the booking was made through. */
export interface BookingLinkReferenceNested {
  readonly displayId: string;
  readonly id: number;
}

/**
 * * `SENT` - Sent
 * * `EXPIRED` - Expired
 * * `REVOKED` - Revoked
 * * `BOOKED` - Booked
 */
export enum BookingLinkStatusEnum {
  SENT = "SENT",
  EXPIRED = "EXPIRED",
  REVOKED = "REVOKED",
  BOOKED = "BOOKED",
}

export enum BookingLinksCountsRetrieveOrderEnum {
  ValueCreatedAt = "-createdAt",
  ValueExpiresAt = "-expiresAt",
  CreatedAt = "createdAt",
  ExpiresAt = "expiresAt",
}

export interface BookingLinksCountsRetrieveParams {
  address?: number;
  /**
   * Booking status
   *
   * * `PENDING` - Pending
   * * `WITHDRAWN` - Withdrawn
   * * `APPROVED` - Approved
   * * `REJECTED` - Rejected
   * * `ARRIVED` - Arrived
   * * `CANCELED` - Canceled
   * * `COMPLETED` - Completed
   * * `EXPIRED` - Expired
   */
  bookingStatus?: TimeSlotBookingListStatusEnum;
  /**
   * Ordering
   *
   * * `createdAt` - Createdat
   * * `-createdAt` - Createdat (descending)
   * * `expiresAt` - Expiresat
   * * `-expiresAt` - Expiresat (descending)
   */
  order?: BookingLinksCountsRetrieveOrderEnum[];
  /** A search term. */
  search?: string;
  /**
   * * `SENT` - Sent
   * * `EXPIRED` - Expired
   * * `REVOKED` - Revoked
   * * `BOOKED` - Booked
   */
  status?: BookingLinkStatusEnum;
}

export type BookingLinksCreateError = Record<string, any>;

export type BookingLinksDestroyError = Record<string, any>;

export interface BookingLinksDestroyParams {
  /** A unique integer value identifying this Booking Link. */
  id: number;
}

export enum BookingLinksListOrderEnum {
  ValueCreatedAt = "-createdAt",
  ValueExpiresAt = "-expiresAt",
  CreatedAt = "createdAt",
  ExpiresAt = "expiresAt",
}

export interface BookingLinksListParams {
  address?: number;
  /**
   * Booking status
   *
   * * `PENDING` - Pending
   * * `WITHDRAWN` - Withdrawn
   * * `APPROVED` - Approved
   * * `REJECTED` - Rejected
   * * `ARRIVED` - Arrived
   * * `CANCELED` - Canceled
   * * `COMPLETED` - Completed
   * * `EXPIRED` - Expired
   */
  bookingStatus?: TimeSlotBookingListStatusEnum;
  /**
   * Ordering
   *
   * * `createdAt` - Createdat
   * * `-createdAt` - Createdat (descending)
   * * `expiresAt` - Expiresat
   * * `-expiresAt` - Expiresat (descending)
   */
  order?: BookingLinksListOrderEnum[];
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  /**
   * * `SENT` - Sent
   * * `EXPIRED` - Expired
   * * `REVOKED` - Revoked
   * * `BOOKED` - Booked
   */
  status?: BookingLinkStatusEnum;
}

export type BookingLinksResendError = Record<string, any>;

export interface BookingLinksResendParams {
  /** A unique integer value identifying this Booking Link. */
  id: number;
}

export type BookingLinksRevokeError = Record<string, any>;

export interface BookingLinksRevokeParams {
  /** A unique integer value identifying this Booking Link. */
  id: number;
}

/**
 * * `SHIPPER` - Shipper
 * * `CARRIER` - Carrier
 */
export enum BookingOriginEnum {
  SHIPPER = "SHIPPER",
  CARRIER = "CARRIER",
}

/** Everything the Add-new-booking form starts from, for one stop of one transport. */
export interface BookingPrefill {
  readonly contactPerson: BookingPrefillContactNested | null;
  readonly contacts: BookingPrefillContactNested[];
  readonly durationMinutes: number;
  readonly shipper: WorkspaceGeneralInfo;
  readonly timeZone: string;
  readonly transport: CarrierBookingTransportDetailNested;
  readonly vehicleType: VehicleTypeNested | null;
  readonly vehicles: BookingPrefillVehicleNested[];
}

export interface BookingPrefillContactNested {
  /**
   * Contact email
   * @format email
   * @maxLength 254
   */
  email: string;
  /** @maxLength 50 */
  fullName?: string;
  readonly id: number;
  /** @maxLength 128 */
  phoneNumber?: string;
}

export interface BookingPrefillVehicleNested {
  readonly driverName: string;
  readonly driverPhone: string;
  readonly index: number;
  readonly plateNumber: string;
}

export interface BookingRouteStopNested {
  /** @maxLength 100 */
  readonly city: string;
  readonly country: CountryEnum;
  readonly id: number;
  /**
   * @min 0
   * @max 32767
   */
  readonly index: number | null;
  readonly type: WaypointTypeEnum;
}

export interface BookingRouteWaypointNested {
  /** @format date-time */
  availabilityEnd?: string | null;
  /** @format date-time */
  availabilityStart?: string | null;
  /** @maxLength 100 */
  city: string;
  contactEmail?: string;
  /** @maxLength 50 */
  contactName?: string;
  /** @maxLength 128 */
  contactPhone?: string;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  readonly id: number;
  /** @maxLength 50 */
  name?: string;
  note?: string;
  /** @maxLength 20 */
  postCode?: string;
  /** @maxLength 150 */
  reference?: string;
  /** @maxLength 100 */
  street?: string;
  /**
   * IANA time zone
   * @maxLength 64
   */
  timezone?: string;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  type: WaypointTypeEnum;
}

/** A booking field its address's current settings no longer match; the duration carries what they give now. */
export interface BookingSettingsConflict {
  /**
   * * `gate` - Gate
   * * `vehicle_type` - Vehicle type
   * * `duration` - Duration
   * * `time` - Time
   */
  bookingField: BookingSettingsConflictFieldEnum;
  expectedDurationMinutes: number | null;
  /**
   * * `DURATION_CHANGED` - Slot duration changed
   * * `VEHICLE_TYPE_NOT_OFFERED` - Vehicle type no longer offered
   * * `GATE_REJECTS_VEHICLE_TYPE` - Gate no longer accepts the vehicle type
   * * `GATE_INACTIVE` - Gate inactive
   * * `OUTSIDE_OPERATING_HOURS` - Outside operating hours
   * * `TIME_SLOTS_DISABLED` - Time slots turned off
   * * `GATE_DELETED` - Gate deleted
   * * `ADDRESS_DELETED` - Address deleted
   * * `WAYPOINT_REMOVED` - Waypoint removed
   * * `WAYPOINT_ADDRESS_CHANGED` - Waypoint address changed
   */
  reason: BookingImpactReasonEnum;
}

/**
 * * `gate` - Gate
 * * `vehicle_type` - Vehicle type
 * * `duration` - Duration
 * * `time` - Time
 */
export enum BookingSettingsConflictFieldEnum {
  Gate = "gate",
  VehicleType = "vehicle_type",
  Duration = "duration",
  Time = "time",
}

/** Read-only mirror of the request cargo item shape, so shared FE cargo helpers accept it as-is. */
export interface BookingTransportCargoItemNested {
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  height?: string | null;
  readonly id: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  length?: string | null;
  /**
   * * `m` - m
   * * `cm` - cm
   * * `mm` - mm
   */
  lengthUnit?: LengthUnitEnum;
  /**
   * @min 0
   * @max 10000
   */
  quantity: number;
  /**
   * * `1 + 1` - 1 + 1
   * * `1 + 2` - 1 + 2
   * * `1 + 3` - 1 + 3
   * * `1 + 4` - 1 + 4
   * * `1 + 5` - 1 + 5
   * * `1 + 6` - 1 + 6
   * * `1 + 7` - 1 + 7
   * * `1 + 8` - 1 + 8
   * * `1 + 9` - 1 + 9
   * * `1 + 10` - 1 + 10
   */
  stackCount?: StackCountEnum;
  stackable?: boolean | null;
  unit: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  volume?: string | null;
  /**
   * * `l` - L
   * * `m3` - m³
   */
  volumeUnit?: VolumeUnitEnum;
  readonly waypointAssignments: BookingCargoItemWaypointAssignmentNested[];
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  weight?: string | null;
  /**
   * * `kg` - kg
   * * `t` - t
   */
  weightUnit?: WeightUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  width?: string | null;
}

/** Read-only mirror of the request cargo shape, so shared FE cargo helpers accept it as-is. */
export interface BookingTransportCargoNested {
  description?: string;
  hasWaypointAssignments?: boolean;
  readonly id: number;
  readonly items: BookingTransportCargoItemNested[];
  /**
   * * `FTL` - Full Truck Load
   * * `LTL` - Less than Truck Load
   * * `FCL` - Full Container Load
   * * `LCL` - Less than Container Load
   * * `PARCEL` - Parcel
   * * `NOT_SPECIFIED` - Not specified
   */
  loadType?: CargoLoadTypeEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  maxLength?: string | null;
  /**
   * * `m` - m
   * * `cm` - cm
   * * `mm` - mm
   */
  maxLengthUnit?: LengthUnitEnum;
  note?: string;
  specialRequirements?: CargoSpecialRequirementsEnum[];
  /**
   * * `REFRIGERATED_GOODS` - Refrigerated goods
   * * `FROZEN_GOODS` - Frozen goods
   * * `METAL_GOODS` - Metal goods
   * * `OVERSIZED_LOAD` - Oversized load
   * * `BULK_MATERIAL` - Bulk material
   * * `LOOSE_MATERIAL` - Loose material
   * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
   * * `LIQUIDS` - Liquids
   * * `VEHICLES` - Vehicles
   * * `ADR` - ADR
   * * `OTHER` - Other
   * * `NOT_SPECIFIED` - Not specified
   */
  type?: CargoTypeEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly value: string | null;
  readonly valueCurrency: CurrencyEnum | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  volume?: string | null;
  /**
   * * `l` - L
   * * `m3` - m³
   */
  volumeUnit?: VolumeUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  weight?: string | null;
  /**
   * * `kg` - kg
   * * `t` - t
   */
  weightUnit?: WeightUnitEnum;
}

export interface BookingTransportDetailNested {
  readonly cargo: BookingTransportCargoNested;
  readonly displayId: string;
  /** @format double */
  readonly distance: number | null;
  readonly id: number;
  readonly incoterms: IncotermsEnum;
  readonly waypoints: BookingRouteWaypointNested[];
}

export interface BookingTransportNested {
  readonly displayId: string;
  readonly id: number;
}

export interface BookingTransportPreviewNested {
  readonly displayId: string;
  readonly id: number;
  readonly waypoints: BookingRouteStopNested[];
}

export interface BookingVehicleNested {
  /** @maxLength 255 */
  driverName?: string;
  /** @maxLength 255 */
  driverPhone?: string;
  readonly id: number;
  /**
   * @min 0
   * @max 32767
   */
  index?: number;
  /** @maxLength 255 */
  plateNumber?: string;
}

export interface BookingWaypointNested {
  /** @format date-time */
  availabilityEnd?: string | null;
  /** @format date-time */
  availabilityStart?: string | null;
  /** @maxLength 100 */
  city: string;
  contactEmail?: string;
  /** @maxLength 50 */
  contactName?: string;
  /** @maxLength 128 */
  contactPhone?: string;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  readonly id: number;
  /** @maxLength 50 */
  name?: string;
  /** @maxLength 20 */
  postCode?: string;
  /** @maxLength 150 */
  reference?: string;
  /** @maxLength 100 */
  street?: string;
  /**
   * IANA time zone
   * @maxLength 64
   */
  timezone?: string;
}

export type BookingsApproveError = Record<string, any>;

export interface BookingsApproveParams {
  /** A unique integer value identifying this Time Slot Booking. */
  id: number;
}

export type BookingsAvailableGatesError = Record<string, any>;

export interface BookingsAvailableGatesParams {
  /** A unique integer value identifying this Time Slot Booking. */
  id: number;
}

export type BookingsCancelError = Record<string, any>;

export interface BookingsCancelParams {
  /** A unique integer value identifying this Time Slot Booking. */
  id: number;
}

export type BookingsChangeGateError = Record<string, any>;

export interface BookingsChangeGateParams {
  /** A unique integer value identifying this Time Slot Booking. */
  id: number;
}

export type BookingsCreateError = Record<string, any>;

export enum BookingsListOrderEnum {
  ValueBookingTime = "-bookingTime",
  ValueCreatedAt = "-createdAt",
  BookingTime = "bookingTime",
  CreatedAt = "createdAt",
}

export interface BookingsListParams {
  address?: number;
  /** Carrier */
  carrierName?: string;
  /** Driver name */
  driverName?: string;
  /** Driver phone */
  driverPhone?: string;
  /** @format date-time */
  fromDatetime?: string;
  /** Multiple values may be separated by commas. */
  gate?: number[];
  /**
   * Ordering
   *
   * * `createdAt` - Createdat
   * * `-createdAt` - Createdat (descending)
   * * `bookingTime` - Bookingtime
   * * `-bookingTime` - Bookingtime (descending)
   */
  order?: BookingsListOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Vehicle plate */
  plateNumber?: string;
  /** A search term. */
  search?: string;
  /**
   * * `PENDING` - Pending
   * * `WITHDRAWN` - Withdrawn
   * * `APPROVED` - Approved
   * * `REJECTED` - Rejected
   * * `ARRIVED` - Arrived
   * * `CANCELED` - Canceled
   * * `COMPLETED` - Completed
   * * `EXPIRED` - Expired
   */
  status?: TimeSlotBookingListStatusEnum;
  /** @format date-time */
  toDatetime?: string;
  /** Transport */
  transport?: number;
  /** Vehicle type */
  vehicleType?: number;
}

export type BookingsPreviewError = Record<string, any>;

export interface BookingsPreviewParams {
  /** A unique integer value identifying this Time Slot Booking. */
  id: number;
}

export type BookingsRejectError = Record<string, any>;

export interface BookingsRejectParams {
  /** A unique integer value identifying this Time Slot Booking. */
  id: number;
}

export type BookingsRetrieveError = Record<string, any>;

export interface BookingsRetrieveParams {
  /** A unique integer value identifying this Time Slot Booking. */
  id: number;
}

export type BookingsTimelineError = Record<string, any>;

export interface BookingsTimelineParams {
  /** @format date */
  date: string;
  /** Multiple values may be separated by commas. */
  gate?: number[];
  /** Show revoked bookings */
  showRevoked?: boolean;
  /**
   * Waypoint type
   *
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType?: WaypointTypeEnum;
}

export type BookingsUpdateError = Record<string, any>;

export interface BookingsUpdateParams {
  /** A unique integer value identifying this Time Slot Booking. */
  id: number;
}

export interface BulkInvitation {
  emails: string[];
  role: number;
  workspaces: number[];
}

export enum ByEmailAuctionsListOrderEnum {
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  ValueFinishingAtAnnotated = "-finishing_at_annotated",
  ValuePublishedAt = "-published_at",
  EarliestWaypointDate = "earliest_waypoint_date",
  FinishingAtAnnotated = "finishing_at_annotated",
  PublishedAt = "published_at",
}

export interface ByEmailAuctionsListParams {
  maxVolumeM3?: number;
  minVolumeM3?: number;
  /** Auction ID */
  auctionId?: number;
  /**
   * Auction status
   *
   * * `ACTIVE` - Active
   * * `WAITING_FOR_ACCEPTATION` - Waiting for acceptation
   * * `CANCELED` - Canceled
   * * `SUCCESSFUL` - Successful
   * * `UNSUCCESSFUL` - Unsuccessful
   * * `OTHER` - Other
   */
  carrierAuctionStatus?: CarrierAuctionStatusEnum;
  deliveryCity?: string;
  deliveryCountry?: string;
  /** @format date-time */
  deliveryDateAfter?: string;
  /** @format date-time */
  deliveryDateBefore?: string;
  deliveryName?: string;
  deliveryPostCode?: string;
  deliveryReference?: string;
  deliveryStreet?: string;
  /**
   * Incoterms
   *
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  /**
   * Load type
   *
   * * `FTL` - Full Truck Load
   * * `LTL` - Less than Truck Load
   * * `FCL` - Full Container Load
   * * `LCL` - Less than Container Load
   * * `PARCEL` - Parcel
   * * `NOT_SPECIFIED` - Not specified
   */
  loadType?: CargoLoadTypeEnum[];
  maxWeightKg?: number;
  minWeightKg?: number;
  /**
   * Ordering
   *
   * * `published_at` - Published at
   * * `-published_at` - Published at (descending)
   * * `finishing_at_annotated` - Finishing at annotated
   * * `-finishing_at_annotated` - Finishing at annotated (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   */
  order?: ByEmailAuctionsListOrderEnum[];
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  pickupCity?: string;
  pickupCountry?: string;
  /** @format date-time */
  pickupDateAfter?: string;
  /** @format date-time */
  pickupDateBefore?: string;
  pickupName?: string;
  pickupPostCode?: string;
  pickupReference?: string;
  pickupStreet?: string;
  /** Reference */
  reference?: string;
  /**
   * Request type
   *
   * * `REFRIGERATED_GOODS` - Refrigerated goods
   * * `FROZEN_GOODS` - Frozen goods
   * * `METAL_GOODS` - Metal goods
   * * `OVERSIZED_LOAD` - Oversized load
   * * `BULK_MATERIAL` - Bulk material
   * * `LOOSE_MATERIAL` - Loose material
   * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
   * * `LIQUIDS` - Liquids
   * * `VEHICLES` - Vehicles
   * * `ADR` - ADR
   * * `OTHER` - Other
   * * `NOT_SPECIFIED` - Not specified
   */
  requestType?: CargoTypeEnum;
  /** Responsible person */
  responsiblePerson?: string;
  /** A search term. */
  search?: string;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
  workspace?: string;
}

export interface ByEmailBookingsAddressesListParams {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Matches each whitespace-separated term against the address name, country, city, street and post code. Quoted phrases are kept whole. */
  search?: string;
}

export enum ByEmailBookingsListOrderEnum {
  ValueBookingTime = "-bookingTime",
  ValueCreatedAt = "-createdAt",
  BookingTime = "bookingTime",
  CreatedAt = "createdAt",
}

export interface ByEmailBookingsListParams {
  address?: number;
  /** Driver name */
  driverName?: string;
  /** @format date-time */
  fromDatetime?: string;
  /**
   * Ordering
   *
   * * `createdAt` - Createdat
   * * `-createdAt` - Createdat (descending)
   * * `bookingTime` - Bookingtime
   * * `-bookingTime` - Bookingtime (descending)
   */
  order?: ByEmailBookingsListOrderEnum[];
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Vehicle plate */
  plateNumber?: string;
  /** Shipper */
  shipper?: string;
  /**
   * * `PENDING` - Pending
   * * `WITHDRAWN` - Withdrawn
   * * `APPROVED` - Approved
   * * `REJECTED` - Rejected
   * * `ARRIVED` - Arrived
   * * `CANCELED` - Canceled
   * * `COMPLETED` - Completed
   * * `EXPIRED` - Expired
   */
  status?: TimeSlotBookingListStatusEnum;
  /** @format date-time */
  toDatetime?: string;
  /** Transport */
  transport?: number;
}

export interface ByEmailBookingsRetrieveParams {
  /** Hash key */
  hash: string;
}

export enum ByEmailContractsListOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
}

export interface ByEmailContractsListParams {
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   */
  order?: ByEmailContractsListOrderEnum[];
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Responsible person */
  responsiblePerson?: string;
  /** A search term. */
  search?: string;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum[];
  workspace?: string;
}

export interface ByEmailContractsRetrieveParams {
  /** Hash key */
  hash: string;
}

export interface ByEmailMessagesListParams {
  /** The pagination cursor value. */
  cursor?: string;
  email: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface ByEmailMessagesMarkAllAsReadCreateParams {
  email: string;
}

export interface ByEmailMessagesMarkAsReadCreateParams {
  email: string;
  /** A unique integer value identifying this message. */
  id: number;
}

export interface ByEmailMessagesUnreadCountRetrieveParams {
  email: string;
}

export interface ByEmailTendersDocumentsListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  tenderHash: string;
}

export interface ByEmailTendersDocumentsRetrieveParams {
  /** A unique integer value identifying this document. */
  id: number;
  tenderHash: string;
}

export enum ByEmailTendersListOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
}

export interface ByEmailTendersListParams {
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   */
  order?: ByEmailTendersListOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Participated */
  participated?: boolean;
  /** Responsible person */
  responsiblePerson?: string;
  /** A search term. */
  search?: string;
  /**
   * Status
   *
   * * `DRAFT` - Draft
   * * `OPEN` - Open
   * * `EVALUATING` - Evaluating
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   */
  tenderDisplayStatus?: TenderDisplayStatusEnum;
  /** Tender ID */
  tenderId?: number;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum[];
  workspace?: string;
}

export interface ByEmailTendersMessagesCreateParams {
  tenderHash: string;
}

export interface ByEmailTendersMessagesListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  tenderHash: string;
}

export interface ByEmailTendersMessagesMarkAsReadCreateParams {
  tenderHash: string;
}

export interface ByEmailTendersMessagesUnreadCountRetrieveParams {
  tenderHash: string;
}

export interface ByEmailTendersRetrieveParams {
  /** Hash key */
  hash: string;
}

export interface ByEmailTendersSavePricesCreateParams {
  /** Hash key */
  hash: string;
}

export interface ByEmailTendersSubmitPricesCreateParams {
  /** Hash key */
  hash: string;
}

export enum ByEmailTransportsListOrderEnum {
  ValueBookingRequired = "-booking_required",
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  BookingRequired = "booking_required",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
}

export interface ByEmailTransportsListParams {
  maxVolumeM3?: number;
  minVolumeM3?: number;
  /** Auction ID */
  auctionId?: number;
  deliveryCity?: string;
  deliveryCountry?: string;
  /** @format date-time */
  deliveryDateAfter?: string;
  /** @format date-time */
  deliveryDateBefore?: string;
  deliveryName?: string;
  deliveryPostCode?: string;
  deliveryReference?: string;
  deliveryStreet?: string;
  /**
   * Incoterms
   *
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  /**
   * Load type
   *
   * * `FTL` - Full Truck Load
   * * `LTL` - Less than Truck Load
   * * `FCL` - Full Container Load
   * * `LCL` - Less than Container Load
   * * `PARCEL` - Parcel
   * * `NOT_SPECIFIED` - Not specified
   */
  loadType?: CargoLoadTypeEnum[];
  maxWeightKg?: number;
  minWeightKg?: number;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   * * `booking_required` - Booking required
   * * `-booking_required` - Booking required (descending)
   */
  order?: ByEmailTransportsListOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  pickupCity?: string;
  pickupCountry?: string;
  /** @format date-time */
  pickupDateAfter?: string;
  /** @format date-time */
  pickupDateBefore?: string;
  pickupName?: string;
  pickupPostCode?: string;
  pickupReference?: string;
  pickupStreet?: string;
  reference?: string;
  /**
   * Request type
   *
   * * `REFRIGERATED_GOODS` - Refrigerated goods
   * * `FROZEN_GOODS` - Frozen goods
   * * `METAL_GOODS` - Metal goods
   * * `OVERSIZED_LOAD` - Oversized load
   * * `BULK_MATERIAL` - Bulk material
   * * `LOOSE_MATERIAL` - Loose material
   * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
   * * `LIQUIDS` - Liquids
   * * `VEHICLES` - Vehicles
   * * `ADR` - ADR
   * * `OTHER` - Other
   * * `NOT_SPECIFIED` - Not specified
   */
  requestType?: CargoTypeEnum;
  /** Responsible person */
  responsiblePerson?: string;
  /** A search term. */
  search?: string;
  /** Slot booking */
  slotBooking?: boolean;
  /**
   * Transport status
   *
   * * `PROCESSING` - Processing
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   * * `CANCELED_BY_CARRIER` - Canceled by carrier
   * * `CANCELED_BY_SUPPORT` - Canceled by support
   */
  transportStatus?: TransportStatusEnum;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
  workspace?: string;
}

export interface ByEmailTransportsTransportRetrieveParams {
  auctionHash: string;
}

export type ByHashBookingLinksAvailableSlotsRetrieveError = Record<string, any>;

export interface ByHashBookingLinksAvailableSlotsRetrieveParams {
  /** @format date */
  date: string;
  /** Hash key */
  hash: string;
  vehicleType?: number | null;
}

export type ByHashBookingLinksBookingCreateError = Record<string, any>;

export interface ByHashBookingLinksBookingCreateParams {
  /** Hash key */
  hash: string;
}

export type ByHashBookingLinksBookingRetrieveError = Record<string, any>;

export interface ByHashBookingLinksBookingRetrieveParams {
  /** Hash key */
  hash: string;
}

export type ByHashBookingLinksBookingUpdateError = Record<string, any>;

export interface ByHashBookingLinksBookingUpdateParams {
  /** Hash key */
  hash: string;
}

export type ByHashBookingLinksCargoItemUnitsListError = Record<string, any>;

export interface ByHashBookingLinksCargoItemUnitsListParams {
  bookingLinkHash: string;
}

export type ByHashBookingLinksRetrieveError = Record<string, any>;

export interface ByHashBookingLinksRetrieveParams {
  /** Hash key */
  hash: string;
}

export interface ByHashContactsAuctionsBatchUpdatesCreateParams {
  auctionHash: string;
  contactHash: string;
}

export interface ByHashContactsAuctionsBatchUpdatesListParams {
  auctionHash: string;
  contactHash: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface ByHashContactsAuctionsBidsCreateParams {
  auctionHash: string;
  contactHash: string;
}

export interface ByHashContactsAuctionsBidsFeePreviewCreateParams {
  auctionHash: string;
  contactHash: string;
}

export interface ByHashContactsAuctionsBidsListParams {
  auctionHash: string;
  contactHash: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface ByHashContactsAuctionsBidsPartialUpdateParams {
  auctionHash: string;
  contactHash: string;
  /** Hash key */
  hash: string;
}

export interface ByHashContactsAuctionsBidsRetrieveParams {
  auctionHash: string;
  contactHash: string;
  /** Hash key */
  hash: string;
}

export interface ByHashContactsAuctionsBidsUpdateParams {
  auctionHash: string;
  contactHash: string;
  /** Hash key */
  hash: string;
}

export type ByHashContactsAuctionsBookingSlotsAvailableSlotsRetrieveError =
  Record<string, any>;

export interface ByHashContactsAuctionsBookingSlotsAvailableSlotsRetrieveParams {
  auctionHash: string;
  contactHash: string;
  /** @format date */
  date: string;
  excludeBooking?: string;
  vehicleType?: number | null;
  waypoint: number;
}

export interface ByHashContactsAuctionsBookingsCancelCreateParams {
  auctionHash: string;
  contactHash: string;
  /** Hash key */
  hash: string;
}

export type ByHashContactsAuctionsBookingsCreateError = Record<string, any>;

export interface ByHashContactsAuctionsBookingsCreateParams {
  auctionHash: string;
  contactHash: string;
}

export type ByHashContactsAuctionsBookingsPrefillRetrieveError = Record<
  string,
  any
>;

export interface ByHashContactsAuctionsBookingsPrefillRetrieveParams {
  auctionHash: string;
  contactHash: string;
  waypoint: number;
}

export interface ByHashContactsAuctionsBookingsRetrieveParams {
  auctionHash: string;
  contactHash: string;
  /** Hash key */
  hash: string;
}

export type ByHashContactsAuctionsBookingsUpdateError = Record<string, any>;

export interface ByHashContactsAuctionsBookingsUpdateParams {
  auctionHash: string;
  contactHash: string;
  /** Hash key */
  hash: string;
}

export interface ByHashContactsAuctionsDocumentsCreateParams {
  auctionHash: string;
  contactHash: string;
}

export interface ByHashContactsAuctionsDocumentsListParams {
  auctionHash: string;
  contactHash: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface ByHashContactsAuctionsDocumentsRetrieveParams {
  auctionHash: string;
  contactHash: string;
  /** A unique integer value identifying this document. */
  id: number;
}

export interface ByHashContactsAuctionsDownloadTransportOrderRetrieveParams {
  contactHash: string;
  hash: string;
  /** A search term. */
  search?: string;
}

export interface ByHashContactsAuctionsMessagesCreateParams {
  auctionHash: string;
  contactHash: string;
}

export interface ByHashContactsAuctionsMessagesListParams {
  auctionHash: string;
  contactHash: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface ByHashContactsAuctionsMessagesMarkAsReadCreateParams {
  auctionHash: string;
  contactHash: string;
}

export interface ByHashContactsAuctionsMessagesUnreadCountRetrieveParams {
  auctionHash: string;
  contactHash: string;
}

export interface ByHashContactsAuctionsRetrieveParams {
  contactHash: string;
  hash: string;
}

export interface ByHashContactsAuctionsStatusCreateParams {
  contactHash: string;
  hash: string;
}

export interface ByHashContactsAuctionsTransportCancelRequestCreateParams {
  contactHash: string;
  hash: string;
}

export interface ByHashContactsAuctionsTransportDetailsCreateParams {
  contactHash: string;
  hash: string;
}

export interface ByHashContactsAuctionsTransportDetailsRetrieveParams {
  contactHash: string;
  hash: string;
}

export interface ByHashContactsAuctionsUpdatesListLatestListParams {
  auctionHash: string;
  contactHash: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
}

export interface ByHashContactsBillingDetailsApproveCreateParams {
  contactHash: string;
  /** A unique integer value identifying this Carrier Billing Details. */
  id: number;
}

export interface ByHashContactsBillingDetailsCreateParams {
  contactHash: string;
}

export interface ByHashContactsBillingDetailsListParams {
  contactHash: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface ByHashContactsBillingDetailsRetrieveParams {
  contactHash: string;
  /** A unique integer value identifying this Carrier Billing Details. */
  id: number;
}

export interface ByHashContactsCargoItemUnitsAllListParams {
  contactHash: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
}

export interface ByHashContactsCargoItemUnitsListParams {
  contactHash: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface ByHashContactsPartialUpdateParams {
  /** Hash key */
  hash: string;
}

export interface ByHashContactsRetrieveParams {
  /** Hash key */
  hash: string;
}

export interface ByHashContactsUpdateParams {
  /** Hash key */
  hash: string;
}

export type CaptchaVerifyCreatePayload = string;

export interface Cargo {
  description?: string;
  readonly hasWaypointAssignments: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  height?: string | null;
  readonly id: number;
  items: CargoItem[];
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  length?: string | null;
  /**
   * * `m` - m
   * * `cm` - cm
   * * `mm` - mm
   */
  lengthUnit?: LengthUnitEnum;
  /**
   * * `FTL` - Full Truck Load
   * * `LTL` - Less than Truck Load
   * * `FCL` - Full Container Load
   * * `LCL` - Less than Container Load
   * * `PARCEL` - Parcel
   * * `NOT_SPECIFIED` - Not specified
   */
  loadType?: CargoLoadTypeEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  maxLength?: string | null;
  /**
   * * `m` - m
   * * `cm` - cm
   * * `mm` - mm
   */
  maxLengthUnit?: LengthUnitEnum;
  note?: string;
  specialRequirements?: CargoSpecialRequirementsEnum[];
  /**
   * * `REFRIGERATED_GOODS` - Refrigerated goods
   * * `FROZEN_GOODS` - Frozen goods
   * * `METAL_GOODS` - Metal goods
   * * `OVERSIZED_LOAD` - Oversized load
   * * `BULK_MATERIAL` - Bulk material
   * * `LOOSE_MATERIAL` - Loose material
   * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
   * * `LIQUIDS` - Liquids
   * * `VEHICLES` - Vehicles
   * * `ADR` - ADR
   * * `OTHER` - Other
   * * `NOT_SPECIFIED` - Not specified
   */
  type?: CargoTypeEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  value?: string | null;
  readonly valueCurrency: CurrencyEnum | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  volume?: string | null;
  /**
   * * `l` - L
   * * `m3` - m³
   */
  volumeUnit?: VolumeUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  weight?: string | null;
  /**
   * * `kg` - kg
   * * `t` - t
   */
  weightUnit?: WeightUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  width?: string | null;
}

export interface CargoCategoriesDestroyParams {
  /** A unique integer value identifying this Cargo Category. */
  id: number;
}

export interface CargoCategoriesListParams {
  /**
   * * `WEIGHT` - Weight
   * * `LENGTH` - Length
   * * `VOLUME` - Volume
   * * `CUSTOM` - Custom
   */
  kind?: CargoCategoryKindEnum;
  name?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  /**
   * * `KG` - kg
   * * `M` - m
   * * `M3` - m³
   */
  unit?: UnitEnum;
}

export interface CargoCategoriesPartialUpdateParams {
  /** A unique integer value identifying this Cargo Category. */
  id: number;
}

export interface CargoCategoriesRetrieveParams {
  /** A unique integer value identifying this Cargo Category. */
  id: number;
}

export interface CargoCategoriesUpdateParams {
  /** A unique integer value identifying this Cargo Category. */
  id: number;
}

export interface CargoCategory {
  readonly id: number;
  /** @default false */
  readonly isUsedInDraft: boolean;
  /**
   * * `WEIGHT` - Weight
   * * `LENGTH` - Length
   * * `VOLUME` - Volume
   * * `CUSTOM` - Custom
   */
  kind?: CargoCategoryKindEnum;
  /** @maxLength 100 */
  name: string;
  ranges?: CargoCategoryRange[];
  /** @maxLength 2 */
  unit?: string | null;
}

/**
 * * `WEIGHT` - Weight
 * * `LENGTH` - Length
 * * `VOLUME` - Volume
 * * `CUSTOM` - Custom
 */
export enum CargoCategoryKindEnum {
  WEIGHT = "WEIGHT",
  LENGTH = "LENGTH",
  VOLUME = "VOLUME",
  CUSTOM = "CUSTOM",
}

export interface CargoCategoryRange {
  id?: number | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  lower?: string | null;
  /** @maxLength 100 */
  name?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  upper?: string | null;
}

export interface CargoItem {
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  height?: string | null;
  id?: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  length?: string | null;
  /**
   * * `m` - m
   * * `cm` - cm
   * * `mm` - mm
   */
  lengthUnit?: LengthUnitEnum;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  originalId?: number | null;
  /**
   * @min 0
   * @max 10000
   */
  quantity: number;
  /**
   * * `1 + 1` - 1 + 1
   * * `1 + 2` - 1 + 2
   * * `1 + 3` - 1 + 3
   * * `1 + 4` - 1 + 4
   * * `1 + 5` - 1 + 5
   * * `1 + 6` - 1 + 6
   * * `1 + 7` - 1 + 7
   * * `1 + 8` - 1 + 8
   * * `1 + 9` - 1 + 9
   * * `1 + 10` - 1 + 10
   */
  stackCount?: StackCountEnum;
  stackable?: boolean | null;
  unit: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  volume?: string | null;
  /**
   * * `l` - L
   * * `m3` - m³
   */
  volumeUnit?: VolumeUnitEnum;
  waypointAssignments?: CargoItemWaypointAssignment[];
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  weight?: string | null;
  /**
   * * `kg` - kg
   * * `t` - t
   */
  weightUnit?: WeightUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  width?: string | null;
}

/**
 * A mixin that sets all serializer fields (including nested ones)
 * to required=False, allow_null=True automatically and ski serializer validation.
 */
export interface CargoItemOptional {
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  height?: string | null;
  id?: number | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  length?: string | null;
  lengthUnit?: LengthUnitEnum | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  originalId?: number | null;
  /**
   * @min 0
   * @max 10000
   */
  quantity?: number | null;
  stackCount?: StackCountEnum | null;
  stackable?: boolean | null;
  readonly unit: number | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  volume?: string | null;
  volumeUnit?: VolumeUnitEnum | null;
  waypointAssignments?: CargoItemWaypointAssignmentOptional[] | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  weight?: string | null;
  weightUnit?: WeightUnitEnum | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  width?: string | null;
}

export interface CargoItemUnit {
  readonly code: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  height?: string | null;
  readonly id: number;
  isActive?: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  length?: string | null;
  /**
   * * `m` - m
   * * `cm` - cm
   * * `mm` - mm
   */
  lengthUnit?: LengthUnitEnum;
  /** @maxLength 150 */
  title: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  volume?: string | null;
  /**
   * * `l` - L
   * * `m3` - m³
   */
  volumeUnit?: VolumeUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  width?: string | null;
}

export interface CargoItemUnitNested {
  readonly id: number;
  /** @maxLength 150 */
  title: string;
}

export interface CargoItemUnitsAllListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
}

export interface CargoItemUnitsListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface CargoItemUnitsPartialUpdateParams {
  /** A unique integer value identifying this cargo item unit. */
  id: number;
}

export interface CargoItemUnitsRetrieveParams {
  /** A unique integer value identifying this cargo item unit. */
  id: number;
}

export interface CargoItemUnitsUpdateParams {
  /** A unique integer value identifying this cargo item unit. */
  id: number;
}

export interface CargoItemWaypointAssignment {
  readonly deliveryWaypoint: number;
  deliveryWaypointIndex?: number | null;
  readonly id: number;
  readonly pickupWaypoint: number;
  pickupWaypointIndex?: number | null;
  /**
   * @min 1
   * @max 10000
   */
  quantity: number;
}

/**
 * A mixin that sets all serializer fields (including nested ones)
 * to required=False, allow_null=True automatically and ski serializer validation.
 */
export interface CargoItemWaypointAssignmentOptional {
  readonly deliveryWaypoint: number | null;
  readonly deliveryWaypointIndex: number | null;
  readonly id: number | null;
  readonly pickupWaypoint: number | null;
  readonly pickupWaypointIndex: number | null;
  readonly quantity: number | null;
}

/**
 * * `FTL` - Full Truck Load
 * * `LTL` - Less than Truck Load
 * * `FCL` - Full Container Load
 * * `LCL` - Less than Container Load
 * * `PARCEL` - Parcel
 * * `NOT_SPECIFIED` - Not specified
 */
export enum CargoLoadTypeEnum {
  FTL = "FTL",
  LTL = "LTL",
  FCL = "FCL",
  LCL = "LCL",
  PARCEL = "PARCEL",
  NOT_SPECIFIED = "NOT_SPECIFIED",
}

/**
 * A mixin that sets all serializer fields (including nested ones)
 * to required=False, allow_null=True automatically and ski serializer validation.
 */
export interface CargoOptional {
  description?: string | null;
  readonly hasWaypointAssignments: boolean | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  height?: string | null;
  readonly id: number | null;
  items?: CargoItemOptional[] | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  length?: string | null;
  lengthUnit?: LengthUnitEnum | null;
  loadType?: CargoLoadTypeEnum | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  maxLength?: string | null;
  maxLengthUnit?: LengthUnitEnum | null;
  note?: string | null;
  specialRequirements?: CargoSpecialRequirementsEnum[] | null;
  type?: CargoTypeEnum | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  value?: string | null;
  readonly valueCurrency: CurrencyEnum | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  volume?: string | null;
  volumeUnit?: VolumeUnitEnum | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  weight?: string | null;
  weightUnit?: WeightUnitEnum | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  width?: string | null;
}

/**
 * * `REFRIGERATED_VEHICLE` - Refrigerated vehicle
 * * `HANDLING_FROM_TOP` - Handling from top
 * * `HANDLING_FROM_BACK` - Handling from back
 * * `HANDLING_FROM_SIDE` - Handling from side
 * * `TAIL_LIFT` - Tail lift
 * * `SLIDING_DOOR` - Sliding door
 * * `SAFETY_VEST_FOR_DRIVER` - Safety vest for driver
 * * `HYDRAULIC_ARM` - Hydraulic arm
 * * `CLAMPING_STRAPS` - Clamping straps
 * * `SAFETY_SHOES_FOR_DRIVER` - Safety shoes for driver
 * * `HELMET_FOR_DRIVER` - Helmet for driver
 */
export enum CargoSpecialRequirementsEnum {
  REFRIGERATED_VEHICLE = "REFRIGERATED_VEHICLE",
  HANDLING_FROM_TOP = "HANDLING_FROM_TOP",
  HANDLING_FROM_BACK = "HANDLING_FROM_BACK",
  HANDLING_FROM_SIDE = "HANDLING_FROM_SIDE",
  TAIL_LIFT = "TAIL_LIFT",
  SLIDING_DOOR = "SLIDING_DOOR",
  SAFETY_VEST_FOR_DRIVER = "SAFETY_VEST_FOR_DRIVER",
  HYDRAULIC_ARM = "HYDRAULIC_ARM",
  CLAMPING_STRAPS = "CLAMPING_STRAPS",
  SAFETY_SHOES_FOR_DRIVER = "SAFETY_SHOES_FOR_DRIVER",
  HELMET_FOR_DRIVER = "HELMET_FOR_DRIVER",
}

/**
 * * `REFRIGERATED_GOODS` - Refrigerated goods
 * * `FROZEN_GOODS` - Frozen goods
 * * `METAL_GOODS` - Metal goods
 * * `OVERSIZED_LOAD` - Oversized load
 * * `BULK_MATERIAL` - Bulk material
 * * `LOOSE_MATERIAL` - Loose material
 * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
 * * `LIQUIDS` - Liquids
 * * `VEHICLES` - Vehicles
 * * `ADR` - ADR
 * * `OTHER` - Other
 * * `NOT_SPECIFIED` - Not specified
 */
export enum CargoTypeEnum {
  REFRIGERATED_GOODS = "REFRIGERATED_GOODS",
  FROZEN_GOODS = "FROZEN_GOODS",
  METAL_GOODS = "METAL_GOODS",
  OVERSIZED_LOAD = "OVERSIZED_LOAD",
  BULK_MATERIAL = "BULK_MATERIAL",
  LOOSE_MATERIAL = "LOOSE_MATERIAL",
  MACHINES_AND_EQUIPMENT = "MACHINES_AND_EQUIPMENT",
  LIQUIDS = "LIQUIDS",
  VEHICLES = "VEHICLES",
  ADR = "ADR",
  OTHER = "OTHER",
  NOT_SPECIFIED = "NOT_SPECIFIED",
}

export interface Carrier {
  address?: CompanyAddress | null;
  readonly contacts: Contact[];
  readonly id: number;
  /** @maxLength 50 */
  internalId?: string;
  /**
   * Active
   * Designates whether this carrier should be treated as active. Unselect this instead of deleting carriers.
   */
  isActive?: boolean;
  readonly isBlocked: boolean;
  readonly isDeleted: boolean;
  /** Demo data */
  isDemo?: boolean;
  /**
   * Title
   * @maxLength 100
   */
  name: string;
  note?: string;
  /** @maxLength 50 */
  registrationNumber?: string;
  /** @maxLength 50 */
  taxNumber?: string;
  /** @maxLength 50 */
  vatNumber?: string;
  website?: string;
  readonly workspace: WorkspaceGeneralInfo;
}

export enum CarrierAuctionStatusEnum {
  ACTIVE = "ACTIVE",
  WAITING_FOR_ACCEPTATION = "WAITING_FOR_ACCEPTATION",
  CANCELED = "CANCELED",
  SUCCESSFUL = "SUCCESSFUL",
  UNSUCCESSFUL = "UNSUCCESSFUL",
  OTHER = "OTHER",
}

export interface CarrierAuctionsCounts {
  active: number;
  waitingForAcceptation: number;
}

export interface CarrierAvailableSlots {
  /** @format date */
  readonly date: string;
  readonly options: CarrierSlotOption[];
  readonly slotDurationMinutes: number;
  readonly timezoneName: string;
  readonly timezoneResolved: boolean;
}

export interface CarrierBillingDetailsByHashInput {
  city: string;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  /** @format email */
  email: string;
  readonly id: number;
  readonly isApproved: boolean;
  name: string;
  postCode: string;
  registrationNumber?: string | null;
  readonly status: BillingDetailsStatusEnum;
  street: string;
  taxNumber?: string | null;
  vatNumber?: string | null;
}

export interface CarrierBillingDetailsByHashOutput {
  readonly city: string;
  readonly country: CountryEnum;
  /** @format email */
  readonly email: string;
  readonly id: number;
  readonly isApproved: boolean;
  readonly name: string;
  readonly postCode: string;
  readonly registrationNumber: string | null;
  readonly status: BillingDetailsStatusEnum;
  readonly street: string;
  readonly taxNumber: string | null;
  readonly vatNumber: string | null;
}

export interface CarrierBillingDetailsLimited {
  readonly id: number;
  readonly isApproved: boolean;
  registrationNumber?: string | null;
  taxNumber?: string | null;
  vatNumber?: string | null;
}

/**
 * The carrier's own row: the shipper row plus the address's shipper and a portal transport link,
 * null for a booking made through a booking link.
 */
export interface CarrierBooking {
  readonly address: BookingAddressNested;
  readonly bookingLinkHash: string;
  readonly carrierName: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly createdBy: BookingAuthorNested;
  /** @format date-time */
  readonly endAt: string;
  readonly gate: GateNested;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  readonly shipper: WorkspaceGeneralInfo;
  /** @format date-time */
  readonly startAt: string;
  readonly status: TimeSlotBookingListStatusEnum;
  readonly timeZone: string;
  readonly transport: CarrierBookingTransportNested | null;
  readonly vehicleType: VehicleTypeNested | null;
  readonly vehicles: CarrierBookingVehicleNested[];
  readonly waypoint: BookingWaypointNested | null;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

/** The carrier's detail page: the carrier card row plus the detail-only blocks. */
export interface CarrierBookingDetail {
  readonly address: BookingAddressNested;
  readonly bookingLinkHash: string;
  /** A linked booking shows its transport's cargo description as it is now. */
  readonly cargoDescription: string;
  readonly cargoItems: BookingCargoItemNested[];
  readonly carrierName: string;
  /** The transport detail's carrier note; empty for a standalone booking. */
  readonly carrierNote: string;
  contactPersonEmail?: string;
  /** @maxLength 200 */
  contactPersonName?: string;
  /** @maxLength 50 */
  contactPersonPhone?: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly createdBy: BookingAuthorNested;
  /** @format date-time */
  readonly endAt: string;
  readonly gate: GateNested;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  readonly shipper: WorkspaceGeneralInfo;
  /** @format date-time */
  readonly startAt: string;
  readonly status: TimeSlotBookingListStatusEnum;
  readonly timeZone: string;
  readonly transport: CarrierBookingTransportDetailNested | null;
  readonly vehicleType: VehicleTypeNested | null;
  readonly vehicles: BookingVehicleNested[];
  readonly waypoint: BookingWaypointNested | null;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

/** The shared detail block plus the portal's two hashes. */
export interface CarrierBookingTransportDetailNested {
  readonly cargo: BookingTransportCargoNested;
  /** Only the portal needs it; a by-hash page already holds its own contact hash. */
  readonly contactHash: string;
  readonly displayId: string;
  /** @format double */
  readonly distance: number | null;
  readonly hash: string;
  readonly id: number;
  readonly incoterms: IncotermsEnum;
  readonly transportationMode: TransportationModeEnum;
  readonly waypoints: BookingRouteWaypointNested[];
}

/** The portal opens a transport through its auction, so the link needs both hashes, not the id. */
export interface CarrierBookingTransportNested {
  /** Only the portal needs it; a by-hash page already holds its own contact hash. */
  readonly contactHash: string;
  readonly displayId: string;
  readonly hash: string;
  readonly id: number;
}

/**
 * No ``driver_phone``: the carrier shape exposed plate and driver name only before the child
 * table landed, and widening it is a separate decision.
 */
export interface CarrierBookingVehicleNested {
  /** @maxLength 255 */
  driverName?: string;
  readonly id: number;
  /**
   * @min 0
   * @max 32767
   */
  index?: number;
  /** @maxLength 255 */
  plateNumber?: string;
}

export interface CarrierByHashBillingDetails {
  city?: string | null;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  /**
   * @format email
   * @maxLength 254
   */
  email: string;
  readonly id: number;
  readonly isApproved: boolean;
  /** @maxLength 100 */
  name: string;
  /** @maxLength 20 */
  postCode?: string;
  registrationNumber?: string | null;
  readonly status: BillingDetailsStatusEnum;
  /** @maxLength 100 */
  street?: string;
  taxNumber?: string | null;
  vatNumber?: string | null;
}

/**
 * Carrier-facing contact-person card returned by both carrier-tender
 * and carrier-contract detail endpoints. The `is_responsible` flag marks
 * the tender's responsible user; followers carry False.
 */
export interface CarrierContactPerson {
  /** @format email */
  readonly email: string;
  readonly fullName: string;
  /** @default false */
  readonly isResponsible: boolean;
  readonly phoneNumber: string | null;
}

export interface CarrierContactsDestroyParams {
  /** A unique integer value identifying this contact. */
  id: number;
}

export interface CarrierContactsListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface CarrierContactsPartialUpdateParams {
  /** A unique integer value identifying this contact. */
  id: number;
}

export interface CarrierContactsRetrieveParams {
  /** A unique integer value identifying this contact. */
  id: number;
}

export interface CarrierContactsUpdateParams {
  /** A unique integer value identifying this contact. */
  id: number;
}

export interface CarrierContractDetail {
  readonly acceptedOffersCount: number;
  readonly contactPersons: CarrierContactPerson[];
  readonly currency: string;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  /** @maxLength 150 */
  readonly name: string;
  readonly priceCategories: ContractPriceCategory[];
  readonly priceKind: TenderPriceKindEnum;
  readonly pricingMode: TenderPricingModeEnum | null;
  readonly status: ContractStatusEnum;
  readonly tenderHash: string;
  readonly tenderId: number;
  readonly tenderLink: CarrierContractTenderLink | null;
  readonly tenderName: string;
  readonly transportationMode: TransportationModeEnum;
  /** @format date */
  readonly validFrom: string;
  /** @format date */
  readonly validTo: string;
  readonly workspace: WorkspaceGeneralInfo;
}

export interface CarrierContractList {
  readonly acceptedOffersCount: number;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  /** @maxLength 150 */
  readonly name: string;
  readonly status: ContractStatusEnum;
  readonly tenderHash: string;
  readonly tenderId: number;
  readonly tenderLink: CarrierContractTenderLink | null;
  readonly tenderName: string;
  readonly transportationMode: TransportationModeEnum;
  /** @format date */
  readonly validFrom: string;
  /** @format date */
  readonly validTo: string;
  readonly workspace: WorkspaceGeneralInfo;
}

/** Target of the "linked tender" link — serialized as null when the tender is unreachable. */
export interface CarrierContractTenderLink {
  readonly hash: string;
  readonly id: number;
}

export interface CarrierContractsPricesRetrieveParams {
  /** Hash key */
  hash: string;
}

export enum CarrierContractsRoutesAutocompleteFieldEnum {
  City = "city",
  PostCode = "post_code",
  Street = "street",
}

export interface CarrierContractsRoutesAutocompleteParams {
  /**
   * * `city` - city
   * * `post_code` - post_code
   * * `street` - street
   */
  field: CarrierContractsRoutesAutocompleteFieldEnum;
  /** Hash key */
  hash: string;
  /** @minLength 1 */
  term: string;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

export enum CarrierContractsRoutesListOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
}

export interface CarrierContractsRoutesListParams {
  /** Hash key */
  hash: string;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   */
  order?: CarrierContractsRoutesListOrderEnum[];
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Responsible person */
  responsiblePerson?: string;
  /** A search term. */
  search?: string;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum[];
  workspace?: string;
}

export interface CarrierCostsStats {
  totalByInterval: TotalByIntervalStats[];
}

export interface CarrierCreate {
  address?: CompanyAddress | null;
  billingDetails?: CarrierBillingDetailsLimited;
  contact: ContactCreate;
  /** @maxLength 50 */
  internalId?: string;
  /**
   * Title
   * @maxLength 100
   */
  name: string;
  note?: string;
  /** @maxLength 50 */
  registrationNumber?: string;
  /** @maxLength 50 */
  taxNumber?: string;
  /** @maxLength 50 */
  vatNumber?: string;
  website?: string;
}

export interface CarrierCreateFirstStep {
  address?: CompanyAddress | null;
  billingDetails?: CarrierBillingDetailsLimited;
  /** @maxLength 50 */
  internalId?: string;
  /**
   * Title
   * @maxLength 100
   */
  name: string;
  note?: string;
  /** @maxLength 50 */
  registrationNumber?: string;
  /** @maxLength 50 */
  taxNumber?: string;
  /** @maxLength 50 */
  vatNumber?: string;
  website?: string;
}

export interface CarrierDocumentCreate {
  /**
   * Document
   * file
   * @format uri
   */
  file: string;
  /**
   * Name
   * @maxLength 200
   */
  title: string;
}

export interface CarrierGeneralInfo {
  readonly contacts: ContactGeneralInfo[];
  readonly id: number;
  /**
   * Active
   * Designates whether this carrier should be treated as active. Unselect this instead of deleting carriers.
   */
  isActive?: boolean;
  readonly isBlocked: boolean;
  /** Demo data */
  isDemo?: boolean;
  /**
   * Title
   * @maxLength 100
   */
  name: string;
}

export interface CarrierGroup {
  contacts: number[];
  /** @format date-time */
  readonly createdAt: string;
  readonly createdBy: UserGeneralInfo;
  readonly id: number;
  /** @maxLength 255 */
  name: string;
  note?: string;
  /** @format date-time */
  readonly updatedAt: string;
  readonly workspace: WorkspaceGeneralInfo;
}

export interface CarrierGroupGeneralInfo {
  contacts: number[];
  id?: number | null;
  /** @maxLength 255 */
  name: string;
}

export interface CarrierGroupsAllListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
}

export interface CarrierGroupsDestroyParams {
  /** A unique integer value identifying this carrier group. */
  id: number;
}

export interface CarrierGroupsListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface CarrierGroupsPartialUpdateParams {
  /** A unique integer value identifying this carrier group. */
  id: number;
}

export interface CarrierGroupsRetrieveParams {
  /** A unique integer value identifying this carrier group. */
  id: number;
}

export interface CarrierGroupsUpdateParams {
  /** A unique integer value identifying this carrier group. */
  id: number;
}

/** A single carrier history offer for a matrix cell. */
export interface CarrierHistoryOfferCell {
  readonly carrierStatus: CarrierOfferCarrierStatusEnum;
  readonly categoryId: number;
  /** @format email */
  readonly email: string;
  /** @format date-time */
  readonly historyDate: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly priceValue: string;
  readonly priceValueCurrency: CurrencyEnum;
  readonly routeId: number;
}

export interface CarrierInfo {
  readonly id: number;
  readonly internalId: string;
  readonly isDeleted: boolean;
  readonly name: string;
}

export interface CarrierMessage {
  carrier: TimelineCarrier;
  readonly contactHash: string;
  content?: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly data: MessageData;
  readonly event: MessageEventEnum;
  readonly id: number;
  readonly objectWorkspace: WorkspaceGeneralInfo;
  reference: Reference;
  /** @format date-time */
  readonly seenAt: string;
  readonly sender: GenericSender;
  readonly type: MessageTypeEnum;
  unreadCount: number;
}

export interface CarrierOfferBulkSave {
  offers: CarrierOfferEntry[];
}

export interface CarrierOfferBulkSubmit {
  offers?: CarrierOfferEntry[];
}

/**
 * * `DRAFT` - Draft
 * * `SUBMITTED` - Submitted
 * * `ACCEPTED` - Accepted
 * * `REJECTED` - Rejected
 * * `REMOVED` - Removed
 */
export enum CarrierOfferCarrierStatusEnum {
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REMOVED = "REMOVED",
}

export interface CarrierOfferCell {
  readonly carrierStatus: CarrierOfferCarrierStatusEnum;
  readonly categoryId: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly priceValue: string;
  readonly priceValueCurrency: CurrencyEnum;
  readonly routeId: number;
}

export interface CarrierOfferEntry {
  categoryId: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  priceValue: string | null;
  routeId: number;
}

/**
 * * `PENDING` - Pending
 * * `ACCEPTED` - Accepted
 * * `REJECTED` - Rejected
 */
export enum CarrierOfferShipperDecisionEnum {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

/**
 * No gates and no status: the collapse means a missing start only says every eligible gate is
 * busy, and conflict detail is the shipper's.
 */
export interface CarrierSlotOption {
  /** @format time */
  readonly startTime: string;
}

export interface CarrierStats {
  name: string;
  /** @format double */
  totalDistance: number;
  /** @format double */
  totalPrice: number;
  transportCount: number;
}

export interface CarrierStatsCostsRetrieveParams {
  /** @format date */
  createdAtAfter?: string;
  /** @format date */
  createdAtBefore?: string;
  /** A unique integer value identifying this carrier. */
  id: number;
  interval?: IntervalEnum;
}

export interface CarrierStatsOverviewRetrieveParams {
  city?: string;
  contactEmail?: string;
  country?: string;
  /** @format date */
  createdAtAfter?: string;
  /** @format date */
  createdAtBefore?: string;
  name?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** @default 1 */
  page?: number;
  /** @default 20 */
  pageSize?: number;
  postCode?: string;
  /** A search term. */
  search?: string;
  street?: string;
}

export interface CarrierStatsResponse {
  id: number;
  /** @format decimal */
  lossPriceDiff: string;
  name: string;
  /** @format double */
  participationRate: number;
  /** @format double */
  rejectionRate: number;
  requests: number;
  transports: number;
  /** @format decimal */
  winPriceDiff: string;
  /** @format double */
  winRate: number;
}

export interface CarrierTender {
  readonly contactHash: string;
  readonly contactPersons: CarrierContactPerson[];
  readonly currency: CurrencyEnum;
  /** @format date-time */
  readonly deadline: string | null;
  /** @format date-time */
  readonly deletedAt: string | null;
  readonly description: string;
  /** @default false */
  readonly hasDraftOffer: boolean;
  /** @default false */
  readonly hasProposal: boolean;
  /** @default false */
  readonly hasSentOffer: boolean;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  readonly isOpenForSubmissions: boolean;
  /** @format date-time */
  readonly lastSavedAt: string | null;
  /** @format email */
  readonly lastSavedByEmail: string | null;
  /** @maxLength 150 */
  readonly name: string;
  readonly offersFilled: number;
  readonly offersTotal: number;
  readonly priceKind: TenderPriceKindEnum;
  readonly pricingMode: TenderPricingModeEnum | null;
  readonly status: TenderDisplayStatusEnum;
  readonly transportationMode: TransportationModeEnum;
  /** @format date */
  readonly validFrom: string;
  /** @format date */
  readonly validTo: string;
  readonly workspace: WorkspaceGeneralInfo;
}

export interface CarrierTenderList {
  /** @format date-time */
  readonly deadline: string | null;
  /** @default false */
  readonly hasDraftOffer: boolean;
  /** @default false */
  readonly hasProposal: boolean;
  /** @default false */
  readonly hasSentOffer: boolean;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  readonly isOpenForSubmissions: boolean;
  /** @format date-time */
  readonly lastSavedAt: string | null;
  /** @format email */
  readonly lastSavedByEmail: string | null;
  /** @maxLength 150 */
  readonly name: string;
  readonly offersFilled: number;
  readonly offersTotal: number;
  readonly status: TenderDisplayStatusEnum;
  readonly transportationMode: TransportationModeEnum;
  /** @format date */
  readonly validFrom: string;
  /** @format date */
  readonly validTo: string;
  readonly workspace: WorkspaceGeneralInfo;
}

export interface CarrierTenderPriceOffers {
  readonly offers: CarrierOfferCell[];
}

export enum CarrierTendersCategoriesRetrieveOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
}

export interface CarrierTendersCategoriesRetrieveParams {
  /** Hash key */
  hash: string;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   */
  order?: CarrierTendersCategoriesRetrieveOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Participated */
  participated?: boolean;
  /** Responsible person */
  responsiblePerson?: string;
  /** A search term. */
  search?: string;
  /**
   * Status
   *
   * * `DRAFT` - Draft
   * * `OPEN` - Open
   * * `EVALUATING` - Evaluating
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   */
  tenderDisplayStatus?: TenderDisplayStatusEnum;
  /** Tender ID */
  tenderId?: number;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum[];
  workspace?: string;
}

export interface CarrierTendersConfirmedContractRetrieveParams {
  /** Hash key */
  hash: string;
}

export interface CarrierTendersContractProposalRetrieveParams {
  /** Hash key */
  hash: string;
}

export enum CarrierTendersHistoryOffersRetrieveOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
}

export interface CarrierTendersHistoryOffersRetrieveParams {
  /** Hash key */
  hash: string;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   */
  order?: CarrierTendersHistoryOffersRetrieveOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Participated */
  participated?: boolean;
  /** Responsible person */
  responsiblePerson?: string;
  /** A search term. */
  search?: string;
  /**
   * Status
   *
   * * `DRAFT` - Draft
   * * `OPEN` - Open
   * * `EVALUATING` - Evaluating
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   */
  tenderDisplayStatus?: TenderDisplayStatusEnum;
  /** Tender ID */
  tenderId?: number;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum[];
  workspace?: string;
}

export interface CarrierTendersOffersRetrieveParams {
  /** Hash key */
  hash: string;
}

export interface CarrierTendersProposalAcceptParams {
  /** Hash key */
  hash: string;
}

export interface CarrierTendersProposalRejectParams {
  /** Hash key */
  hash: string;
}

export enum CarrierTendersRoutesRetrieveOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
}

export interface CarrierTendersRoutesRetrieveParams {
  /** Hash key */
  hash: string;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   */
  order?: CarrierTendersRoutesRetrieveOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Participated */
  participated?: boolean;
  /** Responsible person */
  responsiblePerson?: string;
  /** A search term. */
  search?: string;
  /**
   * Status
   *
   * * `DRAFT` - Draft
   * * `OPEN` - Open
   * * `EVALUATING` - Evaluating
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   */
  tenderDisplayStatus?: TenderDisplayStatusEnum;
  /** Tender ID */
  tenderId?: number;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum[];
  workspace?: string;
}

export interface CarrierTransportsCounts {
  bookingRequired: number;
}

export interface CarrierUpdate {
  address?: CompanyAddress | null;
  readonly id: number;
  /** @maxLength 50 */
  internalId?: string;
  /**
   * Active
   * Designates whether this carrier should be treated as active. Unselect this instead of deleting carriers.
   */
  isActive?: boolean;
  /**
   * Title
   * @maxLength 100
   */
  name: string;
  note?: string;
  /** @maxLength 50 */
  registrationNumber?: string;
  /** @maxLength 50 */
  taxNumber?: string;
  /** @maxLength 50 */
  vatNumber?: string;
  website?: string;
}

export interface CarriersAllListParams {
  city?: string;
  contactEmail?: string;
  country?: string;
  name?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  postCode?: string;
  /** A search term. */
  search?: string;
  street?: string;
}

export interface CarriersContactsListParams {
  /** A unique integer value identifying this carrier. */
  id: number;
  /** Filter contacts by transportation mode. Contacts with no modes set are always included. */
  transportationMode?: TransportationModeEnum;
}

export interface CarriersDestroyParams {
  /** A unique integer value identifying this carrier. */
  id: number;
}

export interface CarriersIsActivePartialUpdateParams {
  /** A unique integer value identifying this carrier. */
  id: number;
}

export interface CarriersListParams {
  city?: string;
  contactEmail?: string;
  country?: string;
  name?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  postCode?: string;
  /** A search term. */
  search?: string;
  street?: string;
}

export interface CarriersPartialUpdateParams {
  /** A unique integer value identifying this carrier. */
  id: number;
}

export interface CarriersRetrieveParams {
  /** A unique integer value identifying this carrier. */
  id: number;
}

export interface CarriersUpdateParams {
  /** A unique integer value identifying this carrier. */
  id: number;
}

export interface ChatBot {
  inputText: string;
}

export interface CheckoutRequestData {
  auctionId: number;
}

export interface CheckoutResponseData {
  error?: string | null;
  sessionId: string | null;
  sessionUrl?: string | null;
}

export interface CofaceCompanyInfoResponse {
  city?: string | null;
  cofaceCompanyId?: string | null;
  cofaceCompanyName?: string | null;
  country?: string | null;
  nationalId?: string | null;
  postcode?: string | null;
  regId?: string | null;
  street?: string | null;
  taxId?: string | null;
  vatId?: string | null;
}

/**
 * * `red` - Red
 * * `yellow` - Yellow
 * * `green` - Green
 * * `blue` - Blue
 * * `purple` - Purple
 * * `neutral` - Grey
 */
export enum ColorEnum {
  Red = "red",
  Yellow = "yellow",
  Green = "green",
  Blue = "blue",
  Purple = "purple",
  Neutral = "neutral",
}

export interface CombinedOverviewStats {
  auctions: OverviewStats;
  transports: TransportOverviewStats;
}

export interface CompanyAddress {
  city?: string | null;
  country?: CountryEnum | null;
  readonly createdBy: UserGeneralInfo;
  readonly id: number;
  /** @maxLength 20 */
  postCode?: string;
  /** @maxLength 100 */
  street?: string;
}

export interface CompanyInfoPayload {
  companyName?: string | null;
  country: string | null;
  externalId?: string | null;
  insuranceStatusCheck?: boolean;
  vatId?: string | null;
}

/** Which booking holds a gate, for a shipper judging a conflict. Never rendered for a carrier. */
export interface ConflictingBookingNested {
  readonly carrierName: string;
  /** @format date-time */
  readonly endAt: string;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  /** @format date-time */
  readonly startAt: string;
  readonly status: ConflictingBookingNestedStatusEnum;
}

/**
 * * `PENDING` - Pending
 * * `WITHDRAWN` - Withdrawn
 * * `APPROVED` - Approved
 * * `REJECTED` - Rejected
 * * `ARRIVED` - Arrived
 * * `CANCELED` - Canceled
 * * `COMPLETED` - Completed
 */
export enum ConflictingBookingNestedStatusEnum {
  PENDING = "PENDING",
  WITHDRAWN = "WITHDRAWN",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  ARRIVED = "ARRIVED",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
}

export interface ConsentByTokenInput {
  accepted?: boolean;
  /**
   * * `EMAIL` - Email
   * * `PRICER_POPUP` - Pricer popup
   */
  consentType: ConsentTypesEnum;
  objectRef: string;
  rejected?: boolean;
}

export interface ConsentByTokenSetOutput {
  consents: ConsentOutput[];
  contactHash?: string;
  displayAcceptPopup?: boolean;
  /** @format email */
  email: string;
  targetObjectRef?: string;
}

export interface ConsentInfo {
  /**
   * * `EMAIL` - Email
   * * `PRICER_POPUP` - Pricer popup
   */
  consentType: ConsentTypesEnum;
  isGained: boolean;
  isRequired: boolean;
  /**
   * * `ACCEPTED_GLOBALLY` - Accepted globally
   * * `REJECTED_GLOBALLY` - Rejected globally
   * * `ACCEPTED_FOR_WORKSPACE` - Accepted for workspace
   * * `REJECTED_FOR_WORKSPACE` - Rejected for workspace
   * * `ACCEPTED_AUTOMATICALLY_FROM_SETTINGS` - Accepted automatically based on settings
   * * `TOO_MANY_REQUESTS` - Too many requests
   * * `REQUESTED` - Requested
   * * `NOT_REQUESTED` - No request sent yet
   * * `OTHER` - Other
   */
  reason: ConsentInfoReasonEnum;
}

/**
 * * `ACCEPTED_GLOBALLY` - Accepted globally
 * * `REJECTED_GLOBALLY` - Rejected globally
 * * `ACCEPTED_FOR_WORKSPACE` - Accepted for workspace
 * * `REJECTED_FOR_WORKSPACE` - Rejected for workspace
 * * `ACCEPTED_AUTOMATICALLY_FROM_SETTINGS` - Accepted automatically based on settings
 * * `TOO_MANY_REQUESTS` - Too many requests
 * * `REQUESTED` - Requested
 * * `NOT_REQUESTED` - No request sent yet
 * * `OTHER` - Other
 */
export enum ConsentInfoReasonEnum {
  ACCEPTED_GLOBALLY = "ACCEPTED_GLOBALLY",
  REJECTED_GLOBALLY = "REJECTED_GLOBALLY",
  ACCEPTED_FOR_WORKSPACE = "ACCEPTED_FOR_WORKSPACE",
  REJECTED_FOR_WORKSPACE = "REJECTED_FOR_WORKSPACE",
  ACCEPTED_AUTOMATICALLY_FROM_SETTINGS = "ACCEPTED_AUTOMATICALLY_FROM_SETTINGS",
  TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
  REQUESTED = "REQUESTED",
  NOT_REQUESTED = "NOT_REQUESTED",
  OTHER = "OTHER",
}

export interface ConsentOutput {
  consentStatuses: ConsentInfo[];
  objectRef: string;
  workspace: WorkspaceGeneralInfo;
}

/**
 * * `EMAIL` - Email
 * * `PRICER_POPUP` - Pricer popup
 */
export enum ConsentTypesEnum {
  EMAIL = "EMAIL",
  PRICER_POPUP = "PRICER_POPUP",
}

export interface ConsentsSettings {
  /**
   * * `EMAIL` - Email
   * * `PRICER_POPUP` - Pricer popup
   */
  consentType: ConsentTypesEnum;
  isAccepted: boolean;
  /** * `EMAIL_SUBSCRIPTION_AUTOMATIC` - Auto email subscription */
  settingsType: ConsentsSettingsSettingsTypeEnum;
}

/** * `EMAIL_SUBSCRIPTION_AUTOMATIC` - Auto email subscription */
export enum ConsentsSettingsSettingsTypeEnum {
  EMAIL_SUBSCRIPTION_AUTOMATIC = "EMAIL_SUBSCRIPTION_AUTOMATIC",
}

export interface Contact {
  carrier?: number;
  readonly carrierContactsCount: number;
  readonly carrierIsBlocked: boolean;
  readonly carrierName: string;
  readonly consentStatuses: ConsentInfo[];
  /**
   * Contact email
   * @format email
   * @maxLength 254
   */
  email: string;
  /** @maxLength 50 */
  fullName?: string;
  groups?: number[];
  readonly id: number;
  /** @maxLength 128 */
  phoneNumber?: string;
  readonly preferredLanguage: LanguageEnum;
  transportationModes?: TransportationModeEnum[];
}

/**
 * Mixin for serializers that need to include a `terms_data` field.
 *
 * Usage:
 *     class MySerializer(TermsDataMixin, ModelSerializer):
 *         terms_data = serializers.SerializerMethodField()
 *
 *         def get_terms_data(self, obj):
 *             return self.build_terms_data(email=obj.email, contact=obj)
 */
export interface ContactByHash {
  readonly billingDetails: CarrierByHashBillingDetails;
  readonly billingDetailsCandidate: CarrierByHashBillingDetails;
  /** @format email */
  readonly email: string;
  /** Hash key */
  readonly hash: string;
  readonly internalId: string;
  readonly preferredLanguage: LanguageEnum;
  readonly termsData: TermsData;
  readonly transportOrderDownloadAllowed: boolean;
  readonly unpaidInvoices: UnpaidInvoices;
}

export interface ContactCreate {
  carrier?: number;
  readonly carrierContactsCount: number;
  readonly carrierIsBlocked: boolean;
  readonly carrierName: string;
  readonly consentStatuses: ConsentInfo[];
  /**
   * Contact email
   * @format email
   * @maxLength 254
   */
  email: string;
  /** @maxLength 50 */
  fullName?: string;
  groups?: number[];
  readonly id: number;
  /** @maxLength 128 */
  phoneNumber?: string;
  /**
   * * `en` - English
   * * `sk` - Slovak
   * * `de` - German
   * * `fr` - French
   * * `it` - Italian
   * * `cs` - Czech
   * * `es` - Spain
   */
  preferredLanguage?: LanguageEnum;
  transportationModes?: TransportationModeEnum[];
}

export interface ContactGeneralInfo {
  readonly consentStatuses: ConsentInfo[];
  /**
   * Contact email
   * @format email
   * @maxLength 254
   */
  email: string;
  /** @maxLength 50 */
  fullName?: string;
  groups: number[];
  readonly id: number;
  /** @maxLength 128 */
  phoneNumber?: string;
  transportationModes?: TransportationModeEnum[];
}

export interface ContractAcceptedByCarrier {
  /** Hash key */
  readonly hash: string;
  /** @maxLength 150 */
  readonly name: string;
}

export interface ContractAction {
  readonly id: number;
  readonly status: ContractStatusEnum;
}

export interface ContractCarrierContact {
  /** @format email */
  readonly email: string;
  readonly fullName: string;
  readonly id: number;
}

export interface ContractDetail {
  readonly carrier: ContractDetailCarrier;
  readonly contractedPrices: number;
  readonly id: number;
  /** @maxLength 150 */
  readonly name: string;
  readonly priceCategories: ContractPriceCategory[];
  readonly status: ContractStatusEnum;
  readonly tender: ContractDetailTender;
  readonly tenderDisplayStatus: TenderDisplayStatusEnum;
  readonly tenderId: number;
  readonly tenderLink: ContractTenderLink | null;
  readonly transportationMode: TransportationModeEnum;
  /** @format date */
  readonly validFrom: string;
  /** @format date */
  readonly validTo: string;
}

export interface ContractDetailCarrier {
  readonly contacts: ContractCarrierContact[];
  readonly id: number;
  readonly name: string;
}

export interface ContractDetailTender {
  readonly id: number;
  readonly name: string;
  readonly pricingMode: TenderPricingModeEnum | null;
  readonly responsibleUser: UserGeneralInfo | null;
}

export interface ContractFilterOption {
  readonly id: number;
  readonly name: string;
}

export interface ContractList {
  carrier: ContractListCarrier;
  readonly contractedPrices: number;
  readonly id: number;
  /** @maxLength 150 */
  name: string;
  readonly status: ContractStatusEnum;
  readonly tenderDisplayStatus: TenderDisplayStatusEnum;
  readonly tenderId: number;
  readonly tenderLink: ContractTenderLink | null;
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
  /** @format date */
  validFrom: string;
  /** @format date */
  validTo: string;
}

export interface ContractListCarrier {
  readonly id: number;
  /**
   * Title
   * @maxLength 100
   */
  readonly name: string;
}

export interface ContractOptionEvaluation {
  contractOptionId: number;
  overall: string;
  verdicts: CriterionVerdict[];
}

/** One row in the cross-contract options table — an agreed ContractPrice with carrier context. */
export interface ContractOptionRow {
  readonly carrierId: number;
  readonly carrierIsBlocked: boolean;
  readonly carrierName: string;
  readonly contractId: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly effectivePrice: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly effectivePriceWorkspace: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly minPrice: string | null;
  readonly minPriceCurrency: CurrencyEnum | null;
  readonly offerId: number;
  readonly priceCategoryId: number;
  readonly priceCategoryName: string;
  readonly priceKind: TenderPriceKindEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly pricePerKm: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly pricePerKmWorkspace: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly priceValue: string;
  readonly priceValueCurrency: CurrencyEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly priceValueWorkspace: string;
  readonly priceValueWorkspaceCurrency: CurrencyEnum | null;
  readonly routeId: number;
  readonly routeIdentifier: string;
  readonly transportationMode: TransportationModeEnum;
  readonly waypoints: ContractRouteWaypoint[];
}

export interface ContractOptionsFilters {
  readonly carriers: ContractFilterOption[];
  readonly priceCategories: ContractFilterOption[];
  readonly routes: ContractFilterOption[];
}

/** A single tender price category column, as referenced from a contract. */
export interface ContractPriceCategory {
  readonly id: number;
  readonly name: string;
}

/** Without carrier_status — a snapshot has no negotiation state. */
export interface ContractPriceCell {
  readonly categoryId: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly priceValue: string;
  readonly priceValueCurrency: CurrencyEnum;
  readonly routeId: number;
}

/**
 * Agreed prices on a contract.
 *
 * ContractProposalSerializer still serves the pending-proposal endpoint: no contract, and so no
 * ContractPrice, exists until the carrier accepts.
 */
export interface ContractPrices {
  readonly id: number | null;
  readonly offers: ContractPriceCell[];
  /** @format date */
  readonly validFrom: string;
  /** @format date */
  readonly validTo: string;
}

export interface ContractProposal {
  readonly id: number | null;
  readonly offers: CarrierOfferCell[];
  /** @format date */
  readonly validFrom: string;
  /** @format date */
  readonly validTo: string;
}

export interface ContractProposalDetail {
  readonly carrierId: number;
  readonly carrierName: string;
  readonly offers: ContractProposalOffer[];
  readonly pricingMode: TenderPricingModeEnum;
  /** @format date-time */
  readonly proposedAt: string;
  readonly transportationMode: TransportationModeEnum;
  /** @format date */
  readonly validFrom: string;
  /** @format date */
  readonly validTo: string;
}

export interface ContractProposalList {
  readonly carrierId: number;
  readonly carrierName: string;
  readonly offersCount: number;
  /** @format date-time */
  readonly proposedAt: string;
  readonly transportationMode: TransportationModeEnum;
}

export interface ContractProposalOffer {
  readonly carrierStatus: CarrierOfferCarrierStatusEnum;
  readonly categoryId: number;
  readonly categoryName: string;
  readonly id: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly minPrice: string | null;
  readonly priceKind: TenderPriceKindEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly priceValue: string;
  readonly priceValueCurrency: CurrencyEnum;
  readonly routeId: number;
  /** @default "" */
  readonly routeIdentifier: string;
  readonly shipperStatus: CarrierOfferShipperDecisionEnum;
  readonly waypoints: TenderRouteItem[];
}

/** One row in the contract routes table — an agreed ContractPrice joined with route + category data. */
export interface ContractRouteRow {
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly minPrice: string | null;
  readonly minPriceCurrency: CurrencyEnum | null;
  readonly offerId: number;
  readonly priceCategoryId: number;
  readonly priceCategoryName: string;
  readonly priceKind: TenderPriceKindEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly priceValue: string;
  readonly priceValueCurrency: CurrencyEnum;
  readonly routeId: number;
  readonly routeIdentifier: string;
  readonly transportationMode: TransportationModeEnum;
  readonly waypoints: ContractRouteWaypoint[];
}

export interface ContractRouteWaypoint {
  readonly addressCity: string;
  readonly addressCountry: string;
  readonly addressPostCode: string;
  readonly addressStreet: string;
  readonly position: number;
  readonly routeItemType: WaypointTypeEnum;
}

/**
 * * `SCHEDULED` - Scheduled
 * * `ACTIVE` - Active
 * * `EXPIRED` - Expired
 * * `CANCELED` - Canceled
 */
export enum ContractStatusEnum {
  SCHEDULED = "SCHEDULED",
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  CANCELED = "CANCELED",
}

/** Target of the "linked tender" link — serialized as null when the tender is unreachable. */
export interface ContractTenderLink {
  readonly id: number;
}

export interface ContractsCancelParams {
  id: number;
}

export interface ContractsListParams {
  /** Carrier name */
  carrierName?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Responsible person */
  responsibleUser?: number;
  /** A search term. */
  search?: string;
  /**
   * Status
   *
   * * `SCHEDULED` - Scheduled
   * * `ACTIVE` - Active
   * * `EXPIRED` - Expired
   * * `CANCELED` - Canceled
   */
  status?: ContractStatusEnum;
  /** Tender name */
  tenderName?: string;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
  /**
   * Valid from
   * @format date
   */
  validFromAfter?: string;
  /**
   * Valid from
   * @format date
   */
  validFromBefore?: string;
  /**
   * Valid to
   * @format date
   */
  validToAfter?: string;
  /**
   * Valid to
   * @format date
   */
  validToBefore?: string;
}

export interface ContractsMatchingEvaluateCreateParams {
  /** Carrier */
  carrierId?: number;
  /** Carrier name */
  carrierName?: string;
  /** Delivery city */
  deliveryCity?: string;
  /** Delivery country */
  deliveryCountry?: string;
  /** Delivery post code */
  deliveryPostCode?: string;
  /** Delivery street */
  deliveryStreet?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Pickup city */
  pickupCity?: string;
  /** Pickup country */
  pickupCountry?: string;
  /** Pickup post code */
  pickupPostCode?: string;
  /** Pickup street */
  pickupStreet?: string;
  /** Price category */
  priceCategoryId?: number;
  /** Route */
  routeId?: number;
  /** Route identifier */
  routeIdentifier?: string;
  /** A search term. */
  search?: string;
}

export enum ContractsOptionsAutocompleteFieldEnum {
  City = "city",
  PostCode = "post_code",
  Street = "street",
}

export interface ContractsOptionsAutocompleteParams {
  /** @format date */
  date: string;
  /** @format date */
  dateEnd?: string;
  /**
   * * `city` - city
   * * `post_code` - post_code
   * * `street` - street
   */
  field: ContractsOptionsAutocompleteFieldEnum;
  /** @minLength 1 */
  term: string;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

export interface ContractsOptionsFiltersParams {
  /** @format date */
  date: string;
  /** @format date */
  dateEnd?: string;
}

export interface ContractsOptionsListParams {
  /** Carrier */
  carrierId?: number;
  /** Carrier name */
  carrierName?: string;
  /**
   * Start date for active contract filtering (YYYY-MM-DD).
   * @format date
   */
  date: string;
  /**
   * End date for active contract filtering (YYYY-MM-DD). Defaults to date when omitted.
   * @format date
   */
  dateEnd?: string;
  /** Delivery city */
  deliveryCity?: string;
  /** Delivery country */
  deliveryCountry?: string;
  /** Delivery post code */
  deliveryPostCode?: string;
  /** Delivery street */
  deliveryStreet?: string;
  /**
   * Route distance in km (e.g. 123.45). Required for per-km effective price calculation.
   * @min 0
   * @exclusiveMin true
   */
  distance?: number;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Pickup city */
  pickupCity?: string;
  /** Pickup country */
  pickupCountry?: string;
  /** Pickup post code */
  pickupPostCode?: string;
  /** Pickup street */
  pickupStreet?: string;
  /** Price category */
  priceCategoryId?: number;
  /** Route */
  routeId?: number;
  /** Route identifier */
  routeIdentifier?: string;
  /** Search */
  search?: string;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
}

export interface ContractsRetrieveParams {
  /** A unique integer value identifying this contract. */
  id: number;
}

export enum ContractsRoutesAutocompleteFieldEnum {
  City = "city",
  PostCode = "post_code",
  Street = "street",
}

export interface ContractsRoutesAutocompleteParams {
  /**
   * * `city` - city
   * * `post_code` - post_code
   * * `street` - street
   */
  field: ContractsRoutesAutocompleteFieldEnum;
  /** A unique integer value identifying this contract. */
  id: number;
  /** @minLength 1 */
  term: string;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

export interface ContractsRoutesListParams {
  /** Carrier name */
  carrierName?: string;
  /** A unique integer value identifying this contract. */
  id: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Responsible person */
  responsibleUser?: number;
  /** A search term. */
  search?: string;
  /**
   * Status
   *
   * * `SCHEDULED` - Scheduled
   * * `ACTIVE` - Active
   * * `EXPIRED` - Expired
   * * `CANCELED` - Canceled
   */
  status?: ContractStatusEnum;
  /** Tender name */
  tenderName?: string;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
  /**
   * Valid from
   * @format date
   */
  validFromAfter?: string;
  /**
   * Valid from
   * @format date
   */
  validFromBefore?: string;
  /**
   * Valid to
   * @format date
   */
  validToAfter?: string;
  /**
   * Valid to
   * @format date
   */
  validToBefore?: string;
}

export type ContractsTendersCancelError = Record<string, any>;

export interface ContractsTendersCancelParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export interface ContractsTendersContractProposalDetailParams {
  /** @pattern ^\d+$ */
  carrierId: string;
  /** A unique integer value identifying this tender. */
  id: number;
  /** Filter by route ID */
  routeId?: number;
  /** Filter by vehicle type ID */
  vehicleTypeId?: number;
}

export interface ContractsTendersContractProposalsParams {
  /**
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  /** A unique integer value identifying this tender. */
  id: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
  /**
   * Status
   *
   * * `DRAFT` - Draft
   * * `OPEN` - Open
   * * `EVALUATING` - Evaluating
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   */
  status?: TenderDisplayStatusEnum;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum[];
  /**
   * Valid from
   * @format date
   */
  validFromAfter?: string;
  /**
   * Valid from
   * @format date
   */
  validFromBefore?: string;
  /**
   * Valid to
   * @format date
   */
  validToAfter?: string;
  /**
   * Valid to
   * @format date
   */
  validToBefore?: string;
}

export interface ContractsTendersContractsParams {
  /**
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  /** A unique integer value identifying this tender. */
  id: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
  /**
   * Status
   *
   * * `DRAFT` - Draft
   * * `OPEN` - Open
   * * `EVALUATING` - Evaluating
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   */
  status?: TenderDisplayStatusEnum;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum[];
  /**
   * Valid from
   * @format date
   */
  validFromAfter?: string;
  /**
   * Valid from
   * @format date
   */
  validFromBefore?: string;
  /**
   * Valid to
   * @format date
   */
  validToAfter?: string;
  /**
   * Valid to
   * @format date
   */
  validToBefore?: string;
}

export interface ContractsTendersCountsParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export type ContractsTendersDestroyError = Record<string, any>;

export interface ContractsTendersDestroyParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export interface ContractsTendersDocumentsListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  tenderPk: number;
}

export interface ContractsTendersFiltersRetrieveParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export type ContractsTendersFinishError = Record<string, any>;

export interface ContractsTendersFinishParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export interface ContractsTendersListParams {
  /**
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  search?: string;
  /**
   * Status
   *
   * * `DRAFT` - Draft
   * * `OPEN` - Open
   * * `EVALUATING` - Evaluating
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   */
  status?: TenderDisplayStatusEnum;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum[];
  /**
   * Valid from
   * @format date
   */
  validFromAfter?: string;
  /**
   * Valid from
   * @format date
   */
  validFromBefore?: string;
  /**
   * Valid to
   * @format date
   */
  validToAfter?: string;
  /**
   * Valid to
   * @format date
   */
  validToBefore?: string;
}

export interface ContractsTendersMessagesCarriersListParams {
  carrier?: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
  tenderPk: number;
}

export interface ContractsTendersMessagesCreateParams {
  tenderPk: number;
}

export interface ContractsTendersMessagesListParams {
  carrier?: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  tenderPk: number;
}

export interface ContractsTendersMessagesMarkAsReadCreateParams {
  tenderPk: number;
}

export interface ContractsTendersMessagesUnreadCountRetrieveParams {
  tenderPk: number;
}

export interface ContractsTendersOfferExportParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export interface ContractsTendersOverviewParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export interface ContractsTendersPriceOffersParams {
  carrierId?: number;
  deliveryCity?: string;
  deliveryCountry?: string;
  deliveryPostCode?: string;
  /** A unique integer value identifying this tender. */
  id: number;
  page?: number;
  pageSize?: number;
  participated?: boolean;
  pickupCity?: string;
  pickupCountry?: string;
  pickupPostCode?: string;
  priceCategoryId?: number;
}

export type ContractsTendersProposeContractError = Record<string, any>;

export interface ContractsTendersProposeContractParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export type ContractsTendersPublishError = Record<string, any>;

export interface ContractsTendersPublishParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export interface ContractsTendersRetrieveParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export type ContractsTendersRevertContractProposalsError = Record<string, any>;

export interface ContractsTendersRevertContractProposalsParams {
  /** @pattern ^\d+$ */
  carrierId: string;
  /** A unique integer value identifying this tender. */
  id: number;
}

export interface ContractsTendersSaveFourthStepParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export interface ContractsTendersSaveSecondStepParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export interface ContractsTendersSaveThirdStepParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export type ContractsTendersUpdateError = Record<string, any>;

export interface ContractsTendersUpdateParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export type ContractsTendersValidateFinishError = Record<string, any>;

export interface ContractsTendersValidateFinishParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export type ContractsTendersValidatePublishError = Record<string, any>;

export interface ContractsTendersValidatePublishParams {
  /** A unique integer value identifying this tender. */
  id: number;
}

export interface CountByIntervalStats {
  count: number;
  /** @format date-time */
  date: string;
}

/**
 * * `AF` - Afghanistan
 * * `AX` - Åland Islands
 * * `AL` - Albania
 * * `DZ` - Algeria
 * * `AS` - American Samoa
 * * `AD` - Andorra
 * * `AO` - Angola
 * * `AI` - Anguilla
 * * `AQ` - Antarctica
 * * `AG` - Antigua and Barbuda
 * * `AR` - Argentina
 * * `AM` - Armenia
 * * `AW` - Aruba
 * * `AU` - Australia
 * * `AT` - Austria
 * * `AZ` - Azerbaijan
 * * `BS` - Bahamas (The)
 * * `BH` - Bahrain
 * * `BD` - Bangladesh
 * * `BB` - Barbados
 * * `BY` - Belarus
 * * `BE` - Belgium
 * * `BZ` - Belize
 * * `BJ` - Benin
 * * `BM` - Bermuda
 * * `BT` - Bhutan
 * * `BO` - Bolivia
 * * `BQ` - Bonaire, Sint Eustatius and Saba
 * * `BA` - Bosnia and Herzegovina
 * * `BW` - Botswana
 * * `BV` - Bouvet Island
 * * `BR` - Brazil
 * * `IO` - British Indian Ocean Territory
 * * `BN` - Brunei
 * * `BG` - Bulgaria
 * * `BF` - Burkina Faso
 * * `BI` - Burundi
 * * `CV` - Cabo Verde
 * * `KH` - Cambodia
 * * `CM` - Cameroon
 * * `CA` - Canada
 * * `KY` - Cayman Islands
 * * `CF` - Central African Republic
 * * `TD` - Chad
 * * `CL` - Chile
 * * `CN` - China
 * * `CX` - Christmas Island
 * * `CC` - Cocos (Keeling) Islands
 * * `CO` - Colombia
 * * `KM` - Comoros
 * * `CG` - Congo
 * * `CK` - Cook Islands
 * * `CR` - Costa Rica
 * * `CI` - Côte d'Ivoire
 * * `HR` - Croatia
 * * `CU` - Cuba
 * * `CW` - Curaçao
 * * `CY` - Cyprus
 * * `CZ` - Czechia
 * * `CD` - Democratic Republic of the Congo
 * * `DK` - Denmark
 * * `DJ` - Djibouti
 * * `DM` - Dominica
 * * `DO` - Dominican Republic
 * * `EC` - Ecuador
 * * `EG` - Egypt
 * * `SV` - El Salvador
 * * `GQ` - Equatorial Guinea
 * * `ER` - Eritrea
 * * `EE` - Estonia
 * * `SZ` - Eswatini
 * * `ET` - Ethiopia
 * * `FK` - Falkland Islands (Malvinas)
 * * `FO` - Faroe Islands
 * * `FJ` - Fiji
 * * `FI` - Finland
 * * `FR` - France
 * * `GF` - French Guiana
 * * `PF` - French Polynesia
 * * `TF` - French Southern Territories
 * * `GA` - Gabon
 * * `GM` - Gambia
 * * `GE` - Georgia
 * * `DE` - Germany
 * * `GH` - Ghana
 * * `GI` - Gibraltar
 * * `GR` - Greece
 * * `GL` - Greenland
 * * `GD` - Grenada
 * * `GP` - Guadeloupe
 * * `GU` - Guam
 * * `GT` - Guatemala
 * * `GG` - Guernsey
 * * `GN` - Guinea
 * * `GW` - Guinea-Bissau
 * * `GY` - Guyana
 * * `HT` - Haiti
 * * `HM` - Heard Island and McDonald Islands
 * * `HN` - Honduras
 * * `HK` - Hong Kong
 * * `HU` - Hungary
 * * `IS` - Iceland
 * * `IN` - India
 * * `ID` - Indonesia
 * * `IR` - Iran
 * * `IQ` - Iraq
 * * `IE` - Ireland
 * * `IM` - Isle of Man
 * * `IL` - Israel
 * * `IT` - Italy
 * * `JM` - Jamaica
 * * `JP` - Japan
 * * `JE` - Jersey
 * * `JO` - Jordan
 * * `KZ` - Kazakhstan
 * * `KE` - Kenya
 * * `KI` - Kiribati
 * * `KW` - Kuwait
 * * `KG` - Kyrgyzstan
 * * `LA` - Laos
 * * `LV` - Latvia
 * * `LB` - Lebanon
 * * `LS` - Lesotho
 * * `LR` - Liberia
 * * `LY` - Libya
 * * `LI` - Liechtenstein
 * * `LT` - Lithuania
 * * `LU` - Luxembourg
 * * `MO` - Macao
 * * `MG` - Madagascar
 * * `MW` - Malawi
 * * `MY` - Malaysia
 * * `MV` - Maldives
 * * `ML` - Mali
 * * `MT` - Malta
 * * `MH` - Marshall Islands
 * * `MQ` - Martinique
 * * `MR` - Mauritania
 * * `MU` - Mauritius
 * * `YT` - Mayotte
 * * `MX` - Mexico
 * * `FM` - Micronesia
 * * `MD` - Moldova
 * * `MC` - Monaco
 * * `MN` - Mongolia
 * * `ME` - Montenegro
 * * `MS` - Montserrat
 * * `MA` - Morocco
 * * `MZ` - Mozambique
 * * `MM` - Myanmar
 * * `NA` - Namibia
 * * `NR` - Naoero
 * * `NP` - Nepal
 * * `NL` - Netherlands
 * * `NC` - New Caledonia
 * * `NZ` - New Zealand
 * * `NI` - Nicaragua
 * * `NE` - Niger
 * * `NG` - Nigeria
 * * `NU` - Niue
 * * `NF` - Norfolk Island
 * * `KP` - North Korea
 * * `MK` - North Macedonia
 * * `MP` - Northern Mariana Islands
 * * `NO` - Norway
 * * `OM` - Oman
 * * `PK` - Pakistan
 * * `PW` - Palau
 * * `PS` - Palestine
 * * `PA` - Panama
 * * `PG` - Papua New Guinea
 * * `PY` - Paraguay
 * * `PE` - Peru
 * * `PH` - Philippines
 * * `PN` - Pitcairn
 * * `PL` - Poland
 * * `PT` - Portugal
 * * `PR` - Puerto Rico
 * * `QA` - Qatar
 * * `RE` - Réunion
 * * `RO` - Romania
 * * `RU` - Russia
 * * `RW` - Rwanda
 * * `BL` - Saint Barthélemy
 * * `SH` - Saint Helena
 * * `KN` - Saint Kitts and Nevis
 * * `LC` - Saint Lucia
 * * `MF` - Saint Martin (French part)
 * * `PM` - Saint Pierre and Miquelon
 * * `VC` - Saint Vincent and the Grenadines
 * * `WS` - Samoa
 * * `SM` - San Marino
 * * `ST` - Sao Tome and Principe
 * * `SA` - Saudi Arabia
 * * `SN` - Senegal
 * * `RS` - Serbia
 * * `SC` - Seychelles
 * * `SL` - Sierra Leone
 * * `SG` - Singapore
 * * `SX` - Sint Maarten (Dutch part)
 * * `SK` - Slovakia
 * * `SI` - Slovenia
 * * `SB` - Solomon Islands
 * * `SO` - Somalia
 * * `ZA` - South Africa
 * * `GS` - South Georgia
 * * `KR` - South Korea
 * * `SS` - South Sudan
 * * `ES` - Spain
 * * `LK` - Sri Lanka
 * * `SD` - Sudan
 * * `SR` - Suriname
 * * `SJ` - Svalbard and Jan Mayen
 * * `SE` - Sweden
 * * `CH` - Switzerland
 * * `SY` - Syria
 * * `TW` - Taiwan
 * * `TJ` - Tajikistan
 * * `TZ` - Tanzania
 * * `TH` - Thailand
 * * `TL` - Timor-Leste
 * * `TG` - Togo
 * * `TK` - Tokelau
 * * `TO` - Tonga
 * * `TT` - Trinidad and Tobago
 * * `TN` - Tunisia
 * * `TR` - Türkiye
 * * `TM` - Turkmenistan
 * * `TC` - Turks and Caicos Islands
 * * `TV` - Tuvalu
 * * `UG` - Uganda
 * * `UA` - Ukraine
 * * `AE` - United Arab Emirates
 * * `GB` - United Kingdom
 * * `UM` - United States Minor Outlying Islands
 * * `US` - United States of America
 * * `UY` - Uruguay
 * * `UZ` - Uzbekistan
 * * `VU` - Vanuatu
 * * `VA` - Vatican City
 * * `VE` - Venezuela
 * * `VN` - Vietnam
 * * `VG` - Virgin Islands (British)
 * * `VI` - Virgin Islands (U.S.)
 * * `WF` - Wallis and Futuna
 * * `EH` - Western Sahara
 * * `YE` - Yemen
 * * `ZM` - Zambia
 * * `ZW` - Zimbabwe
 */
export enum CountryEnum {
  AF = "AF",
  AX = "AX",
  AL = "AL",
  DZ = "DZ",
  AS = "AS",
  AD = "AD",
  AO = "AO",
  AI = "AI",
  AQ = "AQ",
  AG = "AG",
  AR = "AR",
  AM = "AM",
  AW = "AW",
  AU = "AU",
  AT = "AT",
  AZ = "AZ",
  BS = "BS",
  BH = "BH",
  BD = "BD",
  BB = "BB",
  BY = "BY",
  BE = "BE",
  BZ = "BZ",
  BJ = "BJ",
  BM = "BM",
  BT = "BT",
  BO = "BO",
  BQ = "BQ",
  BA = "BA",
  BW = "BW",
  BV = "BV",
  BR = "BR",
  IO = "IO",
  BN = "BN",
  BG = "BG",
  BF = "BF",
  BI = "BI",
  CV = "CV",
  KH = "KH",
  CM = "CM",
  CA = "CA",
  KY = "KY",
  CF = "CF",
  TD = "TD",
  CL = "CL",
  CN = "CN",
  CX = "CX",
  CC = "CC",
  CO = "CO",
  KM = "KM",
  CG = "CG",
  CK = "CK",
  CR = "CR",
  CI = "CI",
  HR = "HR",
  CU = "CU",
  CW = "CW",
  CY = "CY",
  CZ = "CZ",
  CD = "CD",
  DK = "DK",
  DJ = "DJ",
  DM = "DM",
  DO = "DO",
  EC = "EC",
  EG = "EG",
  SV = "SV",
  GQ = "GQ",
  ER = "ER",
  EE = "EE",
  SZ = "SZ",
  ET = "ET",
  FK = "FK",
  FO = "FO",
  FJ = "FJ",
  FI = "FI",
  FR = "FR",
  GF = "GF",
  PF = "PF",
  TF = "TF",
  GA = "GA",
  GM = "GM",
  GE = "GE",
  DE = "DE",
  GH = "GH",
  GI = "GI",
  GR = "GR",
  GL = "GL",
  GD = "GD",
  GP = "GP",
  GU = "GU",
  GT = "GT",
  GG = "GG",
  GN = "GN",
  GW = "GW",
  GY = "GY",
  HT = "HT",
  HM = "HM",
  HN = "HN",
  HK = "HK",
  HU = "HU",
  IS = "IS",
  IN = "IN",
  ID = "ID",
  IR = "IR",
  IQ = "IQ",
  IE = "IE",
  IM = "IM",
  IL = "IL",
  IT = "IT",
  JM = "JM",
  JP = "JP",
  JE = "JE",
  JO = "JO",
  KZ = "KZ",
  KE = "KE",
  KI = "KI",
  KW = "KW",
  KG = "KG",
  LA = "LA",
  LV = "LV",
  LB = "LB",
  LS = "LS",
  LR = "LR",
  LY = "LY",
  LI = "LI",
  LT = "LT",
  LU = "LU",
  MO = "MO",
  MG = "MG",
  MW = "MW",
  MY = "MY",
  MV = "MV",
  ML = "ML",
  MT = "MT",
  MH = "MH",
  MQ = "MQ",
  MR = "MR",
  MU = "MU",
  YT = "YT",
  MX = "MX",
  FM = "FM",
  MD = "MD",
  MC = "MC",
  MN = "MN",
  ME = "ME",
  MS = "MS",
  MA = "MA",
  MZ = "MZ",
  MM = "MM",
  NA = "NA",
  NR = "NR",
  NP = "NP",
  NL = "NL",
  NC = "NC",
  NZ = "NZ",
  NI = "NI",
  NE = "NE",
  NG = "NG",
  NU = "NU",
  NF = "NF",
  KP = "KP",
  MK = "MK",
  MP = "MP",
  NO = "NO",
  OM = "OM",
  PK = "PK",
  PW = "PW",
  PS = "PS",
  PA = "PA",
  PG = "PG",
  PY = "PY",
  PE = "PE",
  PH = "PH",
  PN = "PN",
  PL = "PL",
  PT = "PT",
  PR = "PR",
  QA = "QA",
  RE = "RE",
  RO = "RO",
  RU = "RU",
  RW = "RW",
  BL = "BL",
  SH = "SH",
  KN = "KN",
  LC = "LC",
  MF = "MF",
  PM = "PM",
  VC = "VC",
  WS = "WS",
  SM = "SM",
  ST = "ST",
  SA = "SA",
  SN = "SN",
  RS = "RS",
  SC = "SC",
  SL = "SL",
  SG = "SG",
  SX = "SX",
  SK = "SK",
  SI = "SI",
  SB = "SB",
  SO = "SO",
  ZA = "ZA",
  GS = "GS",
  KR = "KR",
  SS = "SS",
  ES = "ES",
  LK = "LK",
  SD = "SD",
  SR = "SR",
  SJ = "SJ",
  SE = "SE",
  CH = "CH",
  SY = "SY",
  TW = "TW",
  TJ = "TJ",
  TZ = "TZ",
  TH = "TH",
  TL = "TL",
  TG = "TG",
  TK = "TK",
  TO = "TO",
  TT = "TT",
  TN = "TN",
  TR = "TR",
  TM = "TM",
  TC = "TC",
  TV = "TV",
  UG = "UG",
  UA = "UA",
  AE = "AE",
  GB = "GB",
  UM = "UM",
  US = "US",
  UY = "UY",
  UZ = "UZ",
  VU = "VU",
  VA = "VA",
  VE = "VE",
  VN = "VN",
  VG = "VG",
  VI = "VI",
  WF = "WF",
  EH = "EH",
  YE = "YE",
  ZM = "ZM",
  ZW = "ZW",
}

export interface CriterionVerdict {
  readonly contractValue: string | null;
  field: string;
  readonly requestValue: string | null;
  status: string;
  waypointIndex: number | null;
}

/**
 * * `EUR` - EUR
 * * `USD` - USD
 * * `CZK` - CZK
 * * `HUF` - HUF
 * * `PLN` - PLN
 * * `RON` - RON
 * * `GBP` - GBP
 * * `NOK` - NOK
 * * `DKK` - DKK
 * * `SEK` - SEK
 * * `ISK` - ISK
 * * `CHF` - CHF
 * * `CNY` - CNY
 */
export enum CurrencyEnum {
  EUR = "EUR",
  USD = "USD",
  CZK = "CZK",
  HUF = "HUF",
  PLN = "PLN",
  RON = "RON",
  GBP = "GBP",
  NOK = "NOK",
  DKK = "DKK",
  SEK = "SEK",
  ISK = "ISK",
  CHF = "CHF",
  CNY = "CNY",
}

export interface DayTimeline {
  readonly addresses: AddressTimeline[];
  readonly conflictingBookingsCount: number;
  /** @format date */
  readonly date: string;
  /** @format date-time */
  readonly now: string;
}

export interface DistanceDistribution {
  /** @format double */
  avgCost: number;
  /** @format double */
  avgCostPerKm: number;
  /** @format double */
  maxDistance: number;
  /** @format double */
  minDistance: number;
  /** @format double */
  percentage: number;
  rangeLabel: string;
  shipmentCount: number;
}

export interface Document {
  /**
   * * `ALL` - Shared with all
   * * `WINNER` - Shared with winner
   * * `PRIVATE` - Private (only shipper)
   */
  accessLevel?: DocumentAccessLevelEnum;
  readonly assignedObjectContentType: string;
  readonly assignedObjectId: number;
  /** @format date-time */
  readonly createdAt: string;
  readonly createdByContentType: string;
  readonly createdById: number;
  readonly createdByName: string;
  /**
   * Document
   * file
   * @format uri
   */
  file: string;
  /** bytes */
  readonly fileSize: number | null;
  id?: number | null;
  readonly sources: DocumentSource[];
  /**
   * Name
   * @maxLength 200
   */
  title: string;
}

/**
 * * `ALL` - Shared with all
 * * `WINNER` - Shared with winner
 * * `PRIVATE` - Private (only shipper)
 */
export enum DocumentAccessLevelEnum {
  ALL = "ALL",
  WINNER = "WINNER",
  PRIVATE = "PRIVATE",
}

export interface DocumentCreate {
  /**
   * * `ALL` - Shared with all
   * * `WINNER` - Shared with winner
   * * `PRIVATE` - Private (only shipper)
   */
  accessLevel?: DocumentAccessLevelEnum;
  assignedObjectContentType: string;
  /**
   * @min 0
   * @max 2147483647
   */
  assignedObjectId: number;
  /**
   * Document
   * file
   * @format uri
   */
  file: string;
  /**
   * Name
   * @maxLength 200
   */
  title: string;
}

export interface DocumentSource {
  readonly contentType: string;
  readonly displayId: number;
  readonly id: number;
}

export interface DocumentUpdate {
  /**
   * * `ALL` - Shared with all
   * * `WINNER` - Shared with winner
   * * `PRIVATE` - Private (only shipper)
   */
  accessLevel?: DocumentAccessLevelEnum;
  title?: string;
}

export interface DocumentUpload {
  /**
   * @format uri
   * @pattern (?:pdf|docx|xlsx|xls|png|jpg|jpeg)$
   */
  file?: string | null;
  /** @maxLength 5000 */
  inputText?: string;
}

export interface DocumentUploadResponse {
  /**
   * A mixin that sets all serializer fields (including nested ones)
   * to required=False, allow_null=True automatically and ski serializer validation.
   */
  transportFirstStep: DocumentUploadResponseFirstStep;
  /**
   * A mixin that sets all serializer fields (including nested ones)
   * to required=False, allow_null=True automatically and ski serializer validation.
   */
  transportSecondStep: DocumentUploadResponseSecondStep;
  /**
   * A mixin that sets all serializer fields (including nested ones)
   * to required=False, allow_null=True automatically and ski serializer validation.
   */
  transportThirdStep: DocumentUploadResponseThirdStep;
}

/**
 * A mixin that sets all serializer fields (including nested ones)
 * to required=False, allow_null=True automatically and ski serializer validation.
 */
export interface DocumentUploadResponseFirstStep {
  transportationMode?: TransportationModeEnum | null;
  waypoints?: WaypointOptional[] | null;
}

/**
 * A mixin that sets all serializer fields (including nested ones)
 * to required=False, allow_null=True automatically and ski serializer validation.
 */
export interface DocumentUploadResponseSecondStep {
  cargo?: CargoOptional | null;
  /** @maxLength 500 */
  costCenter?: string | null;
  incoterms?: IncotermsEnum | null;
  /** @maxLength 150 */
  reference?: string | null;
  readonly vehicleTypeId: number | null;
}

/**
 * A mixin that sets all serializer fields (including nested ones)
 * to required=False, allow_null=True automatically and ski serializer validation.
 */
export interface DocumentUploadResponseThirdStep {
  contacts?: number[] | null;
  /** @min 1 */
  contractPriceId?: number | null;
  documents?: TransportDocumentValidation[] | null;
  duration?: string | null;
  followers?: number[] | null;
  note?: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  price?: string | null;
  priceCurrency?: string | null;
  responsibleUserId?: number | null;
  tags?: string[] | null;
  type?: TransportTypeEnum | null;
}

export interface DocumentsDestroyParams {
  /** A unique integer value identifying this document. */
  id: number;
}

export interface DocumentsListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface DocumentsPartialUpdateParams {
  /** A unique integer value identifying this document. */
  id: number;
}

export interface DocumentsRetrieveParams {
  /** A unique integer value identifying this document. */
  id: number;
}

export interface DocumentsUpdateParams {
  /** A unique integer value identifying this document. */
  id: number;
}

export interface EmailInfo {
  /** @format date-time */
  readonly changedAt: string | null;
  readonly status: EmailInfoStatusEnum;
}

/**
 * * `processing` - Processing
 * * `sent` - Sent
 * * `retrying` - Retrying
 * * `delivered` - Delivered
 * * `opened` - Opened
 * * `failed` - Failed
 * * `suppressed` - Suppressed
 * * `unsubscribed` - Unsubscribed
 */
export enum EmailInfoStatusEnum {
  Processing = "processing",
  Sent = "sent",
  Retrying = "retrying",
  Delivered = "delivered",
  Opened = "opened",
  Failed = "failed",
  Suppressed = "suppressed",
  Unsubscribed = "unsubscribed",
}

export interface FeatureFlagStatus {
  isActive: boolean;
}

export interface FeatureFlagsStatus {
  readonly flags: Record<string, FeatureFlagStatus>;
  readonly samples: Record<string, FeatureSampleStatus>;
  readonly switches: Record<string, FeatureSwitchStatus>;
}

export interface FeatureSampleStatus {
  isActive: boolean;
}

export interface FeatureSwitch {
  readonly name: FeatureSwitchNameEnum;
}

/**
 * * `calculating-pricer-price-switch` - CALCULATING_PRICER_PRICE
 * * `multiple-contacts-per-carrier-switch` - MULTIPLE_CONTACTS_PER_CARRIER
 */
export enum FeatureSwitchNameEnum {
  CalculatingPricerPriceSwitch = "calculating-pricer-price-switch",
  MultipleContactsPerCarrierSwitch = "multiple-contacts-per-carrier-switch",
}

export interface FeatureSwitchStatus {
  isActive: boolean;
}

export interface FeeConfig {
  readonly feeMode: FeeModeEnum | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly maxFee: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly minFee: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,3}(?:\.\d{0,2})?$
   */
  readonly percentage: string | null;
}

/**
 * * `FLAT` - Flat
 * * `PERCENTAGE` - Percentage
 */
export enum FeeModeEnum {
  FLAT = "FLAT",
  PERCENTAGE = "PERCENTAGE",
}

export interface FeePreviewInput {
  /**
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency: CurrencyEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  price?: string | null;
}

export interface FeePreviewOutput {
  readonly applicable: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly fee: string | null;
  readonly feeMode: FeeModeEnum | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly maxFee: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly minFee: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,3}(?:\.\d{0,2})?$
   */
  readonly percentage: string | null;
}

/**
 * * `city` - city
 * * `name` - name
 * * `post_code` - post_code
 * * `street` - street
 */
export enum FieldEnum {
  City = "city",
  Name = "name",
  PostCode = "post_code",
  Street = "street",
}

/** * `transport_request` - Transport request form */
export enum FieldRulesFormEnum {
  TransportRequest = "transport_request",
}

export interface FieldRulesResponse {
  /** Keyed by dotted field path → rule kind → params object, e.g. {'note': {'required': {}}}. */
  rules: Record<string, Record<string, Record<string, any>>>;
  readonly supportedRuleKinds: RuleKindEnum[];
  /** * `transport_request` - Transport request form */
  targetForm: FieldRulesFormEnum;
}

export interface FieldRulesRetrieveParams {
  /** * `transport_request` - Transport request form */
  targetForm: FieldRulesFormEnum;
}

export interface ForceLogoutRequest {
  immediately: boolean;
}

export interface Gate {
  /**
   * * `red` - Red
   * * `yellow` - Yellow
   * * `green` - Green
   * * `blue` - Blue
   * * `purple` - Purple
   * * `neutral` - Grey
   */
  color: ColorEnum;
  /** @min 1 */
  id?: number;
  /** @maxLength 100 */
  name: string;
  /** @default false */
  specifiesVehicleTypes?: boolean;
  vehicleTypeRules?: GateVehicleTypeRule[];
}

/**
 * * `OUTSIDE_OPERATING_HOURS` - Outside operating hours
 * * `EXCEPTION` - Operating hours exception
 * * `GATE_INACTIVE` - Gate inactive
 */
export enum GateClosureReasonEnum {
  OUTSIDE_OPERATING_HOURS = "OUTSIDE_OPERATING_HOURS",
  EXCEPTION = "EXCEPTION",
  GATE_INACTIVE = "GATE_INACTIVE",
}

/**
 * Replaces the whole gate set for an address.
 *
 * Errors under ``gates`` come in two shapes, discriminated by type: an array holds one object
 * per submitted gate (empty where that gate is fine) and binds to the dialog's field array; an
 * object holds ``non_field_errors`` for failures that belong to the list as a whole, such as an
 * empty payload or one over the cap.
 */
export interface GateListWrite {
  gates: Gate[];
}

export interface GateNested {
  /**
   * * `red` - Red
   * * `yellow` - Yellow
   * * `green` - Green
   * * `blue` - Blue
   * * `purple` - Purple
   * * `neutral` - Grey
   */
  color: ColorEnum;
  readonly id: number;
  readonly isDeleted: boolean;
  /** @maxLength 100 */
  name: string;
}

export interface GateSlot {
  readonly blockingBookings: ConflictingBookingNested[];
  readonly gate: GateNested;
  readonly status: GateSlotStatusEnum;
}

/**
 * * `FREE` - Free
 * * `OVERRIDABLE` - Overridable
 */
export enum GateSlotStatusEnum {
  FREE = "FREE",
  OVERRIDABLE = "OVERRIDABLE",
}

export interface GateVehicleTypeRule {
  readonly id: number;
  isEnabled?: boolean;
  readonly vehicleType: VehicleTypeNested;
  vehicleTypeId: number;
}

export interface GenericSender {
  email: string;
  id: number;
  name: string;
  /**
   * * `carrier` - Carrier
   * * `user` - User
   * * `unknown` - Unknown
   */
  type: GenericSenderTypeEnum;
}

/**
 * * `carrier` - Carrier
 * * `user` - User
 * * `unknown` - Unknown
 */
export enum GenericSenderTypeEnum {
  Carrier = "carrier",
  User = "user",
  Unknown = "unknown",
}

/**
 * * `EXW` - EXW - Ex Works
 * * `FCA` - FCA - Free Carrier
 * * `CPT` - CPT - Carriage Paid To
 * * `CIP` - CIP - Carriage and Insurance Paid To
 * * `DAP` - DAP - Delivered at Place
 * * `DPU` - DPU - Delivered at Place Unloaded
 * * `DDP` - DDP - Delivered Duty Paid
 * * `FAS` - FAS - Free Alongside Ship
 * * `FOB` - FOB - Free On Board
 * * `CFR` - CFR - Cost and Freight
 * * `CIF` - CIF - Cost, Insurance and Freight
 */
export enum IncotermsEnum {
  EXW = "EXW",
  FCA = "FCA",
  CPT = "CPT",
  CIP = "CIP",
  DAP = "DAP",
  DPU = "DPU",
  DDP = "DDP",
  FAS = "FAS",
  FOB = "FOB",
  CFR = "CFR",
  CIF = "CIF",
}

export enum IntervalEnum {
  DAY = "DAY",
  MONTH = "MONTH",
  YEAR = "YEAR",
}

export interface Invitation {
  /**
   * E-mail address
   * @format email
   * @maxLength 254
   */
  email: string;
  role?: number | null;
}

export type InvitationsRemoveCreatePayload = string;

/** Serializer for JWT authentication. */
export interface JWT {
  access: string;
  refresh: string;
  /** User model w/o password */
  user: UserDetails;
}

/**
 * * `en` - English
 * * `sk` - Slovak
 * * `de` - German
 * * `fr` - French
 * * `it` - Italian
 * * `cs` - Czech
 * * `es` - Spain
 */
export enum LanguageEnum {
  En = "en",
  Sk = "sk",
  De = "de",
  Fr = "fr",
  It = "it",
  Cs = "cs",
  Es = "es",
}

export interface LastMessage {
  content: string;
  /** @format date-time */
  createdAt: string;
  readonly sender: GenericSender;
}

/**
 * * `m` - m
 * * `cm` - cm
 * * `mm` - mm
 */
export enum LengthUnitEnum {
  M = "m",
  Cm = "cm",
  Mm = "mm",
}

export interface LocationAddress {
  /** @maxLength 100 */
  city: string;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  readonly id: number;
  readonly location: PointField | null;
  /** @maxLength 20 */
  postCode?: string;
  /** @maxLength 100 */
  street?: string;
}

export interface LocationData {
  addresses: LocationAddress[];
  /** @format double */
  distance?: number;
  readonly points: PointField[];
  polyline?: string;
  /** @format uri */
  readonly staticMap: string | null;
}

export interface LocationStats {
  city: string;
  country: string;
  deliveryCount: number;
  pickupCount: number;
  totalCount: number;
}

export interface Login {
  email?: string;
  password: string;
  username?: string;
}

export interface Logout {
  refresh: string;
}

export interface MarkAsReadMessage {
  carrier: number;
}

export interface MarketingConsentByToken {
  consents: MarketingInputOutput;
  /** @format email */
  email: string;
}

export interface MarketingInputOutput {
  marketingAccepted: boolean;
}

export interface MatchingCheckOptionInput {
  contractOptionId: number;
  /** @default false */
  linkedOption?: boolean;
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode: TransportationModeEnum;
  /** @min 1 */
  vehicleTypeId?: number | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
   */
  volume?: string | null;
  volumeUnit?: VolumeUnitEnum | null;
  waypoints: MatchingWaypointInput[];
  /**
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
   */
  weight?: string | null;
  weightUnit?: WeightUnitEnum | null;
}

export interface MatchingEvaluateInput {
  /** @default true */
  enrichRequestSynchronously?: boolean;
  /** @format uuid */
  formCorrelationId?: string | null;
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode: TransportationModeEnum;
  /** @min 1 */
  vehicleTypeId?: number | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
   */
  volume?: string | null;
  volumeUnit?: VolumeUnitEnum | null;
  waypoints: MatchingWaypointInput[];
  /**
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
   */
  weight?: string | null;
  weightUnit?: WeightUnitEnum | null;
}

export interface MatchingWaypointInput {
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  availabilityEnd?: string | null;
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  availabilityStart?: string | null;
  city?: string | null;
  country?: string | null;
  postCode?: string | null;
  street?: string | null;
  /** The waypoint's stored IANA zone, when the caller already knows it. Supplying it keeps the preview on the same clock as the save; without it the preview falls back to the server's. */
  timezone?: string | null;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  type: WaypointTypeEnum;
}

export interface Member {
  readonly role: Role;
  readonly workspace: WorkspaceGeneralInfo;
}

export interface MergedAuction {
  readonly id: number;
  readonly transportId: number | null;
}

export interface Message {
  carrier?: number;
  content?: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly data: MessageData;
  readonly event: MessageEventEnum;
  readonly id: number;
  /** @format date-time */
  readonly seenAt: string;
  readonly sender: GenericSender;
  readonly type: MessageTypeEnum;
}

export interface MessageData {
  bidCurrency?: string;
  /** @format double */
  bidPrice?: number;
  /** @format double */
  bidPriceWorkspace?: number;
  bidWorkspaceCurrency?: string;
  /** @format double */
  distance?: number;
  fileId?: number;
  fileName?: string;
  fileSize?: number;
}

/**
 * * `NEW_MESSAGE` - New message
 * * `BIDDING_FINISHED` - Bidding finished
 * * `NEW_BID` - New bid
 * * `BID_SELECTED` - Bid selected
 * * `DOCUMENT_UPLOADED` - Document uploaded
 * * `TRANSPORT_CONFIRMED` - Transport confirmed
 * * `REQUEST_REJECTED` - Request rejected
 * * `TRANSPORT_REJECTED` - Transport rejected
 * * `REQUEST_DURATION_EXTENDED` - Request duration extended
 * * `EMAIL_RESENT` -  Email resent
 * * `TENDER_OFFER_SUBMITTED` - Tender offer submitted
 * * `CONTRACT_PROPOSAL_REJECTED` - Contract proposal rejected
 * * `CONTRACT_PROPOSAL_ACCEPTED` - Contract proposal accepted
 * * `TENDER_INFORMATION_MODIFIED` - Tender information modified
 * * `CONTRACT_PROPOSAL_SENT` - Contract proposal sent
 * * `CONTRACT_PROPOSAL_TAKEN_BACK` - Contract proposal taken back
 * * `TENDER_DOCUMENT_UPLOADED` - Document uploaded
 */
export enum MessageEventEnum {
  NEW_MESSAGE = "NEW_MESSAGE",
  BIDDING_FINISHED = "BIDDING_FINISHED",
  NEW_BID = "NEW_BID",
  BID_SELECTED = "BID_SELECTED",
  DOCUMENT_UPLOADED = "DOCUMENT_UPLOADED",
  TRANSPORT_CONFIRMED = "TRANSPORT_CONFIRMED",
  REQUEST_REJECTED = "REQUEST_REJECTED",
  TRANSPORT_REJECTED = "TRANSPORT_REJECTED",
  REQUEST_DURATION_EXTENDED = "REQUEST_DURATION_EXTENDED",
  EMAIL_RESENT = "EMAIL_RESENT",
  TENDER_OFFER_SUBMITTED = "TENDER_OFFER_SUBMITTED",
  CONTRACT_PROPOSAL_REJECTED = "CONTRACT_PROPOSAL_REJECTED",
  CONTRACT_PROPOSAL_ACCEPTED = "CONTRACT_PROPOSAL_ACCEPTED",
  TENDER_INFORMATION_MODIFIED = "TENDER_INFORMATION_MODIFIED",
  CONTRACT_PROPOSAL_SENT = "CONTRACT_PROPOSAL_SENT",
  CONTRACT_PROPOSAL_TAKEN_BACK = "CONTRACT_PROPOSAL_TAKEN_BACK",
  TENDER_DOCUMENT_UPLOADED = "TENDER_DOCUMENT_UPLOADED",
}

/**
 * * `human` - Human
 * * `system` - System
 */
export enum MessageTypeEnum {
  Human = "human",
  System = "system",
}

export interface MessagesListParams {
  carrier?: number;
  /** The pagination cursor value. */
  cursor?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface MessagesMarkAsReadCreateParams {
  /** A unique integer value identifying this message. */
  id: number;
}

export interface MicrosoftAccessToken {
  accessToken: string;
}

export interface MicrosoftGroup {
  displayName: string;
  id: string;
}

export interface MicrosoftLogin {
  code: string;
}

export interface MicrosoftMember {
  displayName: string;
  id: string;
  userPrincipalName: string;
}

export interface MicrosoftMembersRequest {
  groupId?: string | null;
  tenantId: string;
}

export interface MicrosoftTenant {
  id: string;
}

export interface MicrosoftTenantRequest {
  accessToken: string;
}

export interface MicrosoftTenantResponse {
  groups: MicrosoftGroup[];
  tenantId: string;
  tenantName: string;
}

export interface ModifyInvitationByUser {
  workspaceId: number;
}

export interface ModulePromoState {
  bannerOpened: boolean;
  canSendInquiry: boolean;
  /** @format date-time */
  nextInquiryAvailableAt: string | null;
  shouldShowBanner: boolean;
}

/**
 * * `SINGLE_CARRIER` - Only one carrier invited
 * * `SINGLE_BID` - Only one bid received
 * * `WINNER_NOT_LOWEST` - Awarded bid is not the cheapest
 * * `ALL_BIDS_IDENTICAL` - All bids at the same price
 * * `FALLBACK` - Not enough bid data to compare
 * * `NOT_APPLICABLE` - Savings aren't tracked for this request
 */
export enum NotCalculatedReasonEnum {
  SINGLE_CARRIER = "SINGLE_CARRIER",
  SINGLE_BID = "SINGLE_BID",
  WINNER_NOT_LOWEST = "WINNER_NOT_LOWEST",
  ALL_BIDS_IDENTICAL = "ALL_BIDS_IDENTICAL",
  FALLBACK = "FALLBACK",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export interface Notification {
  actor?: number | null;
  /** @format date-time */
  readonly created: string;
  description: string;
  details?: string;
  readonly displayId: number | null;
  /**
   * * `OTP_REQUEST` - Log in to 4Shipper Carrier portal
   * * `CONSENT_REQUEST` - We Need Your Consent to Send RFQs via 4Shipper
   * * `TERMS_REQUIRED_INFORM` - Please Accept Our Terms and Conditions
   * * `CARRIER_REMOVED_FROM_ONGOING_AUCTION` - RFQ  %(request_id)s | You were removed
   * * `CARRIER_NOTE_MODIFIED` - RFQ %(request_id)s | Note changed by the shipper
   * * `CARRIER_UNREAD_MESSAGES` - RFQ  %(request_id)s | Unread Messages from %(shipper)s
   * * `CONTACT_CREATED` - You were added to our carriers mailing list
   * * `AUCTION_PUBLISHED` - RFQ %(request_id)s | Transport requested
   * * `AUCTION_CONTRACTED_PUBLISHED` - RFQ %(request_id)s | Transport requested
   * * `AUCTION_INSTANT_ORDER_CONFIRMED` - RFQ %(request_id)s | Transport order from Bidding InstaOrder - payment confirmed
   * * `AUCTION_INSTANT_ORDER_CREATED` - RFQ %(request_id)s | Transport order from Bidding InstaOrder - acceptation needed
   * * `AUCTION_INSTANT_ORDER_REVERTED` - RFQ %(request_id)s | InstaOrder Transport Canceled
   * * `AUCTION_DURATION_EXTENDED` - RFQ %(request_id)s | Request duration extended
   * * `AUCTION_CANCELED` - RFQ %(request_id)s | Request canceled
   * * `AUCTION_UPDATED_BEFORE_BIDDING` - RFQ %(request_id)s | Request modified
   * * `BID_CONFIRMED_BY_SHIPPER` - Action Required: Confirm your selection | RFQ %(request_id)s
   * * `BID_SELECTION_WITHDRAWN` - RFQ %(request_id)s | Your selection has been withdrawn
   * * `BID_NO_LONGER_LOWEST` - RFQ %(request_id)s | Your bid is no longer the lowest
   * * `CONTRACTED_PRICE_CONFIRMED_BY_SHIPPER` - Your client has confirmed your price offer | RFQ %(request_id)s
   * * `BID_NOT_CHOSEN` - RFQ %(request_id)s | You were not selected
   * * `TRANSPORT_ADDITIONAL_CHANGES` - RFQ %(request_id)s | Transport modified
   * * `TRANSPORT_CANCELED` - RFQ %(request_id)s | Transport canceled
   * * `TRANSPORT_MODIFIED` - RFQ %(request_id)s | Transport modified
   * * `TRANSPORT_UPDATE_REQUESTED` - RFQ %(formatted_request_id)s | Transport update requested
   * * `BILLING_DETAILS_APPROVED` - Billing details approved
   * * `BILLING_DETAILS_REJECTED` - Billing details rejected
   * * `DOCUMENT_UPLOADED` - RFQ %(request_id)s | Document added
   * * `TRANSPORT_CANCEL_REQUEST_ACCEPTED` - RFQ %(request_id)s | Transport cancellation approved
   * * `TRANSPORT_CANCEL_REQUEST_REJECTED` - RFQ %(request_id)s | Transport cancellation rejected
   * * `TENDER_PUBLISHED` - Tender %(request_id)s | Invitation to participate
   * * `TENDER_CONTRACT_PROPOSAL_SENT` - Tender %(request_id)s | New contract proposal
   * * `TENDER_CONTRACT_PROPOSAL_TAKEN_BACK` - Tender %(request_id)s | Contract proposal withdrawn
   * * `TENDER_DOCUMENT_UPLOADED` - Tender %(request_id)s | New document added
   * * `TENDER_FINISHED` - Tender %(request_id)s | Tender finished
   * * `TENDER_CANCELED` - Tender %(request_id)s | Tender canceled
   * * `TENDER_CONTRACT_CANCELED` - Tender %(tender_name)s | Contract has been canceled
   * * `TENDER_DEADLINE_UPDATED` - Tender %(tender_name)s | Tender deadline updated
   * * `TENDER_UPDATED` - Tender %(tender_name)s | Tender details modified
   * * `TIME_SLOT_BOOKING_REJECTED` - %(rfq_prefix)sTime slot booking rejected
   * * `TIME_SLOT_BOOKING_UPDATED` - %(rfq_prefix)sTime slot booking updated
   * * `TIME_SLOT_BOOKING_APPROVED` - %(rfq_prefix)sTime slot booking approved
   * * `TIME_SLOT_BOOKING_CANCELED` - %(rfq_prefix)sTime slot booking canceled
   * * `TIME_SLOT_BOOKING_CANCELED_BY_SYSTEM` - %(rfq_prefix)sTime slot booking canceled
   * * `BOOKING_LINK_SENT` - Time slot booking required
   * * `BLOCKED_CARRIER_INVITATION` - You're missing an RFQ invitation — unpaid invoices on your account
   * * `NEW_AUCTION_BID` - New bid from %(carrier)s
   * * `CONTRACTED_PRICE_PROVIDED` - Contracted price provided by %(carrier)s
   * * `CARRIER_CONFIRMED_BID` - Carrier %(carrier)s confirmed Request %(formatted_request_id)s
   * * `CARRIER_SUBSCRIBED_TO_EMAILS` - Carrier %(target)s subscribed
   * * `CARRIER_UNSUBSCRIBED_FROM_EMAILS` - Carrier %(target)s unsubscribed
   * * `CARRIER_REJECTED_BID` - Carrier %(carrier)s rejected request
   * * `CARRIER_REJECTED_CONTRACTED_PRICE` - Carrier %(carrier)s rejected contracted transport
   * * `CARRIER_REJECTED_AUCTION` - Carrier %(carrier)s rejected participation
   * * `CARRIER_REJECTED_CONTRACTED_TRANSPORT` - Carrier %(carrier)s rejected contracted transport
   * * `TRANSPORT_DETAILS_UPDATED` - Transport data has been changed
   * * `RESPONSIBLE_PERSON_CHANGED` - You were assigned a new Request %(formatted_request_id)s
   * * `FOLLOWER_ADDED` - You were marked as a follower of %(formatted_request_id)s
   * * `TRANSPORT_RESPONSIBLE_PERSON_CHANGED` - You were assigned a new Transport %(formatted_request_id)s
   * * `TRANSPORT_UPDATE_CREATED` - RFQ %(formatted_request_id)s | New shipment update
   * * `CARRIER_UPLOADED_DOCUMENT` - Document added for Request %(formatted_request_id)s
   * * `CARRIER_UPLOADED_DOCUMENT_TO_TRANSPORT` - Document added for Transport %(formatted_request_id)s
   * * `UNREAD_MESSAGES` - Unread messages for RFQ %(formatted_request_id)s
   * * `UNREAD_MESSAGES_FOR_TENDER` - Unread messages for Tender %(formatted_request_id)s
   * * `AUTO_SELECT_NO_BIDS` - Automatic selection failed for Request %(formatted_request_id)s - no bids
   * * `AUTO_SELECT_BID_ABOVE_LIMIT` - Automatic selection failed for Request %(formatted_request_id)s - lowest bid above the limit
   * * `AUTO_SELECT_ERROR` - Automatic selection failed for Request %(formatted_request_id)s
   * * `CARRIER_CREATED_TRANSPORT_CANCEL_REQUEST` - Carrier %(carrier)s marked transport %(formatted_request_id)s as canceled
   * * `AUCTION_DRAFT_CREATED` - Request %(formatted_request_id)s has been created by email
   * * `TENDER_NEW_OFFERS_SUBMITTED` - Tender %(formatted_request_id)s | New price offer by %(carrier)s
   * * `TENDER_UPDATED_OFFERS_SUBMITTED` - Tender %(formatted_request_id)s | Price offer updated by %(carrier)s
   * * `TENDER_CONTRACT_PROPOSAL_ACCEPTED` - Tender %(formatted_request_id)s | Contract proposal accepted by %(carrier)s
   * * `TENDER_CONTRACT_PROPOSAL_REJECTED` - Tender %(formatted_request_id)s | Contract proposal rejected by %(carrier)s
   * * `CARRIER_BOOKING_CANCELED` - %(rfq_prefix)sTime slot booking canceled
   * * `CARRIER_BOOKING_WITHDRAWN` - %(rfq_prefix)sTime slot booking withdrawn
   * * `BOOKING_CANCELED_BY_SYSTEM` - %(rfq_prefix)sTime slot booking canceled
   * * `CARRIER_BOOKING_REQUESTED` - %(rfq_prefix)sTime slot booking requested
   * * `CARRIER_BOOKING_UPDATED` - %(rfq_prefix)sTime slot booking updated
   */
  event: NotificationEventEnum;
  readonly id: number;
  /** Read */
  isRead?: boolean;
  /** @format date-time */
  readonly modified: string;
  objectContentType: number;
  /**
   * @min 0
   * @max 2147483647
   */
  objectId?: number | null;
  recipient: number;
  shortDescription: string;
  targetContentType: number;
  /**
   * @min 0
   * @max 2147483647
   */
  targetId?: number | null;
  readonly workspace: WorkspaceGeneralInfo;
}

export interface NotificationEvent {
  readonly description: string;
  isEnabled: boolean;
  readonly name: NotificationEventNameEnum;
}

/**
 * * `OTP_REQUEST` - Log in to 4Shipper Carrier portal
 * * `CONSENT_REQUEST` - We Need Your Consent to Send RFQs via 4Shipper
 * * `TERMS_REQUIRED_INFORM` - Please Accept Our Terms and Conditions
 * * `CARRIER_REMOVED_FROM_ONGOING_AUCTION` - RFQ  %(request_id)s | You were removed
 * * `CARRIER_NOTE_MODIFIED` - RFQ %(request_id)s | Note changed by the shipper
 * * `CARRIER_UNREAD_MESSAGES` - RFQ  %(request_id)s | Unread Messages from %(shipper)s
 * * `CONTACT_CREATED` - You were added to our carriers mailing list
 * * `AUCTION_PUBLISHED` - RFQ %(request_id)s | Transport requested
 * * `AUCTION_CONTRACTED_PUBLISHED` - RFQ %(request_id)s | Transport requested
 * * `AUCTION_INSTANT_ORDER_CONFIRMED` - RFQ %(request_id)s | Transport order from Bidding InstaOrder - payment confirmed
 * * `AUCTION_INSTANT_ORDER_CREATED` - RFQ %(request_id)s | Transport order from Bidding InstaOrder - acceptation needed
 * * `AUCTION_INSTANT_ORDER_REVERTED` - RFQ %(request_id)s | InstaOrder Transport Canceled
 * * `AUCTION_DURATION_EXTENDED` - RFQ %(request_id)s | Request duration extended
 * * `AUCTION_CANCELED` - RFQ %(request_id)s | Request canceled
 * * `AUCTION_UPDATED_BEFORE_BIDDING` - RFQ %(request_id)s | Request modified
 * * `BID_CONFIRMED_BY_SHIPPER` - Action Required: Confirm your selection | RFQ %(request_id)s
 * * `BID_SELECTION_WITHDRAWN` - RFQ %(request_id)s | Your selection has been withdrawn
 * * `BID_NO_LONGER_LOWEST` - RFQ %(request_id)s | Your bid is no longer the lowest
 * * `CONTRACTED_PRICE_CONFIRMED_BY_SHIPPER` - Your client has confirmed your price offer | RFQ %(request_id)s
 * * `BID_NOT_CHOSEN` - RFQ %(request_id)s | You were not selected
 * * `TRANSPORT_ADDITIONAL_CHANGES` - RFQ %(request_id)s | Transport modified
 * * `TRANSPORT_CANCELED` - RFQ %(request_id)s | Transport canceled
 * * `TRANSPORT_MODIFIED` - RFQ %(request_id)s | Transport modified
 * * `TRANSPORT_UPDATE_REQUESTED` - RFQ %(formatted_request_id)s | Transport update requested
 * * `BILLING_DETAILS_APPROVED` - Billing details approved
 * * `BILLING_DETAILS_REJECTED` - Billing details rejected
 * * `DOCUMENT_UPLOADED` - RFQ %(request_id)s | Document added
 * * `TRANSPORT_CANCEL_REQUEST_ACCEPTED` - RFQ %(request_id)s | Transport cancellation approved
 * * `TRANSPORT_CANCEL_REQUEST_REJECTED` - RFQ %(request_id)s | Transport cancellation rejected
 * * `TENDER_PUBLISHED` - Tender %(request_id)s | Invitation to participate
 * * `TENDER_CONTRACT_PROPOSAL_SENT` - Tender %(request_id)s | New contract proposal
 * * `TENDER_CONTRACT_PROPOSAL_TAKEN_BACK` - Tender %(request_id)s | Contract proposal withdrawn
 * * `TENDER_DOCUMENT_UPLOADED` - Tender %(request_id)s | New document added
 * * `TENDER_FINISHED` - Tender %(request_id)s | Tender finished
 * * `TENDER_CANCELED` - Tender %(request_id)s | Tender canceled
 * * `TENDER_CONTRACT_CANCELED` - Tender %(tender_name)s | Contract has been canceled
 * * `TENDER_DEADLINE_UPDATED` - Tender %(tender_name)s | Tender deadline updated
 * * `TENDER_UPDATED` - Tender %(tender_name)s | Tender details modified
 * * `TIME_SLOT_BOOKING_REJECTED` - %(rfq_prefix)sTime slot booking rejected
 * * `TIME_SLOT_BOOKING_UPDATED` - %(rfq_prefix)sTime slot booking updated
 * * `TIME_SLOT_BOOKING_APPROVED` - %(rfq_prefix)sTime slot booking approved
 * * `TIME_SLOT_BOOKING_CANCELED` - %(rfq_prefix)sTime slot booking canceled
 * * `TIME_SLOT_BOOKING_CANCELED_BY_SYSTEM` - %(rfq_prefix)sTime slot booking canceled
 * * `BOOKING_LINK_SENT` - Time slot booking required
 * * `BLOCKED_CARRIER_INVITATION` - You're missing an RFQ invitation — unpaid invoices on your account
 * * `NEW_AUCTION_BID` - New bid from %(carrier)s
 * * `CONTRACTED_PRICE_PROVIDED` - Contracted price provided by %(carrier)s
 * * `CARRIER_CONFIRMED_BID` - Carrier %(carrier)s confirmed Request %(formatted_request_id)s
 * * `CARRIER_SUBSCRIBED_TO_EMAILS` - Carrier %(target)s subscribed
 * * `CARRIER_UNSUBSCRIBED_FROM_EMAILS` - Carrier %(target)s unsubscribed
 * * `CARRIER_REJECTED_BID` - Carrier %(carrier)s rejected request
 * * `CARRIER_REJECTED_CONTRACTED_PRICE` - Carrier %(carrier)s rejected contracted transport
 * * `CARRIER_REJECTED_AUCTION` - Carrier %(carrier)s rejected participation
 * * `CARRIER_REJECTED_CONTRACTED_TRANSPORT` - Carrier %(carrier)s rejected contracted transport
 * * `TRANSPORT_DETAILS_UPDATED` - Transport data has been changed
 * * `RESPONSIBLE_PERSON_CHANGED` - You were assigned a new Request %(formatted_request_id)s
 * * `FOLLOWER_ADDED` - You were marked as a follower of %(formatted_request_id)s
 * * `TRANSPORT_RESPONSIBLE_PERSON_CHANGED` - You were assigned a new Transport %(formatted_request_id)s
 * * `TRANSPORT_UPDATE_CREATED` - RFQ %(formatted_request_id)s | New shipment update
 * * `CARRIER_UPLOADED_DOCUMENT` - Document added for Request %(formatted_request_id)s
 * * `CARRIER_UPLOADED_DOCUMENT_TO_TRANSPORT` - Document added for Transport %(formatted_request_id)s
 * * `UNREAD_MESSAGES` - Unread messages for RFQ %(formatted_request_id)s
 * * `UNREAD_MESSAGES_FOR_TENDER` - Unread messages for Tender %(formatted_request_id)s
 * * `AUTO_SELECT_NO_BIDS` - Automatic selection failed for Request %(formatted_request_id)s - no bids
 * * `AUTO_SELECT_BID_ABOVE_LIMIT` - Automatic selection failed for Request %(formatted_request_id)s - lowest bid above the limit
 * * `AUTO_SELECT_ERROR` - Automatic selection failed for Request %(formatted_request_id)s
 * * `CARRIER_CREATED_TRANSPORT_CANCEL_REQUEST` - Carrier %(carrier)s marked transport %(formatted_request_id)s as canceled
 * * `AUCTION_DRAFT_CREATED` - Request %(formatted_request_id)s has been created by email
 * * `TENDER_NEW_OFFERS_SUBMITTED` - Tender %(formatted_request_id)s | New price offer by %(carrier)s
 * * `TENDER_UPDATED_OFFERS_SUBMITTED` - Tender %(formatted_request_id)s | Price offer updated by %(carrier)s
 * * `TENDER_CONTRACT_PROPOSAL_ACCEPTED` - Tender %(formatted_request_id)s | Contract proposal accepted by %(carrier)s
 * * `TENDER_CONTRACT_PROPOSAL_REJECTED` - Tender %(formatted_request_id)s | Contract proposal rejected by %(carrier)s
 * * `CARRIER_BOOKING_CANCELED` - %(rfq_prefix)sTime slot booking canceled
 * * `CARRIER_BOOKING_WITHDRAWN` - %(rfq_prefix)sTime slot booking withdrawn
 * * `BOOKING_CANCELED_BY_SYSTEM` - %(rfq_prefix)sTime slot booking canceled
 * * `CARRIER_BOOKING_REQUESTED` - %(rfq_prefix)sTime slot booking requested
 * * `CARRIER_BOOKING_UPDATED` - %(rfq_prefix)sTime slot booking updated
 */
export enum NotificationEventEnum {
  OTP_REQUEST = "OTP_REQUEST",
  CONSENT_REQUEST = "CONSENT_REQUEST",
  TERMS_REQUIRED_INFORM = "TERMS_REQUIRED_INFORM",
  CARRIER_REMOVED_FROM_ONGOING_AUCTION = "CARRIER_REMOVED_FROM_ONGOING_AUCTION",
  CARRIER_NOTE_MODIFIED = "CARRIER_NOTE_MODIFIED",
  CARRIER_UNREAD_MESSAGES = "CARRIER_UNREAD_MESSAGES",
  CONTACT_CREATED = "CONTACT_CREATED",
  AUCTION_PUBLISHED = "AUCTION_PUBLISHED",
  AUCTION_CONTRACTED_PUBLISHED = "AUCTION_CONTRACTED_PUBLISHED",
  AUCTION_INSTANT_ORDER_CONFIRMED = "AUCTION_INSTANT_ORDER_CONFIRMED",
  AUCTION_INSTANT_ORDER_CREATED = "AUCTION_INSTANT_ORDER_CREATED",
  AUCTION_INSTANT_ORDER_REVERTED = "AUCTION_INSTANT_ORDER_REVERTED",
  AUCTION_DURATION_EXTENDED = "AUCTION_DURATION_EXTENDED",
  AUCTION_CANCELED = "AUCTION_CANCELED",
  AUCTION_UPDATED_BEFORE_BIDDING = "AUCTION_UPDATED_BEFORE_BIDDING",
  BID_CONFIRMED_BY_SHIPPER = "BID_CONFIRMED_BY_SHIPPER",
  BID_SELECTION_WITHDRAWN = "BID_SELECTION_WITHDRAWN",
  BID_NO_LONGER_LOWEST = "BID_NO_LONGER_LOWEST",
  CONTRACTED_PRICE_CONFIRMED_BY_SHIPPER = "CONTRACTED_PRICE_CONFIRMED_BY_SHIPPER",
  BID_NOT_CHOSEN = "BID_NOT_CHOSEN",
  TRANSPORT_ADDITIONAL_CHANGES = "TRANSPORT_ADDITIONAL_CHANGES",
  TRANSPORT_CANCELED = "TRANSPORT_CANCELED",
  TRANSPORT_MODIFIED = "TRANSPORT_MODIFIED",
  TRANSPORT_UPDATE_REQUESTED = "TRANSPORT_UPDATE_REQUESTED",
  BILLING_DETAILS_APPROVED = "BILLING_DETAILS_APPROVED",
  BILLING_DETAILS_REJECTED = "BILLING_DETAILS_REJECTED",
  DOCUMENT_UPLOADED = "DOCUMENT_UPLOADED",
  TRANSPORT_CANCEL_REQUEST_ACCEPTED = "TRANSPORT_CANCEL_REQUEST_ACCEPTED",
  TRANSPORT_CANCEL_REQUEST_REJECTED = "TRANSPORT_CANCEL_REQUEST_REJECTED",
  TENDER_PUBLISHED = "TENDER_PUBLISHED",
  TENDER_CONTRACT_PROPOSAL_SENT = "TENDER_CONTRACT_PROPOSAL_SENT",
  TENDER_CONTRACT_PROPOSAL_TAKEN_BACK = "TENDER_CONTRACT_PROPOSAL_TAKEN_BACK",
  TENDER_DOCUMENT_UPLOADED = "TENDER_DOCUMENT_UPLOADED",
  TENDER_FINISHED = "TENDER_FINISHED",
  TENDER_CANCELED = "TENDER_CANCELED",
  TENDER_CONTRACT_CANCELED = "TENDER_CONTRACT_CANCELED",
  TENDER_DEADLINE_UPDATED = "TENDER_DEADLINE_UPDATED",
  TENDER_UPDATED = "TENDER_UPDATED",
  TIME_SLOT_BOOKING_REJECTED = "TIME_SLOT_BOOKING_REJECTED",
  TIME_SLOT_BOOKING_UPDATED = "TIME_SLOT_BOOKING_UPDATED",
  TIME_SLOT_BOOKING_APPROVED = "TIME_SLOT_BOOKING_APPROVED",
  TIME_SLOT_BOOKING_CANCELED = "TIME_SLOT_BOOKING_CANCELED",
  TIME_SLOT_BOOKING_CANCELED_BY_SYSTEM = "TIME_SLOT_BOOKING_CANCELED_BY_SYSTEM",
  BOOKING_LINK_SENT = "BOOKING_LINK_SENT",
  BLOCKED_CARRIER_INVITATION = "BLOCKED_CARRIER_INVITATION",
  NEW_AUCTION_BID = "NEW_AUCTION_BID",
  CONTRACTED_PRICE_PROVIDED = "CONTRACTED_PRICE_PROVIDED",
  CARRIER_CONFIRMED_BID = "CARRIER_CONFIRMED_BID",
  CARRIER_SUBSCRIBED_TO_EMAILS = "CARRIER_SUBSCRIBED_TO_EMAILS",
  CARRIER_UNSUBSCRIBED_FROM_EMAILS = "CARRIER_UNSUBSCRIBED_FROM_EMAILS",
  CARRIER_REJECTED_BID = "CARRIER_REJECTED_BID",
  CARRIER_REJECTED_CONTRACTED_PRICE = "CARRIER_REJECTED_CONTRACTED_PRICE",
  CARRIER_REJECTED_AUCTION = "CARRIER_REJECTED_AUCTION",
  CARRIER_REJECTED_CONTRACTED_TRANSPORT = "CARRIER_REJECTED_CONTRACTED_TRANSPORT",
  TRANSPORT_DETAILS_UPDATED = "TRANSPORT_DETAILS_UPDATED",
  RESPONSIBLE_PERSON_CHANGED = "RESPONSIBLE_PERSON_CHANGED",
  FOLLOWER_ADDED = "FOLLOWER_ADDED",
  TRANSPORT_RESPONSIBLE_PERSON_CHANGED = "TRANSPORT_RESPONSIBLE_PERSON_CHANGED",
  TRANSPORT_UPDATE_CREATED = "TRANSPORT_UPDATE_CREATED",
  CARRIER_UPLOADED_DOCUMENT = "CARRIER_UPLOADED_DOCUMENT",
  CARRIER_UPLOADED_DOCUMENT_TO_TRANSPORT = "CARRIER_UPLOADED_DOCUMENT_TO_TRANSPORT",
  UNREAD_MESSAGES = "UNREAD_MESSAGES",
  UNREAD_MESSAGES_FOR_TENDER = "UNREAD_MESSAGES_FOR_TENDER",
  AUTO_SELECT_NO_BIDS = "AUTO_SELECT_NO_BIDS",
  AUTO_SELECT_BID_ABOVE_LIMIT = "AUTO_SELECT_BID_ABOVE_LIMIT",
  AUTO_SELECT_ERROR = "AUTO_SELECT_ERROR",
  CARRIER_CREATED_TRANSPORT_CANCEL_REQUEST = "CARRIER_CREATED_TRANSPORT_CANCEL_REQUEST",
  AUCTION_DRAFT_CREATED = "AUCTION_DRAFT_CREATED",
  TENDER_NEW_OFFERS_SUBMITTED = "TENDER_NEW_OFFERS_SUBMITTED",
  TENDER_UPDATED_OFFERS_SUBMITTED = "TENDER_UPDATED_OFFERS_SUBMITTED",
  TENDER_CONTRACT_PROPOSAL_ACCEPTED = "TENDER_CONTRACT_PROPOSAL_ACCEPTED",
  TENDER_CONTRACT_PROPOSAL_REJECTED = "TENDER_CONTRACT_PROPOSAL_REJECTED",
  CARRIER_BOOKING_CANCELED = "CARRIER_BOOKING_CANCELED",
  CARRIER_BOOKING_WITHDRAWN = "CARRIER_BOOKING_WITHDRAWN",
  BOOKING_CANCELED_BY_SYSTEM = "BOOKING_CANCELED_BY_SYSTEM",
  CARRIER_BOOKING_REQUESTED = "CARRIER_BOOKING_REQUESTED",
  CARRIER_BOOKING_UPDATED = "CARRIER_BOOKING_UPDATED",
}

/**
 * * `OTP_REQUEST` - OTP_REQUEST
 * * `CONSENT_REQUEST` - CONSENT_REQUEST
 * * `TERMS_REQUIRED_INFORM` - TERMS_REQUIRED_INFORM
 * * `CARRIER_REMOVED_FROM_ONGOING_AUCTION` - CARRIER_REMOVED_FROM_ONGOING_AUCTION
 * * `CARRIER_NOTE_MODIFIED` - CARRIER_NOTE_MODIFIED
 * * `CARRIER_UNREAD_MESSAGES` - CARRIER_UNREAD_MESSAGES
 * * `CONTACT_CREATED` - CONTACT_CREATED
 * * `AUCTION_PUBLISHED` - AUCTION_PUBLISHED
 * * `AUCTION_CONTRACTED_PUBLISHED` - AUCTION_CONTRACTED_PUBLISHED
 * * `AUCTION_INSTANT_ORDER_CONFIRMED` - AUCTION_INSTANT_ORDER_CONFIRMED
 * * `AUCTION_INSTANT_ORDER_CREATED` - AUCTION_INSTANT_ORDER_CREATED
 * * `AUCTION_INSTANT_ORDER_REVERTED` - AUCTION_INSTANT_ORDER_REVERTED
 * * `AUCTION_DURATION_EXTENDED` - AUCTION_DURATION_EXTENDED
 * * `AUCTION_CANCELED` - AUCTION_CANCELED
 * * `AUCTION_UPDATED_BEFORE_BIDDING` - AUCTION_UPDATED_BEFORE_BIDDING
 * * `BID_CONFIRMED_BY_SHIPPER` - BID_CONFIRMED_BY_SHIPPER
 * * `BID_SELECTION_WITHDRAWN` - BID_SELECTION_WITHDRAWN
 * * `BID_NO_LONGER_LOWEST` - BID_NO_LONGER_LOWEST
 * * `CONTRACTED_PRICE_CONFIRMED_BY_SHIPPER` - CONTRACTED_PRICE_CONFIRMED_BY_SHIPPER
 * * `BID_NOT_CHOSEN` - BID_NOT_CHOSEN
 * * `TRANSPORT_ADDITIONAL_CHANGES` - TRANSPORT_ADDITIONAL_CHANGES
 * * `TRANSPORT_CANCELED` - TRANSPORT_CANCELED
 * * `TRANSPORT_MODIFIED` - TRANSPORT_MODIFIED
 * * `TRANSPORT_UPDATE_REQUESTED` - TRANSPORT_UPDATE_REQUESTED
 * * `BILLING_DETAILS_APPROVED` - BILLING_DETAILS_APPROVED
 * * `BILLING_DETAILS_REJECTED` - BILLING_DETAILS_REJECTED
 * * `DOCUMENT_UPLOADED` - DOCUMENT_UPLOADED
 * * `TRANSPORT_CANCEL_REQUEST_ACCEPTED` - TRANSPORT_CANCEL_REQUEST_ACCEPTED
 * * `TRANSPORT_CANCEL_REQUEST_REJECTED` - TRANSPORT_CANCEL_REQUEST_REJECTED
 * * `TENDER_PUBLISHED` - TENDER_PUBLISHED
 * * `TENDER_CONTRACT_PROPOSAL_SENT` - TENDER_CONTRACT_PROPOSAL_SENT
 * * `TENDER_CONTRACT_PROPOSAL_TAKEN_BACK` - TENDER_CONTRACT_PROPOSAL_TAKEN_BACK
 * * `TENDER_DOCUMENT_UPLOADED` - TENDER_DOCUMENT_UPLOADED
 * * `TENDER_FINISHED` - TENDER_FINISHED
 * * `TENDER_CANCELED` - TENDER_CANCELED
 * * `TENDER_CONTRACT_CANCELED` - TENDER_CONTRACT_CANCELED
 * * `TENDER_DEADLINE_UPDATED` - TENDER_DEADLINE_UPDATED
 * * `TENDER_UPDATED` - TENDER_UPDATED
 * * `TIME_SLOT_BOOKING_REJECTED` - TIME_SLOT_BOOKING_REJECTED
 * * `TIME_SLOT_BOOKING_UPDATED` - TIME_SLOT_BOOKING_UPDATED
 * * `TIME_SLOT_BOOKING_APPROVED` - TIME_SLOT_BOOKING_APPROVED
 * * `TIME_SLOT_BOOKING_CANCELED` - TIME_SLOT_BOOKING_CANCELED
 * * `TIME_SLOT_BOOKING_CANCELED_BY_SYSTEM` - TIME_SLOT_BOOKING_CANCELED_BY_SYSTEM
 * * `BOOKING_LINK_SENT` - BOOKING_LINK_SENT
 * * `BLOCKED_CARRIER_INVITATION` - BLOCKED_CARRIER_INVITATION
 * * `NEW_AUCTION_BID` - NEW_AUCTION_BID
 * * `CONTRACTED_PRICE_PROVIDED` - CONTRACTED_PRICE_PROVIDED
 * * `CARRIER_CONFIRMED_BID` - CARRIER_CONFIRMED_BID
 * * `CARRIER_SUBSCRIBED_TO_EMAILS` - CARRIER_SUBSCRIBED_TO_EMAILS
 * * `CARRIER_UNSUBSCRIBED_FROM_EMAILS` - CARRIER_UNSUBSCRIBED_FROM_EMAILS
 * * `CARRIER_REJECTED_BID` - CARRIER_REJECTED_BID
 * * `CARRIER_REJECTED_CONTRACTED_PRICE` - CARRIER_REJECTED_CONTRACTED_PRICE
 * * `CARRIER_REJECTED_AUCTION` - CARRIER_REJECTED_AUCTION
 * * `CARRIER_REJECTED_CONTRACTED_TRANSPORT` - CARRIER_REJECTED_CONTRACTED_TRANSPORT
 * * `TRANSPORT_DETAILS_UPDATED` - TRANSPORT_DETAILS_UPDATED
 * * `RESPONSIBLE_PERSON_CHANGED` - RESPONSIBLE_PERSON_CHANGED
 * * `FOLLOWER_ADDED` - FOLLOWER_ADDED
 * * `TRANSPORT_RESPONSIBLE_PERSON_CHANGED` - TRANSPORT_RESPONSIBLE_PERSON_CHANGED
 * * `TRANSPORT_UPDATE_CREATED` - TRANSPORT_UPDATE_CREATED
 * * `CARRIER_UPLOADED_DOCUMENT` - CARRIER_UPLOADED_DOCUMENT
 * * `CARRIER_UPLOADED_DOCUMENT_TO_TRANSPORT` - CARRIER_UPLOADED_DOCUMENT_TO_TRANSPORT
 * * `UNREAD_MESSAGES` - UNREAD_MESSAGES
 * * `UNREAD_MESSAGES_FOR_TENDER` - UNREAD_MESSAGES_FOR_TENDER
 * * `AUTO_SELECT_NO_BIDS` - AUTO_SELECT_NO_BIDS
 * * `AUTO_SELECT_BID_ABOVE_LIMIT` - AUTO_SELECT_BID_ABOVE_LIMIT
 * * `AUTO_SELECT_ERROR` - AUTO_SELECT_ERROR
 * * `CARRIER_CREATED_TRANSPORT_CANCEL_REQUEST` - CARRIER_CREATED_TRANSPORT_CANCEL_REQUEST
 * * `AUCTION_DRAFT_CREATED` - AUCTION_DRAFT_CREATED
 * * `TENDER_NEW_OFFERS_SUBMITTED` - TENDER_NEW_OFFERS_SUBMITTED
 * * `TENDER_UPDATED_OFFERS_SUBMITTED` - TENDER_UPDATED_OFFERS_SUBMITTED
 * * `TENDER_CONTRACT_PROPOSAL_ACCEPTED` - TENDER_CONTRACT_PROPOSAL_ACCEPTED
 * * `TENDER_CONTRACT_PROPOSAL_REJECTED` - TENDER_CONTRACT_PROPOSAL_REJECTED
 * * `CARRIER_BOOKING_CANCELED` - CARRIER_BOOKING_CANCELED
 * * `CARRIER_BOOKING_WITHDRAWN` - CARRIER_BOOKING_WITHDRAWN
 * * `BOOKING_CANCELED_BY_SYSTEM` - BOOKING_CANCELED_BY_SYSTEM
 * * `CARRIER_BOOKING_REQUESTED` - CARRIER_BOOKING_REQUESTED
 * * `CARRIER_BOOKING_UPDATED` - CARRIER_BOOKING_UPDATED
 */
export enum NotificationEventNameEnum {
  OTP_REQUEST = "OTP_REQUEST",
  CONSENT_REQUEST = "CONSENT_REQUEST",
  TERMS_REQUIRED_INFORM = "TERMS_REQUIRED_INFORM",
  CARRIER_REMOVED_FROM_ONGOING_AUCTION = "CARRIER_REMOVED_FROM_ONGOING_AUCTION",
  CARRIER_NOTE_MODIFIED = "CARRIER_NOTE_MODIFIED",
  CARRIER_UNREAD_MESSAGES = "CARRIER_UNREAD_MESSAGES",
  CONTACT_CREATED = "CONTACT_CREATED",
  AUCTION_PUBLISHED = "AUCTION_PUBLISHED",
  AUCTION_CONTRACTED_PUBLISHED = "AUCTION_CONTRACTED_PUBLISHED",
  AUCTION_INSTANT_ORDER_CONFIRMED = "AUCTION_INSTANT_ORDER_CONFIRMED",
  AUCTION_INSTANT_ORDER_CREATED = "AUCTION_INSTANT_ORDER_CREATED",
  AUCTION_INSTANT_ORDER_REVERTED = "AUCTION_INSTANT_ORDER_REVERTED",
  AUCTION_DURATION_EXTENDED = "AUCTION_DURATION_EXTENDED",
  AUCTION_CANCELED = "AUCTION_CANCELED",
  AUCTION_UPDATED_BEFORE_BIDDING = "AUCTION_UPDATED_BEFORE_BIDDING",
  BID_CONFIRMED_BY_SHIPPER = "BID_CONFIRMED_BY_SHIPPER",
  BID_SELECTION_WITHDRAWN = "BID_SELECTION_WITHDRAWN",
  BID_NO_LONGER_LOWEST = "BID_NO_LONGER_LOWEST",
  CONTRACTED_PRICE_CONFIRMED_BY_SHIPPER = "CONTRACTED_PRICE_CONFIRMED_BY_SHIPPER",
  BID_NOT_CHOSEN = "BID_NOT_CHOSEN",
  TRANSPORT_ADDITIONAL_CHANGES = "TRANSPORT_ADDITIONAL_CHANGES",
  TRANSPORT_CANCELED = "TRANSPORT_CANCELED",
  TRANSPORT_MODIFIED = "TRANSPORT_MODIFIED",
  TRANSPORT_UPDATE_REQUESTED = "TRANSPORT_UPDATE_REQUESTED",
  BILLING_DETAILS_APPROVED = "BILLING_DETAILS_APPROVED",
  BILLING_DETAILS_REJECTED = "BILLING_DETAILS_REJECTED",
  DOCUMENT_UPLOADED = "DOCUMENT_UPLOADED",
  TRANSPORT_CANCEL_REQUEST_ACCEPTED = "TRANSPORT_CANCEL_REQUEST_ACCEPTED",
  TRANSPORT_CANCEL_REQUEST_REJECTED = "TRANSPORT_CANCEL_REQUEST_REJECTED",
  TENDER_PUBLISHED = "TENDER_PUBLISHED",
  TENDER_CONTRACT_PROPOSAL_SENT = "TENDER_CONTRACT_PROPOSAL_SENT",
  TENDER_CONTRACT_PROPOSAL_TAKEN_BACK = "TENDER_CONTRACT_PROPOSAL_TAKEN_BACK",
  TENDER_DOCUMENT_UPLOADED = "TENDER_DOCUMENT_UPLOADED",
  TENDER_FINISHED = "TENDER_FINISHED",
  TENDER_CANCELED = "TENDER_CANCELED",
  TENDER_CONTRACT_CANCELED = "TENDER_CONTRACT_CANCELED",
  TENDER_DEADLINE_UPDATED = "TENDER_DEADLINE_UPDATED",
  TENDER_UPDATED = "TENDER_UPDATED",
  TIME_SLOT_BOOKING_REJECTED = "TIME_SLOT_BOOKING_REJECTED",
  TIME_SLOT_BOOKING_UPDATED = "TIME_SLOT_BOOKING_UPDATED",
  TIME_SLOT_BOOKING_APPROVED = "TIME_SLOT_BOOKING_APPROVED",
  TIME_SLOT_BOOKING_CANCELED = "TIME_SLOT_BOOKING_CANCELED",
  TIME_SLOT_BOOKING_CANCELED_BY_SYSTEM = "TIME_SLOT_BOOKING_CANCELED_BY_SYSTEM",
  BOOKING_LINK_SENT = "BOOKING_LINK_SENT",
  BLOCKED_CARRIER_INVITATION = "BLOCKED_CARRIER_INVITATION",
  NEW_AUCTION_BID = "NEW_AUCTION_BID",
  CONTRACTED_PRICE_PROVIDED = "CONTRACTED_PRICE_PROVIDED",
  CARRIER_CONFIRMED_BID = "CARRIER_CONFIRMED_BID",
  CARRIER_SUBSCRIBED_TO_EMAILS = "CARRIER_SUBSCRIBED_TO_EMAILS",
  CARRIER_UNSUBSCRIBED_FROM_EMAILS = "CARRIER_UNSUBSCRIBED_FROM_EMAILS",
  CARRIER_REJECTED_BID = "CARRIER_REJECTED_BID",
  CARRIER_REJECTED_CONTRACTED_PRICE = "CARRIER_REJECTED_CONTRACTED_PRICE",
  CARRIER_REJECTED_AUCTION = "CARRIER_REJECTED_AUCTION",
  CARRIER_REJECTED_CONTRACTED_TRANSPORT = "CARRIER_REJECTED_CONTRACTED_TRANSPORT",
  TRANSPORT_DETAILS_UPDATED = "TRANSPORT_DETAILS_UPDATED",
  RESPONSIBLE_PERSON_CHANGED = "RESPONSIBLE_PERSON_CHANGED",
  FOLLOWER_ADDED = "FOLLOWER_ADDED",
  TRANSPORT_RESPONSIBLE_PERSON_CHANGED = "TRANSPORT_RESPONSIBLE_PERSON_CHANGED",
  TRANSPORT_UPDATE_CREATED = "TRANSPORT_UPDATE_CREATED",
  CARRIER_UPLOADED_DOCUMENT = "CARRIER_UPLOADED_DOCUMENT",
  CARRIER_UPLOADED_DOCUMENT_TO_TRANSPORT = "CARRIER_UPLOADED_DOCUMENT_TO_TRANSPORT",
  UNREAD_MESSAGES = "UNREAD_MESSAGES",
  UNREAD_MESSAGES_FOR_TENDER = "UNREAD_MESSAGES_FOR_TENDER",
  AUTO_SELECT_NO_BIDS = "AUTO_SELECT_NO_BIDS",
  AUTO_SELECT_BID_ABOVE_LIMIT = "AUTO_SELECT_BID_ABOVE_LIMIT",
  AUTO_SELECT_ERROR = "AUTO_SELECT_ERROR",
  CARRIER_CREATED_TRANSPORT_CANCEL_REQUEST = "CARRIER_CREATED_TRANSPORT_CANCEL_REQUEST",
  AUCTION_DRAFT_CREATED = "AUCTION_DRAFT_CREATED",
  TENDER_NEW_OFFERS_SUBMITTED = "TENDER_NEW_OFFERS_SUBMITTED",
  TENDER_UPDATED_OFFERS_SUBMITTED = "TENDER_UPDATED_OFFERS_SUBMITTED",
  TENDER_CONTRACT_PROPOSAL_ACCEPTED = "TENDER_CONTRACT_PROPOSAL_ACCEPTED",
  TENDER_CONTRACT_PROPOSAL_REJECTED = "TENDER_CONTRACT_PROPOSAL_REJECTED",
  CARRIER_BOOKING_CANCELED = "CARRIER_BOOKING_CANCELED",
  CARRIER_BOOKING_WITHDRAWN = "CARRIER_BOOKING_WITHDRAWN",
  BOOKING_CANCELED_BY_SYSTEM = "BOOKING_CANCELED_BY_SYSTEM",
  CARRIER_BOOKING_REQUESTED = "CARRIER_BOOKING_REQUESTED",
  CARRIER_BOOKING_UPDATED = "CARRIER_BOOKING_UPDATED",
}

export interface NotificationsListParams {
  isRead?: boolean;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface NotificationsMarkAsReadCreateParams {
  /** A unique integer value identifying this notification. */
  id: number;
}

export interface NotificationsRetrieveParams {
  /** A unique integer value identifying this notification. */
  id: number;
}

/**
 * Mixin for serializers that need to include a `terms_data` field.
 *
 * Usage:
 *     class MySerializer(TermsDataMixin, ModelSerializer):
 *         terms_data = serializers.SerializerMethodField()
 *
 *         def get_terms_data(self, obj):
 *             return self.build_terms_data(email=obj.email, contact=obj)
 */
export interface OneTimePassword {
  /** @format date-time */
  readonly createdAt: string;
  /**
   * @format email
   * @maxLength 254
   */
  email: string;
  /** @format date-time */
  expiresAt?: string;
  /**
   * Hash key
   * @maxLength 64
   */
  hash?: string;
  /** Verified */
  isVerified?: boolean;
  readonly preferredLanguage: LanguageEnum;
  readonly termsData: TermsData;
  /** @format date-time */
  readonly updatedAt: string;
}

export interface OneTimePasswordRequest {
  /** @format email */
  email: string;
  /**
   * @maxLength 500
   * @default ""
   */
  redirectUrl?: string;
}

export interface OneTimePasswordVerify {
  otpHash: string;
}

export interface OperatingHoursDayWrite {
  intervals: OperatingHoursIntervalWrite[];
  isOpen: boolean;
  /**
   * * `0` - Monday
   * * `1` - Tuesday
   * * `2` - Wednesday
   * * `3` - Thursday
   * * `4` - Friday
   * * `5` - Saturday
   * * `6` - Sunday
   */
  weekday: WeekdayEnum;
}

export interface OperatingHoursExceptionInterval {
  /** @format time */
  readonly endTime: string;
  /** @format time */
  readonly startTime: string;
}

export interface OperatingHoursExceptionIntervalWrite {
  /** @format time */
  endTime: string;
  /** @format time */
  startTime: string;
}

export interface OperatingHoursExceptionList {
  /** @format date */
  readonly dateFrom: string;
  /** @format date */
  readonly dateTo: string;
  readonly gates: GateNested[];
  readonly id: number;
  readonly intervals: OperatingHoursExceptionInterval[];
  readonly isClosed: boolean;
  /**
   * Exception name
   * @maxLength 100
   */
  readonly name: string;
}

export interface OperatingHoursExceptionWrite {
  /** @format date */
  dateFrom: string;
  /** @format date */
  dateTo: string;
  /** @maxItems 100 */
  gates?: number[];
  intervals: OperatingHoursExceptionIntervalWrite[];
  isClosed: boolean;
  /**
   * @maxLength 100
   * @default ""
   */
  name?: string;
}

export interface OperatingHoursInterval {
  /** @format time */
  readonly endTime: string;
  /** @format time */
  readonly startTime: string;
}

export interface OperatingHoursIntervalWrite {
  /** @format time */
  endTime: string;
  /** @format time */
  startTime: string;
}

export interface OperatingHoursList {
  readonly intervals: OperatingHoursInterval[];
  readonly isOpen: boolean;
  /**
   * @min 0
   * @max 32767
   */
  readonly weekday: WeekdayEnum;
}

/**
 * The whole week for an address. Every weekday must be present exactly once; a closed day is
 * sent as ``is_open: false`` with no intervals.
 */
export interface OperatingHoursListWrite {
  days: OperatingHoursDayWrite[];
}

/**
 * * `manual` - Manual
 * * `email` - Email
 * * `ai_document` - AI document
 * * `unknown` - Unknown
 */
export enum OriginEnum {
  Manual = "manual",
  Email = "email",
  AiDocument = "ai_document",
  Unknown = "unknown",
}

export interface OtpRetrieveParams {
  otpHash: string;
}

export interface OtpSetLanguage {
  /**
   * * `en` - English
   * * `sk` - Slovak
   * * `de` - German
   * * `fr` - French
   * * `it` - Italian
   * * `cs` - Czech
   * * `es` - Spain
   */
  preferredLanguage: LanguageEnum;
}

export interface OtpSetLanguageParams {
  otpHash: string;
}

export interface OtpUnpaidInvoicesRetrieveParams {
  otpHash: string;
}

export interface OverviewStats {
  countByInterval: CountByIntervalStats[];
  /**
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency: CurrencyEnum;
}

export interface PaginatedAddressDeactivationImpactList {
  /** @example 2 */
  bookingLinksCount: number;
  /** @example 2 */
  canceledCount: number;
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: AddressDeactivationImpact[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedAddressListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: AddressList[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedAuctionByEmailList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: AuctionByEmail[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedAuctionListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: AuctionList[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedBidByHashList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: BidByHash[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedBidHistoryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: BidHistory[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedBookingAddressNestedList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: BookingAddressNested[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedBookingImpactList {
  /** @example 2 */
  canceledCount: number;
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: BookingImpact[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedBookingLinkListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: BookingLinkList[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedCargoCategoryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CargoCategory[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedCargoItemUnitList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CargoItemUnit[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedCarrierBillingDetailsByHashInputList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CarrierBillingDetailsByHashInput[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedCarrierBookingList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CarrierBooking[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedCarrierContractListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CarrierContractList[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedCarrierGroupList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CarrierGroup[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedCarrierList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Carrier[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedCarrierMessageList {
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?cursor=cD00ODY%3D""
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?cursor=cj0xJnA9NDg3"
   */
  previous?: string | null;
  results: CarrierMessage[];
}

export interface PaginatedCarrierStatsResponse {
  count: number;
  /** @format uri */
  next: string | null;
  /** @format uri */
  previous: string | null;
  results: CarrierStatsResponse[];
  totalPages: number;
}

export interface PaginatedCarrierTenderListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CarrierTenderList[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedContactList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Contact[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedContractListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ContractList[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedContractOptionRowList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ContractOptionRow[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedContractRouteRowList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ContractRouteRow[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedDocumentList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Document[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedMessageList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Message[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedNotificationList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Notification[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedOperatingHoursExceptionListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: OperatingHoursExceptionList[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedRouteAddressList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: RouteAddress[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedRouteListList {
  /** A flat list of all matching IDs (not just the current page). */
  allIds?: number[];
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: RouteList[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedScheduledUserTaskList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ScheduledUserTask[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedTenderListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: TenderList[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedTermsAndConditionsList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: TermsAndConditions[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedTimeSlotBookingListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: TimeSlotBookingList[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedTransportBatchUpdateList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: TransportBatchUpdate[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedTransportByEmailList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: TransportByEmail[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedTransportListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: TransportList[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedUserList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: User[];
}

export interface PaginatedUserMessageList {
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?cursor=cD00ODY%3D""
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?cursor=cj0xJnA9NDg3"
   */
  previous?: string | null;
  results: UserMessage[];
}

export interface PaginatedVehicleTypeList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: VehicleType[];
  /** @example 12 */
  totalPages?: number;
}

export interface PaginatedWorkspaceTagList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: WorkspaceTag[];
  /** @example 12 */
  totalPages?: number;
}

export interface PasswordChange {
  /** @maxLength 128 */
  new_password1: string;
  /** @maxLength 128 */
  new_password2: string;
}

/** Serializer for requesting a password reset e-mail. */
export interface PasswordReset {
  /** @format email */
  email: string;
}

/** Serializer for confirming a password reset attempt. */
export interface PasswordResetConfirm {
  /** @maxLength 128 */
  new_password1: string;
  /** @maxLength 128 */
  new_password2: string;
  token: string;
  uid: string;
}

export interface PatchedAddress {
  city?: string | null;
  contacts?: AddressContact[];
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country?: CountryEnum;
  readonly createdBy?: UserGeneralInfo;
  readonly id?: number;
  /** @maxLength 50 */
  name?: string;
  /** @maxLength 20 */
  postCode?: string;
  /** @maxLength 100 */
  street?: string;
  /** IANA time zone */
  readonly timezone?: string;
  readonly workspace?: WorkspaceGeneralInfo;
}

export interface PatchedAuctionUpdate {
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  autoSelectLimit?: string;
  duration?: string;
  invitedContacts?: number[];
  isAutoSelect?: boolean;
}

export interface PatchedCargoCategory {
  readonly id?: number;
  /** @default false */
  readonly isUsedInDraft?: boolean;
  /**
   * * `WEIGHT` - Weight
   * * `LENGTH` - Length
   * * `VOLUME` - Volume
   * * `CUSTOM` - Custom
   */
  kind?: CargoCategoryKindEnum;
  /** @maxLength 100 */
  name?: string;
  ranges?: CargoCategoryRange[];
  /** @maxLength 2 */
  unit?: string | null;
}

export interface PatchedCargoItemUnit {
  readonly code?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  height?: string | null;
  readonly id?: number;
  isActive?: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  length?: string | null;
  /**
   * * `m` - m
   * * `cm` - cm
   * * `mm` - mm
   */
  lengthUnit?: LengthUnitEnum;
  /** @maxLength 150 */
  title?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  volume?: string | null;
  /**
   * * `l` - L
   * * `m3` - m³
   */
  volumeUnit?: VolumeUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  width?: string | null;
}

export interface PatchedCarrierGroup {
  contacts?: number[];
  /** @format date-time */
  readonly createdAt?: string;
  readonly createdBy?: UserGeneralInfo;
  readonly id?: number;
  /** @maxLength 255 */
  name?: string;
  note?: string;
  /** @format date-time */
  readonly updatedAt?: string;
  readonly workspace?: WorkspaceGeneralInfo;
}

export interface PatchedCarrierUpdate {
  address?: CompanyAddress | null;
  readonly id?: number;
  /** @maxLength 50 */
  internalId?: string;
  /**
   * Active
   * Designates whether this carrier should be treated as active. Unselect this instead of deleting carriers.
   */
  isActive?: boolean;
  /**
   * Title
   * @maxLength 100
   */
  name?: string;
  note?: string;
  /** @maxLength 50 */
  registrationNumber?: string;
  /** @maxLength 50 */
  taxNumber?: string;
  /** @maxLength 50 */
  vatNumber?: string;
  website?: string;
}

export interface PatchedCarrierUpdateIsActive {
  /**
   * Active
   * Designates whether this carrier should be treated as active. Unselect this instead of deleting carriers.
   */
  isActive?: boolean;
}

export interface PatchedContact {
  carrier?: number;
  readonly carrierContactsCount?: number;
  readonly carrierIsBlocked?: boolean;
  readonly carrierName?: string;
  readonly consentStatuses?: ConsentInfo[];
  /**
   * Contact email
   * @format email
   * @maxLength 254
   */
  email?: string;
  /** @maxLength 50 */
  fullName?: string;
  groups?: number[];
  readonly id?: number;
  /** @maxLength 128 */
  phoneNumber?: string;
  readonly preferredLanguage?: LanguageEnum;
  transportationModes?: TransportationModeEnum[];
}

/**
 * Mixin for serializers that need to include a `terms_data` field.
 *
 * Usage:
 *     class MySerializer(TermsDataMixin, ModelSerializer):
 *         terms_data = serializers.SerializerMethodField()
 *
 *         def get_terms_data(self, obj):
 *             return self.build_terms_data(email=obj.email, contact=obj)
 */
export interface PatchedContactByHash {
  readonly billingDetails?: CarrierByHashBillingDetails;
  readonly billingDetailsCandidate?: CarrierByHashBillingDetails;
  /** @format email */
  readonly email?: string;
  /** Hash key */
  readonly hash?: string;
  readonly internalId?: string;
  readonly preferredLanguage?: LanguageEnum;
  readonly termsData?: TermsData;
  readonly transportOrderDownloadAllowed?: boolean;
  readonly unpaidInvoices?: UnpaidInvoices;
}

export interface PatchedDocumentUpdate {
  /**
   * * `ALL` - Shared with all
   * * `WINNER` - Shared with winner
   * * `PRIVATE` - Private (only shipper)
   */
  accessLevel?: DocumentAccessLevelEnum;
  title?: string;
}

export interface PatchedRouteAddress {
  /** @maxLength 100 */
  city?: string;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country?: CountryEnum;
  readonly id?: number;
  /** If enabled, this address is shown as favorite addresses. */
  isFavorite?: boolean;
  /** @maxLength 50 */
  name?: string;
  /** @maxLength 20 */
  postCode?: string;
  /** @default false */
  saveToDirectory?: boolean;
  /** @maxLength 100 */
  street?: string;
}

export interface PatchedRouteUpdate {
  /** @maxLength 100 */
  identifier?: string;
  items?: RouteItemUpdate[];
  /**
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
}

export interface PatchedScheduledUserTask {
  /** @format date-time */
  readonly createdAt?: string;
  /**
   * Day(s) Of The Month
   * Cron Days Of The Month to Run. Use "*" for "all". (Example: "1,15")
   * @maxLength 124
   */
  dayOfMonth?: string;
  /**
   * Day(s) Of The Week
   * Cron Days Of The Week to Run. Use "*" for "all", Sunday is 0 or 7, Monday is 1. (Example: "0,5")
   * @maxLength 64
   */
  dayOfWeek?: string;
  filters?: any | null;
  /**
   * Hour(s)
   * Cron Hours to Run. Use "*" for "all". (Example: "8,20")
   * @maxLength 96
   */
  hour?: string;
  readonly humanReadableFilters?: string[];
  readonly id?: number;
  /**
   * Minute(s)
   * Cron Minutes to Run. Use "*" for "all". (Example: "0,30")
   * @maxLength 240
   */
  minute?: string;
  /**
   * * `DAILY` - Daily
   * * `WEEKLY` - Weekly
   * * `MONTHLY` - Monthly
   */
  periodicity?: ScheduledUserTaskPeriodicityEnum;
  readonly periodicityDisplay?: string;
  /** Comma separated list of email addresses */
  recipients?: string[];
  /** @maxLength 150 */
  title?: string;
}

export interface PatchedTransport {
  readonly cancelRequestStatus?: TransportCancelRequestStatusEnum;
  cargo?: Cargo;
  readonly carrier?: CarrierInfo;
  /** @maxLength 500 */
  costCenter?: string;
  /** @format date-time */
  readonly createdAt?: string;
  readonly createdBy?: UserGeneralInfo;
  /** @format double */
  readonly distance?: number;
  followers?: number[];
  readonly id?: number;
  readonly incoterms?: string;
  readonly mergedFromAuctions?: number[];
  note?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly price?: string;
  readonly priceCurrency?: CurrencyEnum;
  /** @maxLength 150 */
  reference?: string;
  /** @format int32 */
  readonly requestId?: number;
  resolvingRequests?: number[];
  readonly responsibleUser?: UserGeneralInfo;
  responsibleUserId?: number | null;
  /**
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
  /** @format uri */
  readonly staticMap?: string | null;
  /**
   * * `PROCESSING` - Processing
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   * * `CANCELED_BY_CARRIER` - Canceled by carrier
   * * `CANCELED_BY_SUPPORT` - Canceled by support
   */
  status?: TransportStatusEnum;
  tags?: string[];
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
  readonly type?: TransportTypeEnum;
  readonly vehicleTypeId?: number | null;
  waypoints?: Waypoint[];
  readonly winningBid?: Bid;
}

/**
 * Update contract: identical to the create one except that origin is not writable.
 *
 * Origin is create-time provenance and must never change afterwards. Enforcing that here rather
 * than by discarding the value in the usecase keeps the rule visible in the API contract: the
 * generated client types this field readonly, so a caller cannot send it believing it will apply.
 * Read-only rather than rejected on purpose — DRF ignores read-only input, so a client that GETs a
 * request and PATCHes the whole payload back still succeeds instead of tripping over a field it
 * never meant to change.
 *
 * Redeclared rather than listed in Meta.read_only_fields: that setting only affects
 * auto-generated fields, and origin is declared explicitly on the parent.
 */
export interface PatchedTransportRequestUpdate {
  readonly auction?: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  autoSelectLimit?: string | null;
  autoSelectLimitCurrency?: string | null;
  availabilityRequired?: boolean;
  cargo?: Cargo;
  contacts?: number[];
  readonly contractId?: number | null;
  /** @min 1 */
  contractPriceId?: number | null;
  /** @maxLength 500 */
  costCenter?: string;
  /** @format date-time */
  readonly createdAt?: string;
  readonly createdBy?: UserGeneralInfo;
  /** @format double */
  readonly distance?: number;
  duration?: string;
  followers?: number[];
  /** @format uuid */
  formCorrelationId?: string | null;
  readonly id?: number;
  /**
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  isAutoSelect?: boolean;
  mergedFrom?: number[];
  note?: string;
  readonly origin?: OriginEnum;
  price?: string | null;
  priceCurrency?: string | null;
  /** @maxLength 150 */
  reference?: string;
  resolvingTransport?: number | null;
  readonly responsibleUser?: UserGeneralInfo;
  responsibleUserId?: number | null;
  /**
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
  /** @format uri */
  readonly staticMap?: string | null;
  tags?: string[];
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
  type?: TransportTypeEnum | null;
  readonly vehicleType?: VehicleType | null;
  vehicleTypeId?: number | null;
  waypoints?: Waypoint[];
}

/** It's used for listing bids for user. Main difference is that shipper status could be updated. */
export interface PatchedUpdateBid {
  readonly carrier?: number;
  readonly carrierNote?: string;
  readonly carrierStatus?: BidStatusEnum;
  /** @format date-time */
  readonly carrierStatusChangedAt?: string;
  /** @format date-time */
  readonly createdAt?: string;
  readonly id?: number;
  readonly isAutoSelect?: boolean;
  readonly isConfirmedByShipper?: boolean;
  isInstantOrder?: boolean;
  readonly isManuallyExcluded?: boolean;
  readonly isRejected?: boolean;
  readonly isWinning?: boolean;
  metadata?: BidMetadata | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  offeredPrice?: string;
  readonly offeredPriceCurrency?: CurrencyEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  priceWorkspace?: string;
  readonly priceWorkspaceCurrency?: CurrencyEnum;
  shipperNote?: string;
  /**
   * * `CONFIRMED` - Confirmed
   * * `REJECTED` - Rejected
   * * `NOT_DECIDED` - Not decided
   */
  shipperStatus?: BidStatusEnum;
  /** @format date-time */
  readonly shipperStatusChangedAt?: string;
}

/** Separate serializer for carrier to update decision on bid. */
export interface PatchedUpdateBidByHash {
  readonly carrier?: number;
  carrierNote?: string;
  /**
   * * `CONFIRMED` - Confirmed
   * * `REJECTED` - Rejected
   * * `NOT_DECIDED` - Not decided
   */
  carrierStatus?: BidStatusEnum;
  readonly comparison?: BidComparisonEnum;
  /** @format date-time */
  readonly createdAt?: string;
  /** Hash key */
  readonly hash?: string;
  readonly id?: number;
  readonly isConfirmedByShipper?: boolean;
  readonly isRejected?: boolean;
  readonly isWinning?: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  offeredPrice?: string;
  readonly offeredPriceCurrency?: CurrencyEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  priceWorkspace?: string;
  readonly priceWorkspaceCurrency?: CurrencyEnum;
  readonly shipperNote?: string;
  readonly shipperStatus?: BidStatusEnum;
}

export interface PatchedUser {
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string;
  /** @maxLength 150 */
  firstName?: string;
  readonly id?: number;
  /**
   * Active
   * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
   */
  isActive?: boolean;
  /** @maxLength 150 */
  lastName?: string;
  readonly notificationSettings?: Record<
    string,
    Record<string, Record<string, boolean>>
  >;
  /** @maxLength 128 */
  phoneNumber?: string;
  readonly role?: number;
  roleId?: number;
  readonly workspace?: WorkspaceGeneralInfo;
}

/** User model w/o password */
export interface PatchedUserDetails {
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string;
  firstName?: string;
  readonly id?: number;
  /**
   * Active
   * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
   */
  isActive?: boolean;
  readonly isEmailVerified?: boolean;
  /** @maxLength 150 */
  lastName?: string;
  readonly members?: Member[];
  readonly notificationSettings?: Record<
    string,
    Record<string, Record<string, boolean>>
  >;
  readonly permissions?: string[];
  phoneNumber?: string;
  /** Language */
  preferredLanguage?: LanguageEnum;
  readonly workspace?: Workspace;
  workspaceId?: number;
}

export interface PatchedVehicleType {
  readonly id?: number;
  /** @default false */
  readonly isUsedInDraft?: boolean;
  /**
   * m²
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  maxCargoSpace?: string | null;
  /**
   * m³
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  maxCargoVolume?: string | null;
  /**
   * kg
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,0})?$
   */
  maxPayload?: string | null;
  /** @maxLength 100 */
  name?: string;
}

export interface PatchedWorkspaceTag {
  /** @maxLength 100 */
  name?: string;
}

export interface PatchedWorkspaceUpdate {
  address?: CompanyAddress | null;
  billingDetails?: BillingDetailsLimited | null;
  /**
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  readonly currencyRecalcInProgress?: boolean;
  /** @default false */
  deleteLogo?: boolean;
  /**
   * Email sender name
   * @maxLength 100
   */
  emailFromName?: string;
  /** Short identifier used in the workspace inbound e-mail address. */
  readonly emailHash?: string;
  /** Hash key */
  readonly hash?: string;
  readonly id?: number;
  /**
   * * `m` - m
   * * `cm` - cm
   * * `mm` - mm
   */
  lengthUnit?: LengthUnitEnum;
  /** @format uri */
  readonly logo?: string | null;
  microsoftAccount?: WorkspaceSocialMicrosoft | null;
  name?: string;
  readonly packageData?: WorkspacePackageData | null;
  preferences?: WorkspacePreferences;
  /**
   * * `l` - L
   * * `m3` - m³
   */
  volumeUnit?: VolumeUnitEnum;
  /**
   * * `kg` - kg
   * * `t` - t
   */
  weightUnit?: WeightUnitEnum;
}

/**
 * * `INVOICE` - Invoice
 * * `CREDIT_CARD` - Credit card
 */
export enum PaymentMethodEnum {
  INVOICE = "INVOICE",
  CREDIT_CARD = "CREDIT_CARD",
}

export interface PointField {
  /** @format double */
  lat: number;
  /** @format double */
  lng: number;
}

export interface PortalCompanyInfoResponse {
  banned: boolean;
  city: string;
  country: string;
  /** @format double */
  currentLimit: number;
  id: number;
  /** @format double */
  initialLimit: number;
  name: string;
  postcode: string;
  regId: string;
  status: string;
  street: string;
  taxId: string;
  type: string;
  vatId: string;
}

/** Only what the pricer reads; other fields of a posted-back transport request are not validated. */
export interface PricerRequest {
  cargo: Cargo;
  /**
   * @format double
   * @min 0
   */
  distance: number;
  /** @default "ROAD" */
  transportationMode?: TransportationModeEnum;
  waypoints: Waypoint[];
}

export interface PricerResult {
  readonly carrier: Carrier;
  expireAt: string;
  readonly expired: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly price: string;
}

export interface PrivacyConsentsCreateParams {
  token: string;
}

export type PrivacyConsentsCreatePayload = ConsentByTokenInput[];

export interface PrivacyConsentsMarketingCreateParams {
  token: string;
}

export interface PrivacyConsentsMarketingRetrieveParams {
  token: string;
}

export type PrivacyConsentsRequestResendCreateError = ConsentInfo;

export interface PrivacyConsentsRetrieveParams {
  consentTypes?: ConsentTypesEnum[];
  token: string;
}

export interface PrivacyConsentsSettingsCreateParams {
  token: string;
}

export type PrivacyConsentsSettingsCreatePayload = ConsentsSettings[];

export interface PrivacyConsentsSettingsListParams {
  token: string;
}

export interface PrivacyConsentsTermsCreateParams {
  token: string;
}

export type PrivacyConsentsTermsCreatePayload = TermsConsentByTokenInput[];

export interface PrivacyConsentsTermsRetrieveParams {
  token: string;
}

export interface PrivacyTermsAndConditionsListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface PrivacyTermsAndConditionsRetrieveParams {
  /** A unique integer value identifying this terms and conditions. */
  id: number;
}

export interface ProposeContract {
  /**
   * List of CarrierOffer IDs to include in the contract proposal.
   * @minItems 1
   */
  offerIds: number[];
}

export interface PushAuthorizeRequest {
  channelName: string;
  socketId: string;
}

export interface PushAuthorizeResponse {
  readonly auth: string;
}

export interface RailVehicleDetails {
  /** @maxLength 255 */
  trackingLink?: string;
  /** @maxLength 255 */
  trainNumber?: string;
  readonly transportationMode: TransportationModeEnum;
  /** @maxLength 255 */
  wagonContainerNumber?: string;
}

export interface RecaptchaVerifyResult {
  score: number;
  success: boolean;
}

export interface Reference {
  readonly displayId: number | null;
  readonly objectContentType: string;
  readonly objectHash: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  readonly objectId: number;
  readonly timelineId: number;
}

export interface Register {
  password1?: string;
  password2?: string;
  company: string;
  /** @format email */
  email: string;
  firstName: string;
  /**
   * * `en` - English
   * * `sk` - Slovak
   * * `de` - German
   * * `fr` - French
   * * `it` - Italian
   * * `cs` - Czech
   * * `es` - Spain
   */
  language?: LanguageEnum;
  lastName?: string;
  marketingPurposes?: boolean;
  phoneNumber: string;
  url?: string;
  utmCampaign?: string;
  utmMedium?: string;
  utmSource?: string;
}

export interface ResendConsentRequestInput {
  /** @default "EMAIL" */
  consentType?: ConsentTypesEnum;
  /** @format email */
  email: string;
}

export interface ResendEmailVerification {
  /** @format email */
  email: string;
}

export interface RestAuthDetail {
  readonly detail: string;
}

export interface RoadVehicleDetails {
  /** @maxLength 255 */
  driverName?: string;
  /** @maxLength 255 */
  driverPhone?: string;
  /** @maxLength 255 */
  plateNumber?: string;
  /** @maxLength 255 */
  trackingLink?: string;
  readonly transportationMode: TransportationModeEnum;
}

export interface Role {
  readonly description: string;
  readonly id: number;
  readonly isDefault: boolean;
  readonly title: string;
}

export interface RolesListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
}

export interface RolesRetrieveParams {
  /** A unique integer value identifying this role. */
  id: number;
}

export interface RouteAddress {
  /** @maxLength 100 */
  city?: string;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  readonly id: number;
  /** If enabled, this address is shown as favorite addresses. */
  isFavorite?: boolean;
  /** @maxLength 50 */
  name?: string;
  /** @maxLength 20 */
  postCode?: string;
  /** @default false */
  saveToDirectory?: boolean;
  /** @maxLength 100 */
  street?: string;
}

export interface RouteAddressesDestroyParams {
  /** A unique integer value identifying this Route Address. */
  id: number;
}

export interface RouteAddressesListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface RouteAddressesPartialUpdateParams {
  /** A unique integer value identifying this Route Address. */
  id: number;
}

export interface RouteAddressesRetrieveParams {
  /** A unique integer value identifying this Route Address. */
  id: number;
}

export interface RouteAddressesUpdateParams {
  /** A unique integer value identifying this Route Address. */
  id: number;
}

export interface RouteBulkCreate {
  routes: RouteCreate[];
}

export interface RouteBulkDelete {
  ids: number[];
}

export interface RouteCheckDraftUsageInput {
  ids: number[];
}

export interface RouteCreate {
  /** @maxLength 100 */
  identifier?: string;
  items: RouteItemCreate[];
  /**
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
}

export interface RouteItem {
  address: RouteAddress;
  readonly id: number;
  /**
   * @min 1
   * @max 32767
   */
  position: number;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  routeItemType: WaypointTypeEnum;
}

export interface RouteItemCreate {
  /** @min 1 */
  addressId: number;
  /** @min 1 */
  position: number;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  routeItemType: WaypointTypeEnum;
}

export interface RouteItemUpdate {
  /** @min 1 */
  addressId: number;
  id?: number;
  /** @min 1 */
  position: number;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  routeItemType: WaypointTypeEnum;
}

export interface RouteList {
  /** @format date-time */
  readonly createdAt: string;
  readonly id: number;
  /** @maxLength 100 */
  identifier?: string;
  /** @default false */
  readonly isUsedInDraft: boolean;
  readonly isUsedInTender: boolean;
  readonly items: RouteItem[];
  /**
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
}

export interface RouteStats {
  /** @format double */
  avgWeight: number;
  fromCity: string;
  fromCountry: string;
  shipmentCount: number;
  toCity: string;
  toCountry: string;
  /** @format double */
  totalWeight: number;
}

/**
 * * `ONE_WAY` - One way
 * * `ROUND_TRIP` - Round trip
 */
export enum RouteTypeEnum {
  ONE_WAY = "ONE_WAY",
  ROUND_TRIP = "ROUND_TRIP",
}

export interface RouteUpdate {
  /** @maxLength 100 */
  identifier?: string;
  items: RouteItemUpdate[];
  /**
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType: RouteTypeEnum;
}

export enum RoutesAutocompleteFieldEnum {
  City = "city",
  PostCode = "post_code",
  Street = "street",
}

export interface RoutesAutocompleteParams {
  /**
   * * `city` - city
   * * `post_code` - post_code
   * * `street` - street
   */
  field: RoutesAutocompleteFieldEnum;
  /** @minLength 1 */
  term: string;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

export interface RoutesDestroyParams {
  /** A unique integer value identifying this route. */
  id: number;
}

export interface RoutesListParams {
  country?: string;
  deliveryCity?: string;
  deliveryCountry?: string;
  deliveryPostCode?: string;
  deliveryStreet?: string;
  /** Multiple values may be separated by commas. */
  ids?: number[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  pickupCity?: string;
  pickupCountry?: string;
  pickupPostCode?: string;
  pickupStreet?: string;
  /**
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
  /** A search term. */
  search?: string;
}

export interface RoutesOverviewStats {
  /** @format double */
  averageDistance: number;
  /** @format double */
  averageVolume: number;
  /** @format double */
  averageWeight: number;
  distanceDistribution: DistanceDistribution[];
  locations: LocationStats[];
  routes: RouteStats[];
  /** @format double */
  totalDistance: number;
  totalShipments: number;
  /** @format double */
  totalVolume: number;
  /** @format double */
  totalWeight: number;
  uniqueRoutes: number;
}

export interface RoutesPartialUpdateParams {
  /** A unique integer value identifying this route. */
  id: number;
}

export interface RoutesRetrieveParams {
  /** A unique integer value identifying this route. */
  id: number;
}

export interface RoutesUpdateParams {
  /** A unique integer value identifying this route. */
  id: number;
}

/** * `required` - Required */
export enum RuleKindEnum {
  Required = "required",
}

/** One stored auction saving (a single calculation method). */
export interface Saving {
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly amount: string | null;
  readonly currency: string | null;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  readonly fraction: number | null;
  readonly notCalculatedReason: NotCalculatedReasonEnum | null;
}

/**
 * * `AVERAGE` - Average comparison
 * * `SECOND_CHEAPEST` - Second-cheapest comparison
 */
export enum SavingsCalculationMethodEnum {
  AVERAGE = "AVERAGE",
  SECOND_CHEAPEST = "SECOND_CHEAPEST",
}

export interface ScheduledUserTask {
  /** @format date-time */
  readonly createdAt: string;
  /**
   * Day(s) Of The Month
   * Cron Days Of The Month to Run. Use "*" for "all". (Example: "1,15")
   * @maxLength 124
   */
  dayOfMonth?: string;
  /**
   * Day(s) Of The Week
   * Cron Days Of The Week to Run. Use "*" for "all", Sunday is 0 or 7, Monday is 1. (Example: "0,5")
   * @maxLength 64
   */
  dayOfWeek?: string;
  filters?: any | null;
  /**
   * Hour(s)
   * Cron Hours to Run. Use "*" for "all". (Example: "8,20")
   * @maxLength 96
   */
  hour?: string;
  readonly humanReadableFilters: string[];
  readonly id: number;
  /**
   * Minute(s)
   * Cron Minutes to Run. Use "*" for "all". (Example: "0,30")
   * @maxLength 240
   */
  minute?: string;
  /**
   * * `DAILY` - Daily
   * * `WEEKLY` - Weekly
   * * `MONTHLY` - Monthly
   */
  periodicity: ScheduledUserTaskPeriodicityEnum;
  readonly periodicityDisplay: string;
  /** Comma separated list of email addresses */
  recipients?: string[];
  /** @maxLength 150 */
  title: string;
}

/**
 * * `DAILY` - Daily
 * * `WEEKLY` - Weekly
 * * `MONTHLY` - Monthly
 */
export enum ScheduledUserTaskPeriodicityEnum {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
}

export enum SchemaRetrieveFormatEnum {
  Json = "json",
  Yaml = "yaml",
}

export interface SchemaRetrieveParams {
  format?: SchemaRetrieveFormatEnum;
  /**
   * * `en` - English
   * * `sk` - Slovak
   * * `de` - German
   * * `fr` - French
   * * `it` - Italian
   * * `cs` - Czech
   * * `es` - Spain
   */
  lang?: LanguageEnum;
}

export interface SeaVehicleDetails {
  /** @maxLength 255 */
  billOfLadingNumber?: string;
  /** @maxLength 255 */
  containerNumber?: string;
  readonly transportationMode: TransportationModeEnum;
  /** @maxLength 255 */
  vesselName?: string;
  /** @maxLength 255 */
  voyageNumber?: string;
}

/**
 * * `GLOBAL` - Global
 * * `PER_VEHICLE_TYPE` - Per vehicle type
 */
export enum SlotDurationModeEnum {
  GLOBAL = "GLOBAL",
  PER_VEHICLE_TYPE = "PER_VEHICLE_TYPE",
}

/**
 * ``start_time`` is the address's wall clock; the instant is derivable from ``date`` and
 * ``timezone_name`` on the envelope, so it is not repeated per option.
 */
export interface SlotOption {
  readonly gates: GateSlot[];
  /** @format time */
  readonly startTime: string;
  readonly status: SlotOptionStatusEnum;
}

/**
 * * `AVAILABLE` - Available
 * * `CONFLICT` - Conflict
 */
export enum SlotOptionStatusEnum {
  AVAILABLE = "AVAILABLE",
  CONFLICT = "CONFLICT",
}

/**
 * * `1 + 1` - 1 + 1
 * * `1 + 2` - 1 + 2
 * * `1 + 3` - 1 + 3
 * * `1 + 4` - 1 + 4
 * * `1 + 5` - 1 + 5
 * * `1 + 6` - 1 + 6
 * * `1 + 7` - 1 + 7
 * * `1 + 8` - 1 + 8
 * * `1 + 9` - 1 + 9
 * * `1 + 10` - 1 + 10
 */
export enum StackCountEnum {
  Value11 = "1 + 1",
  Value12 = "1 + 2",
  Value13 = "1 + 3",
  Value14 = "1 + 4",
  Value15 = "1 + 5",
  Value16 = "1 + 6",
  Value17 = "1 + 7",
  Value18 = "1 + 8",
  Value19 = "1 + 9",
  Value110 = "1 + 10",
}

/**
 * * `selected` - Selected
 * * `confirmed` - Confirmed
 * * `removed` - Removed by shipper
 * * `rejected` - Rejected by carrier
 * * `neutral` - Bid received
 */
export enum StateEnum {
  Selected = "selected",
  Confirmed = "confirmed",
  Removed = "removed",
  Rejected = "rejected",
  Neutral = "neutral",
}

export interface StatsOverviewRetrieveParams {
  /** @format date */
  createdAtAfter?: string;
  /** @format date */
  createdAtBefore?: string;
  interval?: IntervalEnum;
}

export interface StatsRoutesRetrieveParams {
  /** @format date */
  createdAtAfter?: string;
  /** @format date */
  createdAtBefore?: string;
}

export interface StatsTopCarriersRetrieveParams {
  count?: number;
  /** @format date */
  createdAtAfter?: string;
  /** @format date */
  createdAtBefore?: string;
}

export interface StatsTopCountriesListParams {
  count?: number;
  /** @format date */
  createdAtAfter?: string;
  /** @format date */
  createdAtBefore?: string;
  waypointStatsType?: WaypointStatsTypeEnum;
}

export interface TagsAllListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
}

export interface TagsListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface TagsPartialUpdateParams {
  /** A unique integer value identifying this workspace tag. */
  id: number;
}

export interface TagsRetrieveParams {
  /** A unique integer value identifying this workspace tag. */
  id: number;
}

export interface TagsUpdateParams {
  /** A unique integer value identifying this workspace tag. */
  id: number;
}

export interface TenderCarrierConversation {
  carrier: TimelineCarrier;
  /** @format date-time */
  lastCarrierMessageAt: string | null;
  lastMessage?: LastMessage | null;
  unreadCount: number;
}

export interface TenderCarrierProgress {
  readonly carriersData: TenderCarrierProgressDetails[];
  readonly carriersWithOffer: number;
  readonly totalCarriers: number;
}

export interface TenderCarrierProgressDetails {
  readonly carrierName: string;
  readonly offerCount: number;
}

export interface TenderContractList {
  /** @format date-time */
  readonly canceledAt: string | null;
  readonly carrierId: number;
  readonly carrierName: string;
  /** @format date-time */
  readonly confirmedAt: string | null;
  readonly contractId: number;
  readonly offersCount: number;
  readonly status: ContractStatusEnum;
  readonly transportationMode: TransportationModeEnum;
}

export interface TenderCountsResponse {
  contracts: number;
  documents: number;
  proposals: number;
}

export interface TenderDetail {
  readonly carrierProgress: TenderCarrierProgress;
  readonly currency: CurrencyEnum;
  /** @format date-time */
  readonly deadline: string | null;
  readonly description: string;
  readonly detailsLocked: boolean;
  readonly followers: UserGeneralInfo[];
  readonly id: number;
  readonly isOpenForSubmissions: boolean;
  /** @maxLength 150 */
  readonly name: string;
  readonly priceKind: TenderPriceKindEnum;
  readonly pricingCount: number;
  readonly pricingMode: TenderPricingModeEnum | null;
  readonly responsibleUser: UserGeneralInfo | null;
  readonly routesCount: number;
  readonly status: TenderDisplayStatusEnum;
  readonly tenderProgress: TenderProgress;
  readonly transportationMode: TransportationModeEnum;
  /** @format date */
  readonly validFrom: string;
  /** @format date */
  readonly validTo: string;
}

export interface TenderDetailCarrierOffer {
  readonly carrierId: number;
  readonly carrierName: string;
  readonly carrierStatus: CarrierOfferCarrierStatusEnum;
  readonly id: number;
  readonly isContractCanceled: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly minPrice: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly priceValue: string;
  readonly shipperStatus: CarrierOfferShipperDecisionEnum;
}

export interface TenderDetailCell {
  readonly carrierOffers: TenderDetailCarrierOffer[];
  readonly id: number;
  readonly priceCategoryId: number;
  readonly priceCategoryMode: TenderPricingModeEnum;
  readonly priceCategoryName: string;
  readonly routeId: number;
}

export interface TenderDetailCellsPage {
  readonly count: number;
  readonly next: string | null;
  readonly previous: string | null;
  readonly results: TenderDetailCell[];
  readonly totalPages: number;
}

export interface TenderDetailFilters {
  readonly carriers: TenderFilterCarrier[];
  readonly deliveryWaypoints: TenderFilterWaypoint[];
  readonly pickupWaypoints: TenderFilterWaypoint[];
  readonly priceCategories: TenderFilterPriceCategory[];
}

export interface TenderDetailRoute {
  readonly id: number;
  readonly identifier: string;
  readonly waypoints: TenderRouteItem[];
}

/**
 * * `DRAFT` - Draft
 * * `OPEN` - Open
 * * `EVALUATING` - Evaluating
 * * `FINISHED` - Finished
 * * `CANCELED` - Canceled
 */
export enum TenderDisplayStatusEnum {
  DRAFT = "DRAFT",
  OPEN = "OPEN",
  EVALUATING = "EVALUATING",
  FINISHED = "FINISHED",
  CANCELED = "CANCELED",
}

export interface TenderFilterCarrier {
  id: number;
  name: string;
}

export interface TenderFilterPriceCategory {
  id: number;
  name: string;
}

export interface TenderFilterWaypoint {
  city: string;
  country: string;
  id: number;
  postCode: string;
}

export interface TenderFirstStep {
  /**
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency: CurrencyEnum;
  /** @format date-time */
  deadline?: string | null;
  /** @default "" */
  description?: string;
  /** @maxLength 150 */
  name: string;
  tenderId?: number | null;
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode: TransportationModeEnum;
  /** @format date */
  validFrom: string;
  /** @format date */
  validTo: string;
}

export interface TenderFourthStepCarrier {
  /** @min 1 */
  carrierId: number;
  contactIds?: number[];
}

export interface TenderFourthStepCarriers {
  carriers?: TenderFourthStepCarrier[];
  followerIds?: number[];
  responsibleUserId?: number | null;
}

export interface TenderList {
  readonly carriersTotal: number;
  readonly carriersWithOffer: number;
  readonly contractProposalsTotal: number;
  readonly contractsTotal: number;
  /** @format date-time */
  readonly deadline: string | null;
  readonly id: number;
  readonly isOpenForSubmissions: boolean;
  /** @maxLength 150 */
  readonly name: string;
  readonly priceKind: TenderPriceKindEnum;
  readonly priceOffersConfirmed: number;
  readonly priceOffersTotal: number;
  readonly pricingCategoriesCount: number;
  readonly pricingCategoriesType: TenderPricingModeEnum | null;
  readonly routesPriced: number;
  readonly routesTotal: number;
  readonly status: TenderDisplayStatusEnum;
  readonly transportationMode: TransportationModeEnum;
  /** @format date */
  readonly validFrom: string;
  /** @format date */
  readonly validTo: string;
}

export interface TenderOverviewCargoCategory {
  readonly id: number;
  readonly kind: CargoCategoryKindEnum;
  readonly name: string;
  readonly ranges: TenderOverviewCargoCategoryRange[];
  readonly unit: UnitEnum;
}

export interface TenderOverviewCargoCategoryRange {
  readonly id: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly lower: string | null;
  readonly name: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly upper: string | null;
}

export interface TenderOverviewCarriers {
  readonly items: TenderOverviewCarriersItem[];
  readonly total: number;
}

export interface TenderOverviewCarriersItem {
  readonly contactIds: number[];
  readonly emails: string[];
  readonly id: number;
  readonly name: string;
}

export interface TenderOverviewPricing {
  readonly categories: TenderOverviewCargoCategory[];
  readonly mode: TenderPricingModeEnum | null;
  readonly vehicles: TenderOverviewVehicleItem[];
}

export interface TenderOverviewResponse {
  readonly carriers: TenderOverviewCarriers;
  readonly pricing: TenderOverviewPricing;
  readonly routes: TenderOverviewRoutes;
  readonly tender: TenderOverviewTender;
}

export interface TenderOverviewRouteItem {
  readonly id: number;
  readonly routeId: number;
}

export interface TenderOverviewRoutes {
  readonly items: TenderOverviewRouteItem[];
  readonly total: number;
}

export interface TenderOverviewTender {
  readonly currency: CurrencyEnum;
  /** @format date-time */
  readonly deadline: string | null;
  readonly description: string;
  readonly detailsLocked: boolean;
  readonly followers: UserGeneralInfo[];
  readonly id: number;
  /** @maxLength 150 */
  readonly name: string;
  readonly priceKind: TenderPriceKindEnum;
  readonly responsibleUser: UserGeneralInfo | null;
  readonly status: TenderDisplayStatusEnum;
  readonly transportationMode: TransportationModeEnum;
  /** @format date */
  readonly validFrom: string;
  /** @format date */
  readonly validTo: string;
}

export interface TenderOverviewVehicleItem {
  readonly id: number;
  readonly name: string;
}

export interface TenderPriceCategoryCol {
  readonly categoryName: string;
  readonly id: number;
}

/**
 * * `FIXED` - Fixed price
 * * `PER_KM` - Price per km
 */
export enum TenderPriceKindEnum {
  FIXED = "FIXED",
  PER_KM = "PER_KM",
}

export interface TenderPriceOffersResponse {
  readonly cells: TenderDetailCellsPage;
  readonly routes: TenderDetailRoute[];
}

/**
 * * `VEHICLES` - Vehicles
 * * `CARGO_CATEGORIES` - Cargo categories
 */
export enum TenderPricingModeEnum {
  VEHICLES = "VEHICLES",
  CARGO_CATEGORIES = "CARGO_CATEGORIES",
}

export interface TenderProgress {
  readonly contractCreated: number;
  readonly entriesCovered: number;
  readonly totalEntries: number;
}

export interface TenderRoute {
  readonly id: number;
  /** @default "" */
  readonly identifier: string;
  readonly waypoints: TenderRouteItem[];
}

export interface TenderRouteItem {
  /**
   * City
   * @maxLength 100
   */
  readonly addressCity: string;
  /**
   * Country code
   * @maxLength 2
   */
  readonly addressCountry: string;
  /**
   * Post code
   * @maxLength 20
   */
  readonly addressPostCode: string;
  /**
   * Street
   * @maxLength 100
   */
  readonly addressStreet: string;
  /**
   * @min 0
   * @max 32767
   */
  readonly position: number;
  readonly routeItemType: WaypointTypeEnum;
}

export interface TenderSecondStepRoutes {
  /**
   * * `FIXED` - Fixed price
   * * `PER_KM` - Price per km
   */
  priceKind: TenderPriceKindEnum;
  routeIds: number[];
}

export interface TenderThirdStepPricingCategories {
  /** @min 1 */
  cargoCategoryId?: number | null;
  cargoCategoryRangeIds?: number[];
  /**
   * * `VEHICLES` - Vehicles
   * * `CARGO_CATEGORIES` - Cargo categories
   */
  mode: TenderPricingModeEnum;
  vehicleTypeIds?: number[];
}

export interface TenderUpdate {
  carriers?: TenderFourthStepCarrier[];
  /** @format date-time */
  deadline?: string;
  description?: string;
  followerIds?: number[];
  /** @maxLength 150 */
  name?: string;
  responsibleUserId?: number | null;
}

export interface TermsAndConditions {
  /** @format uri */
  file: string;
  readonly id: number;
  provider: TermsAndConditionsProvider;
  /** @format date-time */
  publishedAt: string;
  /** @format date-time */
  requiredFrom: string;
  /**
   * @min 0
   * @max 32767
   * @default 1
   */
  versionNumber?: number;
}

export interface TermsAndConditionsConsent {
  readonly isAccepted: boolean;
  readonly isRejected: boolean;
}

export interface TermsAndConditionsProvider {
  /** 3rd party provider */
  is3rdParty?: boolean;
  readonly id: number;
  /**
   * Provider info
   * Additional information about provider
   */
  info?: string;
  /** @maxLength 255 */
  name: string;
}

export interface TermsByTokenOutput {
  consents: TermsOutput[];
  /** @format email */
  email: string;
}

export interface TermsConsentByTokenInput {
  accepted?: boolean;
  rejected?: boolean;
  termsId: number;
}

export interface TermsData {
  approved: boolean;
  requiredApproved: boolean;
  token: string;
}

export interface TermsOutput {
  consent?: TermsAndConditionsConsent;
  terms: TermsAndConditions;
}

/** Only the gate, and required: the dialog always presents a choice. */
export interface TimeSlotBookingApprove {
  gate: number;
}

export interface TimeSlotBookingCargoItemWrite {
  /** @maxLength 255 */
  description?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  height?: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  length?: string | null;
  /**
   * * `m` - m
   * * `cm` - cm
   * * `mm` - mm
   */
  lengthUnit?: LengthUnitEnum;
  /**
   * @min 0
   * @max 10000
   */
  quantity: number;
  transportCargoItem?: number | null;
  unit?: number | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  volume?: string | null;
  /**
   * * `l` - L
   * * `m3` - m³
   */
  volumeUnit?: VolumeUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,7}(?:\.\d{0,3})?$
   */
  weight?: string | null;
  /**
   * * `kg` - kg
   * * `t` - t
   */
  weightUnit?: WeightUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,6}(?:\.\d{0,2})?$
   */
  width?: string | null;
}

/** What a carrier may send when booking a slot for one stop of a transport it won. */
export interface TimeSlotBookingCarrierCreate {
  cargoItems?: TimeSlotBookingCargoItemWrite[];
  /**
   * @format email
   * @maxLength 254
   */
  contactPersonEmail: string;
  /** @maxLength 200 */
  contactPersonName?: string;
  /** @maxLength 50 */
  contactPersonPhone?: string;
  /** @format date */
  date: string;
  /** @format time */
  time: string;
  transport: number;
  vehicleType?: number | null;
  vehicles?: TimeSlotBookingVehicleWrite[];
  waypoint: number;
}

/**
 * What a carrier may change on its pending booking: vehicles and cargo items are replaced by
 * the payload, so both lists are required and clearing them takes an explicit ``[]``; the other
 * fields except the contact e-mail keep their stored value when omitted.
 */
export interface TimeSlotBookingCarrierUpdate {
  cargoItems: TimeSlotBookingCargoItemWrite[];
  /**
   * @format email
   * @maxLength 254
   */
  contactPersonEmail: string;
  /** @maxLength 200 */
  contactPersonName?: string;
  /** @maxLength 50 */
  contactPersonPhone?: string;
  /** @format date */
  date: string;
  /** @format time */
  time: string;
  vehicles: TimeSlotBookingVehicleWrite[];
}

export interface TimeSlotBookingChangeGate {
  gate: number;
}

export interface TimeSlotBookingCreate {
  cargoDescription?: string;
  cargoItems?: TimeSlotBookingCargoItemWrite[];
  carrier?: number | null;
  /** @maxLength 100 */
  carrierName?: string;
  contactPersonEmail?: string;
  /** @maxLength 200 */
  contactPersonName?: string;
  /** @maxLength 50 */
  contactPersonPhone?: string;
  /** @format date */
  date: string;
  gate: number;
  /** @format time */
  time: string;
  transport?: number | null;
  vehicleType?: number | null;
  vehicles?: TimeSlotBookingVehicleWrite[];
  waypoint?: number | null;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

/** The slot a booking holds, as every booking shape reports it: bounds plus the address clock. */
export interface TimeSlotBookingDetail {
  readonly address: BookingAddressNested;
  /** A linked booking shows its transport's cargo description as it is now. */
  readonly cargoDescription: string;
  readonly cargoItems: BookingCargoItemNested[];
  readonly carrier: number | null;
  readonly carrierName: string;
  /** The transport detail's carrier note; empty for a standalone booking. */
  readonly carrierNote: string;
  readonly conflictCount: number;
  contactPersonEmail?: string;
  /** @maxLength 200 */
  contactPersonName?: string;
  /** @maxLength 50 */
  contactPersonPhone?: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly createdBy: BookingAuthorNested;
  /** @format date-time */
  readonly endAt: string;
  readonly gate: GateNested;
  readonly id: number;
  /**
   * * `SHIPPER` - Shipper
   * * `CARRIER` - Carrier
   */
  origin: BookingOriginEnum;
  readonly settingsConflicts: BookingSettingsConflict[];
  /** @format date-time */
  readonly startAt: string;
  readonly status: TimeSlotBookingListStatusEnum;
  readonly timeZone: string;
  readonly transport: BookingTransportDetailNested | null;
  readonly vehicleType: VehicleTypeNested | null;
  readonly vehicles: BookingVehicleNested[];
  readonly waypoint: BookingWaypointNested | null;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

/** The slot a booking holds, as every booking shape reports it: bounds plus the address clock. */
export interface TimeSlotBookingList {
  readonly address: BookingAddressNested;
  readonly carrier: number | null;
  readonly carrierName: string;
  readonly conflictCount: number;
  /** @format date-time */
  readonly createdAt: string;
  readonly createdBy: BookingAuthorNested;
  /** @format date-time */
  readonly endAt: string;
  readonly gate: GateNested;
  readonly id: number;
  /**
   * * `SHIPPER` - Shipper
   * * `CARRIER` - Carrier
   */
  origin: BookingOriginEnum;
  /** @format date-time */
  readonly startAt: string;
  readonly status: TimeSlotBookingListStatusEnum;
  readonly timeZone: string;
  readonly transport: BookingTransportNested | null;
  readonly vehicleType: VehicleTypeNested | null;
  readonly vehicles: BookingVehicleNested[];
  readonly waypoint: BookingWaypointNested | null;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

/**
 * * `PENDING` - Pending
 * * `WITHDRAWN` - Withdrawn
 * * `APPROVED` - Approved
 * * `REJECTED` - Rejected
 * * `ARRIVED` - Arrived
 * * `CANCELED` - Canceled
 * * `COMPLETED` - Completed
 * * `EXPIRED` - Expired
 */
export enum TimeSlotBookingListStatusEnum {
  PENDING = "PENDING",
  WITHDRAWN = "WITHDRAWN",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  ARRIVED = "ARRIVED",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  EXPIRED = "EXPIRED",
}

/** The slot a booking holds, as every booking shape reports it: bounds plus the address clock. */
export interface TimeSlotBookingPreview {
  readonly address: BookingAddressNested;
  readonly carrier: number | null;
  readonly carrierName: string;
  readonly conflictCount: number;
  /** @format date-time */
  readonly endAt: string;
  readonly gate: GateNested;
  readonly id: number;
  readonly origin: BookingOriginEnum;
  /** @format date-time */
  readonly startAt: string;
  readonly status: TimeSlotBookingListStatusEnum;
  readonly timeZone: string;
  readonly transport: BookingTransportPreviewNested | null;
  readonly vehicleType: VehicleTypeNested | null;
  readonly vehicles: BookingVehicleNested[];
  readonly waypointType: WaypointTypeEnum;
}

/**
 * The shipper edit: the create shape, judged against the stored booking. The transport and stop may be restated
 * but never changed; vehicles and cargo items are replaced wholesale, so both lists are required.
 */
export interface TimeSlotBookingUpdate {
  cargoDescription?: string;
  cargoItems: TimeSlotBookingCargoItemWrite[];
  carrier?: number | null;
  /** @maxLength 100 */
  carrierName?: string;
  contactPersonEmail?: string;
  /** @maxLength 200 */
  contactPersonName?: string;
  /** @maxLength 50 */
  contactPersonPhone?: string;
  /** @format date */
  date: string;
  gate: number;
  /** @format time */
  time: string;
  transport?: number | null;
  vehicleType?: number | null;
  vehicles: TimeSlotBookingVehicleWrite[];
  waypoint?: number | null;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

export interface TimeSlotBookingVehicleWrite {
  /** @maxLength 255 */
  driverName?: string;
  /** @maxLength 255 */
  driverPhone?: string;
  /** @maxLength 255 */
  plateNumber?: string;
}

/** One-call initial setup payload: settings + gates + operating hours. */
export interface TimeSlotSetup {
  autoApproveBookings?: boolean;
  /**
   * @min 5
   * @max 1440
   */
  defaultSlotDurationMinutes: number;
  gates: Gate[];
  /**
   * The whole week for an address. Every weekday must be present exactly once; a closed day is
   * sent as ``is_open: false`` with no intervals.
   */
  operatingHours: OperatingHoursListWrite;
  /**
   * * `GLOBAL` - Global
   * * `PER_VEHICLE_TYPE` - Per vehicle type
   */
  slotDurationMode: SlotDurationModeEnum;
  vehicleTypeRules: AddressVehicleTypeRuleWrite[];
}

export interface TimelineBlock {
  readonly carrierName: string;
  readonly conflictCount: number;
  readonly continuesAfter: boolean;
  readonly continuesBefore: boolean;
  readonly durationMinutes: number;
  /** @format date-time */
  readonly endAt: string;
  readonly gate: number;
  readonly hash: string;
  readonly id: number;
  /** @format date-time */
  readonly startAt: string;
  readonly status: TimeSlotBookingListStatusEnum;
  readonly vehicleType: VehicleTypeNested | null;
  readonly waypointType: WaypointTypeEnum;
}

export interface TimelineCarrier {
  readonly id: number;
  /**
   * Title
   * @maxLength 100
   */
  readonly name: string;
  readonly workspace: WorkspaceGeneralInfo;
}

export interface TimelineClosedInterval {
  readonly closure: TimelineClosure;
  /** @format date-time */
  readonly endAt: string;
  /** @format date-time */
  readonly startAt: string;
}

export interface TimelineClosure {
  readonly name: string;
  readonly note: string;
  readonly reason: GateClosureReasonEnum;
}

export interface TimelineGateRow {
  readonly closedIntervals: TimelineClosedInterval[];
  readonly closure: TimelineClosure | null;
  readonly color: ColorEnum;
  readonly id: number;
  readonly isActive: boolean;
  readonly name: string;
  readonly openIntervals: TimelineInterval[];
  readonly specifiesVehicleTypes: boolean;
  readonly vehicleTypeRules: GateVehicleTypeRule[];
}

export interface TimelineInterval {
  /** @format date-time */
  readonly endAt: string;
  /** @format date-time */
  readonly startAt: string;
}

export interface TokenRefresh {
  readonly access: string;
  refresh: string;
}

export interface TokenVerify {
  token: string;
}

export interface TopCarriersStats {
  carriers: CarrierStats[];
  totalCount: number;
  /** @format double */
  totalDistance: number;
  /** @format double */
  totalPrice: number;
}

export interface TopCountryStats {
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  deliveryCount: number;
  pickupCount: number;
}

export interface TotalByIntervalStats {
  /** @format date-time */
  date: string;
  /** @format double */
  total: number;
}

export interface TranslateLocations {
  addresses: LocationAddress[];
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode: TransportationModeEnum;
  waypointTypes?: WaypointTypeEnum[];
}

export interface Transport {
  readonly cancelRequestStatus: TransportCancelRequestStatusEnum;
  cargo: Cargo;
  readonly carrier: CarrierInfo;
  /** @maxLength 500 */
  costCenter?: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly createdBy: UserGeneralInfo;
  /** @format double */
  readonly distance: number;
  followers?: number[];
  readonly id: number;
  readonly incoterms: string;
  readonly mergedFromAuctions: number[];
  note?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly price: string;
  readonly priceCurrency: CurrencyEnum;
  /** @maxLength 150 */
  reference?: string;
  /** @format int32 */
  readonly requestId: number;
  resolvingRequests?: number[];
  readonly responsibleUser: UserGeneralInfo;
  responsibleUserId?: number | null;
  /**
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType: RouteTypeEnum;
  /** @format uri */
  readonly staticMap: string | null;
  /**
   * * `PROCESSING` - Processing
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   * * `CANCELED_BY_CARRIER` - Canceled by carrier
   * * `CANCELED_BY_SUPPORT` - Canceled by support
   */
  status?: TransportStatusEnum;
  tags?: string[];
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode: TransportationModeEnum;
  readonly type: TransportTypeEnum;
  readonly vehicleTypeId: number | null;
  waypoints: Waypoint[];
  readonly winningBid: Bid;
}

export interface TransportBatchUpdate {
  /** @format date-time */
  readonly createdAt: string;
  readonly id: number;
  /** @maxLength 500 */
  note?: string;
  readonly sender: GenericSender;
  readonly transport: number;
  /**
   * * `REQUEST` - Request
   * * `ETA` - ETA
   * * `CONFIRMATION` - Confirmation
   */
  type: TransportUpdateTypeEnum;
  updates: TransportUpdate[];
}

/** The part of a transport update that decides which time slot bookings it cancels. */
export interface TransportBookingImpact {
  waypoints: Waypoint[];
}

export interface TransportByEmail {
  /** @format int32 */
  readonly auctionId: number;
  readonly bookingRequired: boolean;
  readonly cancelRequestStatus: TransportCancelRequestStatusEnum;
  readonly cargo: Cargo;
  readonly contactHash: string;
  /** @format double */
  readonly distance: number;
  readonly hash: string;
  readonly id: number;
  readonly incoterms: IncotermsEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly price: string;
  readonly priceCurrency: CurrencyEnum;
  /** @maxLength 150 */
  readonly reference: string;
  readonly status: TransportStatusEnum;
  readonly transportationMode: TransportationModeEnum;
  readonly type: TransportTypeEnum;
  readonly waypoints: Waypoint[];
  readonly workspace: WorkspaceGeneralInfo;
}

export interface TransportByHash {
  readonly cancelRequestStatus: TransportCancelRequestStatusEnum;
  readonly cargo: Cargo;
  /** @format date-time */
  readonly deletedAt: string | null;
  readonly hash: string;
  readonly id: number;
  readonly incoterms: IncotermsEnum;
  readonly locationData: LocationData;
  /** @maxLength 150 */
  readonly reference: string;
  readonly responsibleUser: UserGeneralInfo;
  readonly status: TransportStatusEnum;
  readonly transportationMode: TransportationModeEnum;
  readonly type: TransportTypeEnum;
  readonly vehicleType: VehicleType | null;
  readonly waypoints: WaypointWithBooking[];
}

/** Plain waypoints: the booking state needs a prefetch only the by-hash retrieve pays for. */
export interface TransportByHashList {
  readonly cancelRequestStatus: TransportCancelRequestStatusEnum;
  readonly cargo: Cargo;
  /** @format date-time */
  readonly deletedAt: string | null;
  readonly hash: string;
  readonly id: number;
  readonly incoterms: IncotermsEnum;
  readonly locationData: LocationData;
  /** @maxLength 150 */
  readonly reference: string;
  readonly responsibleUser: UserGeneralInfo;
  readonly status: TransportStatusEnum;
  readonly transportationMode: TransportationModeEnum;
  readonly type: TransportTypeEnum;
  readonly vehicleType: VehicleType | null;
  readonly waypoints: Waypoint[];
}

export interface TransportCancelRequestCreate {
  note?: string;
  /**
   * * `PENDING` - Pending
   * * `REVOKED` - Revoked
   * * `ACCEPTED` - Accepted
   * * `REJECTED` - Rejected
   */
  status: TransportCancelRequestStatusEnum;
}

/**
 * * `PENDING` - Pending
 * * `REVOKED` - Revoked
 * * `ACCEPTED` - Accepted
 * * `REJECTED` - Rejected
 */
export enum TransportCancelRequestStatusEnum {
  PENDING = "PENDING",
  REVOKED = "REVOKED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

/** Not a ModelSerializer: one row per invited email that resolves to a live Contact in the shipper's workspace. */
export interface TransportContact {
  /** @format email */
  readonly email: string;
  readonly name: string;
  readonly phone: string;
}

export interface TransportDetail {
  /** @maxLength 255 */
  carrierNote?: string;
  shipperExtraInfo?: string;
  readonly transport: number;
  vehicles: TransportDetailVehicle[];
}

export interface TransportDetailByHash {
  /** @maxLength 255 */
  carrierNote?: string;
  readonly id: number;
  readonly shipperExtraInfo: string;
  vehicles: TransportDetailVehicleByHash[];
}

export interface TransportDetailVehicle {
  readonly id: number;
  /**
   * @min 0
   * @max 32767
   */
  index?: number | null;
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
  vehicleDetails?: VehicleDetails | null;
}

export interface TransportDetailVehicleByHash {
  /**
   * @min 0
   * @max 32767
   */
  index?: number | null;
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
  vehicleDetails?: VehicleDetails | null;
}

export interface TransportDocumentValidation {
  /** @max 10485760 */
  fileSize?: number | null;
  /** @maxLength 200 */
  title?: string | null;
}

export interface TransportLatestUpdate {
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  datetime: string;
  readonly id: number;
  readonly note: string;
  readonly timezone: string | null;
  readonly type: TransportUpdateTypeEnum;
  waypoint: number;
  readonly waypointData: WaypointUpdateData;
}

export interface TransportList {
  readonly cancelRequestStatus: TransportCancelRequestStatusEnum;
  cargo: Cargo;
  readonly carrierName: string;
  /** @format date-time */
  readonly createdAt: string;
  /** @format double */
  readonly distance: number;
  readonly hasTimeSlotWaypoint: boolean;
  readonly id: number;
  readonly incoterms: string;
  readonly mergedFromAuctions: number[];
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  price: string;
  readonly priceCurrency: CurrencyEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  priceWorkspace?: string;
  readonly priceWorkspaceCurrency: CurrencyEnum;
  /** @maxLength 150 */
  reference?: string;
  /** @format int32 */
  readonly requestId: number;
  readonly responsibleUser: UserGeneralInfo;
  /**
   * * `PROCESSING` - Processing
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   * * `CANCELED_BY_CARRIER` - Canceled by carrier
   * * `CANCELED_BY_SUPPORT` - Canceled by support
   */
  status?: TransportStatusEnum;
  readonly tags: string[];
  transportDetail?: TransportDetail;
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode: TransportationModeEnum;
  /**
   * * `SPOT` - Spot transport
   * * `CONTRACTED` - Contracted transport
   */
  type: TransportTypeEnum;
  readonly vehicleTypeId: number | null;
  waypoints: TransportListWaypoint[];
}

/** Read-only booking-wizard fields; requires instances annotated by ``transports_list_selector``. */
export interface TransportListWaypoint {
  address?: number | null;
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  availabilityEnd?: string | null;
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  availabilityStart?: string | null;
  /** @maxLength 100 */
  city: string;
  contactEmail?: string;
  /** @maxLength 50 */
  contactName?: string;
  /** @maxLength 128 */
  contactPhone?: string;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  /** @format date-time */
  readonly existingBookingEnd: string | null;
  /** @format date-time */
  readonly existingBookingStart: string | null;
  readonly hasExistingBooking: boolean;
  id?: number | null;
  /**
   * @min 0
   * @max 32767
   */
  index?: number | null;
  /** @maxLength 50 */
  name?: string;
  note?: string;
  /** @maxLength 20 */
  postCode?: string;
  /** @maxLength 150 */
  reference?: string;
  saveToDirectory?: boolean;
  /** @maxLength 100 */
  street?: string;
  readonly timeSlotsEnabled: boolean;
  readonly timezone: string | null;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  type: WaypointTypeEnum;
}

export interface TransportOrTransportRequestFirstStep {
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode: TransportationModeEnum;
  waypoints: Waypoint[];
}

export interface TransportOrTransportRequestSecondStep {
  cargo: Cargo;
  /** @maxLength 500 */
  costCenter?: string;
  /**
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  /** @maxLength 150 */
  reference?: string;
  vehicleTypeId?: number | null;
}

export interface TransportOverviewStats {
  /** @format double */
  averagePrice: number;
  /** @format double */
  averagePricePerKm: number | null;
  /** @format double */
  averageSavings: number;
  /** @format double */
  averageSavingsPercent: number;
  countByInterval: CountByIntervalStats[];
  /**
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency: CurrencyEnum;
  /** @format double */
  secondCheapestSavings: number;
  /** @format double */
  secondCheapestSavingsPercent: number;
  /** @format double */
  totalPrice: number;
  totalPriceByInterval: TotalByIntervalStats[];
}

export interface TransportRequest {
  readonly auction: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  autoSelectLimit?: string | null;
  autoSelectLimitCurrency?: string | null;
  availabilityRequired?: boolean;
  cargo: Cargo;
  contacts?: number[];
  readonly contractId: number | null;
  /** @min 1 */
  contractPriceId?: number | null;
  /** @maxLength 500 */
  costCenter?: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly createdBy: UserGeneralInfo;
  /** @format double */
  readonly distance: number;
  duration: string;
  followers?: number[];
  /** @format uuid */
  formCorrelationId?: string | null;
  readonly id: number;
  /**
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  isAutoSelect?: boolean;
  mergedFrom?: number[];
  note?: string;
  /**
   * * `manual` - Manual
   * * `email` - Email
   * * `ai_document` - AI document
   * * `unknown` - Unknown
   */
  origin?: OriginEnum;
  price?: string | null;
  priceCurrency?: string | null;
  /** @maxLength 150 */
  reference?: string;
  resolvingTransport?: number | null;
  readonly responsibleUser: UserGeneralInfo;
  responsibleUserId?: number | null;
  /**
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType: RouteTypeEnum;
  /** @format uri */
  readonly staticMap: string | null;
  tags?: string[];
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode: TransportationModeEnum;
  type?: TransportTypeEnum | null;
  readonly vehicleType: VehicleType | null;
  vehicleTypeId?: number | null;
  waypoints: Waypoint[];
}

export interface TransportRequestByEmail {
  readonly cargo: Cargo;
  /** @format date-time */
  readonly deletedAt: string | null;
  /** @format double */
  readonly distance: number;
  readonly incoterms: IncotermsEnum;
  readonly reference: string | null;
  readonly responsibleUser: UserGeneralInfo;
  readonly transportationMode: TransportationModeEnum;
  /** Transport type */
  readonly type: TransportTypeEnum;
  readonly vehicleType: VehicleType | null;
  readonly waypoints: WaypointByHash[];
}

export interface TransportRequestByHash {
  readonly cargo: Cargo;
  /** @format date-time */
  readonly deletedAt: string | null;
  /** @format double */
  readonly distance: number;
  readonly incoterms: IncotermsEnum;
  readonly locationData: LocationData;
  readonly reference: string | null;
  readonly responsibleUser: UserGeneralInfo;
  readonly transportationMode: TransportationModeEnum;
  /** Transport type */
  readonly type: TransportTypeEnum;
  readonly vehicleType: VehicleType | null;
  readonly waypoints: WaypointByHash[];
}

/** Transport-option conversion from the request detail: contracted → other option, contracted ↔ spot. */
export interface TransportRequestChangeOption {
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  autoSelectLimit?: string | null;
  autoSelectLimitCurrency?: string | null;
  contacts?: number[];
  /** @min 1 */
  contractPriceId?: number | null;
  duration?: string | null;
  /** @format uuid */
  formCorrelationId?: string | null;
  isAutoSelect?: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  price?: string | null;
  priceCurrency?: string | null;
  /**
   * * `SPOT` - Spot transport
   * * `CONTRACTED` - Contracted transport
   */
  type: TransportTypeEnum;
}

/** Details (fourth) step: administrative and bidding-settings fields only. */
export interface TransportRequestFourthStep {
  documents?: TransportDocumentValidation[];
  duration?: string;
  followers?: number[];
  note?: string;
  responsibleUserId?: number | null;
  tags?: string[];
}

export interface TransportRequestList {
  readonly cargo: Cargo;
  readonly createdBy: UserGeneralInfo;
  readonly distance: number;
  readonly id: number;
  readonly incoterms: string;
  readonly reference: string;
  readonly responsibleUser: UserGeneralInfo;
  readonly tags: string[];
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode: TransportationModeEnum;
  /**
   * * `SPOT` - Spot transport
   * * `CONTRACTED` - Contracted transport
   */
  type: TransportTypeEnum;
  waypoints: Waypoint[];
}

/** Carriers (third) step: transport / carrier-selection fields only. */
export interface TransportRequestThirdStep {
  contacts?: number[];
  /** @min 1 */
  contractPriceId?: number | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  price?: string | null;
  priceCurrency?: string | null;
  type?: TransportTypeEnum | null;
}

/** Read-only; requires waypoints with ``address`` selected. */
export interface TransportRequestWithAddressState {
  readonly auction: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  autoSelectLimit?: string | null;
  autoSelectLimitCurrency?: string | null;
  availabilityRequired?: boolean;
  cargo: Cargo;
  contacts?: number[];
  readonly contractId: number | null;
  /** @min 1 */
  contractPriceId?: number | null;
  /** @maxLength 500 */
  costCenter?: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly createdBy: UserGeneralInfo;
  /** @format double */
  readonly distance: number;
  duration: string;
  followers?: number[];
  /** @format uuid */
  formCorrelationId?: string | null;
  readonly id: number;
  /**
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  isAutoSelect?: boolean;
  mergedFrom?: number[];
  note?: string;
  /**
   * * `manual` - Manual
   * * `email` - Email
   * * `ai_document` - AI document
   * * `unknown` - Unknown
   */
  origin?: OriginEnum;
  price?: string | null;
  priceCurrency?: string | null;
  /** @maxLength 150 */
  reference?: string;
  resolvingTransport?: number | null;
  readonly responsibleUser: UserGeneralInfo;
  responsibleUserId?: number | null;
  /**
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType: RouteTypeEnum;
  /** @format uri */
  readonly staticMap: string | null;
  tags?: string[];
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode: TransportationModeEnum;
  type?: TransportTypeEnum | null;
  readonly vehicleType: VehicleType | null;
  vehicleTypeId?: number | null;
  readonly waypoints: WaypointWithAddressState[];
}

export interface TransportRequestsChangeTransportOptionCreateParams {
  /** A unique integer value identifying this transport request. */
  id: number;
}

export interface TransportRequestsUpdateActiveCreateParams {
  /** A unique integer value identifying this transport request. */
  id: number;
}

export interface TransportRequestsUpdateCreateParams {
  /** A unique integer value identifying this transport request. */
  id: number;
}

export enum TransportStatsOverviewRetrieveOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  ValueId = "-id",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
  Id = "id",
}

export interface TransportStatsOverviewRetrieveParams {
  maxVolumeM3?: number;
  minVolumeM3?: number;
  airWaybillNumber?: string;
  airline?: string;
  /** Auction ID */
  auctionId?: number;
  billOfLadingNumber?: string;
  /** Carrier ID */
  carrierId?: number;
  carrierName?: string;
  containerNumber?: string;
  costCenter?: string;
  /** @format date-time */
  createdAtAfter?: string;
  /** @format date-time */
  createdAtBefore?: string;
  createdBy?: number;
  /**
   * Currency
   *
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  deliveryCity?: string;
  deliveryCountry?: string;
  /** @format date-time */
  deliveryDateAfter?: string;
  /** @format date-time */
  deliveryDateBefore?: string;
  deliveryName?: string;
  deliveryPostCode?: string;
  deliveryReference?: string;
  deliveryStreet?: string;
  driverName?: string;
  driverPhone?: string;
  flightNumber?: string;
  fromPlace?: string;
  /** Transport ID */
  id?: number;
  /**
   * Incoterms
   *
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  interval?: IntervalEnum;
  /** Is past */
  isPast?: boolean;
  /**
   * Load type
   *
   * * `FTL` - Full Truck Load
   * * `LTL` - Less than Truck Load
   * * `FCL` - Full Container Load
   * * `LCL` - Less than Container Load
   * * `PARCEL` - Parcel
   * * `NOT_SPECIFIED` - Not specified
   */
  loadType?: CargoLoadTypeEnum[];
  maxWeightKg?: number;
  minWeightKg?: number;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   * * `id` - Id
   * * `-id` - Id (descending)
   */
  order?: TransportStatsOverviewRetrieveOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  pickupCity?: string;
  pickupCountry?: string;
  /** @format date-time */
  pickupDateAfter?: string;
  /** @format date-time */
  pickupDateBefore?: string;
  pickupName?: string;
  pickupPostCode?: string;
  pickupReference?: string;
  pickupStreet?: string;
  plateNumber?: string;
  /** @format date-time */
  publishedAtAfter?: string;
  /** @format date-time */
  publishedAtBefore?: string;
  reference?: string;
  /**
   * Request type
   *
   * * `REFRIGERATED_GOODS` - Refrigerated goods
   * * `FROZEN_GOODS` - Frozen goods
   * * `METAL_GOODS` - Metal goods
   * * `OVERSIZED_LOAD` - Oversized load
   * * `BULK_MATERIAL` - Bulk material
   * * `LOOSE_MATERIAL` - Loose material
   * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
   * * `LIQUIDS` - Liquids
   * * `VEHICLES` - Vehicles
   * * `ADR` - ADR
   * * `OTHER` - Other
   * * `NOT_SPECIFIED` - Not specified
   */
  requestType?: CargoTypeEnum;
  responsibleUser?: number;
  /**
   * Route type
   *
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
  /** A search term. */
  search?: string;
  /**
   * STA
   * @format date-time
   */
  staAfter?: string;
  /**
   * STA
   * @format date-time
   */
  staBefore?: string;
  /**
   * STD
   * @format date-time
   */
  stdAfter?: string;
  /**
   * STD
   * @format date-time
   */
  stdBefore?: string;
  /** Multiple values may be separated by commas. */
  tag?: string[];
  toPlace?: string;
  trainNumber?: string;
  /**
   * Transport status
   *
   * * `PROCESSING` - Processing
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   * * `CANCELED_BY_CARRIER` - Canceled by carrier
   * * `CANCELED_BY_SUPPORT` - Canceled by support
   */
  transportStatus?: TransportStatusEnum;
  /**
   * Transport type
   *
   * * `SPOT` - Spot transport
   * * `CONTRACTED` - Contracted transport
   */
  transportType?: TransportTypeEnum;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
  vesselName?: string;
  voyageNumber?: string;
  wagonContainerNumber?: string;
}

/**
 * * `PROCESSING` - Processing
 * * `FINISHED` - Finished
 * * `CANCELED` - Canceled
 * * `CANCELED_BY_CARRIER` - Canceled by carrier
 * * `CANCELED_BY_SUPPORT` - Canceled by support
 */
export enum TransportStatusEnum {
  PROCESSING = "PROCESSING",
  FINISHED = "FINISHED",
  CANCELED = "CANCELED",
  CANCELED_BY_CARRIER = "CANCELED_BY_CARRIER",
  CANCELED_BY_SUPPORT = "CANCELED_BY_SUPPORT",
}

export interface TransportThirdStep {
  note?: string;
  responsibleUser?: number | null;
}

/**
 * * `SPOT` - Spot transport
 * * `CONTRACTED` - Contracted transport
 */
export enum TransportTypeEnum {
  SPOT = "SPOT",
  CONTRACTED = "CONTRACTED",
}

export interface TransportUpdate {
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  datetime: string;
  readonly id: number;
  readonly timezone: string | null;
  waypoint: number;
  readonly waypointData: WaypointUpdateData;
}

export interface TransportUpdateStatus {
  /**
   * * `PROCESSING` - Processing
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   * * `CANCELED_BY_CARRIER` - Canceled by carrier
   * * `CANCELED_BY_SUPPORT` - Canceled by support
   */
  status: TransportStatusEnum;
}

/**
 * * `REQUEST` - Request
 * * `ETA` - ETA
 * * `CONFIRMATION` - Confirmation
 */
export enum TransportUpdateTypeEnum {
  REQUEST = "REQUEST",
  ETA = "ETA",
  CONFIRMATION = "CONFIRMATION",
}

/** The shipper's transport detail; requires ``transports_retrieve_selector``. */
export interface TransportWithBookings {
  readonly cancelRequestStatus: TransportCancelRequestStatusEnum;
  cargo: Cargo;
  readonly carrier: CarrierInfo;
  /** @maxLength 500 */
  costCenter?: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly createdBy: UserGeneralInfo;
  /** @format double */
  readonly distance: number;
  followers?: number[];
  readonly id: number;
  readonly incoterms: string;
  readonly mergedFromAuctions: number[];
  note?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly price: string;
  readonly priceCurrency: CurrencyEnum;
  /** @maxLength 150 */
  reference?: string;
  /** @format int32 */
  readonly requestId: number;
  resolvingRequests?: number[];
  readonly responsibleUser: UserGeneralInfo;
  responsibleUserId?: number | null;
  /**
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType: RouteTypeEnum;
  /** @format uri */
  readonly staticMap: string | null;
  /**
   * * `PROCESSING` - Processing
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   * * `CANCELED_BY_CARRIER` - Canceled by carrier
   * * `CANCELED_BY_SUPPORT` - Canceled by support
   */
  status?: TransportStatusEnum;
  tags?: string[];
  /**
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode: TransportationModeEnum;
  readonly type: TransportTypeEnum;
  readonly vehicleTypeId: number | null;
  readonly waypoints: WaypointWithBooking[];
  readonly winningBid: Bid;
}

/**
 * * `ROAD` - Road
 * * `AIR` - Air
 * * `SEA` - Sea
 * * `RAIL` - Rail
 * * `INTERMODAL` - Intermodal
 */
export enum TransportationModeEnum {
  ROAD = "ROAD",
  AIR = "AIR",
  SEA = "SEA",
  RAIL = "RAIL",
  INTERMODAL = "INTERMODAL",
}

export interface TransportsBatchUpdatesCreateParams {
  transportPk: number;
}

export interface TransportsBatchUpdatesListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  transportPk: number;
}

export interface TransportsBookingImpactParams {
  /** A unique integer value identifying this transport. */
  id: number;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
}

export interface TransportsContactsListParams {
  /** A unique integer value identifying this transport. */
  id: number;
}

export interface TransportsDestroyParams {
  /** A unique integer value identifying this transport. */
  id: number;
}

export interface TransportsDocumentsListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  transportPk: number;
}

export enum TransportsDownloadOrderRetrieveOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  ValueId = "-id",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
  Id = "id",
}

export interface TransportsDownloadOrderRetrieveParams {
  maxVolumeM3?: number;
  minVolumeM3?: number;
  airWaybillNumber?: string;
  airline?: string;
  /** Auction ID */
  auctionId?: number;
  billOfLadingNumber?: string;
  /** Carrier ID */
  carrierId?: number;
  carrierName?: string;
  containerNumber?: string;
  costCenter?: string;
  /** @format date-time */
  createdAtAfter?: string;
  /** @format date-time */
  createdAtBefore?: string;
  createdBy?: number;
  /**
   * Currency
   *
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  deliveryCity?: string;
  deliveryCountry?: string;
  /** @format date-time */
  deliveryDateAfter?: string;
  /** @format date-time */
  deliveryDateBefore?: string;
  deliveryName?: string;
  deliveryPostCode?: string;
  deliveryReference?: string;
  deliveryStreet?: string;
  driverName?: string;
  driverPhone?: string;
  flightNumber?: string;
  fromPlace?: string;
  /** A unique integer value identifying this transport. */
  id: number;
  /**
   * Incoterms
   *
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  /** Is past */
  isPast?: boolean;
  /**
   * Load type
   *
   * * `FTL` - Full Truck Load
   * * `LTL` - Less than Truck Load
   * * `FCL` - Full Container Load
   * * `LCL` - Less than Container Load
   * * `PARCEL` - Parcel
   * * `NOT_SPECIFIED` - Not specified
   */
  loadType?: CargoLoadTypeEnum[];
  maxWeightKg?: number;
  minWeightKg?: number;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   * * `id` - Id
   * * `-id` - Id (descending)
   */
  order?: TransportsDownloadOrderRetrieveOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  pickupCity?: string;
  pickupCountry?: string;
  /** @format date-time */
  pickupDateAfter?: string;
  /** @format date-time */
  pickupDateBefore?: string;
  pickupName?: string;
  pickupPostCode?: string;
  pickupReference?: string;
  pickupStreet?: string;
  plateNumber?: string;
  /** @format date-time */
  publishedAtAfter?: string;
  /** @format date-time */
  publishedAtBefore?: string;
  reference?: string;
  /**
   * Request type
   *
   * * `REFRIGERATED_GOODS` - Refrigerated goods
   * * `FROZEN_GOODS` - Frozen goods
   * * `METAL_GOODS` - Metal goods
   * * `OVERSIZED_LOAD` - Oversized load
   * * `BULK_MATERIAL` - Bulk material
   * * `LOOSE_MATERIAL` - Loose material
   * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
   * * `LIQUIDS` - Liquids
   * * `VEHICLES` - Vehicles
   * * `ADR` - ADR
   * * `OTHER` - Other
   * * `NOT_SPECIFIED` - Not specified
   */
  requestType?: CargoTypeEnum;
  responsibleUser?: number;
  /**
   * Route type
   *
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
  /** A search term. */
  search?: string;
  /**
   * STA
   * @format date-time
   */
  staAfter?: string;
  /**
   * STA
   * @format date-time
   */
  staBefore?: string;
  /**
   * STD
   * @format date-time
   */
  stdAfter?: string;
  /**
   * STD
   * @format date-time
   */
  stdBefore?: string;
  /** Multiple values may be separated by commas. */
  tag?: string[];
  toPlace?: string;
  trainNumber?: string;
  /**
   * Transport status
   *
   * * `PROCESSING` - Processing
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   * * `CANCELED_BY_CARRIER` - Canceled by carrier
   * * `CANCELED_BY_SUPPORT` - Canceled by support
   */
  transportStatus?: TransportStatusEnum;
  /**
   * Transport type
   *
   * * `SPOT` - Spot transport
   * * `CONTRACTED` - Contracted transport
   */
  transportType?: TransportTypeEnum;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
  vesselName?: string;
  voyageNumber?: string;
  wagonContainerNumber?: string;
}

export enum TransportsExportRetrieveOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  ValueId = "-id",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
  Id = "id",
}

export interface TransportsExportRetrieveParams {
  maxVolumeM3?: number;
  minVolumeM3?: number;
  airWaybillNumber?: string;
  airline?: string;
  /** Auction ID */
  auctionId?: number;
  billOfLadingNumber?: string;
  /** Carrier ID */
  carrierId?: number;
  carrierName?: string;
  containerNumber?: string;
  costCenter?: string;
  /** @format date-time */
  createdAtAfter?: string;
  /** @format date-time */
  createdAtBefore?: string;
  createdBy?: number;
  /**
   * Currency
   *
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  deliveryCity?: string;
  deliveryCountry?: string;
  /** @format date-time */
  deliveryDateAfter?: string;
  /** @format date-time */
  deliveryDateBefore?: string;
  deliveryName?: string;
  deliveryPostCode?: string;
  deliveryReference?: string;
  deliveryStreet?: string;
  driverName?: string;
  driverPhone?: string;
  flightNumber?: string;
  fromPlace?: string;
  /** Transport ID */
  id?: number;
  /**
   * Incoterms
   *
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  /** Is past */
  isPast?: boolean;
  /**
   * Load type
   *
   * * `FTL` - Full Truck Load
   * * `LTL` - Less than Truck Load
   * * `FCL` - Full Container Load
   * * `LCL` - Less than Container Load
   * * `PARCEL` - Parcel
   * * `NOT_SPECIFIED` - Not specified
   */
  loadType?: CargoLoadTypeEnum[];
  maxWeightKg?: number;
  minWeightKg?: number;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   * * `id` - Id
   * * `-id` - Id (descending)
   */
  order?: TransportsExportRetrieveOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  pickupCity?: string;
  pickupCountry?: string;
  /** @format date-time */
  pickupDateAfter?: string;
  /** @format date-time */
  pickupDateBefore?: string;
  pickupName?: string;
  pickupPostCode?: string;
  pickupReference?: string;
  pickupStreet?: string;
  plateNumber?: string;
  /** @format date-time */
  publishedAtAfter?: string;
  /** @format date-time */
  publishedAtBefore?: string;
  reference?: string;
  /**
   * Request type
   *
   * * `REFRIGERATED_GOODS` - Refrigerated goods
   * * `FROZEN_GOODS` - Frozen goods
   * * `METAL_GOODS` - Metal goods
   * * `OVERSIZED_LOAD` - Oversized load
   * * `BULK_MATERIAL` - Bulk material
   * * `LOOSE_MATERIAL` - Loose material
   * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
   * * `LIQUIDS` - Liquids
   * * `VEHICLES` - Vehicles
   * * `ADR` - ADR
   * * `OTHER` - Other
   * * `NOT_SPECIFIED` - Not specified
   */
  requestType?: CargoTypeEnum;
  responsibleUser?: number;
  /**
   * Route type
   *
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
  /** A search term. */
  search?: string;
  /**
   * STA
   * @format date-time
   */
  staAfter?: string;
  /**
   * STA
   * @format date-time
   */
  staBefore?: string;
  /**
   * STD
   * @format date-time
   */
  stdAfter?: string;
  /**
   * STD
   * @format date-time
   */
  stdBefore?: string;
  /** Multiple values may be separated by commas. */
  tag?: string[];
  toPlace?: string;
  trainNumber?: string;
  /**
   * Transport status
   *
   * * `PROCESSING` - Processing
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   * * `CANCELED_BY_CARRIER` - Canceled by carrier
   * * `CANCELED_BY_SUPPORT` - Canceled by support
   */
  transportStatus?: TransportStatusEnum;
  /**
   * Transport type
   *
   * * `SPOT` - Spot transport
   * * `CONTRACTED` - Contracted transport
   */
  transportType?: TransportTypeEnum;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
  vesselName?: string;
  voyageNumber?: string;
  wagonContainerNumber?: string;
}

export enum TransportsListOrderEnum {
  ValueCreatedAt = "-created_at",
  ValueEarliestWaypointDate = "-earliest_waypoint_date",
  ValueId = "-id",
  CreatedAt = "created_at",
  EarliestWaypointDate = "earliest_waypoint_date",
  Id = "id",
}

export interface TransportsListParams {
  maxVolumeM3?: number;
  minVolumeM3?: number;
  airWaybillNumber?: string;
  airline?: string;
  /** Auction ID */
  auctionId?: number;
  billOfLadingNumber?: string;
  /** Carrier ID */
  carrierId?: number;
  carrierName?: string;
  containerNumber?: string;
  costCenter?: string;
  /** @format date-time */
  createdAtAfter?: string;
  /** @format date-time */
  createdAtBefore?: string;
  createdBy?: number;
  /**
   * Currency
   *
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  deliveryCity?: string;
  deliveryCountry?: string;
  /** @format date-time */
  deliveryDateAfter?: string;
  /** @format date-time */
  deliveryDateBefore?: string;
  deliveryName?: string;
  deliveryPostCode?: string;
  deliveryReference?: string;
  deliveryStreet?: string;
  driverName?: string;
  driverPhone?: string;
  flightNumber?: string;
  fromPlace?: string;
  /** Transport ID */
  id?: number;
  /**
   * Incoterms
   *
   * * `EXW` - EXW - Ex Works
   * * `FCA` - FCA - Free Carrier
   * * `CPT` - CPT - Carriage Paid To
   * * `CIP` - CIP - Carriage and Insurance Paid To
   * * `DAP` - DAP - Delivered at Place
   * * `DPU` - DPU - Delivered at Place Unloaded
   * * `DDP` - DDP - Delivered Duty Paid
   * * `FAS` - FAS - Free Alongside Ship
   * * `FOB` - FOB - Free On Board
   * * `CFR` - CFR - Cost and Freight
   * * `CIF` - CIF - Cost, Insurance and Freight
   */
  incoterms?: IncotermsEnum;
  /** Is past */
  isPast?: boolean;
  /**
   * Load type
   *
   * * `FTL` - Full Truck Load
   * * `LTL` - Less than Truck Load
   * * `FCL` - Full Container Load
   * * `LCL` - Less than Container Load
   * * `PARCEL` - Parcel
   * * `NOT_SPECIFIED` - Not specified
   */
  loadType?: CargoLoadTypeEnum[];
  maxWeightKg?: number;
  minWeightKg?: number;
  /**
   * Ordering
   *
   * * `created_at` - Created at
   * * `-created_at` - Created at (descending)
   * * `earliest_waypoint_date` - Earliest waypoint date
   * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
   * * `id` - Id
   * * `-id` - Id (descending)
   */
  order?: TransportsListOrderEnum[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  pickupCity?: string;
  pickupCountry?: string;
  /** @format date-time */
  pickupDateAfter?: string;
  /** @format date-time */
  pickupDateBefore?: string;
  pickupName?: string;
  pickupPostCode?: string;
  pickupReference?: string;
  pickupStreet?: string;
  plateNumber?: string;
  /** @format date-time */
  publishedAtAfter?: string;
  /** @format date-time */
  publishedAtBefore?: string;
  reference?: string;
  /**
   * Request type
   *
   * * `REFRIGERATED_GOODS` - Refrigerated goods
   * * `FROZEN_GOODS` - Frozen goods
   * * `METAL_GOODS` - Metal goods
   * * `OVERSIZED_LOAD` - Oversized load
   * * `BULK_MATERIAL` - Bulk material
   * * `LOOSE_MATERIAL` - Loose material
   * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
   * * `LIQUIDS` - Liquids
   * * `VEHICLES` - Vehicles
   * * `ADR` - ADR
   * * `OTHER` - Other
   * * `NOT_SPECIFIED` - Not specified
   */
  requestType?: CargoTypeEnum;
  responsibleUser?: number;
  /**
   * Route type
   *
   * * `ONE_WAY` - One way
   * * `ROUND_TRIP` - Round trip
   */
  routeType?: RouteTypeEnum;
  /** A search term. */
  search?: string;
  /**
   * STA
   * @format date-time
   */
  staAfter?: string;
  /**
   * STA
   * @format date-time
   */
  staBefore?: string;
  /**
   * STD
   * @format date-time
   */
  stdAfter?: string;
  /**
   * STD
   * @format date-time
   */
  stdBefore?: string;
  /** Multiple values may be separated by commas. */
  tag?: string[];
  toPlace?: string;
  trainNumber?: string;
  /**
   * Transport status
   *
   * * `PROCESSING` - Processing
   * * `FINISHED` - Finished
   * * `CANCELED` - Canceled
   * * `CANCELED_BY_CARRIER` - Canceled by carrier
   * * `CANCELED_BY_SUPPORT` - Canceled by support
   */
  transportStatus?: TransportStatusEnum;
  /**
   * Transport type
   *
   * * `SPOT` - Spot transport
   * * `CONTRACTED` - Contracted transport
   */
  transportType?: TransportTypeEnum;
  /**
   * Transportation mode
   *
   * * `ROAD` - Road
   * * `AIR` - Air
   * * `SEA` - Sea
   * * `RAIL` - Rail
   * * `INTERMODAL` - Intermodal
   */
  transportationMode?: TransportationModeEnum;
  vesselName?: string;
  voyageNumber?: string;
  wagonContainerNumber?: string;
}

export interface TransportsMessagesCreateParams {
  transportPk: number;
}

export interface TransportsMessagesListParams {
  carrier?: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  transportPk: number;
}

export interface TransportsMessagesMarkAsReadCreateParams {
  transportPk: number;
}

export interface TransportsMessagesUnreadCountRetrieveParams {
  transportPk: number;
}

export interface TransportsPartialUpdateParams {
  /** A unique integer value identifying this transport. */
  id: number;
}

export interface TransportsRetrieveParams {
  /** A unique integer value identifying this transport. */
  id: number;
}

export interface TransportsStatusCreateParams {
  /** A unique integer value identifying this transport. */
  id: number;
}

export interface TransportsTransportDetailsCreateParams {
  /** A unique integer value identifying this transport. */
  id: number;
}

export interface TransportsTransportDetailsRetrieveParams {
  /** A unique integer value identifying this transport. */
  id: number;
}

export interface TransportsUpdateParams {
  /** A unique integer value identifying this transport. */
  id: number;
}

export interface TransportsUpdatesListLatestListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
  transportPk: number;
}

/**
 * * `KG` - kg
 * * `M` - m
 * * `M3` - m³
 */
export enum UnitEnum {
  KG = "KG",
  M = "M",
  M3 = "M3",
}

export interface UnpaidInvoices {
  readonly invoicesCount: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  readonly totalAmount: string;
}

/** It's used for listing bids for user. Main difference is that shipper status could be updated. */
export interface UpdateBid {
  readonly carrier: number;
  readonly carrierNote: string;
  readonly carrierStatus: BidStatusEnum;
  /** @format date-time */
  readonly carrierStatusChangedAt: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly id: number;
  readonly isAutoSelect: boolean;
  readonly isConfirmedByShipper: boolean;
  isInstantOrder?: boolean;
  readonly isManuallyExcluded: boolean;
  readonly isRejected: boolean;
  readonly isWinning: boolean;
  metadata?: BidMetadata | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  offeredPrice?: string;
  readonly offeredPriceCurrency: CurrencyEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  priceWorkspace?: string;
  readonly priceWorkspaceCurrency: CurrencyEnum;
  shipperNote?: string;
  /**
   * * `CONFIRMED` - Confirmed
   * * `REJECTED` - Rejected
   * * `NOT_DECIDED` - Not decided
   */
  shipperStatus: BidStatusEnum;
  /** @format date-time */
  readonly shipperStatusChangedAt: string;
}

/** Separate serializer for carrier to update decision on bid. */
export interface UpdateBidByHash {
  readonly carrier: number;
  carrierNote?: string;
  /**
   * * `CONFIRMED` - Confirmed
   * * `REJECTED` - Rejected
   * * `NOT_DECIDED` - Not decided
   */
  carrierStatus: BidStatusEnum;
  readonly comparison: BidComparisonEnum;
  /** @format date-time */
  readonly createdAt: string;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  readonly isConfirmedByShipper: boolean;
  readonly isRejected: boolean;
  readonly isWinning: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  offeredPrice?: string;
  readonly offeredPriceCurrency: CurrencyEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  priceWorkspace?: string;
  readonly priceWorkspaceCurrency: CurrencyEnum;
  readonly shipperNote: string;
  readonly shipperStatus: BidStatusEnum;
}

export interface User {
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email: string;
  /** @maxLength 150 */
  firstName?: string;
  readonly id: number;
  /**
   * Active
   * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
   */
  isActive?: boolean;
  /** @maxLength 150 */
  lastName?: string;
  readonly notificationSettings: Record<
    string,
    Record<string, Record<string, boolean>>
  >;
  /** @maxLength 128 */
  phoneNumber?: string;
  readonly role: number;
  roleId?: number;
  readonly workspace: WorkspaceGeneralInfo;
}

/** User model w/o password */
export interface UserDetails {
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email: string;
  firstName: string;
  readonly id: number;
  /**
   * Active
   * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
   */
  isActive?: boolean;
  readonly isEmailVerified: boolean;
  /** @maxLength 150 */
  lastName?: string;
  readonly members: Member[];
  readonly notificationSettings: Record<
    string,
    Record<string, Record<string, boolean>>
  >;
  readonly permissions: string[];
  phoneNumber: string;
  /** Language */
  preferredLanguage?: LanguageEnum;
  readonly workspace: Workspace;
  workspaceId?: number;
}

export interface UserGeneralInfo {
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email: string;
  /** @maxLength 150 */
  firstName?: string;
  readonly id: number;
  /** @maxLength 150 */
  lastName?: string;
  /** @maxLength 128 */
  phoneNumber?: string;
  readonly workspace: WorkspaceGeneralInfo;
}

export interface UserMessage {
  carrier: TimelineCarrier;
  content?: string;
  /** @format date-time */
  readonly createdAt: string;
  readonly data: MessageData;
  readonly event: MessageEventEnum;
  readonly id: number;
  readonly objectWorkspace: WorkspaceGeneralInfo;
  reference: Reference;
  /** @format date-time */
  readonly seenAt: string;
  readonly sender: GenericSender;
  readonly type: MessageTypeEnum;
  unreadCount: number;
}

export interface UserNotificationSettings {
  events: Record<string, NotificationEvent[]>;
}

export interface UserPermissions {
  permissions: string[];
}

export interface UsersAllListParams {
  excludeRoles?: string[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
}

export interface UsersDestroyParams {
  /** A unique integer value identifying this user. */
  id: number;
}

export interface UsersListParams {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
}

export interface UsersPartialUpdateParams {
  /** A unique integer value identifying this user. */
  id: number;
}

export interface UsersPermissionsRetrieveParams {
  /** A unique integer value identifying this user. */
  id: number;
}

export interface UsersRetrieveParams {
  /** A unique integer value identifying this user. */
  id: number;
}

export interface UsersUpdateParams {
  /** A unique integer value identifying this user. */
  id: number;
}

export type VehicleDetails =
  | RoadVehicleDetails
  | AirVehicleDetails
  | SeaVehicleDetails
  | RailVehicleDetails;

export interface VehicleType {
  readonly id: number;
  /** @default false */
  readonly isUsedInDraft: boolean;
  /**
   * m²
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  maxCargoSpace?: string | null;
  /**
   * m³
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  maxCargoVolume?: string | null;
  /**
   * kg
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,0})?$
   */
  maxPayload?: string | null;
  /** @maxLength 100 */
  name: string;
}

export interface VehicleTypeBulk {
  vehicleTypes: VehicleTypeBulkItem[];
}

export interface VehicleTypeBulkItem {
  id?: number | null;
  /** @default false */
  readonly isUsedInDraft: boolean;
  /**
   * m²
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  maxCargoSpace?: string | null;
  /**
   * m³
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  maxCargoVolume?: string | null;
  /**
   * kg
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,0})?$
   */
  maxPayload?: string | null;
  /** @maxLength 100 */
  name: string;
}

export interface VehicleTypeNested {
  readonly id: number;
  /** @maxLength 100 */
  name: string;
}

export interface VehicleTypesDestroyParams {
  /** A unique integer value identifying this Vehicle Type. */
  id: number;
}

export interface VehicleTypesListParams {
  name?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
}

export interface VehicleTypesPartialUpdateParams {
  /** A unique integer value identifying this Vehicle Type. */
  id: number;
}

export interface VehicleTypesRetrieveParams {
  /** A unique integer value identifying this Vehicle Type. */
  id: number;
}

export interface VehicleTypesUpdateParams {
  /** A unique integer value identifying this Vehicle Type. */
  id: number;
}

export interface VerifyEmail {
  key: string;
}

/**
 * * `l` - L
 * * `m3` - m³
 */
export enum VolumeUnitEnum {
  L = "l",
  M3 = "m3",
}

export interface Waypoint {
  address?: number | null;
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  availabilityEnd?: string | null;
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  availabilityStart?: string | null;
  /** @maxLength 100 */
  city: string;
  contactEmail?: string;
  /** @maxLength 50 */
  contactName?: string;
  /** @maxLength 128 */
  contactPhone?: string;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  id?: number | null;
  /**
   * @min 0
   * @max 32767
   */
  index?: number | null;
  /** @maxLength 50 */
  name?: string;
  note?: string;
  /** @maxLength 20 */
  postCode?: string;
  /** @maxLength 150 */
  reference?: string;
  saveToDirectory?: boolean;
  /** @maxLength 100 */
  street?: string;
  readonly timezone: string | null;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  type: WaypointTypeEnum;
}

export interface WaypointAutocompleteRequest {
  /**
   * * `city` - city
   * * `name` - name
   * * `post_code` - post_code
   * * `street` - street
   */
  field: FieldEnum;
  /**
   * * `auction` - Auction
   * * `transport` - Transport
   */
  modelType?: WaypointModelTypeEnum;
  term: string;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  waypointType: WaypointTypeEnum;
}

export interface WaypointBooking {
  /** @format date-time */
  readonly endAt: string;
  readonly gate: GateNested;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  /** @format date-time */
  readonly startAt: string;
  readonly status: TimeSlotBookingListStatusEnum;
  readonly timeZone: string;
}

export interface WaypointByHash {
  readonly addressId: number | null;
  /** @format date-time */
  readonly availabilityEnd: string | null;
  /** @format date-time */
  readonly availabilityStart: string | null;
  /** @maxLength 100 */
  readonly city: string;
  readonly contactEmail: string | null;
  readonly contactName: string | null;
  readonly contactPhone: string | null;
  readonly country: CountryEnum;
  readonly id: number;
  /**
   * @min 0
   * @max 32767
   */
  readonly index: number | null;
  /** @maxLength 50 */
  readonly name: string;
  readonly note: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  readonly originalId: number | null;
  /** @maxLength 20 */
  readonly postCode: string;
  readonly reference: string | null;
  /** @maxLength 100 */
  readonly street: string;
  readonly timezone: string | null;
  readonly type: WaypointTypeEnum;
}

/**
 * * `auction` - Auction
 * * `transport` - Transport
 */
export enum WaypointModelTypeEnum {
  Auction = "auction",
  Transport = "transport",
}

/**
 * A mixin that sets all serializer fields (including nested ones)
 * to required=False, allow_null=True automatically and ski serializer validation.
 */
export interface WaypointOptional {
  address?: number | null;
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  availabilityEnd?: string | null;
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  availabilityStart?: string | null;
  /** @maxLength 100 */
  city?: string | null;
  contactEmail?: string | null;
  /** @maxLength 50 */
  contactName?: string | null;
  /** @maxLength 128 */
  contactPhone?: string | null;
  country?: CountryEnum | null;
  id?: number | null;
  /**
   * @min 0
   * @max 32767
   */
  index?: number | null;
  /** @maxLength 50 */
  name?: string | null;
  note?: string | null;
  /** @maxLength 20 */
  postCode?: string | null;
  /** @maxLength 150 */
  reference?: string | null;
  saveToDirectory?: boolean | null;
  /** @maxLength 100 */
  street?: string | null;
  readonly timezone: string | null;
  type?: WaypointTypeEnum | null;
}

export enum WaypointStatsTypeEnum {
  PICKUP = "PICKUP",
  DELIVERY = "DELIVERY",
  PICKUP_AND_DELIVERY = "PICKUP_AND_DELIVERY",
}

/**
 * * `PICKUP` - Pickup
 * * `DELIVERY` - Delivery
 */
export enum WaypointTypeEnum {
  PICKUP = "PICKUP",
  DELIVERY = "DELIVERY",
}

export interface WaypointUpdateData {
  readonly address: string;
  readonly country: CountryEnum;
  readonly index: number | null;
  readonly type: WaypointTypeEnum;
}

/** Requires instances with ``address`` selected. A link to a deleted directory address keeps its text editable. */
export interface WaypointWithAddressState {
  address?: number | null;
  readonly addressIsDeleted: boolean;
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  availabilityEnd?: string | null;
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  availabilityStart?: string | null;
  /** @maxLength 100 */
  city: string;
  contactEmail?: string;
  /** @maxLength 50 */
  contactName?: string;
  /** @maxLength 128 */
  contactPhone?: string;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  id?: number | null;
  /**
   * @min 0
   * @max 32767
   */
  index?: number | null;
  /** @maxLength 50 */
  name?: string;
  note?: string;
  /** @maxLength 20 */
  postCode?: string;
  /** @maxLength 150 */
  reference?: string;
  saveToDirectory?: boolean;
  /** @maxLength 100 */
  street?: string;
  readonly timezone: string | null;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  type: WaypointTypeEnum;
}

/**
 * Requires instances prefetched with ``waypoints_with_booking_state_queryset``. ``booking_required`` comes
 * from the stored status, not the reported one, so the detail agrees with the list badge.
 */
export interface WaypointWithBooking {
  address?: number | null;
  readonly addressIsDeleted: boolean;
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  availabilityEnd?: string | null;
  /**
   * A value without an offset is read as the wall clock at the waypoint's address; one with an offset names an instant and is stored as sent. Responses are always UTC.
   * @format date-time
   */
  availabilityStart?: string | null;
  readonly booking: WaypointBooking | null;
  readonly bookingRequired: boolean;
  /** @maxLength 100 */
  city: string;
  contactEmail?: string;
  /** @maxLength 50 */
  contactName?: string;
  /** @maxLength 128 */
  contactPhone?: string;
  /**
   * * `AF` - Afghanistan
   * * `AX` - Åland Islands
   * * `AL` - Albania
   * * `DZ` - Algeria
   * * `AS` - American Samoa
   * * `AD` - Andorra
   * * `AO` - Angola
   * * `AI` - Anguilla
   * * `AQ` - Antarctica
   * * `AG` - Antigua and Barbuda
   * * `AR` - Argentina
   * * `AM` - Armenia
   * * `AW` - Aruba
   * * `AU` - Australia
   * * `AT` - Austria
   * * `AZ` - Azerbaijan
   * * `BS` - Bahamas (The)
   * * `BH` - Bahrain
   * * `BD` - Bangladesh
   * * `BB` - Barbados
   * * `BY` - Belarus
   * * `BE` - Belgium
   * * `BZ` - Belize
   * * `BJ` - Benin
   * * `BM` - Bermuda
   * * `BT` - Bhutan
   * * `BO` - Bolivia
   * * `BQ` - Bonaire, Sint Eustatius and Saba
   * * `BA` - Bosnia and Herzegovina
   * * `BW` - Botswana
   * * `BV` - Bouvet Island
   * * `BR` - Brazil
   * * `IO` - British Indian Ocean Territory
   * * `BN` - Brunei
   * * `BG` - Bulgaria
   * * `BF` - Burkina Faso
   * * `BI` - Burundi
   * * `CV` - Cabo Verde
   * * `KH` - Cambodia
   * * `CM` - Cameroon
   * * `CA` - Canada
   * * `KY` - Cayman Islands
   * * `CF` - Central African Republic
   * * `TD` - Chad
   * * `CL` - Chile
   * * `CN` - China
   * * `CX` - Christmas Island
   * * `CC` - Cocos (Keeling) Islands
   * * `CO` - Colombia
   * * `KM` - Comoros
   * * `CG` - Congo
   * * `CK` - Cook Islands
   * * `CR` - Costa Rica
   * * `CI` - Côte d'Ivoire
   * * `HR` - Croatia
   * * `CU` - Cuba
   * * `CW` - Curaçao
   * * `CY` - Cyprus
   * * `CZ` - Czechia
   * * `CD` - Democratic Republic of the Congo
   * * `DK` - Denmark
   * * `DJ` - Djibouti
   * * `DM` - Dominica
   * * `DO` - Dominican Republic
   * * `EC` - Ecuador
   * * `EG` - Egypt
   * * `SV` - El Salvador
   * * `GQ` - Equatorial Guinea
   * * `ER` - Eritrea
   * * `EE` - Estonia
   * * `SZ` - Eswatini
   * * `ET` - Ethiopia
   * * `FK` - Falkland Islands (Malvinas)
   * * `FO` - Faroe Islands
   * * `FJ` - Fiji
   * * `FI` - Finland
   * * `FR` - France
   * * `GF` - French Guiana
   * * `PF` - French Polynesia
   * * `TF` - French Southern Territories
   * * `GA` - Gabon
   * * `GM` - Gambia
   * * `GE` - Georgia
   * * `DE` - Germany
   * * `GH` - Ghana
   * * `GI` - Gibraltar
   * * `GR` - Greece
   * * `GL` - Greenland
   * * `GD` - Grenada
   * * `GP` - Guadeloupe
   * * `GU` - Guam
   * * `GT` - Guatemala
   * * `GG` - Guernsey
   * * `GN` - Guinea
   * * `GW` - Guinea-Bissau
   * * `GY` - Guyana
   * * `HT` - Haiti
   * * `HM` - Heard Island and McDonald Islands
   * * `HN` - Honduras
   * * `HK` - Hong Kong
   * * `HU` - Hungary
   * * `IS` - Iceland
   * * `IN` - India
   * * `ID` - Indonesia
   * * `IR` - Iran
   * * `IQ` - Iraq
   * * `IE` - Ireland
   * * `IM` - Isle of Man
   * * `IL` - Israel
   * * `IT` - Italy
   * * `JM` - Jamaica
   * * `JP` - Japan
   * * `JE` - Jersey
   * * `JO` - Jordan
   * * `KZ` - Kazakhstan
   * * `KE` - Kenya
   * * `KI` - Kiribati
   * * `KW` - Kuwait
   * * `KG` - Kyrgyzstan
   * * `LA` - Laos
   * * `LV` - Latvia
   * * `LB` - Lebanon
   * * `LS` - Lesotho
   * * `LR` - Liberia
   * * `LY` - Libya
   * * `LI` - Liechtenstein
   * * `LT` - Lithuania
   * * `LU` - Luxembourg
   * * `MO` - Macao
   * * `MG` - Madagascar
   * * `MW` - Malawi
   * * `MY` - Malaysia
   * * `MV` - Maldives
   * * `ML` - Mali
   * * `MT` - Malta
   * * `MH` - Marshall Islands
   * * `MQ` - Martinique
   * * `MR` - Mauritania
   * * `MU` - Mauritius
   * * `YT` - Mayotte
   * * `MX` - Mexico
   * * `FM` - Micronesia
   * * `MD` - Moldova
   * * `MC` - Monaco
   * * `MN` - Mongolia
   * * `ME` - Montenegro
   * * `MS` - Montserrat
   * * `MA` - Morocco
   * * `MZ` - Mozambique
   * * `MM` - Myanmar
   * * `NA` - Namibia
   * * `NR` - Naoero
   * * `NP` - Nepal
   * * `NL` - Netherlands
   * * `NC` - New Caledonia
   * * `NZ` - New Zealand
   * * `NI` - Nicaragua
   * * `NE` - Niger
   * * `NG` - Nigeria
   * * `NU` - Niue
   * * `NF` - Norfolk Island
   * * `KP` - North Korea
   * * `MK` - North Macedonia
   * * `MP` - Northern Mariana Islands
   * * `NO` - Norway
   * * `OM` - Oman
   * * `PK` - Pakistan
   * * `PW` - Palau
   * * `PS` - Palestine
   * * `PA` - Panama
   * * `PG` - Papua New Guinea
   * * `PY` - Paraguay
   * * `PE` - Peru
   * * `PH` - Philippines
   * * `PN` - Pitcairn
   * * `PL` - Poland
   * * `PT` - Portugal
   * * `PR` - Puerto Rico
   * * `QA` - Qatar
   * * `RE` - Réunion
   * * `RO` - Romania
   * * `RU` - Russia
   * * `RW` - Rwanda
   * * `BL` - Saint Barthélemy
   * * `SH` - Saint Helena
   * * `KN` - Saint Kitts and Nevis
   * * `LC` - Saint Lucia
   * * `MF` - Saint Martin (French part)
   * * `PM` - Saint Pierre and Miquelon
   * * `VC` - Saint Vincent and the Grenadines
   * * `WS` - Samoa
   * * `SM` - San Marino
   * * `ST` - Sao Tome and Principe
   * * `SA` - Saudi Arabia
   * * `SN` - Senegal
   * * `RS` - Serbia
   * * `SC` - Seychelles
   * * `SL` - Sierra Leone
   * * `SG` - Singapore
   * * `SX` - Sint Maarten (Dutch part)
   * * `SK` - Slovakia
   * * `SI` - Slovenia
   * * `SB` - Solomon Islands
   * * `SO` - Somalia
   * * `ZA` - South Africa
   * * `GS` - South Georgia
   * * `KR` - South Korea
   * * `SS` - South Sudan
   * * `ES` - Spain
   * * `LK` - Sri Lanka
   * * `SD` - Sudan
   * * `SR` - Suriname
   * * `SJ` - Svalbard and Jan Mayen
   * * `SE` - Sweden
   * * `CH` - Switzerland
   * * `SY` - Syria
   * * `TW` - Taiwan
   * * `TJ` - Tajikistan
   * * `TZ` - Tanzania
   * * `TH` - Thailand
   * * `TL` - Timor-Leste
   * * `TG` - Togo
   * * `TK` - Tokelau
   * * `TO` - Tonga
   * * `TT` - Trinidad and Tobago
   * * `TN` - Tunisia
   * * `TR` - Türkiye
   * * `TM` - Turkmenistan
   * * `TC` - Turks and Caicos Islands
   * * `TV` - Tuvalu
   * * `UG` - Uganda
   * * `UA` - Ukraine
   * * `AE` - United Arab Emirates
   * * `GB` - United Kingdom
   * * `UM` - United States Minor Outlying Islands
   * * `US` - United States of America
   * * `UY` - Uruguay
   * * `UZ` - Uzbekistan
   * * `VU` - Vanuatu
   * * `VA` - Vatican City
   * * `VE` - Venezuela
   * * `VN` - Vietnam
   * * `VG` - Virgin Islands (British)
   * * `VI` - Virgin Islands (U.S.)
   * * `WF` - Wallis and Futuna
   * * `EH` - Western Sahara
   * * `YE` - Yemen
   * * `ZM` - Zambia
   * * `ZW` - Zimbabwe
   */
  country: CountryEnum;
  id?: number | null;
  /**
   * @min 0
   * @max 32767
   */
  index?: number | null;
  /** @maxLength 50 */
  name?: string;
  note?: string;
  /** @maxLength 20 */
  postCode?: string;
  /** @maxLength 150 */
  reference?: string;
  saveToDirectory?: boolean;
  /** @maxLength 100 */
  street?: string;
  readonly timeSlotsEnabled: boolean;
  readonly timezone: string | null;
  /**
   * * `PICKUP` - Pickup
   * * `DELIVERY` - Delivery
   */
  type: WaypointTypeEnum;
}

/**
 * * `0` - Monday
 * * `1` - Tuesday
 * * `2` - Wednesday
 * * `3` - Thursday
 * * `4` - Friday
 * * `5` - Saturday
 * * `6` - Sunday
 */
export enum WeekdayEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

/**
 * * `kg` - kg
 * * `t` - t
 */
export enum WeightUnitEnum {
  Kg = "kg",
  T = "t",
}

export interface Workspace {
  address?: CompanyAddress | null;
  billingDetails?: BillingDetailsLimited | null;
  /**
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  readonly currencyRecalcInProgress: boolean;
  /**
   * Email sender name
   * @maxLength 100
   */
  emailFromName?: string;
  /** Short identifier used in the workspace inbound e-mail address. */
  readonly emailHash: string;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  /**
   * * `m` - m
   * * `cm` - cm
   * * `mm` - mm
   */
  lengthUnit?: LengthUnitEnum;
  /** @format uri */
  readonly logo: string | null;
  microsoftAccount?: WorkspaceSocialMicrosoft | null;
  /**
   * Title
   * @maxLength 100
   */
  name: string;
  readonly packageData: WorkspacePackageData | null;
  preferences?: WorkspacePreferences;
  /**
   * * `l` - L
   * * `m3` - m³
   */
  volumeUnit?: VolumeUnitEnum;
  /**
   * * `kg` - kg
   * * `t` - t
   */
  weightUnit?: WeightUnitEnum;
}

export interface WorkspaceByHash {
  readonly address: CompanyAddress;
  readonly billingDetails: BillingDetails;
  readonly id: number;
  /** @format uri */
  readonly logo: string | null;
  /**
   * Title
   * @maxLength 100
   */
  readonly name: string;
}

export interface WorkspaceDownloadSampleTransportOrderRetrieveParams {
  /** A unique integer value identifying this workspace. */
  id: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A search term. */
  search?: string;
}

export interface WorkspaceGeneralInfo {
  readonly id: number;
  /**
   * Title
   * @maxLength 100
   */
  name: string;
}

export interface WorkspaceInvitation {
  /** @format date-time */
  sent?: string | null;
  readonly workspace: WorkspaceGeneralInfo;
}

export interface WorkspaceLogo {
  /** @format uri */
  logo: string;
}

export interface WorkspaceLogoutAllUsersCreateParams {
  /** A unique integer value identifying this workspace. */
  id: number;
}

export interface WorkspacePackageData {
  contractMatchingEnabled?: boolean;
  tenderEnabled?: boolean;
  timeSlotsEnabled?: boolean;
}

export interface WorkspacePartialUpdateParams {
  /** A unique integer value identifying this workspace. */
  id: number;
}

export interface WorkspacePreferences {
  /**
   * * `PASSWORD` - Password
   * * `MICROSOFT` - Microsoft account
   */
  authProvider?: WorkspacePreferencesAuthProviderEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  autoSelectLimit?: string | null;
  autoSelectLimitCurrency?: string;
  /** Default note for carrier in the request */
  carrierNote?: string;
  isAutoSelectEnabled?: boolean;
  isPricerPopupEnabled?: boolean;
  isTransportDocumentEnabled?: boolean;
  /** Default savings calculation method */
  savingsCalculationMethod?: SavingsCalculationMethodEnum;
}

/**
 * * `PASSWORD` - Password
 * * `MICROSOFT` - Microsoft account
 */
export enum WorkspacePreferencesAuthProviderEnum {
  PASSWORD = "PASSWORD",
  MICROSOFT = "MICROSOFT",
}

export interface WorkspaceRetrieveParams {
  /** A unique integer value identifying this workspace. */
  id: number;
}

export interface WorkspaceScheduledTasksCreateParams {
  workspacePk: number;
}

export interface WorkspaceScheduledTasksDestroyParams {
  /** A unique integer value identifying this scheduled user task. */
  id: number;
  workspacePk: number;
}

export interface WorkspaceScheduledTasksListParams {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  workspacePk: number;
}

export interface WorkspaceScheduledTasksPartialUpdateParams {
  /** A unique integer value identifying this scheduled user task. */
  id: number;
  workspacePk: number;
}

export interface WorkspaceScheduledTasksRetrieveParams {
  /** A unique integer value identifying this scheduled user task. */
  id: number;
  workspacePk: number;
}

export interface WorkspaceScheduledTasksUpdateParams {
  /** A unique integer value identifying this scheduled user task. */
  id: number;
  workspacePk: number;
}

export interface WorkspaceSocialMicrosoft {
  /** @maxLength 255 */
  microsoftGroupId?: string;
  /** @maxLength 500 */
  microsoftGroupName?: string;
  /** @maxLength 255 */
  microsoftTenantId: string;
  /** @maxLength 500 */
  microsoftTenantName?: string;
}

export interface WorkspaceTag {
  /** @maxLength 100 */
  name: string;
}

export interface WorkspaceUpdate {
  address?: CompanyAddress | null;
  billingDetails?: BillingDetailsLimited | null;
  /**
   * * `EUR` - EUR
   * * `USD` - USD
   * * `CZK` - CZK
   * * `HUF` - HUF
   * * `PLN` - PLN
   * * `RON` - RON
   * * `GBP` - GBP
   * * `NOK` - NOK
   * * `DKK` - DKK
   * * `SEK` - SEK
   * * `ISK` - ISK
   * * `CHF` - CHF
   * * `CNY` - CNY
   */
  currency?: CurrencyEnum;
  readonly currencyRecalcInProgress: boolean;
  /** @default false */
  deleteLogo?: boolean;
  /**
   * Email sender name
   * @maxLength 100
   */
  emailFromName?: string;
  /** Short identifier used in the workspace inbound e-mail address. */
  readonly emailHash: string;
  /** Hash key */
  readonly hash: string;
  readonly id: number;
  /**
   * * `m` - m
   * * `cm` - cm
   * * `mm` - mm
   */
  lengthUnit?: LengthUnitEnum;
  /** @format uri */
  readonly logo: string | null;
  microsoftAccount?: WorkspaceSocialMicrosoft | null;
  name?: string;
  readonly packageData: WorkspacePackageData | null;
  preferences?: WorkspacePreferences;
  /**
   * * `l` - L
   * * `m3` - m³
   */
  volumeUnit?: VolumeUnitEnum;
  /**
   * * `kg` - kg
   * * `t` - t
   */
  weightUnit?: WeightUnitEnum;
}

export interface WorkspaceUpdateParams {
  /** A unique integer value identifying this workspace. */
  id: number;
}

export interface WorkspaceUploadLogoCreateParams {
  /** A unique integer value identifying this workspace. */
  id: number;
}

export namespace Addresses {
  /**
   * No description
   * @tags addresses
   * @name AddressesList
   * @request GET:/api/v1/addresses/
   * @secure
   * @response `200` `PaginatedAddressListList`
   */
  export namespace AddressesList {
    export type RequestParams = {};
    export type RequestQuery = {
      city?: string;
      /**
       * * `AF` - Afghanistan
       * * `AX` - Åland Islands
       * * `AL` - Albania
       * * `DZ` - Algeria
       * * `AS` - American Samoa
       * * `AD` - Andorra
       * * `AO` - Angola
       * * `AI` - Anguilla
       * * `AQ` - Antarctica
       * * `AG` - Antigua and Barbuda
       * * `AR` - Argentina
       * * `AM` - Armenia
       * * `AW` - Aruba
       * * `AU` - Australia
       * * `AT` - Austria
       * * `AZ` - Azerbaijan
       * * `BS` - Bahamas (The)
       * * `BH` - Bahrain
       * * `BD` - Bangladesh
       * * `BB` - Barbados
       * * `BY` - Belarus
       * * `BE` - Belgium
       * * `BZ` - Belize
       * * `BJ` - Benin
       * * `BM` - Bermuda
       * * `BT` - Bhutan
       * * `BO` - Bolivia
       * * `BQ` - Bonaire, Sint Eustatius and Saba
       * * `BA` - Bosnia and Herzegovina
       * * `BW` - Botswana
       * * `BV` - Bouvet Island
       * * `BR` - Brazil
       * * `IO` - British Indian Ocean Territory
       * * `BN` - Brunei
       * * `BG` - Bulgaria
       * * `BF` - Burkina Faso
       * * `BI` - Burundi
       * * `CV` - Cabo Verde
       * * `KH` - Cambodia
       * * `CM` - Cameroon
       * * `CA` - Canada
       * * `KY` - Cayman Islands
       * * `CF` - Central African Republic
       * * `TD` - Chad
       * * `CL` - Chile
       * * `CN` - China
       * * `CX` - Christmas Island
       * * `CC` - Cocos (Keeling) Islands
       * * `CO` - Colombia
       * * `KM` - Comoros
       * * `CG` - Congo
       * * `CK` - Cook Islands
       * * `CR` - Costa Rica
       * * `CI` - Côte d'Ivoire
       * * `HR` - Croatia
       * * `CU` - Cuba
       * * `CW` - Curaçao
       * * `CY` - Cyprus
       * * `CZ` - Czechia
       * * `CD` - Democratic Republic of the Congo
       * * `DK` - Denmark
       * * `DJ` - Djibouti
       * * `DM` - Dominica
       * * `DO` - Dominican Republic
       * * `EC` - Ecuador
       * * `EG` - Egypt
       * * `SV` - El Salvador
       * * `GQ` - Equatorial Guinea
       * * `ER` - Eritrea
       * * `EE` - Estonia
       * * `SZ` - Eswatini
       * * `ET` - Ethiopia
       * * `FK` - Falkland Islands (Malvinas)
       * * `FO` - Faroe Islands
       * * `FJ` - Fiji
       * * `FI` - Finland
       * * `FR` - France
       * * `GF` - French Guiana
       * * `PF` - French Polynesia
       * * `TF` - French Southern Territories
       * * `GA` - Gabon
       * * `GM` - Gambia
       * * `GE` - Georgia
       * * `DE` - Germany
       * * `GH` - Ghana
       * * `GI` - Gibraltar
       * * `GR` - Greece
       * * `GL` - Greenland
       * * `GD` - Grenada
       * * `GP` - Guadeloupe
       * * `GU` - Guam
       * * `GT` - Guatemala
       * * `GG` - Guernsey
       * * `GN` - Guinea
       * * `GW` - Guinea-Bissau
       * * `GY` - Guyana
       * * `HT` - Haiti
       * * `HM` - Heard Island and McDonald Islands
       * * `HN` - Honduras
       * * `HK` - Hong Kong
       * * `HU` - Hungary
       * * `IS` - Iceland
       * * `IN` - India
       * * `ID` - Indonesia
       * * `IR` - Iran
       * * `IQ` - Iraq
       * * `IE` - Ireland
       * * `IM` - Isle of Man
       * * `IL` - Israel
       * * `IT` - Italy
       * * `JM` - Jamaica
       * * `JP` - Japan
       * * `JE` - Jersey
       * * `JO` - Jordan
       * * `KZ` - Kazakhstan
       * * `KE` - Kenya
       * * `KI` - Kiribati
       * * `KW` - Kuwait
       * * `KG` - Kyrgyzstan
       * * `LA` - Laos
       * * `LV` - Latvia
       * * `LB` - Lebanon
       * * `LS` - Lesotho
       * * `LR` - Liberia
       * * `LY` - Libya
       * * `LI` - Liechtenstein
       * * `LT` - Lithuania
       * * `LU` - Luxembourg
       * * `MO` - Macao
       * * `MG` - Madagascar
       * * `MW` - Malawi
       * * `MY` - Malaysia
       * * `MV` - Maldives
       * * `ML` - Mali
       * * `MT` - Malta
       * * `MH` - Marshall Islands
       * * `MQ` - Martinique
       * * `MR` - Mauritania
       * * `MU` - Mauritius
       * * `YT` - Mayotte
       * * `MX` - Mexico
       * * `FM` - Micronesia
       * * `MD` - Moldova
       * * `MC` - Monaco
       * * `MN` - Mongolia
       * * `ME` - Montenegro
       * * `MS` - Montserrat
       * * `MA` - Morocco
       * * `MZ` - Mozambique
       * * `MM` - Myanmar
       * * `NA` - Namibia
       * * `NR` - Naoero
       * * `NP` - Nepal
       * * `NL` - Netherlands
       * * `NC` - New Caledonia
       * * `NZ` - New Zealand
       * * `NI` - Nicaragua
       * * `NE` - Niger
       * * `NG` - Nigeria
       * * `NU` - Niue
       * * `NF` - Norfolk Island
       * * `KP` - North Korea
       * * `MK` - North Macedonia
       * * `MP` - Northern Mariana Islands
       * * `NO` - Norway
       * * `OM` - Oman
       * * `PK` - Pakistan
       * * `PW` - Palau
       * * `PS` - Palestine
       * * `PA` - Panama
       * * `PG` - Papua New Guinea
       * * `PY` - Paraguay
       * * `PE` - Peru
       * * `PH` - Philippines
       * * `PN` - Pitcairn
       * * `PL` - Poland
       * * `PT` - Portugal
       * * `PR` - Puerto Rico
       * * `QA` - Qatar
       * * `RE` - Réunion
       * * `RO` - Romania
       * * `RU` - Russia
       * * `RW` - Rwanda
       * * `BL` - Saint Barthélemy
       * * `SH` - Saint Helena
       * * `KN` - Saint Kitts and Nevis
       * * `LC` - Saint Lucia
       * * `MF` - Saint Martin (French part)
       * * `PM` - Saint Pierre and Miquelon
       * * `VC` - Saint Vincent and the Grenadines
       * * `WS` - Samoa
       * * `SM` - San Marino
       * * `ST` - Sao Tome and Principe
       * * `SA` - Saudi Arabia
       * * `SN` - Senegal
       * * `RS` - Serbia
       * * `SC` - Seychelles
       * * `SL` - Sierra Leone
       * * `SG` - Singapore
       * * `SX` - Sint Maarten (Dutch part)
       * * `SK` - Slovakia
       * * `SI` - Slovenia
       * * `SB` - Solomon Islands
       * * `SO` - Somalia
       * * `ZA` - South Africa
       * * `GS` - South Georgia
       * * `KR` - South Korea
       * * `SS` - South Sudan
       * * `ES` - Spain
       * * `LK` - Sri Lanka
       * * `SD` - Sudan
       * * `SR` - Suriname
       * * `SJ` - Svalbard and Jan Mayen
       * * `SE` - Sweden
       * * `CH` - Switzerland
       * * `SY` - Syria
       * * `TW` - Taiwan
       * * `TJ` - Tajikistan
       * * `TZ` - Tanzania
       * * `TH` - Thailand
       * * `TL` - Timor-Leste
       * * `TG` - Togo
       * * `TK` - Tokelau
       * * `TO` - Tonga
       * * `TT` - Trinidad and Tobago
       * * `TN` - Tunisia
       * * `TR` - Türkiye
       * * `TM` - Turkmenistan
       * * `TC` - Turks and Caicos Islands
       * * `TV` - Tuvalu
       * * `UG` - Uganda
       * * `UA` - Ukraine
       * * `AE` - United Arab Emirates
       * * `GB` - United Kingdom
       * * `UM` - United States Minor Outlying Islands
       * * `US` - United States of America
       * * `UY` - Uruguay
       * * `UZ` - Uzbekistan
       * * `VU` - Vanuatu
       * * `VA` - Vatican City
       * * `VE` - Venezuela
       * * `VN` - Vietnam
       * * `VG` - Virgin Islands (British)
       * * `VI` - Virgin Islands (U.S.)
       * * `WF` - Wallis and Futuna
       * * `EH` - Western Sahara
       * * `YE` - Yemen
       * * `ZM` - Zambia
       * * `ZW` - Zimbabwe
       */
      country?: CountryEnum;
      name?: string;
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `name` - Name
       * * `-name` - Name (descending)
       */
      order?: AddressesListOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      postCode?: string;
      /** A search term. */
      search?: string;
      street?: string;
      /** Time slots enabled */
      timeSlotsEnabled?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedAddressListList;
  }

  /**
   * No description
   * @tags addresses
   * @name AddressesCreate
   * @request POST:/api/v1/addresses/
   * @secure
   * @response `201` `Address`
   */
  export namespace AddressesCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Address;
    export type RequestHeaders = {};
    export type ResponseBody = Address;
  }

  /**
   * @description The bookable start times at this address on one date. Scoping comes from the mixin.
   * @tags time-slots
   * @name AddressesAvailableSlotsList
   * @request GET:/api/v1/addresses/{address_pk}/available-slots/
   * @secure
   * @response `200` `AvailableSlots`
   * @response `400` `Record<string,any>`
   */
  export namespace AddressesAvailableSlotsList {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {
      /** @format date */
      date: string;
      excludeBooking?: number | null;
      gate?: number | null;
      /** @default false */
      includeConflicts?: boolean;
      vehicleType?: number | null;
      waypoint?: number | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AvailableSlots;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags time-slots
   * @name AddressesExceptionsList
   * @request GET:/api/v1/addresses/{address_pk}/exceptions/
   * @secure
   * @response `200` `PaginatedOperatingHoursExceptionListList`
   */
  export namespace AddressesExceptionsList {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedOperatingHoursExceptionListList;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags time-slots
   * @name AddressesExceptionsCreate
   * @request POST:/api/v1/addresses/{address_pk}/exceptions/
   * @secure
   * @response `201` `OperatingHoursExceptionList`
   */
  export namespace AddressesExceptionsCreate {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = OperatingHoursExceptionWrite;
    export type RequestHeaders = {};
    export type ResponseBody = OperatingHoursExceptionList;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags time-slots
   * @name AddressesExceptionsUpdate
   * @request PUT:/api/v1/addresses/{address_pk}/exceptions/{id}/
   * @secure
   * @response `200` `OperatingHoursExceptionList`
   */
  export namespace AddressesExceptionsUpdate {
    export type RequestParams = {
      addressPk: number;
      /** A unique integer value identifying this Operating Hours Exception. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = OperatingHoursExceptionWrite;
    export type RequestHeaders = {};
    export type ResponseBody = OperatingHoursExceptionList;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags time-slots
   * @name AddressesExceptionsDestroy
   * @request DELETE:/api/v1/addresses/{address_pk}/exceptions/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace AddressesExceptionsDestroy {
    export type RequestParams = {
      addressPk: number;
      /** A unique integer value identifying this Operating Hours Exception. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Dry run of the exception delete: upcoming bookings the change affects. Deletes nothing.
   * @tags time-slots
   * @name AddressesExceptionsDeleteImpact
   * @request POST:/api/v1/addresses/{address_pk}/exceptions/{id}/delete-impact/
   * @secure
   * @response `200` `PaginatedBookingImpactList`
   */
  export namespace AddressesExceptionsDeleteImpact {
    export type RequestParams = {
      addressPk: number;
      /** A unique integer value identifying this Operating Hours Exception. */
      id: number;
    };
    export type RequestQuery = {
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedBookingImpactList;
  }

  /**
   * @description Dry run of the exception update: upcoming bookings the change affects. Saves nothing.
   * @tags time-slots
   * @name AddressesExceptionsUpdateImpact
   * @request POST:/api/v1/addresses/{address_pk}/exceptions/{id}/impact/
   * @secure
   * @response `200` `PaginatedBookingImpactList`
   */
  export namespace AddressesExceptionsUpdateImpact {
    export type RequestParams = {
      addressPk: number;
      /** A unique integer value identifying this Operating Hours Exception. */
      id: number;
    };
    export type RequestQuery = {
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
    };
    export type RequestBody = OperatingHoursExceptionWrite;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedBookingImpactList;
  }

  /**
   * @description Dry run of the exception create: upcoming bookings the change affects. Saves nothing.
   * @tags time-slots
   * @name AddressesExceptionsCreateImpact
   * @request POST:/api/v1/addresses/{address_pk}/exceptions/impact/
   * @secure
   * @response `200` `PaginatedBookingImpactList`
   */
  export namespace AddressesExceptionsCreateImpact {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
    };
    export type RequestBody = OperatingHoursExceptionWrite;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedBookingImpactList;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags time-slots
   * @name AddressesGatesList
   * @request GET:/api/v1/addresses/{address_pk}/gates/
   * @secure
   * @response `200` `(Gate)[]`
   */
  export namespace AddressesGatesList {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Gate[];
  }

  /**
   * @description Replace the whole gate set for the address.
   * @tags time-slots
   * @name AddressesGatesBulkUpdate
   * @request PUT:/api/v1/addresses/{address_pk}/gates/bulk/
   * @secure
   * @response `200` `(Gate)[]`
   */
  export namespace AddressesGatesBulkUpdate {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = GateListWrite;
    export type RequestHeaders = {};
    export type ResponseBody = Gate[];
  }

  /**
   * @description Dry run of the gate replacement: upcoming bookings the change affects. Saves nothing.
   * @tags time-slots
   * @name AddressesGatesBulkImpact
   * @request POST:/api/v1/addresses/{address_pk}/gates/bulk-impact/
   * @secure
   * @response `200` `PaginatedBookingImpactList`
   */
  export namespace AddressesGatesBulkImpact {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
    };
    export type RequestBody = GateListWrite;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedBookingImpactList;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags time-slots
   * @name AddressesOperatingHoursList
   * @request GET:/api/v1/addresses/{address_pk}/operating-hours/
   * @secure
   * @response `200` `(OperatingHoursList)[]`
   */
  export namespace AddressesOperatingHoursList {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OperatingHoursList[];
  }

  /**
   * @description Replace the whole week for the address.
   * @tags time-slots
   * @name AddressesOperatingHoursBulkUpdate
   * @request PUT:/api/v1/addresses/{address_pk}/operating-hours/bulk/
   * @secure
   * @response `200` `(OperatingHoursList)[]`
   */
  export namespace AddressesOperatingHoursBulkUpdate {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = OperatingHoursListWrite;
    export type RequestHeaders = {};
    export type ResponseBody = OperatingHoursList[];
  }

  /**
   * @description Dry run of the week replacement: upcoming bookings the change affects. Saves nothing.
   * @tags time-slots
   * @name AddressesOperatingHoursBulkImpact
   * @request POST:/api/v1/addresses/{address_pk}/operating-hours/bulk-impact/
   * @secure
   * @response `200` `PaginatedBookingImpactList`
   */
  export namespace AddressesOperatingHoursBulkImpact {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
    };
    export type RequestBody = OperatingHoursListWrite;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedBookingImpactList;
  }

  /**
   * @description An address has exactly one settings record, so it is addressed by address alone.
   * @tags time-slots
   * @name AddressesTimeSlotSettingsList
   * @request GET:/api/v1/addresses/{address_pk}/time-slot-settings/
   * @secure
   * @response `200` `AddressTimeSlotSettings`
   */
  export namespace AddressesTimeSlotSettingsList {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AddressTimeSlotSettings;
  }

  /**
   * @description An address has exactly one settings record, so it is addressed by address alone.
   * @tags time-slots
   * @name AddressesTimeSlotSettingsCreate
   * @request POST:/api/v1/addresses/{address_pk}/time-slot-settings/
   * @secure
   * @response `201` `AddressTimeSlotSettings`
   */
  export namespace AddressesTimeSlotSettingsCreate {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = AddressTimeSlotSettingsWrite;
    export type RequestHeaders = {};
    export type ResponseBody = AddressTimeSlotSettings;
  }

  /**
   * @description Future bookings and open links that deleting the address or turning its time slots off would close.
   * @tags time-slots
   * @name AddressesTimeSlotSettingsDeactivationPreview
   * @request GET:/api/v1/addresses/{address_pk}/time-slot-settings/deactivation-preview/
   * @secure
   * @response `200` `PaginatedAddressDeactivationImpactList`
   */
  export namespace AddressesTimeSlotSettingsDeactivationPreview {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedAddressDeactivationImpactList;
  }

  /**
   * @description Dry run of the update: upcoming bookings the change affects. Saves nothing.
   * @tags time-slots
   * @name AddressesTimeSlotSettingsImpact
   * @request POST:/api/v1/addresses/{address_pk}/time-slot-settings/impact/
   * @secure
   * @response `200` `PaginatedBookingImpactList`
   */
  export namespace AddressesTimeSlotSettingsImpact {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
    };
    export type RequestBody = AddressTimeSlotSettingsWrite;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedBookingImpactList;
  }

  /**
   * @description Enable time slots for the address in one call: settings, gates and operating hours together.
   * @tags time-slots
   * @name AddressesTimeSlotSettingsSetupCreate
   * @request POST:/api/v1/addresses/{address_pk}/time-slot-settings/setup/
   * @secure
   * @response `201` `AddressTimeSlotSettings`
   */
  export namespace AddressesTimeSlotSettingsSetupCreate {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = TimeSlotSetup;
    export type RequestHeaders = {};
    export type ResponseBody = AddressTimeSlotSettings;
  }

  /**
   * @description An address has exactly one settings record, so it is addressed by address alone.
   * @tags time-slots
   * @name AddressesTimeSlotSettingsTurnOff
   * @request POST:/api/v1/addresses/{address_pk}/time-slot-settings/turn-off/
   * @secure
   * @response `200` `AddressTimeSlotSettings`
   */
  export namespace AddressesTimeSlotSettingsTurnOff {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AddressTimeSlotSettings;
  }

  /**
   * @description An address has exactly one settings record, so it is addressed by address alone.
   * @tags time-slots
   * @name AddressesTimeSlotSettingsTurnOn
   * @request POST:/api/v1/addresses/{address_pk}/time-slot-settings/turn-on/
   * @secure
   * @response `200` `AddressTimeSlotSettings`
   */
  export namespace AddressesTimeSlotSettingsTurnOn {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AddressTimeSlotSettings;
  }

  /**
   * @description An address has exactly one settings record, so it is addressed by address alone.
   * @tags time-slots
   * @name AddressesTimeSlotSettingsUpdate
   * @request PUT:/api/v1/addresses/{address_pk}/time-slot-settings/update/
   * @secure
   * @response `200` `AddressTimeSlotSettings`
   */
  export namespace AddressesTimeSlotSettingsUpdate {
    export type RequestParams = {
      addressPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = AddressTimeSlotSettingsWrite;
    export type RequestHeaders = {};
    export type ResponseBody = AddressTimeSlotSettings;
  }

  /**
   * No description
   * @tags addresses
   * @name AddressesRetrieve
   * @request GET:/api/v1/addresses/{id}/
   * @secure
   * @response `200` `Address`
   */
  export namespace AddressesRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this Address. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Address;
  }

  /**
   * No description
   * @tags addresses
   * @name AddressesUpdate
   * @request PUT:/api/v1/addresses/{id}/
   * @secure
   * @response `200` `Address`
   */
  export namespace AddressesUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this Address. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = Address;
    export type RequestHeaders = {};
    export type ResponseBody = Address;
  }

  /**
   * No description
   * @tags addresses
   * @name AddressesPartialUpdate
   * @request PATCH:/api/v1/addresses/{id}/
   * @secure
   * @response `200` `Address`
   */
  export namespace AddressesPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this Address. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedAddress;
    export type RequestHeaders = {};
    export type ResponseBody = Address;
  }

  /**
   * No description
   * @tags addresses
   * @name AddressesDestroy
   * @request DELETE:/api/v1/addresses/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace AddressesDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this Address. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Ai {
  /**
   * @description Refuse before anything is spent: the chatbot's calls are billed and metered by nothing. Raised ahead of authentication and validation on purpose — the action is ``AllowAny``, and an unimplemented endpoint owes every caller the same answer.
   * @tags ai
   * @name AiChatBotStreamCreate
   * @request POST:/api/v1/ai/chat-bot-stream/
   * @secure
   * @response `501` `void` The AI assistant is not in service.
   */
  export namespace AiChatBotStreamCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ChatBot;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags ai
   * @name AiExtractRequestDataFromDocumentCreate
   * @request POST:/api/v1/ai/extract-request-data-from-document/
   * @secure
   * @response `200` `DocumentUploadResponse`
   * @response `403` `void` The caller has no active workspace.
   * @response `429` `AIRequestLimitReached`
   */
  export namespace AiExtractRequestDataFromDocumentCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DocumentUpload;
    export type RequestHeaders = {};
    export type ResponseBody = DocumentUploadResponse;
  }

  /**
   * @description Report the caller's own AI usage so a client can warn before it refuses, not after.
   * @tags ai
   * @name AiRateLimitStatusRetrieve
   * @request GET:/api/v1/ai/rate-limit-status/
   * @secure
   * @response `200` `AIRateLimitStatus`
   * @response `403` `void` The caller has no active workspace.
   */
  export namespace AiRateLimitStatusRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AIRateLimitStatus;
  }
}

export namespace AuctionStats {
  /**
   * No description
   * @tags auction-stats
   * @name AuctionStatsOverviewRetrieve
   * @request GET:/api/v1/auction-stats/overview/
   * @secure
   * @response `200` `AuctionOverviewStats`
   */
  export namespace AuctionStatsOverviewRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {
      maxVolumeM3?: number;
      minVolumeM3?: number;
      /** Auction ID */
      auctionId?: number;
      /**
       * Auction status
       *
       * * `DRAFT` - Draft
       * * `MERGED` - Merged
       * * `ACTIVE` - Active auction
       * * `INSTANT_ORDER` - Instant order
       * * `BIDDING_FINISHED` - Finished auction
       * * `WAITING_FOR_CARRIER` - Waiting for carrier
       * * `REJECTED` - Rejected
       * * `CONFIRMED` - Confirmed
       * * `CANCELED` - Canceled
       * * `OTHER` - Other
       */
      auctionStatus?: AuctionFilterStatusEnum;
      /** Carrier id */
      carrierId?: number;
      /** Winning carrier */
      carrierName?: string;
      costCenter?: string;
      /** @format date-time */
      createdAtAfter?: string;
      /** @format date-time */
      createdAtBefore?: string;
      createdBy?: number;
      /**
       * Currency
       *
       * * `EUR` - EUR
       * * `USD` - USD
       * * `CZK` - CZK
       * * `HUF` - HUF
       * * `PLN` - PLN
       * * `RON` - RON
       * * `GBP` - GBP
       * * `NOK` - NOK
       * * `DKK` - DKK
       * * `SEK` - SEK
       * * `ISK` - ISK
       * * `CHF` - CHF
       * * `CNY` - CNY
       */
      currency?: CurrencyEnum;
      deliveryCity?: string;
      deliveryCountry?: string;
      /** @format date-time */
      deliveryDateAfter?: string;
      /** @format date-time */
      deliveryDateBefore?: string;
      deliveryName?: string;
      deliveryPostCode?: string;
      deliveryReference?: string;
      deliveryStreet?: string;
      /**
       * Incoterms
       *
       * * `EXW` - EXW - Ex Works
       * * `FCA` - FCA - Free Carrier
       * * `CPT` - CPT - Carriage Paid To
       * * `CIP` - CIP - Carriage and Insurance Paid To
       * * `DAP` - DAP - Delivered at Place
       * * `DPU` - DPU - Delivered at Place Unloaded
       * * `DDP` - DDP - Delivered Duty Paid
       * * `FAS` - FAS - Free Alongside Ship
       * * `FOB` - FOB - Free On Board
       * * `CFR` - CFR - Cost and Freight
       * * `CIF` - CIF - Cost, Insurance and Freight
       */
      incoterms?: IncotermsEnum;
      interval?: IntervalEnum;
      /**
       * Load type
       *
       * * `FTL` - Full Truck Load
       * * `LTL` - Less than Truck Load
       * * `FCL` - Full Container Load
       * * `LCL` - Less than Container Load
       * * `PARCEL` - Parcel
       * * `NOT_SPECIFIED` - Not specified
       */
      loadType?: CargoLoadTypeEnum[];
      maxWeightKg?: number;
      minWeightKg?: number;
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       * * `saving_avg` - Saving avg
       * * `-saving_avg` - Saving avg (descending)
       * * `saving_second_cheapest` - Saving second cheapest
       * * `-saving_second_cheapest` - Saving second cheapest (descending)
       */
      order?: AuctionStatsOverviewRetrieveOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      pickupCity?: string;
      pickupCountry?: string;
      /** @format date-time */
      pickupDateAfter?: string;
      /** @format date-time */
      pickupDateBefore?: string;
      pickupName?: string;
      pickupPostCode?: string;
      pickupReference?: string;
      pickupStreet?: string;
      /** @format date-time */
      publishedAtAfter?: string;
      /** @format date-time */
      publishedAtBefore?: string;
      reference?: string;
      /**
       * Request type
       *
       * * `REFRIGERATED_GOODS` - Refrigerated goods
       * * `FROZEN_GOODS` - Frozen goods
       * * `METAL_GOODS` - Metal goods
       * * `OVERSIZED_LOAD` - Oversized load
       * * `BULK_MATERIAL` - Bulk material
       * * `LOOSE_MATERIAL` - Loose material
       * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
       * * `LIQUIDS` - Liquids
       * * `VEHICLES` - Vehicles
       * * `ADR` - ADR
       * * `OTHER` - Other
       * * `NOT_SPECIFIED` - Not specified
       */
      requestType?: CargoTypeEnum;
      responsibleUser?: number;
      /**
       * Route type
       *
       * * `ONE_WAY` - One way
       * * `ROUND_TRIP` - Round trip
       */
      routeType?: RouteTypeEnum;
      /** A search term. */
      search?: string;
      /** Multiple values may be separated by commas. */
      tag?: string[];
      /**
       * Transport type
       *
       * * `SPOT` - Spot transport
       * * `CONTRACTED` - Contracted transport
       */
      transportType?: TransportTypeEnum;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionOverviewStats;
  }
}

export namespace Auctions {
  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsList
   * @request GET:/api/v1/auctions/
   * @secure
   * @response `200` `PaginatedAuctionListList`
   */
  export namespace AuctionsList {
    export type RequestParams = {};
    export type RequestQuery = {
      maxVolumeM3?: number;
      minVolumeM3?: number;
      /** Auction ID */
      auctionId?: number;
      /**
       * Auction status
       *
       * * `DRAFT` - Draft
       * * `MERGED` - Merged
       * * `ACTIVE` - Active auction
       * * `INSTANT_ORDER` - Instant order
       * * `BIDDING_FINISHED` - Finished auction
       * * `WAITING_FOR_CARRIER` - Waiting for carrier
       * * `REJECTED` - Rejected
       * * `CONFIRMED` - Confirmed
       * * `CANCELED` - Canceled
       * * `OTHER` - Other
       */
      auctionStatus?: AuctionFilterStatusEnum;
      /** Carrier id */
      carrierId?: number;
      /** Winning carrier */
      carrierName?: string;
      costCenter?: string;
      /** @format date-time */
      createdAtAfter?: string;
      /** @format date-time */
      createdAtBefore?: string;
      createdBy?: number;
      /**
       * Currency
       *
       * * `EUR` - EUR
       * * `USD` - USD
       * * `CZK` - CZK
       * * `HUF` - HUF
       * * `PLN` - PLN
       * * `RON` - RON
       * * `GBP` - GBP
       * * `NOK` - NOK
       * * `DKK` - DKK
       * * `SEK` - SEK
       * * `ISK` - ISK
       * * `CHF` - CHF
       * * `CNY` - CNY
       */
      currency?: CurrencyEnum;
      deliveryCity?: string;
      deliveryCountry?: string;
      /** @format date-time */
      deliveryDateAfter?: string;
      /** @format date-time */
      deliveryDateBefore?: string;
      deliveryName?: string;
      deliveryPostCode?: string;
      deliveryReference?: string;
      deliveryStreet?: string;
      /**
       * Incoterms
       *
       * * `EXW` - EXW - Ex Works
       * * `FCA` - FCA - Free Carrier
       * * `CPT` - CPT - Carriage Paid To
       * * `CIP` - CIP - Carriage and Insurance Paid To
       * * `DAP` - DAP - Delivered at Place
       * * `DPU` - DPU - Delivered at Place Unloaded
       * * `DDP` - DDP - Delivered Duty Paid
       * * `FAS` - FAS - Free Alongside Ship
       * * `FOB` - FOB - Free On Board
       * * `CFR` - CFR - Cost and Freight
       * * `CIF` - CIF - Cost, Insurance and Freight
       */
      incoterms?: IncotermsEnum;
      /**
       * Load type
       *
       * * `FTL` - Full Truck Load
       * * `LTL` - Less than Truck Load
       * * `FCL` - Full Container Load
       * * `LCL` - Less than Container Load
       * * `PARCEL` - Parcel
       * * `NOT_SPECIFIED` - Not specified
       */
      loadType?: CargoLoadTypeEnum[];
      maxWeightKg?: number;
      minWeightKg?: number;
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       * * `saving_avg` - Saving avg
       * * `-saving_avg` - Saving avg (descending)
       * * `saving_second_cheapest` - Saving second cheapest
       * * `-saving_second_cheapest` - Saving second cheapest (descending)
       */
      order?: AuctionsListOrderEnum[];
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      pickupCity?: string;
      pickupCountry?: string;
      /** @format date-time */
      pickupDateAfter?: string;
      /** @format date-time */
      pickupDateBefore?: string;
      pickupName?: string;
      pickupPostCode?: string;
      pickupReference?: string;
      pickupStreet?: string;
      /** @format date-time */
      publishedAtAfter?: string;
      /** @format date-time */
      publishedAtBefore?: string;
      reference?: string;
      /**
       * Request type
       *
       * * `REFRIGERATED_GOODS` - Refrigerated goods
       * * `FROZEN_GOODS` - Frozen goods
       * * `METAL_GOODS` - Metal goods
       * * `OVERSIZED_LOAD` - Oversized load
       * * `BULK_MATERIAL` - Bulk material
       * * `LOOSE_MATERIAL` - Loose material
       * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
       * * `LIQUIDS` - Liquids
       * * `VEHICLES` - Vehicles
       * * `ADR` - ADR
       * * `OTHER` - Other
       * * `NOT_SPECIFIED` - Not specified
       */
      requestType?: CargoTypeEnum;
      responsibleUser?: number;
      /**
       * Route type
       *
       * * `ONE_WAY` - One way
       * * `ROUND_TRIP` - Round trip
       */
      routeType?: RouteTypeEnum;
      /** A search term. */
      search?: string;
      /** Multiple values may be separated by commas. */
      tag?: string[];
      /**
       * Transport type
       *
       * * `SPOT` - Spot transport
       * * `CONTRACTED` - Contracted transport
       */
      transportType?: TransportTypeEnum;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedAuctionListList;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsCreate
   * @request POST:/api/v1/auctions/
   * @secure
   * @response `201` `Auction`
   */
  export namespace AuctionsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Auction;
    export type RequestHeaders = {};
    export type ResponseBody = Auction;
  }

  /**
   * @description ViewSet for Bid model just for logged in user.
   * @tags bids
   * @name AuctionsBidsList
   * @request GET:/api/v1/auctions/{auction_pk}/bids/
   * @secure
   * @response `200` `(Bid)[]`
   */
  export namespace AuctionsBidsList {
    export type RequestParams = {
      auctionPk: number;
    };
    export type RequestQuery = {
      /** Carrier */
      carrierId?: number;
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `price` - Price
       * * `-price` - Price (descending)
       */
      order?: AuctionsBidsListOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Bid[];
  }

  /**
   * @description Paginated, read-only bidding history: all bids for an auction.
   * @tags bids
   * @name AuctionBidsHistoryList
   * @request GET:/api/v1/auctions/{auction_pk}/bids-history/
   * @secure
   * @response `200` `PaginatedBidHistoryList`
   */
  export namespace AuctionBidsHistoryList {
    export type RequestParams = {
      auctionPk: number;
    };
    export type RequestQuery = {
      /** Carrier */
      carrierId?: number;
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `price` - Price
       * * `-price` - Price (descending)
       */
      order?: AuctionBidsHistoryListOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedBidHistoryList;
  }

  /**
   * @description Distinct carriers that placed a bid in this auction — options for the carrier filter.
   * @tags auctions
   * @name AuctionsBidsHistoryBiddersList
   * @request GET:/api/v1/auctions/{auction_pk}/bids-history/bidders/
   * @secure
   * @response `200` `(BidHistoryBidder)[]`
   */
  export namespace AuctionsBidsHistoryBiddersList {
    export type RequestParams = {
      auctionPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BidHistoryBidder[];
  }

  /**
   * @description ViewSet for Bid model just for logged in user.
   * @tags bids
   * @name AuctionsBidsRetrieve
   * @request GET:/api/v1/auctions/{auction_pk}/bids/{id}/
   * @secure
   * @response `200` `Bid`
   */
  export namespace AuctionsBidsRetrieve {
    export type RequestParams = {
      auctionPk: number;
      /** A unique integer value identifying this bid. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Bid;
  }

  /**
   * @description ViewSet for Bid model just for logged in user.
   * @tags bids
   * @name AuctionsBidsUpdate
   * @request PUT:/api/v1/auctions/{auction_pk}/bids/{id}/
   * @secure
   * @response `200` `UpdateBid`
   */
  export namespace AuctionsBidsUpdate {
    export type RequestParams = {
      auctionPk: number;
      /** A unique integer value identifying this bid. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateBid;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateBid;
  }

  /**
   * @description ViewSet for Bid model just for logged in user.
   * @tags bids
   * @name AuctionsBidsPartialUpdate
   * @request PATCH:/api/v1/auctions/{auction_pk}/bids/{id}/
   * @secure
   * @response `200` `UpdateBid`
   */
  export namespace AuctionsBidsPartialUpdate {
    export type RequestParams = {
      auctionPk: number;
      /** A unique integer value identifying this bid. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedUpdateBid;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateBid;
  }

  /**
   * @description ViewSet for Bid model just for logged in user.
   * @tags bids
   * @name AuctionsBidsExcludeFromStatsCreate
   * @request POST:/api/v1/auctions/{auction_pk}/bids/{id}/exclude-from-stats/
   * @secure
   * @response `200` `Bid`
   */
  export namespace AuctionsBidsExcludeFromStatsCreate {
    export type RequestParams = {
      auctionPk: number;
      /** A unique integer value identifying this bid. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Bid;
  }

  /**
   * @description ViewSet for Bid model just for logged in user.
   * @tags bids
   * @name AuctionsBidsIncludeInStatsCreate
   * @request POST:/api/v1/auctions/{auction_pk}/bids/{id}/include-in-stats/
   * @secure
   * @response `200` `Bid`
   */
  export namespace AuctionsBidsIncludeInStatsCreate {
    export type RequestParams = {
      auctionPk: number;
      /** A unique integer value identifying this bid. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Bid;
  }

  /**
   * No description
   * @tags documents
   * @name AuctionsDocumentsList
   * @request GET:/api/v1/auctions/{auction_pk}/documents/
   * @secure
   * @response `200` `PaginatedDocumentList`
   */
  export namespace AuctionsDocumentsList {
    export type RequestParams = {
      auctionPk: number;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedDocumentList;
  }

  /**
   * No description
   * @tags messages
   * @name AuctionsMessagesList
   * @request GET:/api/v1/auctions/{auction_pk}/messages/
   * @secure
   * @response `200` `PaginatedMessageList`
   */
  export namespace AuctionsMessagesList {
    export type RequestParams = {
      auctionPk: number;
    };
    export type RequestQuery = {
      carrier?: number;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedMessageList;
  }

  /**
   * No description
   * @tags messages
   * @name AuctionsMessagesCreate
   * @request POST:/api/v1/auctions/{auction_pk}/messages/
   * @secure
   * @response `201` `Message`
   */
  export namespace AuctionsMessagesCreate {
    export type RequestParams = {
      auctionPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = Message;
    export type RequestHeaders = {};
    export type ResponseBody = Message;
  }

  /**
   * No description
   * @tags messages
   * @name AuctionsMessagesMarkAsReadCreate
   * @request POST:/api/v1/auctions/{auction_pk}/messages/mark-as-read/
   * @secure
   * @response `200` `MarkAsReadMessage`
   */
  export namespace AuctionsMessagesMarkAsReadCreate {
    export type RequestParams = {
      auctionPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = MarkAsReadMessage;
    export type RequestHeaders = {};
    export type ResponseBody = MarkAsReadMessage;
  }

  /**
   * No description
   * @tags auctions
   * @name AuctionsParticipantsList
   * @request GET:/api/v1/auctions/{auction_pk}/participants/
   * @secure
   * @response `200` `(AuctionParticipant)[]`
   */
  export namespace AuctionsParticipantsList {
    export type RequestParams = {
      auctionPk: number;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionParticipant[];
  }

  /**
   * No description
   * @tags auctions
   * @name AuctionsParticipantsRetrieve
   * @request GET:/api/v1/auctions/{auction_pk}/participants/{id}/
   * @secure
   * @response `200` `AuctionParticipant`
   */
  export namespace AuctionsParticipantsRetrieve {
    export type RequestParams = {
      auctionPk: number;
      /** A unique integer value identifying this auction participant. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionParticipant;
  }

  /**
   * No description
   * @tags auctions
   * @name AuctionsParticipantsResendInvitationCreate
   * @request POST:/api/v1/auctions/{auction_pk}/participants/{id}/resend-invitation/
   * @secure
   * @response `200` `AuctionParticipantResendInvitation`
   */
  export namespace AuctionsParticipantsResendInvitationCreate {
    export type RequestParams = {
      auctionPk: number;
      /** A unique integer value identifying this auction participant. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = AuctionParticipantResendInvitation;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionParticipantResendInvitation;
  }

  /**
   * No description
   * @tags auctions
   * @name AuctionsParticipantsStatusCreate
   * @request POST:/api/v1/auctions/{auction_pk}/participants/{id}/status/
   * @secure
   * @response `200` `AuctionSetParticipantStatus`
   */
  export namespace AuctionsParticipantsStatusCreate {
    export type RequestParams = {
      auctionPk: number;
      /** A unique integer value identifying this auction participant. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = AuctionSetParticipantStatus;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionSetParticipantStatus;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsRetrieve
   * @request GET:/api/v1/auctions/{id}/
   * @secure
   * @response `200` `Auction`
   */
  export namespace AuctionsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this auction. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Auction;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsUpdate
   * @request PUT:/api/v1/auctions/{id}/
   * @secure
   * @response `200` `AuctionUpdate`
   */
  export namespace AuctionsUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this auction. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = AuctionUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionUpdate;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsPartialUpdate
   * @request PATCH:/api/v1/auctions/{id}/
   * @secure
   * @response `200` `AuctionUpdate`
   */
  export namespace AuctionsPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this auction. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedAuctionUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionUpdate;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsDestroy
   * @request DELETE:/api/v1/auctions/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace AuctionsDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this auction. */
      id: number;
    };
    export type RequestQuery = {
      includeMerged?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsCancelCreate
   * @request POST:/api/v1/auctions/{id}/cancel/
   * @secure
   * @response `200` `Auction`
   */
  export namespace AuctionsCancelCreate {
    export type RequestParams = {
      /** A unique integer value identifying this auction. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = Auction;
    export type RequestHeaders = {};
    export type ResponseBody = Auction;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsChangePaymentMethodCreate
   * @request POST:/api/v1/auctions/{id}/change-payment-method/
   * @secure
   * @response `200` `AuctionChangePaymentMethod`
   */
  export namespace AuctionsChangePaymentMethodCreate {
    export type RequestParams = {
      /** A unique integer value identifying this auction. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = AuctionChangePaymentMethod;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionChangePaymentMethod;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsContractOptionRetrieve
   * @request GET:/api/v1/auctions/{id}/contract-option/
   * @secure
   * @response `200` `ContractOptionRow`
   */
  export namespace AuctionsContractOptionRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this auction. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractOptionRow;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsMergedList
   * @request GET:/api/v1/auctions/{id}/merged/
   * @secure
   * @response `200` `(AuctionList)[]`
   */
  export namespace AuctionsMergedList {
    export type RequestParams = {
      /** A unique integer value identifying this auction. */
      id: number;
    };
    export type RequestQuery = {
      maxVolumeM3?: number;
      minVolumeM3?: number;
      /** Auction ID */
      auctionId?: number;
      /**
       * Auction status
       *
       * * `DRAFT` - Draft
       * * `MERGED` - Merged
       * * `ACTIVE` - Active auction
       * * `INSTANT_ORDER` - Instant order
       * * `BIDDING_FINISHED` - Finished auction
       * * `WAITING_FOR_CARRIER` - Waiting for carrier
       * * `REJECTED` - Rejected
       * * `CONFIRMED` - Confirmed
       * * `CANCELED` - Canceled
       * * `OTHER` - Other
       */
      auctionStatus?: AuctionFilterStatusEnum;
      /** Carrier id */
      carrierId?: number;
      /** Winning carrier */
      carrierName?: string;
      costCenter?: string;
      /** @format date-time */
      createdAtAfter?: string;
      /** @format date-time */
      createdAtBefore?: string;
      createdBy?: number;
      /**
       * Currency
       *
       * * `EUR` - EUR
       * * `USD` - USD
       * * `CZK` - CZK
       * * `HUF` - HUF
       * * `PLN` - PLN
       * * `RON` - RON
       * * `GBP` - GBP
       * * `NOK` - NOK
       * * `DKK` - DKK
       * * `SEK` - SEK
       * * `ISK` - ISK
       * * `CHF` - CHF
       * * `CNY` - CNY
       */
      currency?: CurrencyEnum;
      deliveryCity?: string;
      deliveryCountry?: string;
      /** @format date-time */
      deliveryDateAfter?: string;
      /** @format date-time */
      deliveryDateBefore?: string;
      deliveryName?: string;
      deliveryPostCode?: string;
      deliveryReference?: string;
      deliveryStreet?: string;
      /**
       * Incoterms
       *
       * * `EXW` - EXW - Ex Works
       * * `FCA` - FCA - Free Carrier
       * * `CPT` - CPT - Carriage Paid To
       * * `CIP` - CIP - Carriage and Insurance Paid To
       * * `DAP` - DAP - Delivered at Place
       * * `DPU` - DPU - Delivered at Place Unloaded
       * * `DDP` - DDP - Delivered Duty Paid
       * * `FAS` - FAS - Free Alongside Ship
       * * `FOB` - FOB - Free On Board
       * * `CFR` - CFR - Cost and Freight
       * * `CIF` - CIF - Cost, Insurance and Freight
       */
      incoterms?: IncotermsEnum;
      /**
       * Load type
       *
       * * `FTL` - Full Truck Load
       * * `LTL` - Less than Truck Load
       * * `FCL` - Full Container Load
       * * `LCL` - Less than Container Load
       * * `PARCEL` - Parcel
       * * `NOT_SPECIFIED` - Not specified
       */
      loadType?: CargoLoadTypeEnum[];
      maxWeightKg?: number;
      minWeightKg?: number;
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       * * `saving_avg` - Saving avg
       * * `-saving_avg` - Saving avg (descending)
       * * `saving_second_cheapest` - Saving second cheapest
       * * `-saving_second_cheapest` - Saving second cheapest (descending)
       */
      order?: AuctionsMergedListOrderEnum[];
      pickupCity?: string;
      pickupCountry?: string;
      /** @format date-time */
      pickupDateAfter?: string;
      /** @format date-time */
      pickupDateBefore?: string;
      pickupName?: string;
      pickupPostCode?: string;
      pickupReference?: string;
      pickupStreet?: string;
      /** @format date-time */
      publishedAtAfter?: string;
      /** @format date-time */
      publishedAtBefore?: string;
      reference?: string;
      /**
       * Request type
       *
       * * `REFRIGERATED_GOODS` - Refrigerated goods
       * * `FROZEN_GOODS` - Frozen goods
       * * `METAL_GOODS` - Metal goods
       * * `OVERSIZED_LOAD` - Oversized load
       * * `BULK_MATERIAL` - Bulk material
       * * `LOOSE_MATERIAL` - Loose material
       * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
       * * `LIQUIDS` - Liquids
       * * `VEHICLES` - Vehicles
       * * `ADR` - ADR
       * * `OTHER` - Other
       * * `NOT_SPECIFIED` - Not specified
       */
      requestType?: CargoTypeEnum;
      responsibleUser?: number;
      /**
       * Route type
       *
       * * `ONE_WAY` - One way
       * * `ROUND_TRIP` - Round trip
       */
      routeType?: RouteTypeEnum;
      /** A search term. */
      search?: string;
      /** Multiple values may be separated by commas. */
      tag?: string[];
      /**
       * Transport type
       *
       * * `SPOT` - Spot transport
       * * `CONTRACTED` - Contracted transport
       */
      transportType?: TransportTypeEnum;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionList[];
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsPublishCreate
   * @request POST:/api/v1/auctions/{id}/publish/
   * @secure
   * @response `200` `Auction`
   */
  export namespace AuctionsPublishCreate {
    export type RequestParams = {
      /** A unique integer value identifying this auction. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = Auction;
    export type RequestHeaders = {};
    export type ResponseBody = Auction;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsTakeInstantOrderCreate
   * @request POST:/api/v1/auctions/{id}/take-instant-order/
   * @secure
   * @response `200` `AuctionTakeInstantOrder`
   */
  export namespace AuctionsTakeInstantOrderCreate {
    export type RequestParams = {
      /** A unique integer value identifying this auction. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = AuctionTakeInstantOrder;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionTakeInstantOrder;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsUnlinkMergedCreate
   * @request POST:/api/v1/auctions/{id}/unlink-merged/
   * @secure
   * @response `200` `AuctionUnlinkMerged`
   */
  export namespace AuctionsUnlinkMergedCreate {
    export type RequestParams = {
      /** A unique integer value identifying this auction. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = AuctionUnlinkMerged;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionUnlinkMerged;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsExportRetrieve
   * @request GET:/api/v1/auctions/export/
   * @secure
   * @response `200` `File`
   * @response `204` `void` No response body
   */
  export namespace AuctionsExportRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {
      maxVolumeM3?: number;
      minVolumeM3?: number;
      /** Auction ID */
      auctionId?: number;
      /**
       * Auction status
       *
       * * `DRAFT` - Draft
       * * `MERGED` - Merged
       * * `ACTIVE` - Active auction
       * * `INSTANT_ORDER` - Instant order
       * * `BIDDING_FINISHED` - Finished auction
       * * `WAITING_FOR_CARRIER` - Waiting for carrier
       * * `REJECTED` - Rejected
       * * `CONFIRMED` - Confirmed
       * * `CANCELED` - Canceled
       * * `OTHER` - Other
       */
      auctionStatus?: AuctionFilterStatusEnum;
      /** Carrier id */
      carrierId?: number;
      /** Winning carrier */
      carrierName?: string;
      costCenter?: string;
      /** @format date-time */
      createdAtAfter?: string;
      /** @format date-time */
      createdAtBefore?: string;
      createdBy?: number;
      /**
       * Currency
       *
       * * `EUR` - EUR
       * * `USD` - USD
       * * `CZK` - CZK
       * * `HUF` - HUF
       * * `PLN` - PLN
       * * `RON` - RON
       * * `GBP` - GBP
       * * `NOK` - NOK
       * * `DKK` - DKK
       * * `SEK` - SEK
       * * `ISK` - ISK
       * * `CHF` - CHF
       * * `CNY` - CNY
       */
      currency?: CurrencyEnum;
      deliveryCity?: string;
      deliveryCountry?: string;
      /** @format date-time */
      deliveryDateAfter?: string;
      /** @format date-time */
      deliveryDateBefore?: string;
      deliveryName?: string;
      deliveryPostCode?: string;
      deliveryReference?: string;
      deliveryStreet?: string;
      /**
       * Incoterms
       *
       * * `EXW` - EXW - Ex Works
       * * `FCA` - FCA - Free Carrier
       * * `CPT` - CPT - Carriage Paid To
       * * `CIP` - CIP - Carriage and Insurance Paid To
       * * `DAP` - DAP - Delivered at Place
       * * `DPU` - DPU - Delivered at Place Unloaded
       * * `DDP` - DDP - Delivered Duty Paid
       * * `FAS` - FAS - Free Alongside Ship
       * * `FOB` - FOB - Free On Board
       * * `CFR` - CFR - Cost and Freight
       * * `CIF` - CIF - Cost, Insurance and Freight
       */
      incoterms?: IncotermsEnum;
      /**
       * Load type
       *
       * * `FTL` - Full Truck Load
       * * `LTL` - Less than Truck Load
       * * `FCL` - Full Container Load
       * * `LCL` - Less than Container Load
       * * `PARCEL` - Parcel
       * * `NOT_SPECIFIED` - Not specified
       */
      loadType?: CargoLoadTypeEnum[];
      maxWeightKg?: number;
      minWeightKg?: number;
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       * * `saving_avg` - Saving avg
       * * `-saving_avg` - Saving avg (descending)
       * * `saving_second_cheapest` - Saving second cheapest
       * * `-saving_second_cheapest` - Saving second cheapest (descending)
       */
      order?: AuctionsExportRetrieveOrderEnum[];
      pickupCity?: string;
      pickupCountry?: string;
      /** @format date-time */
      pickupDateAfter?: string;
      /** @format date-time */
      pickupDateBefore?: string;
      pickupName?: string;
      pickupPostCode?: string;
      pickupReference?: string;
      pickupStreet?: string;
      /** @format date-time */
      publishedAtAfter?: string;
      /** @format date-time */
      publishedAtBefore?: string;
      reference?: string;
      /**
       * Request type
       *
       * * `REFRIGERATED_GOODS` - Refrigerated goods
       * * `FROZEN_GOODS` - Frozen goods
       * * `METAL_GOODS` - Metal goods
       * * `OVERSIZED_LOAD` - Oversized load
       * * `BULK_MATERIAL` - Bulk material
       * * `LOOSE_MATERIAL` - Loose material
       * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
       * * `LIQUIDS` - Liquids
       * * `VEHICLES` - Vehicles
       * * `ADR` - ADR
       * * `OTHER` - Other
       * * `NOT_SPECIFIED` - Not specified
       */
      requestType?: CargoTypeEnum;
      responsibleUser?: number;
      /**
       * Route type
       *
       * * `ONE_WAY` - One way
       * * `ROUND_TRIP` - Round trip
       */
      routeType?: RouteTypeEnum;
      /** A search term. */
      search?: string;
      /** Multiple values may be separated by commas. */
      tag?: string[];
      /**
       * Transport type
       *
       * * `SPOT` - Spot transport
       * * `CONTRACTED` - Contracted transport
       */
      transportType?: TransportTypeEnum;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Blob;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags auctions
   * @name AuctionsListToMergeList
   * @request GET:/api/v1/auctions/list-to-merge/
   * @secure
   * @response `200` `(Auction)[]`
   */
  export namespace AuctionsListToMergeList {
    export type RequestParams = {};
    export type RequestQuery = {
      maxVolumeM3?: number;
      minVolumeM3?: number;
      /** Auction ID */
      auctionId?: number;
      /**
       * Auction status
       *
       * * `DRAFT` - Draft
       * * `MERGED` - Merged
       * * `ACTIVE` - Active auction
       * * `INSTANT_ORDER` - Instant order
       * * `BIDDING_FINISHED` - Finished auction
       * * `WAITING_FOR_CARRIER` - Waiting for carrier
       * * `REJECTED` - Rejected
       * * `CONFIRMED` - Confirmed
       * * `CANCELED` - Canceled
       * * `OTHER` - Other
       */
      auctionStatus?: AuctionFilterStatusEnum;
      /** Carrier id */
      carrierId?: number;
      /** Winning carrier */
      carrierName?: string;
      costCenter?: string;
      /** @format date-time */
      createdAtAfter?: string;
      /** @format date-time */
      createdAtBefore?: string;
      createdBy?: number;
      /**
       * Currency
       *
       * * `EUR` - EUR
       * * `USD` - USD
       * * `CZK` - CZK
       * * `HUF` - HUF
       * * `PLN` - PLN
       * * `RON` - RON
       * * `GBP` - GBP
       * * `NOK` - NOK
       * * `DKK` - DKK
       * * `SEK` - SEK
       * * `ISK` - ISK
       * * `CHF` - CHF
       * * `CNY` - CNY
       */
      currency?: CurrencyEnum;
      deliveryCity?: string;
      deliveryCountry?: string;
      /** @format date-time */
      deliveryDateAfter?: string;
      /** @format date-time */
      deliveryDateBefore?: string;
      deliveryName?: string;
      deliveryPostCode?: string;
      deliveryReference?: string;
      deliveryStreet?: string;
      ids?: string[];
      /**
       * Incoterms
       *
       * * `EXW` - EXW - Ex Works
       * * `FCA` - FCA - Free Carrier
       * * `CPT` - CPT - Carriage Paid To
       * * `CIP` - CIP - Carriage and Insurance Paid To
       * * `DAP` - DAP - Delivered at Place
       * * `DPU` - DPU - Delivered at Place Unloaded
       * * `DDP` - DDP - Delivered Duty Paid
       * * `FAS` - FAS - Free Alongside Ship
       * * `FOB` - FOB - Free On Board
       * * `CFR` - CFR - Cost and Freight
       * * `CIF` - CIF - Cost, Insurance and Freight
       */
      incoterms?: IncotermsEnum;
      /**
       * Load type
       *
       * * `FTL` - Full Truck Load
       * * `LTL` - Less than Truck Load
       * * `FCL` - Full Container Load
       * * `LCL` - Less than Container Load
       * * `PARCEL` - Parcel
       * * `NOT_SPECIFIED` - Not specified
       */
      loadType?: CargoLoadTypeEnum[];
      maxWeightKg?: number;
      minWeightKg?: number;
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       * * `saving_avg` - Saving avg
       * * `-saving_avg` - Saving avg (descending)
       * * `saving_second_cheapest` - Saving second cheapest
       * * `-saving_second_cheapest` - Saving second cheapest (descending)
       */
      order?: AuctionsListToMergeListOrderEnum[];
      pickupCity?: string;
      pickupCountry?: string;
      /** @format date-time */
      pickupDateAfter?: string;
      /** @format date-time */
      pickupDateBefore?: string;
      pickupName?: string;
      pickupPostCode?: string;
      pickupReference?: string;
      pickupStreet?: string;
      /** @format date-time */
      publishedAtAfter?: string;
      /** @format date-time */
      publishedAtBefore?: string;
      reference?: string;
      /**
       * Request type
       *
       * * `REFRIGERATED_GOODS` - Refrigerated goods
       * * `FROZEN_GOODS` - Frozen goods
       * * `METAL_GOODS` - Metal goods
       * * `OVERSIZED_LOAD` - Oversized load
       * * `BULK_MATERIAL` - Bulk material
       * * `LOOSE_MATERIAL` - Loose material
       * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
       * * `LIQUIDS` - Liquids
       * * `VEHICLES` - Vehicles
       * * `ADR` - ADR
       * * `OTHER` - Other
       * * `NOT_SPECIFIED` - Not specified
       */
      requestType?: CargoTypeEnum;
      responsibleUser?: number;
      /**
       * Route type
       *
       * * `ONE_WAY` - One way
       * * `ROUND_TRIP` - Round trip
       */
      routeType?: RouteTypeEnum;
      /** A search term. */
      search?: string;
      /** Multiple values may be separated by commas. */
      tag?: string[];
      /**
       * Transport type
       *
       * * `SPOT` - Spot transport
       * * `CONTRACTED` - Contracted transport
       */
      transportType?: TransportTypeEnum;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Auction[];
  }
}

export namespace Auth {
  /**
   * @description Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework Accept the following POST parameters: username, password Return the REST Framework Token Object's key.
   * @tags auth
   * @name AuthLoginCreate
   * @request POST:/api/v1/auth/login/
   * @secure
   * @response `200` `JWT`
   */
  export namespace AuthLoginCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Login;
    export type RequestHeaders = {};
    export type ResponseBody = JWT;
  }

  /**
   * @description Calls Django logout method and delete the Token object assigned to the current User object. Accepts/Returns nothing.
   * @tags auth
   * @name AuthLogoutCreate
   * @request POST:/api/v1/auth/logout/
   * @secure
   * @response `200` `RestAuthDetail`
   */
  export namespace AuthLogoutCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Logout;
    export type RequestHeaders = {};
    export type ResponseBody = RestAuthDetail;
  }

  /**
   * @description Calls Django Auth SetPasswordForm save method. Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
   * @tags auth
   * @name AuthPasswordChangeCreate
   * @request POST:/api/v1/auth/password/change/
   * @secure
   * @response `200` `RestAuthDetail`
   */
  export namespace AuthPasswordChangeCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PasswordChange;
    export type RequestHeaders = {};
    export type ResponseBody = RestAuthDetail;
  }

  /**
   * @description Calls Django Auth PasswordResetForm save method. Accepts the following POST parameters: email Returns the success/fail message.
   * @tags auth
   * @name AuthPasswordResetCreate
   * @request POST:/api/v1/auth/password/reset/
   * @secure
   * @response `200` `RestAuthDetail`
   */
  export namespace AuthPasswordResetCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PasswordReset;
    export type RequestHeaders = {};
    export type ResponseBody = RestAuthDetail;
  }

  /**
   * @description Password reset e-mail link is confirmed, therefore this resets the user's password. Accepts the following POST parameters: token, uid, new_password1, new_password2 Returns the success/fail message.
   * @tags auth
   * @name AuthPasswordResetConfirmCreate
   * @request POST:/api/v1/auth/password/reset/confirm/
   * @secure
   * @response `200` `RestAuthDetail`
   */
  export namespace AuthPasswordResetConfirmCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PasswordResetConfirm;
    export type RequestHeaders = {};
    export type ResponseBody = RestAuthDetail;
  }

  /**
   * @description Registers a new user. Accepts the following POST parameters: username, email, password1, password2.
   * @tags auth
   * @name AuthRegisterCreate
   * @request POST:/api/v1/auth/register/
   * @secure
   * @response `201` `JWT`
   */
  export namespace AuthRegisterCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Register;
    export type RequestHeaders = {};
    export type ResponseBody = JWT;
  }

  /**
   * @description Resends another email to an unverified email. Accepts the following POST parameter: email.
   * @tags auth
   * @name AuthRegisterResendEmailCreate
   * @request POST:/api/v1/auth/register/resend-email/
   * @secure
   * @response `201` `RestAuthDetail`
   */
  export namespace AuthRegisterResendEmailCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ResendEmailVerification;
    export type RequestHeaders = {};
    export type ResponseBody = RestAuthDetail;
  }

  /**
   * @description Verifies the email associated with the provided key. Accepts the following POST parameter: key.
   * @tags auth
   * @name AuthRegisterVerifyEmailCreate
   * @request POST:/api/v1/auth/register/verify-email/
   * @secure
   * @response `200` `RestAuthDetail`
   */
  export namespace AuthRegisterVerifyEmailCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = VerifyEmail;
    export type RequestHeaders = {};
    export type ResponseBody = RestAuthDetail;
  }

  /**
   * @description class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter class FacebookLogin(SocialLoginView): adapter_class = FacebookOAuth2Adapter ------------- example usage for facebook with code ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client class FacebookLogin(SocialLoginView): adapter_class = FacebookOAuth2Adapter client_class = OAuth2Client callback_url = 'localhost:8000' -------------
   * @tags auth
   * @name AuthSocialMicrosoftCreate
   * @request POST:/api/v1/auth/social/microsoft/
   * @secure
   * @response `200` `JWT`
   */
  export namespace AuthSocialMicrosoftCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MicrosoftLogin;
    export type RequestHeaders = {};
    export type ResponseBody = JWT;
  }

  /**
   * @description class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter class FacebookLogin(SocialLoginView): adapter_class = FacebookOAuth2Adapter ------------- example usage for facebook with code ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client class FacebookLogin(SocialLoginView): adapter_class = FacebookOAuth2Adapter client_class = OAuth2Client callback_url = 'localhost:8000' -------------
   * @tags auth
   * @name AuthSocialMicrosoftAccessTokenCreate
   * @request POST:/api/v1/auth/social/microsoft/access_token
   * @secure
   * @response `200` `MicrosoftAccessToken`
   */
  export namespace AuthSocialMicrosoftAccessTokenCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MicrosoftLogin;
    export type RequestHeaders = {};
    export type ResponseBody = MicrosoftAccessToken;
  }

  /**
   * No description
   * @tags auth
   * @name AuthSocialMicrosoftInfoCreate
   * @request POST:/api/v1/auth/social/microsoft/info
   * @secure
   * @response `200` `MicrosoftTenantResponse`
   */
  export namespace AuthSocialMicrosoftInfoCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MicrosoftTenantRequest;
    export type RequestHeaders = {};
    export type ResponseBody = MicrosoftTenantResponse;
  }

  /**
   * @description Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
   * @tags auth
   * @name AuthTokenRefreshCreate
   * @request POST:/api/v1/auth/token/refresh/
   * @response `200` `TokenRefresh`
   */
  export namespace AuthTokenRefreshCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TokenRefresh;
    export type RequestHeaders = {};
    export type ResponseBody = TokenRefresh;
  }

  /**
   * @description Takes a token and indicates if it is valid.  This view provides no information about a token's fitness for a particular use.
   * @tags auth
   * @name AuthTokenVerifyCreate
   * @request POST:/api/v1/auth/token/verify/
   * @response `200` `TokenVerify`
   */
  export namespace AuthTokenVerifyCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TokenVerify;
    export type RequestHeaders = {};
    export type ResponseBody = TokenVerify;
  }

  /**
   * @description Reads and updates UserModel fields Accepts GET, PUT, PATCH methods. Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email Returns UserModel fields.
   * @tags auth
   * @name AuthUserRetrieve
   * @request GET:/api/v1/auth/user/
   * @secure
   * @response `200` `UserDetails`
   */
  export namespace AuthUserRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserDetails;
  }

  /**
   * @description Reads and updates UserModel fields Accepts GET, PUT, PATCH methods. Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email Returns UserModel fields.
   * @tags auth
   * @name AuthUserUpdate
   * @request PUT:/api/v1/auth/user/
   * @secure
   * @response `200` `UserDetails`
   */
  export namespace AuthUserUpdate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UserDetails;
    export type RequestHeaders = {};
    export type ResponseBody = UserDetails;
  }

  /**
   * @description Reads and updates UserModel fields Accepts GET, PUT, PATCH methods. Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email Returns UserModel fields.
   * @tags auth
   * @name AuthUserPartialUpdate
   * @request PATCH:/api/v1/auth/user/
   * @secure
   * @response `200` `UserDetails`
   */
  export namespace AuthUserPartialUpdate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PatchedUserDetails;
    export type RequestHeaders = {};
    export type ResponseBody = UserDetails;
  }
}

export namespace BookingLinks {
  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags time-slots
   * @name BookingLinksList
   * @request GET:/api/v1/booking-links/
   * @secure
   * @response `200` `PaginatedBookingLinkListList`
   */
  export namespace BookingLinksList {
    export type RequestParams = {};
    export type RequestQuery = {
      address?: number;
      /**
       * Booking status
       *
       * * `PENDING` - Pending
       * * `WITHDRAWN` - Withdrawn
       * * `APPROVED` - Approved
       * * `REJECTED` - Rejected
       * * `ARRIVED` - Arrived
       * * `CANCELED` - Canceled
       * * `COMPLETED` - Completed
       * * `EXPIRED` - Expired
       */
      bookingStatus?: TimeSlotBookingListStatusEnum;
      /**
       * Ordering
       *
       * * `createdAt` - Createdat
       * * `-createdAt` - Createdat (descending)
       * * `expiresAt` - Expiresat
       * * `-expiresAt` - Expiresat (descending)
       */
      order?: BookingLinksListOrderEnum[];
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
      /**
       * * `SENT` - Sent
       * * `EXPIRED` - Expired
       * * `REVOKED` - Revoked
       * * `BOOKED` - Booked
       */
      status?: BookingLinkStatusEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedBookingLinkListList;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags time-slots
   * @name BookingLinksCreate
   * @request POST:/api/v1/booking-links/
   * @secure
   * @response `201` `BookingLinkList`
   * @response `400` `Record<string,any>`
   */
  export namespace BookingLinksCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BookingLinkCreate;
    export type RequestHeaders = {};
    export type ResponseBody = BookingLinkList;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags time-slots
   * @name BookingLinksDestroy
   * @request DELETE:/api/v1/booking-links/{id}/
   * @secure
   * @response `204` `void` No response body
   * @response `400` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace BookingLinksDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this Booking Link. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description E-mail a link not booked or revoked yet again with a fresh validity, within the send limit.
   * @tags time-slots
   * @name BookingLinksResend
   * @request POST:/api/v1/booking-links/{id}/resend/
   * @secure
   * @response `200` `BookingLinkList`
   * @response `400` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace BookingLinksResend {
    export type RequestParams = {
      /** A unique integer value identifying this Booking Link. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BookingLinkList;
  }

  /**
   * @description Take back a link that has not expired yet; idempotent for an already revoked one.
   * @tags time-slots
   * @name BookingLinksRevoke
   * @request POST:/api/v1/booking-links/{id}/revoke/
   * @secure
   * @response `200` `BookingLinkList`
   * @response `400` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace BookingLinksRevoke {
    export type RequestParams = {
      /** A unique integer value identifying this Booking Link. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BookingLinkList;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags time-slots
   * @name BookingLinksCountsRetrieve
   * @request GET:/api/v1/booking-links/counts/
   * @secure
   * @response `200` `BookingLinkCounts`
   */
  export namespace BookingLinksCountsRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {
      address?: number;
      /**
       * Booking status
       *
       * * `PENDING` - Pending
       * * `WITHDRAWN` - Withdrawn
       * * `APPROVED` - Approved
       * * `REJECTED` - Rejected
       * * `ARRIVED` - Arrived
       * * `CANCELED` - Canceled
       * * `COMPLETED` - Completed
       * * `EXPIRED` - Expired
       */
      bookingStatus?: TimeSlotBookingListStatusEnum;
      /**
       * Ordering
       *
       * * `createdAt` - Createdat
       * * `-createdAt` - Createdat (descending)
       * * `expiresAt` - Expiresat
       * * `-expiresAt` - Expiresat (descending)
       */
      order?: BookingLinksCountsRetrieveOrderEnum[];
      /** A search term. */
      search?: string;
      /**
       * * `SENT` - Sent
       * * `EXPIRED` - Expired
       * * `REVOKED` - Revoked
       * * `BOOKED` - Booked
       */
      status?: BookingLinkStatusEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BookingLinkCounts;
  }
}

export namespace Bookings {
  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags time-slots
   * @name BookingsList
   * @request GET:/api/v1/bookings/
   * @secure
   * @response `200` `PaginatedTimeSlotBookingListList`
   */
  export namespace BookingsList {
    export type RequestParams = {};
    export type RequestQuery = {
      address?: number;
      /** Carrier */
      carrierName?: string;
      /** Driver name */
      driverName?: string;
      /** Driver phone */
      driverPhone?: string;
      /** @format date-time */
      fromDatetime?: string;
      /** Multiple values may be separated by commas. */
      gate?: number[];
      /**
       * Ordering
       *
       * * `createdAt` - Createdat
       * * `-createdAt` - Createdat (descending)
       * * `bookingTime` - Bookingtime
       * * `-bookingTime` - Bookingtime (descending)
       */
      order?: BookingsListOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** Vehicle plate */
      plateNumber?: string;
      /** A search term. */
      search?: string;
      /**
       * * `PENDING` - Pending
       * * `WITHDRAWN` - Withdrawn
       * * `APPROVED` - Approved
       * * `REJECTED` - Rejected
       * * `ARRIVED` - Arrived
       * * `CANCELED` - Canceled
       * * `COMPLETED` - Completed
       * * `EXPIRED` - Expired
       */
      status?: TimeSlotBookingListStatusEnum;
      /** @format date-time */
      toDatetime?: string;
      /** Transport */
      transport?: number;
      /** Vehicle type */
      vehicleType?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedTimeSlotBookingListList;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags time-slots
   * @name BookingsCreate
   * @request POST:/api/v1/bookings/
   * @secure
   * @response `201` `TimeSlotBookingList`
   * @response `400` `Record<string,any>`
   */
  export namespace BookingsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TimeSlotBookingCreate;
    export type RequestHeaders = {};
    export type ResponseBody = TimeSlotBookingList;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags time-slots
   * @name BookingsRetrieve
   * @request GET:/api/v1/bookings/{id}/
   * @secure
   * @response `200` `TimeSlotBookingDetail`
   * @response `404` `Record<string,any>`
   */
  export namespace BookingsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this Time Slot Booking. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TimeSlotBookingDetail;
  }

  /**
   * @description Edit a stored-PENDING or stored-APPROVED booking in one request: slot, gate, vehicle type, contact and cargo.
   * @tags time-slots
   * @name BookingsUpdate
   * @request PUT:/api/v1/bookings/{id}/
   * @secure
   * @response `200` `TimeSlotBookingDetail`
   * @response `400` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace BookingsUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this Time Slot Booking. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = TimeSlotBookingUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = TimeSlotBookingDetail;
  }

  /**
   * @description Approve a stored-PENDING booking onto the chosen gate; idempotent on the same gate.
   * @tags time-slots
   * @name BookingsApprove
   * @request POST:/api/v1/bookings/{id}/approve/
   * @secure
   * @response `200` `TimeSlotBookingList`
   * @response `400` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace BookingsApprove {
    export type RequestParams = {
      /** A unique integer value identifying this Time Slot Booking. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = TimeSlotBookingApprove;
    export type RequestHeaders = {};
    export type ResponseBody = TimeSlotBookingList;
  }

  /**
   * @description The gates this booking may move to - what the change-gate dialog offers.
   * @tags time-slots
   * @name BookingsAvailableGates
   * @request GET:/api/v1/bookings/{id}/available-gates/
   * @secure
   * @response `200` `(GateNested)[]`
   * @response `404` `Record<string,any>`
   */
  export namespace BookingsAvailableGates {
    export type RequestParams = {
      /** A unique integer value identifying this Time Slot Booking. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GateNested[];
  }

  /**
   * @description Cancel a stored-APPROVED booking; idempotent for an already canceled one.
   * @tags time-slots
   * @name BookingsCancel
   * @request POST:/api/v1/bookings/{id}/cancel/
   * @secure
   * @response `200` `TimeSlotBookingList`
   * @response `400` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace BookingsCancel {
    export type RequestParams = {
      /** A unique integer value identifying this Time Slot Booking. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TimeSlotBookingList;
  }

  /**
   * @description Move the booking to another gate at its address; idempotent for its current gate.
   * @tags time-slots
   * @name BookingsChangeGate
   * @request POST:/api/v1/bookings/{id}/change-gate/
   * @secure
   * @response `200` `TimeSlotBookingDetail`
   * @response `400` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace BookingsChangeGate {
    export type RequestParams = {
      /** A unique integer value identifying this Time Slot Booking. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = TimeSlotBookingChangeGate;
    export type RequestHeaders = {};
    export type ResponseBody = TimeSlotBookingDetail;
  }

  /**
   * @description The compact read-only booking the timeline's modal shows.
   * @tags time-slots
   * @name BookingsPreview
   * @request GET:/api/v1/bookings/{id}/preview/
   * @secure
   * @response `200` `TimeSlotBookingPreview`
   * @response `404` `Record<string,any>`
   */
  export namespace BookingsPreview {
    export type RequestParams = {
      /** A unique integer value identifying this Time Slot Booking. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TimeSlotBookingPreview;
  }

  /**
   * @description Reject a stored-PENDING booking; idempotent for an already rejected one.
   * @tags time-slots
   * @name BookingsReject
   * @request POST:/api/v1/bookings/{id}/reject/
   * @secure
   * @response `200` `TimeSlotBookingList`
   * @response `400` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace BookingsReject {
    export type RequestParams = {
      /** A unique integer value identifying this Time Slot Booking. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TimeSlotBookingList;
  }

  /**
   * @description The bookings filter's address -> gates tree, deleted and turned-off addresses and deleted gates included.
   * @tags time-slots
   * @name BookingsAddressGateOptionsList
   * @request GET:/api/v1/bookings/address-gate-options/
   * @secure
   * @response `200` `(BookingAddressGateOption)[]`
   */
  export namespace BookingsAddressGateOptionsList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BookingAddressGateOption[];
  }

  /**
   * @description One date's gate timeline across every address with time slots turned on.
   * @tags time-slots
   * @name BookingsTimeline
   * @request GET:/api/v1/bookings/timeline/
   * @secure
   * @response `200` `DayTimeline`
   * @response `400` `Record<string,any>`
   */
  export namespace BookingsTimeline {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date */
      date: string;
      /** Multiple values may be separated by commas. */
      gate?: number[];
      /** Show revoked bookings */
      showRevoked?: boolean;
      /**
       * Waypoint type
       *
       * * `PICKUP` - Pickup
       * * `DELIVERY` - Delivery
       */
      waypointType?: WaypointTypeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DayTimeline;
  }
}

export namespace ByEmail {
  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags by-email
   * @name ByEmailAuctionsList
   * @request GET:/api/v1/by-email/auctions/
   * @secure
   * @response `200` `PaginatedAuctionByEmailList`
   */
  export namespace ByEmailAuctionsList {
    export type RequestParams = {};
    export type RequestQuery = {
      maxVolumeM3?: number;
      minVolumeM3?: number;
      /** Auction ID */
      auctionId?: number;
      /**
       * Auction status
       *
       * * `ACTIVE` - Active
       * * `WAITING_FOR_ACCEPTATION` - Waiting for acceptation
       * * `CANCELED` - Canceled
       * * `SUCCESSFUL` - Successful
       * * `UNSUCCESSFUL` - Unsuccessful
       * * `OTHER` - Other
       */
      carrierAuctionStatus?: CarrierAuctionStatusEnum;
      deliveryCity?: string;
      deliveryCountry?: string;
      /** @format date-time */
      deliveryDateAfter?: string;
      /** @format date-time */
      deliveryDateBefore?: string;
      deliveryName?: string;
      deliveryPostCode?: string;
      deliveryReference?: string;
      deliveryStreet?: string;
      /**
       * Incoterms
       *
       * * `EXW` - EXW - Ex Works
       * * `FCA` - FCA - Free Carrier
       * * `CPT` - CPT - Carriage Paid To
       * * `CIP` - CIP - Carriage and Insurance Paid To
       * * `DAP` - DAP - Delivered at Place
       * * `DPU` - DPU - Delivered at Place Unloaded
       * * `DDP` - DDP - Delivered Duty Paid
       * * `FAS` - FAS - Free Alongside Ship
       * * `FOB` - FOB - Free On Board
       * * `CFR` - CFR - Cost and Freight
       * * `CIF` - CIF - Cost, Insurance and Freight
       */
      incoterms?: IncotermsEnum;
      /**
       * Load type
       *
       * * `FTL` - Full Truck Load
       * * `LTL` - Less than Truck Load
       * * `FCL` - Full Container Load
       * * `LCL` - Less than Container Load
       * * `PARCEL` - Parcel
       * * `NOT_SPECIFIED` - Not specified
       */
      loadType?: CargoLoadTypeEnum[];
      maxWeightKg?: number;
      minWeightKg?: number;
      /**
       * Ordering
       *
       * * `published_at` - Published at
       * * `-published_at` - Published at (descending)
       * * `finishing_at_annotated` - Finishing at annotated
       * * `-finishing_at_annotated` - Finishing at annotated (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       */
      order?: ByEmailAuctionsListOrderEnum[];
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      pickupCity?: string;
      pickupCountry?: string;
      /** @format date-time */
      pickupDateAfter?: string;
      /** @format date-time */
      pickupDateBefore?: string;
      pickupName?: string;
      pickupPostCode?: string;
      pickupReference?: string;
      pickupStreet?: string;
      /** Reference */
      reference?: string;
      /**
       * Request type
       *
       * * `REFRIGERATED_GOODS` - Refrigerated goods
       * * `FROZEN_GOODS` - Frozen goods
       * * `METAL_GOODS` - Metal goods
       * * `OVERSIZED_LOAD` - Oversized load
       * * `BULK_MATERIAL` - Bulk material
       * * `LOOSE_MATERIAL` - Loose material
       * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
       * * `LIQUIDS` - Liquids
       * * `VEHICLES` - Vehicles
       * * `ADR` - ADR
       * * `OTHER` - Other
       * * `NOT_SPECIFIED` - Not specified
       */
      requestType?: CargoTypeEnum;
      /** Responsible person */
      responsiblePerson?: string;
      /** A search term. */
      search?: string;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
      workspace?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedAuctionByEmailList;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags by-email
   * @name ByEmailAuctionsAutocompleteCreate
   * @request POST:/api/v1/by-email/auctions/autocomplete/
   * @secure
   * @response `200` `AutocompleteResponse`
   */
  export namespace ByEmailAuctionsAutocompleteCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AutocompleteRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AutocompleteResponse;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags by-email
   * @name ByEmailAuctionsCountsRetrieve
   * @request GET:/api/v1/by-email/auctions/counts/
   * @secure
   * @response `200` `CarrierAuctionsCounts`
   */
  export namespace ByEmailAuctionsCountsRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierAuctionsCounts;
  }

  /**
   * @description Every booking on a transport the carrier won, on an auction its signed-in email was invited to, and every booking made through a booking link sent to that email. Read-only: every write goes through the by-hash auction link.
   * @tags time-slots, by-email
   * @name ByEmailBookingsList
   * @request GET:/api/v1/by-email/bookings/
   * @secure
   * @response `200` `PaginatedCarrierBookingList`
   */
  export namespace ByEmailBookingsList {
    export type RequestParams = {};
    export type RequestQuery = {
      address?: number;
      /** Driver name */
      driverName?: string;
      /** @format date-time */
      fromDatetime?: string;
      /**
       * Ordering
       *
       * * `createdAt` - Createdat
       * * `-createdAt` - Createdat (descending)
       * * `bookingTime` - Bookingtime
       * * `-bookingTime` - Bookingtime (descending)
       */
      order?: ByEmailBookingsListOrderEnum[];
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** Vehicle plate */
      plateNumber?: string;
      /** Shipper */
      shipper?: string;
      /**
       * * `PENDING` - Pending
       * * `WITHDRAWN` - Withdrawn
       * * `APPROVED` - Approved
       * * `REJECTED` - Rejected
       * * `ARRIVED` - Arrived
       * * `CANCELED` - Canceled
       * * `COMPLETED` - Completed
       * * `EXPIRED` - Expired
       */
      status?: TimeSlotBookingListStatusEnum;
      /** @format date-time */
      toDatetime?: string;
      /** Transport */
      transport?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      "X-Carrier-Token": string;
    };
    export type ResponseBody = PaginatedCarrierBookingList;
  }

  /**
   * @description Every booking on a transport the carrier won, on an auction its signed-in email was invited to, and every booking made through a booking link sent to that email. Read-only: every write goes through the by-hash auction link.
   * @tags time-slots, by-email
   * @name ByEmailBookingsRetrieve
   * @request GET:/api/v1/by-email/bookings/{hash}/
   * @secure
   * @response `200` `CarrierBookingDetail`
   */
  export namespace ByEmailBookingsRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      "X-Carrier-Token": string;
    };
    export type ResponseBody = CarrierBookingDetail;
  }

  /**
   * @description The addresses this carrier's own bookings sit at - what the `address` filter picks from.
   * @tags time-slots, by-email
   * @name ByEmailBookingsAddressesList
   * @request GET:/api/v1/by-email/bookings/addresses/
   * @secure
   * @response `200` `PaginatedBookingAddressNestedList`
   */
  export namespace ByEmailBookingsAddressesList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** Matches each whitespace-separated term against the address name, country, city, street and post code. Quoted phrases are kept whole. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      "X-Carrier-Token": string;
    };
    export type ResponseBody = PaginatedBookingAddressNestedList;
  }

  /**
   * @description The shipper names on this carrier's own bookings - what the quick `shipper` filter offers.
   * @tags time-slots, by-email
   * @name ByEmailBookingsShippersRetrieve
   * @request GET:/api/v1/by-email/bookings/shippers/
   * @secure
   * @response `200` `AutocompleteResponse`
   */
  export namespace ByEmailBookingsShippersRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      "X-Carrier-Token": string;
    };
    export type ResponseBody = AutocompleteResponse;
  }

  /**
   * No description
   * @tags carrier-contracts, by-email
   * @name ByEmailContractsList
   * @request GET:/api/v1/by-email/contracts/
   * @secure
   * @response `200` `PaginatedCarrierContractListList`
   */
  export namespace ByEmailContractsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       */
      order?: ByEmailContractsListOrderEnum[];
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** Responsible person */
      responsiblePerson?: string;
      /** A search term. */
      search?: string;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum[];
      workspace?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedCarrierContractListList;
  }

  /**
   * No description
   * @tags carrier-contracts, by-email
   * @name ByEmailContractsRetrieve
   * @request GET:/api/v1/by-email/contracts/{hash}/
   * @secure
   * @response `200` `CarrierContractDetail`
   */
  export namespace ByEmailContractsRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierContractDetail;
  }

  /**
   * No description
   * @tags carrier-contracts, by-email
   * @name CarrierContractsPricesRetrieve
   * @request GET:/api/v1/by-email/contracts/{hash}/contract-prices/
   * @secure
   * @response `200` `ContractPrices`
   */
  export namespace CarrierContractsPricesRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractPrices;
  }

  /**
   * No description
   * @tags carrier-contracts, by-email
   * @name CarrierContractsRoutesList
   * @request GET:/api/v1/by-email/contracts/{hash}/routes/
   * @secure
   * @response `200` `PaginatedContractRouteRowList`
   */
  export namespace CarrierContractsRoutesList {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       */
      order?: CarrierContractsRoutesListOrderEnum[];
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** Responsible person */
      responsiblePerson?: string;
      /** A search term. */
      search?: string;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum[];
      workspace?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedContractRouteRowList;
  }

  /**
   * No description
   * @tags carrier-contracts, by-email
   * @name CarrierContractsRoutesAutocomplete
   * @request GET:/api/v1/by-email/contracts/{hash}/routes/autocomplete/
   * @secure
   * @response `200` `AutocompleteResponse`
   * @response `400` `void` No response body
   */
  export namespace CarrierContractsRoutesAutocomplete {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {
      /**
       * * `city` - city
       * * `post_code` - post_code
       * * `street` - street
       */
      field: CarrierContractsRoutesAutocompleteFieldEnum;
      /** @minLength 1 */
      term: string;
      /**
       * * `PICKUP` - Pickup
       * * `DELIVERY` - Delivery
       */
      waypointType: WaypointTypeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AutocompleteResponse;
  }

  /**
   * @description List the inbox newest-first, one message per conversation (cursor paginated).
   * @tags messages, by-email
   * @name ByEmailMessagesList
   * @request GET:/api/v1/by-email/messages/
   * @secure
   * @response `200` `PaginatedCarrierMessageList`
   */
  export namespace ByEmailMessagesList {
    export type RequestParams = {
      email: string;
    };
    export type RequestQuery = {
      /** The pagination cursor value. */
      cursor?: string;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedCarrierMessageList;
  }

  /**
   * @description Cursor-paginated cross-timeline message inbox.
   * @tags messages, by-email
   * @name ByEmailMessagesMarkAsReadCreate
   * @request POST:/api/v1/by-email/messages/{id}/mark_as_read/
   * @secure
   * @response `200` `void` No response body
   */
  export namespace ByEmailMessagesMarkAsReadCreate {
    export type RequestParams = {
      email: string;
      /** A unique integer value identifying this message. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Cursor-paginated cross-timeline message inbox.
   * @tags messages, by-email
   * @name ByEmailMessagesMarkAllAsReadCreate
   * @request POST:/api/v1/by-email/messages/mark-all-as-read/
   * @secure
   * @response `200` `string`
   */
  export namespace ByEmailMessagesMarkAllAsReadCreate {
    export type RequestParams = {
      email: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description Cursor-paginated cross-timeline message inbox.
   * @tags messages, by-email
   * @name ByEmailMessagesUnreadCountRetrieve
   * @request GET:/api/v1/by-email/messages/unread-count/
   * @secure
   * @response `200` `number`
   */
  export namespace ByEmailMessagesUnreadCountRetrieve {
    export type RequestParams = {
      email: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = number;
  }

  /**
   * No description
   * @tags carrier-tenders, by-email
   * @name ByEmailTendersList
   * @request GET:/api/v1/by-email/tenders/
   * @secure
   * @response `200` `PaginatedCarrierTenderListList`
   */
  export namespace ByEmailTendersList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       */
      order?: ByEmailTendersListOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** Participated */
      participated?: boolean;
      /** Responsible person */
      responsiblePerson?: string;
      /** A search term. */
      search?: string;
      /**
       * Status
       *
       * * `DRAFT` - Draft
       * * `OPEN` - Open
       * * `EVALUATING` - Evaluating
       * * `FINISHED` - Finished
       * * `CANCELED` - Canceled
       */
      tenderDisplayStatus?: TenderDisplayStatusEnum;
      /** Tender ID */
      tenderId?: number;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum[];
      workspace?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedCarrierTenderListList;
  }

  /**
   * No description
   * @tags carrier-tenders, by-email
   * @name ByEmailTendersRetrieve
   * @request GET:/api/v1/by-email/tenders/{hash}/
   * @secure
   * @response `200` `CarrierTender`
   */
  export namespace ByEmailTendersRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierTender;
  }

  /**
   * No description
   * @tags carrier-tenders, by-email
   * @name CarrierTendersProposalAccept
   * @request POST:/api/v1/by-email/tenders/{hash}/accept-proposal/
   * @secure
   * @response `200` `ContractAcceptedByCarrier`
   */
  export namespace CarrierTendersProposalAccept {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractAcceptedByCarrier;
  }

  /**
   * No description
   * @tags carrier-tenders, by-email
   * @name CarrierTendersCategoriesRetrieve
   * @request GET:/api/v1/by-email/tenders/{hash}/categories/
   * @secure
   * @response `200` `(TenderPriceCategoryCol)[]`
   */
  export namespace CarrierTendersCategoriesRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       */
      order?: CarrierTendersCategoriesRetrieveOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** Participated */
      participated?: boolean;
      /** Responsible person */
      responsiblePerson?: string;
      /** A search term. */
      search?: string;
      /**
       * Status
       *
       * * `DRAFT` - Draft
       * * `OPEN` - Open
       * * `EVALUATING` - Evaluating
       * * `FINISHED` - Finished
       * * `CANCELED` - Canceled
       */
      tenderDisplayStatus?: TenderDisplayStatusEnum;
      /** Tender ID */
      tenderId?: number;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum[];
      workspace?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TenderPriceCategoryCol[];
  }

  /**
   * No description
   * @tags carrier-tenders, by-email
   * @name CarrierTendersConfirmedContractRetrieve
   * @request GET:/api/v1/by-email/tenders/{hash}/confirmed-contract/
   * @secure
   * @response `200` `ContractPrices`
   * @response `204` `void` No response body
   */
  export namespace CarrierTendersConfirmedContractRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractPrices;
  }

  /**
   * No description
   * @tags carrier-tenders, by-email
   * @name CarrierTendersContractProposalRetrieve
   * @request GET:/api/v1/by-email/tenders/{hash}/contract-proposal/
   * @secure
   * @response `200` `ContractProposal`
   * @response `204` `void` No response body
   */
  export namespace CarrierTendersContractProposalRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractProposal;
  }

  /**
   * No description
   * @tags carrier-tenders, by-email
   * @name CarrierTendersHistoryOffersRetrieve
   * @request GET:/api/v1/by-email/tenders/{hash}/history-offers/
   * @secure
   * @response `200` `(CarrierHistoryOfferCell)[]`
   */
  export namespace CarrierTendersHistoryOffersRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       */
      order?: CarrierTendersHistoryOffersRetrieveOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** Participated */
      participated?: boolean;
      /** Responsible person */
      responsiblePerson?: string;
      /** A search term. */
      search?: string;
      /**
       * Status
       *
       * * `DRAFT` - Draft
       * * `OPEN` - Open
       * * `EVALUATING` - Evaluating
       * * `FINISHED` - Finished
       * * `CANCELED` - Canceled
       */
      tenderDisplayStatus?: TenderDisplayStatusEnum;
      /** Tender ID */
      tenderId?: number;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum[];
      workspace?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierHistoryOfferCell[];
  }

  /**
   * No description
   * @tags carrier-tenders, by-email
   * @name CarrierTendersOffersRetrieve
   * @request GET:/api/v1/by-email/tenders/{hash}/price-offers/
   * @secure
   * @response `200` `CarrierTenderPriceOffers`
   */
  export namespace CarrierTendersOffersRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierTenderPriceOffers;
  }

  /**
   * No description
   * @tags carrier-tenders, by-email
   * @name CarrierTendersProposalReject
   * @request POST:/api/v1/by-email/tenders/{hash}/reject-proposal/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace CarrierTendersProposalReject {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags carrier-tenders, by-email
   * @name CarrierTendersRoutesRetrieve
   * @request GET:/api/v1/by-email/tenders/{hash}/routes/
   * @secure
   * @response `200` `(TenderRoute)[]`
   */
  export namespace CarrierTendersRoutesRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       */
      order?: CarrierTendersRoutesRetrieveOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** Participated */
      participated?: boolean;
      /** Responsible person */
      responsiblePerson?: string;
      /** A search term. */
      search?: string;
      /**
       * Status
       *
       * * `DRAFT` - Draft
       * * `OPEN` - Open
       * * `EVALUATING` - Evaluating
       * * `FINISHED` - Finished
       * * `CANCELED` - Canceled
       */
      tenderDisplayStatus?: TenderDisplayStatusEnum;
      /** Tender ID */
      tenderId?: number;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum[];
      workspace?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TenderRoute[];
  }

  /**
   * No description
   * @tags carrier-tenders, by-email
   * @name ByEmailTendersSavePricesCreate
   * @request POST:/api/v1/by-email/tenders/{hash}/save-prices/
   * @secure
   * @response `200` `CarrierOfferBulkSave`
   */
  export namespace ByEmailTendersSavePricesCreate {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CarrierOfferBulkSave;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierOfferBulkSave;
  }

  /**
   * No description
   * @tags carrier-tenders, by-email
   * @name ByEmailTendersSubmitPricesCreate
   * @request POST:/api/v1/by-email/tenders/{hash}/submit-prices/
   * @secure
   * @response `200` `CarrierOfferBulkSubmit`
   */
  export namespace ByEmailTendersSubmitPricesCreate {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CarrierOfferBulkSubmit;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierOfferBulkSubmit;
  }

  /**
   * No description
   * @tags documents, by-email
   * @name ByEmailTendersDocumentsList
   * @request GET:/api/v1/by-email/tenders/{tender_hash}/documents/
   * @secure
   * @response `200` `PaginatedDocumentList`
   */
  export namespace ByEmailTendersDocumentsList {
    export type RequestParams = {
      tenderHash: string;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedDocumentList;
  }

  /**
   * No description
   * @tags documents, by-email
   * @name ByEmailTendersDocumentsRetrieve
   * @request GET:/api/v1/by-email/tenders/{tender_hash}/documents/{id}/
   * @secure
   * @response `200` `Document`
   */
  export namespace ByEmailTendersDocumentsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this document. */
      id: number;
      tenderHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Document;
  }

  /**
   * @description Messages for a specific tender (carrier-facing, OTP auth).
   * @tags messages, by-email
   * @name ByEmailTendersMessagesList
   * @request GET:/api/v1/by-email/tenders/{tender_hash}/messages/
   * @secure
   * @response `200` `PaginatedMessageList`
   */
  export namespace ByEmailTendersMessagesList {
    export type RequestParams = {
      tenderHash: string;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedMessageList;
  }

  /**
   * @description Messages for a specific tender (carrier-facing, OTP auth).
   * @tags messages, by-email
   * @name ByEmailTendersMessagesCreate
   * @request POST:/api/v1/by-email/tenders/{tender_hash}/messages/
   * @secure
   * @response `201` `Message`
   */
  export namespace ByEmailTendersMessagesCreate {
    export type RequestParams = {
      tenderHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = Message;
    export type RequestHeaders = {};
    export type ResponseBody = Message;
  }

  /**
   * @description Messages for a specific tender (carrier-facing, OTP auth).
   * @tags messages, by-email
   * @name ByEmailTendersMessagesMarkAsReadCreate
   * @request POST:/api/v1/by-email/tenders/{tender_hash}/messages/mark-as-read/
   * @secure
   * @response `200` `void` No response body
   */
  export namespace ByEmailTendersMessagesMarkAsReadCreate {
    export type RequestParams = {
      tenderHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Messages for a specific tender (carrier-facing, OTP auth).
   * @tags messages, by-email
   * @name ByEmailTendersMessagesUnreadCountRetrieve
   * @request GET:/api/v1/by-email/tenders/{tender_hash}/messages/unread-count/
   * @secure
   * @response `200` `number`
   */
  export namespace ByEmailTendersMessagesUnreadCountRetrieve {
    export type RequestParams = {
      tenderHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = number;
  }

  /**
   * No description
   * @tags carrier-tenders, by-email
   * @name ByEmailTendersAutocompleteCreate
   * @request POST:/api/v1/by-email/tenders/autocomplete/
   * @secure
   * @response `200` `AutocompleteResponse`
   */
  export namespace ByEmailTendersAutocompleteCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AutocompleteRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AutocompleteResponse;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags by-email
   * @name ByEmailTransportsList
   * @request GET:/api/v1/by-email/transports/
   * @secure
   * @response `200` `PaginatedTransportByEmailList`
   */
  export namespace ByEmailTransportsList {
    export type RequestParams = {};
    export type RequestQuery = {
      maxVolumeM3?: number;
      minVolumeM3?: number;
      /** Auction ID */
      auctionId?: number;
      deliveryCity?: string;
      deliveryCountry?: string;
      /** @format date-time */
      deliveryDateAfter?: string;
      /** @format date-time */
      deliveryDateBefore?: string;
      deliveryName?: string;
      deliveryPostCode?: string;
      deliveryReference?: string;
      deliveryStreet?: string;
      /**
       * Incoterms
       *
       * * `EXW` - EXW - Ex Works
       * * `FCA` - FCA - Free Carrier
       * * `CPT` - CPT - Carriage Paid To
       * * `CIP` - CIP - Carriage and Insurance Paid To
       * * `DAP` - DAP - Delivered at Place
       * * `DPU` - DPU - Delivered at Place Unloaded
       * * `DDP` - DDP - Delivered Duty Paid
       * * `FAS` - FAS - Free Alongside Ship
       * * `FOB` - FOB - Free On Board
       * * `CFR` - CFR - Cost and Freight
       * * `CIF` - CIF - Cost, Insurance and Freight
       */
      incoterms?: IncotermsEnum;
      /**
       * Load type
       *
       * * `FTL` - Full Truck Load
       * * `LTL` - Less than Truck Load
       * * `FCL` - Full Container Load
       * * `LCL` - Less than Container Load
       * * `PARCEL` - Parcel
       * * `NOT_SPECIFIED` - Not specified
       */
      loadType?: CargoLoadTypeEnum[];
      maxWeightKg?: number;
      minWeightKg?: number;
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       * * `booking_required` - Booking required
       * * `-booking_required` - Booking required (descending)
       */
      order?: ByEmailTransportsListOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      pickupCity?: string;
      pickupCountry?: string;
      /** @format date-time */
      pickupDateAfter?: string;
      /** @format date-time */
      pickupDateBefore?: string;
      pickupName?: string;
      pickupPostCode?: string;
      pickupReference?: string;
      pickupStreet?: string;
      reference?: string;
      /**
       * Request type
       *
       * * `REFRIGERATED_GOODS` - Refrigerated goods
       * * `FROZEN_GOODS` - Frozen goods
       * * `METAL_GOODS` - Metal goods
       * * `OVERSIZED_LOAD` - Oversized load
       * * `BULK_MATERIAL` - Bulk material
       * * `LOOSE_MATERIAL` - Loose material
       * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
       * * `LIQUIDS` - Liquids
       * * `VEHICLES` - Vehicles
       * * `ADR` - ADR
       * * `OTHER` - Other
       * * `NOT_SPECIFIED` - Not specified
       */
      requestType?: CargoTypeEnum;
      /** Responsible person */
      responsiblePerson?: string;
      /** A search term. */
      search?: string;
      /** Slot booking */
      slotBooking?: boolean;
      /**
       * Transport status
       *
       * * `PROCESSING` - Processing
       * * `FINISHED` - Finished
       * * `CANCELED` - Canceled
       * * `CANCELED_BY_CARRIER` - Canceled by carrier
       * * `CANCELED_BY_SUPPORT` - Canceled by support
       */
      transportStatus?: TransportStatusEnum;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
      workspace?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedTransportByEmailList;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags by-email
   * @name ByEmailTransportsAutocompleteCreate
   * @request POST:/api/v1/by-email/transports/autocomplete/
   * @secure
   * @response `200` `AutocompleteResponse`
   */
  export namespace ByEmailTransportsAutocompleteCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AutocompleteRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AutocompleteResponse;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags by-email
   * @name ByEmailTransportsCountsRetrieve
   * @request GET:/api/v1/by-email/transports/counts/
   * @secure
   * @response `200` `CarrierTransportsCounts`
   */
  export namespace ByEmailTransportsCountsRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierTransportsCounts;
  }

  /**
   * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
   * @tags by-email
   * @name ByEmailTransportsTransportRetrieve
   * @request GET:/api/v1/by-email/transports/transport/
   * @secure
   * @response `200` `TransportByEmail`
   */
  export namespace ByEmailTransportsTransportRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {
      auctionHash: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TransportByEmail;
  }

  /**
   * No description
   * @tags by-email
   * @name ByEmailWaypointsAutocompleteCreate
   * @request POST:/api/v1/by-email/waypoints/autocomplete/
   * @secure
   * @response `200` `AutocompleteResponse`
   */
  export namespace ByEmailWaypointsAutocompleteCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = WaypointAutocompleteRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AutocompleteResponse;
  }
}

export namespace ByHash {
  /**
   * @description Active cargo units of the link's shipper, for the booking form of a usable link and the edit form of the booking made through a used one. An expired or revoked link answers 400 with ``code`` ``link_expired`` or ``link_revoked``.
   * @tags by-hash
   * @name ByHashBookingLinksCargoItemUnitsList
   * @request GET:/api/v1/by-hash/booking-links/{booking_link_hash}/cargo-item-units/
   * @response `200` `(CargoItemUnit)[]`
   * @response `400` `Record<string,any>`
   * @response `403` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace ByHashBookingLinksCargoItemUnitsList {
    export type RequestParams = {
      bookingLinkHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CargoItemUnit[];
  }

  /**
   * @description A booking link opened by its recipient. The hash is the only credential.
   * @tags time-slots, by-hash
   * @name ByHashBookingLinksRetrieve
   * @request GET:/api/v1/by-hash/booking-links/{hash}/
   * @response `200` `BookingLinkByHash`
   * @response `403` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace ByHashBookingLinksRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BookingLinkByHash;
  }

  /**
   * @description Free starts at the link's address: for the booking form of a usable link, or for the edit form of the pending booking made through it, whose own slot is not counted as taken. An expired or revoked link answers 400 with ``code`` ``link_expired`` or ``link_revoked``; a settled booking with ``non_field_errors``.
   * @tags time-slots, by-hash
   * @name ByHashBookingLinksAvailableSlotsRetrieve
   * @request GET:/api/v1/by-hash/booking-links/{hash}/available-slots/
   * @response `200` `CarrierAvailableSlots`
   * @response `400` `Record<string,any>`
   * @response `403` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace ByHashBookingLinksAvailableSlotsRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {
      /** @format date */
      date: string;
      vehicleType?: number | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierAvailableSlots;
  }

  /**
   * @description The booking made through the link, also past the link's expiry; 404 for a link without one.
   * @tags time-slots, by-hash
   * @name ByHashBookingLinksBookingRetrieve
   * @request GET:/api/v1/by-hash/booking-links/{hash}/booking/
   * @response `200` `CarrierBookingDetail`
   * @response `403` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace ByHashBookingLinksBookingRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierBookingDetail;
  }

  /**
   * @description Book a slot at the link's address, once per link. An unusable link answers 400 with ``code`` ``link_used``, ``link_expired`` or ``link_revoked``.
   * @tags time-slots, by-hash
   * @name ByHashBookingLinksBookingCreate
   * @request POST:/api/v1/by-hash/booking-links/{hash}/booking/
   * @response `201` `CarrierBookingDetail`
   * @response `400` `Record<string,any>`
   * @response `403` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace ByHashBookingLinksBookingCreate {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = BookingLinkBookingCreate;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierBookingDetail;
  }

  /**
   * @description Edit the booking made through the link while it is still pending, the whole form again; also past the link's expiry. 404 for a link without a booking, 400 once the shipper has settled it.
   * @tags time-slots, by-hash
   * @name ByHashBookingLinksBookingUpdate
   * @request PUT:/api/v1/by-hash/booking-links/{hash}/booking/
   * @response `200` `CarrierBookingDetail`
   * @response `400` `Record<string,any>`
   * @response `403` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace ByHashBookingLinksBookingUpdate {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = BookingLinkBookingUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierBookingDetail;
  }

  /**
   * No description
   * @tags transport, updates, by-hash
   * @name ByHashContactsAuctionsBatchUpdatesList
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/batch-updates/
   * @secure
   * @response `200` `PaginatedTransportBatchUpdateList`
   */
  export namespace ByHashContactsAuctionsBatchUpdatesList {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedTransportBatchUpdateList;
  }

  /**
   * No description
   * @tags transport, updates, by-hash
   * @name ByHashContactsAuctionsBatchUpdatesCreate
   * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/batch-updates/
   * @secure
   * @response `201` `TransportBatchUpdate`
   */
  export namespace ByHashContactsAuctionsBatchUpdatesCreate {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = TransportBatchUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = TransportBatchUpdate;
  }

  /**
   * No description
   * @tags bids, by-hash
   * @name ByHashContactsAuctionsBidsList
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bids/
   * @secure
   * @response `200` `PaginatedBidByHashList`
   */
  export namespace ByHashContactsAuctionsBidsList {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedBidByHashList;
  }

  /**
   * No description
   * @tags bids, by-hash
   * @name ByHashContactsAuctionsBidsCreate
   * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bids/
   * @secure
   * @response `201` `BidByHash`
   */
  export namespace ByHashContactsAuctionsBidsCreate {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = BidByHash;
    export type RequestHeaders = {};
    export type ResponseBody = BidByHash;
  }

  /**
   * No description
   * @tags bids, by-hash
   * @name ByHashContactsAuctionsBidsRetrieve
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bids/{hash}/
   * @secure
   * @response `200` `BidByHash`
   */
  export namespace ByHashContactsAuctionsBidsRetrieve {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BidByHash;
  }

  /**
   * No description
   * @tags bids, by-hash
   * @name ByHashContactsAuctionsBidsUpdate
   * @request PUT:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bids/{hash}/
   * @secure
   * @response `200` `UpdateBidByHash`
   */
  export namespace ByHashContactsAuctionsBidsUpdate {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateBidByHash;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateBidByHash;
  }

  /**
   * No description
   * @tags bids, by-hash
   * @name ByHashContactsAuctionsBidsPartialUpdate
   * @request PATCH:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bids/{hash}/
   * @secure
   * @response `200` `UpdateBidByHash`
   */
  export namespace ByHashContactsAuctionsBidsPartialUpdate {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedUpdateBidByHash;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateBidByHash;
  }

  /**
   * No description
   * @tags auctions
   * @name ByHashContactsAuctionsBidsFeePreviewCreate
   * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bids/fee-preview/
   * @secure
   * @response `200` `FeePreviewOutput`
   */
  export namespace ByHashContactsAuctionsBidsFeePreviewCreate {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = FeePreviewInput;
    export type RequestHeaders = {};
    export type ResponseBody = FeePreviewOutput;
  }

  /**
   * @description Bookable starts at a stop of the auction's own transport - its own viewset, since the bookings one is booking-shaped (hash lookup, serializer map).
   * @tags time-slots, by-hash
   * @name ByHashContactsAuctionsBookingSlotsAvailableSlotsRetrieve
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/booking-slots/available-slots/
   * @secure
   * @response `200` `CarrierAvailableSlots`
   * @response `400` `Record<string,any>`
   */
  export namespace ByHashContactsAuctionsBookingSlotsAvailableSlotsRetrieve {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {
      /** @format date */
      date: string;
      excludeBooking?: string;
      vehicleType?: number | null;
      waypoint: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierAvailableSlots;
  }

  /**
   * @description Book a slot for one stop of the auction's transport.
   * @tags time-slots, by-hash
   * @name ByHashContactsAuctionsBookingsCreate
   * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bookings/
   * @secure
   * @response `201` `CarrierBookingDetail`
   * @response `400` `Record<string,any>`
   */
  export namespace ByHashContactsAuctionsBookingsCreate {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = TimeSlotBookingCarrierCreate;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierBookingDetail;
  }

  /**
   * @description Create, read, edit and cancel a booking on the auction's own transport.
   * @tags time-slots, by-hash
   * @name ByHashContactsAuctionsBookingsRetrieve
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bookings/{hash}/
   * @secure
   * @response `200` `CarrierBookingDetail`
   */
  export namespace ByHashContactsAuctionsBookingsRetrieve {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierBookingDetail;
  }

  /**
   * @description Edit a pending booking on the auction's transport.
   * @tags time-slots, by-hash
   * @name ByHashContactsAuctionsBookingsUpdate
   * @request PUT:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bookings/{hash}/
   * @secure
   * @response `200` `CarrierBookingDetail`
   * @response `400` `Record<string,any>`
   */
  export namespace ByHashContactsAuctionsBookingsUpdate {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = TimeSlotBookingCarrierUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierBookingDetail;
  }

  /**
   * @description Create, read, edit and cancel a booking on the auction's own transport.
   * @tags time-slots, by-hash
   * @name ByHashContactsAuctionsBookingsCancelCreate
   * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bookings/{hash}/cancel/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace ByHashContactsAuctionsBookingsCancelCreate {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Everything the Add-new-booking form starts from, for one stop of the auction's transport.
   * @tags time-slots, by-hash
   * @name ByHashContactsAuctionsBookingsPrefillRetrieve
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bookings/prefill/
   * @secure
   * @response `200` `BookingPrefill`
   * @response `400` `Record<string,any>`
   * @response `404` `Record<string,any>`
   */
  export namespace ByHashContactsAuctionsBookingsPrefillRetrieve {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {
      waypoint: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BookingPrefill;
  }

  /**
   * No description
   * @tags documents, by-hash
   * @name ByHashContactsAuctionsDocumentsList
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/documents/
   * @secure
   * @response `200` `PaginatedDocumentList`
   */
  export namespace ByHashContactsAuctionsDocumentsList {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedDocumentList;
  }

  /**
   * No description
   * @tags documents, by-hash
   * @name ByHashContactsAuctionsDocumentsCreate
   * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/documents/
   * @secure
   * @response `201` `Document`
   */
  export namespace ByHashContactsAuctionsDocumentsCreate {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CarrierDocumentCreate;
    export type RequestHeaders = {};
    export type ResponseBody = Document;
  }

  /**
   * No description
   * @tags documents, by-hash
   * @name ByHashContactsAuctionsDocumentsRetrieve
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/documents/{id}/
   * @secure
   * @response `200` `Document`
   */
  export namespace ByHashContactsAuctionsDocumentsRetrieve {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
      /** A unique integer value identifying this document. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Document;
  }

  /**
   * No description
   * @tags messages, by-hash
   * @name ByHashContactsAuctionsMessagesList
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/messages/
   * @secure
   * @response `200` `PaginatedMessageList`
   */
  export namespace ByHashContactsAuctionsMessagesList {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedMessageList;
  }

  /**
   * No description
   * @tags messages, by-hash
   * @name ByHashContactsAuctionsMessagesCreate
   * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/messages/
   * @secure
   * @response `201` `Message`
   */
  export namespace ByHashContactsAuctionsMessagesCreate {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = Message;
    export type RequestHeaders = {};
    export type ResponseBody = Message;
  }

  /**
   * No description
   * @tags messages, by-hash
   * @name ByHashContactsAuctionsMessagesMarkAsReadCreate
   * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/messages/mark_as_read/
   * @secure
   * @response `200` `void` No response body
   */
  export namespace ByHashContactsAuctionsMessagesMarkAsReadCreate {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags messages, by-hash
   * @name ByHashContactsAuctionsMessagesUnreadCountRetrieve
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/messages/unread-count/
   * @secure
   * @response `200` `number`
   */
  export namespace ByHashContactsAuctionsMessagesUnreadCountRetrieve {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = number;
  }

  /**
   * No description
   * @tags transport, updates, by-hash
   * @name ByHashContactsAuctionsUpdatesListLatestList
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/updates/list-latest/
   * @secure
   * @response `200` `(TransportLatestUpdate)[]`
   */
  export namespace ByHashContactsAuctionsUpdatesListLatestList {
    export type RequestParams = {
      auctionHash: string;
      contactHash: string;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TransportLatestUpdate[];
  }

  /**
   * No description
   * @tags auctions, by-hash
   * @name ByHashContactsAuctionsRetrieve
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{hash}/
   * @secure
   * @response `200` `AuctionByHash`
   */
  export namespace ByHashContactsAuctionsRetrieve {
    export type RequestParams = {
      contactHash: string;
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionByHash;
  }

  /**
   * No description
   * @tags auctions, by-hash
   * @name ByHashContactsAuctionsDownloadTransportOrderRetrieve
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{hash}/download-transport-order/
   * @secure
   * @response `200` `File`
   */
  export namespace ByHashContactsAuctionsDownloadTransportOrderRetrieve {
    export type RequestParams = {
      contactHash: string;
      hash: string;
    };
    export type RequestQuery = {
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Blob;
  }

  /**
   * No description
   * @tags auctions, by-hash
   * @name ByHashContactsAuctionsStatusCreate
   * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{hash}/status/
   * @secure
   * @response `200` `AuctionSetParticipantStatus`
   */
  export namespace ByHashContactsAuctionsStatusCreate {
    export type RequestParams = {
      contactHash: string;
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = AuctionSetParticipantStatus;
    export type RequestHeaders = {};
    export type ResponseBody = AuctionSetParticipantStatus;
  }

  /**
   * No description
   * @tags transport-cancel-request, auctions
   * @name ByHashContactsAuctionsTransportCancelRequestCreate
   * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{hash}/transport-cancel-request/
   * @secure
   * @response `200` `TransportCancelRequestCreate`
   */
  export namespace ByHashContactsAuctionsTransportCancelRequestCreate {
    export type RequestParams = {
      contactHash: string;
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = TransportCancelRequestCreate;
    export type RequestHeaders = {};
    export type ResponseBody = TransportCancelRequestCreate;
  }

  /**
   * No description
   * @tags transport-details
   * @name ByHashContactsAuctionsTransportDetailsRetrieve
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{hash}/transport-details/
   * @secure
   * @response `200` `TransportDetailByHash`
   */
  export namespace ByHashContactsAuctionsTransportDetailsRetrieve {
    export type RequestParams = {
      contactHash: string;
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TransportDetailByHash;
  }

  /**
   * No description
   * @tags transport-details
   * @name ByHashContactsAuctionsTransportDetailsCreate
   * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{hash}/transport-details/
   * @secure
   * @response `200` `TransportDetailByHash`
   */
  export namespace ByHashContactsAuctionsTransportDetailsCreate {
    export type RequestParams = {
      contactHash: string;
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = TransportDetailByHash;
    export type RequestHeaders = {};
    export type ResponseBody = TransportDetailByHash;
  }

  /**
   * @description This must be a viewset, because i want to use it in carrier by hash router
   * @tags billing, by-hash
   * @name ByHashContactsBillingDetailsList
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/billing-details/
   * @secure
   * @response `200` `PaginatedCarrierBillingDetailsByHashInputList`
   */
  export namespace ByHashContactsBillingDetailsList {
    export type RequestParams = {
      contactHash: string;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedCarrierBillingDetailsByHashInputList;
  }

  /**
   * @description This must be a viewset, because i want to use it in carrier by hash router
   * @tags billing, by-hash
   * @name ByHashContactsBillingDetailsCreate
   * @request POST:/api/v1/by-hash/contacts/{contact_hash}/billing-details/
   * @secure
   * @response `201` `CarrierBillingDetailsByHashOutput`
   */
  export namespace ByHashContactsBillingDetailsCreate {
    export type RequestParams = {
      contactHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CarrierBillingDetailsByHashInput;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierBillingDetailsByHashOutput;
  }

  /**
   * @description This must be a viewset, because i want to use it in carrier by hash router
   * @tags billing, by-hash
   * @name ByHashContactsBillingDetailsRetrieve
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/billing-details/{id}/
   * @secure
   * @response `200` `CarrierBillingDetailsByHashInput`
   */
  export namespace ByHashContactsBillingDetailsRetrieve {
    export type RequestParams = {
      contactHash: string;
      /** A unique integer value identifying this Carrier Billing Details. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierBillingDetailsByHashInput;
  }

  /**
   * @description This must be a viewset, because i want to use it in carrier by hash router
   * @tags billing, by-hash
   * @name ByHashContactsBillingDetailsApproveCreate
   * @request POST:/api/v1/by-hash/contacts/{contact_hash}/billing-details/{id}/approve/
   * @secure
   * @response `200` `CarrierBillingDetailsByHashOutput`
   */
  export namespace ByHashContactsBillingDetailsApproveCreate {
    export type RequestParams = {
      contactHash: string;
      /** A unique integer value identifying this Carrier Billing Details. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierBillingDetailsByHashOutput;
  }

  /**
   * No description
   * @tags by-hash
   * @name ByHashContactsCargoItemUnitsList
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/cargo-item-units/
   * @secure
   * @response `200` `PaginatedCargoItemUnitList`
   */
  export namespace ByHashContactsCargoItemUnitsList {
    export type RequestParams = {
      contactHash: string;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedCargoItemUnitList;
  }

  /**
   * No description
   * @tags by-hash
   * @name ByHashContactsCargoItemUnitsAllList
   * @request GET:/api/v1/by-hash/contacts/{contact_hash}/cargo-item-units/all/
   * @secure
   * @response `200` `(CargoItemUnit)[]`
   */
  export namespace ByHashContactsCargoItemUnitsAllList {
    export type RequestParams = {
      contactHash: string;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CargoItemUnit[];
  }

  /**
   * No description
   * @tags carriers, by-hash
   * @name ByHashContactsRetrieve
   * @request GET:/api/v1/by-hash/contacts/{hash}/
   * @secure
   * @response `200` `ContactByHash`
   */
  export namespace ByHashContactsRetrieve {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContactByHash;
  }

  /**
   * No description
   * @tags carriers, by-hash
   * @name ByHashContactsUpdate
   * @request PUT:/api/v1/by-hash/contacts/{hash}/
   * @secure
   * @response `200` `ContactByHash`
   */
  export namespace ByHashContactsUpdate {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ContactByHash;
    export type RequestHeaders = {};
    export type ResponseBody = ContactByHash;
  }

  /**
   * No description
   * @tags carriers, by-hash
   * @name ByHashContactsPartialUpdate
   * @request PATCH:/api/v1/by-hash/contacts/{hash}/
   * @secure
   * @response `200` `ContactByHash`
   */
  export namespace ByHashContactsPartialUpdate {
    export type RequestParams = {
      /** Hash key */
      hash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedContactByHash;
    export type RequestHeaders = {};
    export type ResponseBody = ContactByHash;
  }
}

export namespace Captcha {
  /**
   * No description
   * @tags core
   * @name CaptchaVerifyCreate
   * @request POST:/api/v1/captcha/verify/
   * @secure
   * @response `200` `RecaptchaVerifyResult`
   */
  export namespace CaptchaVerifyCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CaptchaVerifyCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = RecaptchaVerifyResult;
  }
}

export namespace CargoCategories {
  /**
   * @description ViewSet providing CRUD operations for a cargo category. URL: /cargo-categories/
   * @tags cargo-categories
   * @name CargoCategoriesList
   * @request GET:/api/v1/cargo-categories/
   * @secure
   * @response `200` `PaginatedCargoCategoryList`
   */
  export namespace CargoCategoriesList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * * `WEIGHT` - Weight
       * * `LENGTH` - Length
       * * `VOLUME` - Volume
       * * `CUSTOM` - Custom
       */
      kind?: CargoCategoryKindEnum;
      name?: string;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
      /**
       * * `KG` - kg
       * * `M` - m
       * * `M3` - m³
       */
      unit?: UnitEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedCargoCategoryList;
  }

  /**
   * @description ViewSet providing CRUD operations for a cargo category. URL: /cargo-categories/
   * @tags cargo-categories
   * @name CargoCategoriesCreate
   * @request POST:/api/v1/cargo-categories/
   * @secure
   * @response `201` `CargoCategory`
   */
  export namespace CargoCategoriesCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CargoCategory;
    export type RequestHeaders = {};
    export type ResponseBody = CargoCategory;
  }

  /**
   * @description ViewSet providing CRUD operations for a cargo category. URL: /cargo-categories/
   * @tags cargo-categories
   * @name CargoCategoriesRetrieve
   * @request GET:/api/v1/cargo-categories/{id}/
   * @secure
   * @response `200` `CargoCategory`
   */
  export namespace CargoCategoriesRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this Cargo Category. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CargoCategory;
  }

  /**
   * @description ViewSet providing CRUD operations for a cargo category. URL: /cargo-categories/
   * @tags cargo-categories
   * @name CargoCategoriesUpdate
   * @request PUT:/api/v1/cargo-categories/{id}/
   * @secure
   * @response `200` `CargoCategory`
   */
  export namespace CargoCategoriesUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this Cargo Category. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = CargoCategory;
    export type RequestHeaders = {};
    export type ResponseBody = CargoCategory;
  }

  /**
   * @description ViewSet providing CRUD operations for a cargo category. URL: /cargo-categories/
   * @tags cargo-categories
   * @name CargoCategoriesPartialUpdate
   * @request PATCH:/api/v1/cargo-categories/{id}/
   * @secure
   * @response `200` `CargoCategory`
   */
  export namespace CargoCategoriesPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this Cargo Category. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedCargoCategory;
    export type RequestHeaders = {};
    export type ResponseBody = CargoCategory;
  }

  /**
   * @description ViewSet providing CRUD operations for a cargo category. URL: /cargo-categories/
   * @tags cargo-categories
   * @name CargoCategoriesDestroy
   * @request DELETE:/api/v1/cargo-categories/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace CargoCategoriesDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this Cargo Category. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace CargoItemUnits {
  /**
   * No description
   * @tags cargo-item-units
   * @name CargoItemUnitsList
   * @request GET:/api/v1/cargo-item-units/
   * @secure
   * @response `200` `PaginatedCargoItemUnitList`
   */
  export namespace CargoItemUnitsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedCargoItemUnitList;
  }

  /**
   * No description
   * @tags cargo-item-units
   * @name CargoItemUnitsCreate
   * @request POST:/api/v1/cargo-item-units/
   * @secure
   * @response `201` `CargoItemUnit`
   */
  export namespace CargoItemUnitsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CargoItemUnit;
    export type RequestHeaders = {};
    export type ResponseBody = CargoItemUnit;
  }

  /**
   * No description
   * @tags cargo-item-units
   * @name CargoItemUnitsRetrieve
   * @request GET:/api/v1/cargo-item-units/{id}/
   * @secure
   * @response `200` `CargoItemUnit`
   */
  export namespace CargoItemUnitsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this cargo item unit. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CargoItemUnit;
  }

  /**
   * No description
   * @tags cargo-item-units
   * @name CargoItemUnitsUpdate
   * @request PUT:/api/v1/cargo-item-units/{id}/
   * @secure
   * @response `200` `CargoItemUnit`
   */
  export namespace CargoItemUnitsUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this cargo item unit. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = CargoItemUnit;
    export type RequestHeaders = {};
    export type ResponseBody = CargoItemUnit;
  }

  /**
   * No description
   * @tags cargo-item-units
   * @name CargoItemUnitsPartialUpdate
   * @request PATCH:/api/v1/cargo-item-units/{id}/
   * @secure
   * @response `200` `CargoItemUnit`
   */
  export namespace CargoItemUnitsPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this cargo item unit. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedCargoItemUnit;
    export type RequestHeaders = {};
    export type ResponseBody = CargoItemUnit;
  }

  /**
   * No description
   * @tags tags
   * @name CargoItemUnitsAllList
   * @request GET:/api/v1/cargo-item-units/all/
   * @secure
   * @response `200` `(CargoItemUnit)[]`
   */
  export namespace CargoItemUnitsAllList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CargoItemUnit[];
  }
}

export namespace CarrierContacts {
  /**
   * No description
   * @tags carriers, contacts
   * @name CarrierContactsList
   * @request GET:/api/v1/carrier-contacts/
   * @secure
   * @response `200` `PaginatedContactList`
   */
  export namespace CarrierContactsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedContactList;
  }

  /**
   * No description
   * @tags carriers, contacts
   * @name CarrierContactsCreate
   * @request POST:/api/v1/carrier-contacts/
   * @secure
   * @response `201` `Contact`
   */
  export namespace CarrierContactsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Contact;
    export type RequestHeaders = {};
    export type ResponseBody = Contact;
  }

  /**
   * No description
   * @tags carriers, contacts
   * @name CarrierContactsRetrieve
   * @request GET:/api/v1/carrier-contacts/{id}/
   * @secure
   * @response `200` `Contact`
   */
  export namespace CarrierContactsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this contact. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Contact;
  }

  /**
   * No description
   * @tags carriers, contacts
   * @name CarrierContactsUpdate
   * @request PUT:/api/v1/carrier-contacts/{id}/
   * @secure
   * @response `200` `Contact`
   */
  export namespace CarrierContactsUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this contact. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = Contact;
    export type RequestHeaders = {};
    export type ResponseBody = Contact;
  }

  /**
   * No description
   * @tags carriers, contacts
   * @name CarrierContactsPartialUpdate
   * @request PATCH:/api/v1/carrier-contacts/{id}/
   * @secure
   * @response `200` `Contact`
   */
  export namespace CarrierContactsPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this contact. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedContact;
    export type RequestHeaders = {};
    export type ResponseBody = Contact;
  }

  /**
   * No description
   * @tags carriers, contacts
   * @name CarrierContactsDestroy
   * @request DELETE:/api/v1/carrier-contacts/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace CarrierContactsDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this contact. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace CarrierGroups {
  /**
   * No description
   * @tags carriers
   * @name CarrierGroupsList
   * @request GET:/api/v1/carrier-groups/
   * @secure
   * @response `200` `PaginatedCarrierGroupList`
   */
  export namespace CarrierGroupsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedCarrierGroupList;
  }

  /**
   * No description
   * @tags carriers
   * @name CarrierGroupsCreate
   * @request POST:/api/v1/carrier-groups/
   * @secure
   * @response `201` `CarrierGroup`
   */
  export namespace CarrierGroupsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CarrierGroup;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierGroup;
  }

  /**
   * No description
   * @tags carriers
   * @name CarrierGroupsRetrieve
   * @request GET:/api/v1/carrier-groups/{id}/
   * @secure
   * @response `200` `CarrierGroup`
   */
  export namespace CarrierGroupsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this carrier group. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierGroup;
  }

  /**
   * No description
   * @tags carriers
   * @name CarrierGroupsUpdate
   * @request PUT:/api/v1/carrier-groups/{id}/
   * @secure
   * @response `200` `CarrierGroup`
   */
  export namespace CarrierGroupsUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this carrier group. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = CarrierGroup;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierGroup;
  }

  /**
   * No description
   * @tags carriers
   * @name CarrierGroupsPartialUpdate
   * @request PATCH:/api/v1/carrier-groups/{id}/
   * @secure
   * @response `200` `CarrierGroup`
   */
  export namespace CarrierGroupsPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this carrier group. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedCarrierGroup;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierGroup;
  }

  /**
   * No description
   * @tags carriers
   * @name CarrierGroupsDestroy
   * @request DELETE:/api/v1/carrier-groups/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace CarrierGroupsDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this carrier group. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags carriers
   * @name CarrierGroupsAllList
   * @request GET:/api/v1/carrier-groups/all/
   * @secure
   * @response `200` `(CarrierGroupGeneralInfo)[]`
   */
  export namespace CarrierGroupsAllList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierGroupGeneralInfo[];
  }
}

export namespace CarrierStats {
  /**
   * No description
   * @tags carrier-stats
   * @name CarrierStatsCostsRetrieve
   * @request GET:/api/v1/carrier-stats/{id}/costs/
   * @secure
   * @response `200` `CarrierCostsStats`
   */
  export namespace CarrierStatsCostsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this carrier. */
      id: number;
    };
    export type RequestQuery = {
      /** @format date */
      createdAtAfter?: string;
      /** @format date */
      createdAtBefore?: string;
      interval?: IntervalEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierCostsStats;
  }

  /**
   * No description
   * @tags carrier-stats
   * @name CarrierStatsOverviewRetrieve
   * @request GET:/api/v1/carrier-stats/overview/
   * @secure
   * @response `200` `PaginatedCarrierStatsResponse`
   */
  export namespace CarrierStatsOverviewRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {
      city?: string;
      contactEmail?: string;
      country?: string;
      /** @format date */
      createdAtAfter?: string;
      /** @format date */
      createdAtBefore?: string;
      name?: string;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** @default 1 */
      page?: number;
      /** @default 20 */
      pageSize?: number;
      postCode?: string;
      /** A search term. */
      search?: string;
      street?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedCarrierStatsResponse;
  }
}

export namespace Carriers {
  /**
   * No description
   * @tags carriers
   * @name CarriersList
   * @request GET:/api/v1/carriers/
   * @secure
   * @response `200` `PaginatedCarrierList`
   */
  export namespace CarriersList {
    export type RequestParams = {};
    export type RequestQuery = {
      city?: string;
      contactEmail?: string;
      country?: string;
      name?: string;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      postCode?: string;
      /** A search term. */
      search?: string;
      street?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedCarrierList;
  }

  /**
   * No description
   * @tags carriers
   * @name CarriersCreate
   * @request POST:/api/v1/carriers/
   * @secure
   * @response `201` `Carrier`
   */
  export namespace CarriersCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CarrierCreate;
    export type RequestHeaders = {};
    export type ResponseBody = Carrier;
  }

  /**
   * No description
   * @tags carriers
   * @name CarriersRetrieve
   * @request GET:/api/v1/carriers/{id}/
   * @secure
   * @response `200` `Carrier`
   */
  export namespace CarriersRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this carrier. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Carrier;
  }

  /**
   * No description
   * @tags carriers
   * @name CarriersUpdate
   * @request PUT:/api/v1/carriers/{id}/
   * @secure
   * @response `200` `Carrier`
   */
  export namespace CarriersUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this carrier. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = CarrierUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = Carrier;
  }

  /**
   * No description
   * @tags carriers
   * @name CarriersPartialUpdate
   * @request PATCH:/api/v1/carriers/{id}/
   * @secure
   * @response `200` `Carrier`
   */
  export namespace CarriersPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this carrier. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedCarrierUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = Carrier;
  }

  /**
   * No description
   * @tags carriers
   * @name CarriersDestroy
   * @request DELETE:/api/v1/carriers/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace CarriersDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this carrier. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags carriers
   * @name CarriersContactsList
   * @request GET:/api/v1/carriers/{id}/contacts/
   * @secure
   * @response `200` `(ContactGeneralInfo)[]`
   */
  export namespace CarriersContactsList {
    export type RequestParams = {
      /** A unique integer value identifying this carrier. */
      id: number;
    };
    export type RequestQuery = {
      /** Filter contacts by transportation mode. Contacts with no modes set are always included. */
      transportationMode?: TransportationModeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContactGeneralInfo[];
  }

  /**
   * No description
   * @tags carriers
   * @name CarriersIsActivePartialUpdate
   * @request PATCH:/api/v1/carriers/{id}/is_active/
   * @secure
   * @response `200` `Carrier`
   */
  export namespace CarriersIsActivePartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this carrier. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedCarrierUpdateIsActive;
    export type RequestHeaders = {};
    export type ResponseBody = Carrier;
  }

  /**
   * No description
   * @tags carriers
   * @name CarriersAllList
   * @request GET:/api/v1/carriers/all/
   * @secure
   * @response `200` `(CarrierGeneralInfo)[]`
   */
  export namespace CarriersAllList {
    export type RequestParams = {};
    export type RequestQuery = {
      city?: string;
      contactEmail?: string;
      country?: string;
      name?: string;
      /** Which field to use when ordering the results. */
      ordering?: string;
      postCode?: string;
      /** A search term. */
      search?: string;
      street?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierGeneralInfo[];
  }

  /**
   * No description
   * @tags carriers
   * @name CarriersAutocompleteCreate
   * @request POST:/api/v1/carriers/autocomplete/
   * @secure
   * @response `200` `AutocompleteResponse`
   */
  export namespace CarriersAutocompleteCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AutocompleteRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AutocompleteResponse;
  }

  /**
   * No description
   * @tags carriers
   * @name CarriersValidateFirstStepCreate
   * @request POST:/api/v1/carriers/validate-first-step/
   * @secure
   * @response `200` `CarrierCreateFirstStep`
   */
  export namespace CarriersValidateFirstStepCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CarrierCreateFirstStep;
    export type RequestHeaders = {};
    export type ResponseBody = CarrierCreateFirstStep;
  }
}

export namespace ContractModulePromo {
  /**
   * @description Permanently dismiss the promo banner for the current user.
   * @tags module-promo
   * @name ContractModulePromoDismissCreate
   * @request POST:/api/v1/contract-module-promo/dismiss/
   * @secure
   * @response `200` `ModulePromoState`
   */
  export namespace ContractModulePromoDismissCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModulePromoState;
  }

  /**
   * @description Send a module demo inquiry to support (throttled per user).
   * @tags module-promo
   * @name ContractModulePromoSendInquiryCreate
   * @request POST:/api/v1/contract-module-promo/send-inquiry/
   * @secure
   * @response `200` `ModulePromoState`
   * @response `400` `void` Throttled (inquiry sent recently), no workspace, or module already enabled.
   */
  export namespace ContractModulePromoSendInquiryCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModulePromoState;
  }

  /**
   * @description Return the module promo banner state for the current user.
   * @tags module-promo
   * @name ContractModulePromoStateRetrieve
   * @request GET:/api/v1/contract-module-promo/state/
   * @secure
   * @response `200` `ModulePromoState`
   */
  export namespace ContractModulePromoStateRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModulePromoState;
  }
}

export namespace Contracts {
  /**
   * @description ViewSet for Contract operations. URL: /api/v1/contracts/
   * @tags contracts
   * @name ContractsList
   * @request GET:/api/v1/contracts/
   * @secure
   * @response `200` `PaginatedContractListList`
   */
  export namespace ContractsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Carrier name */
      carrierName?: string;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** Responsible person */
      responsibleUser?: number;
      /** A search term. */
      search?: string;
      /**
       * Status
       *
       * * `SCHEDULED` - Scheduled
       * * `ACTIVE` - Active
       * * `EXPIRED` - Expired
       * * `CANCELED` - Canceled
       */
      status?: ContractStatusEnum;
      /** Tender name */
      tenderName?: string;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
      /**
       * Valid from
       * @format date
       */
      validFromAfter?: string;
      /**
       * Valid from
       * @format date
       */
      validFromBefore?: string;
      /**
       * Valid to
       * @format date
       */
      validToAfter?: string;
      /**
       * Valid to
       * @format date
       */
      validToBefore?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedContractListList;
  }

  /**
   * @description ViewSet for Contract operations. URL: /api/v1/contracts/
   * @tags contracts
   * @name ContractsRetrieve
   * @request GET:/api/v1/contracts/{id}/
   * @secure
   * @response `200` `ContractDetail`
   */
  export namespace ContractsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this contract. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractDetail;
  }

  /**
   * @description Cancel a contract. URL: /api/v1/contracts/{id}/cancel/
   * @tags contracts
   * @name ContractsCancel
   * @request POST:/api/v1/contracts/{id}/cancel/
   * @secure
   * @response `200` `ContractAction`
   * @response `400` `void` No response body
   * @response `404` `void` No response body
   */
  export namespace ContractsCancel {
    export type RequestParams = {
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractAction;
  }

  /**
   * @description ViewSet for Contract operations. URL: /api/v1/contracts/
   * @tags contracts
   * @name ContractsRoutesList
   * @request GET:/api/v1/contracts/{id}/routes/
   * @secure
   * @response `200` `PaginatedContractRouteRowList`
   */
  export namespace ContractsRoutesList {
    export type RequestParams = {
      /** A unique integer value identifying this contract. */
      id: number;
    };
    export type RequestQuery = {
      /** Carrier name */
      carrierName?: string;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** Responsible person */
      responsibleUser?: number;
      /** A search term. */
      search?: string;
      /**
       * Status
       *
       * * `SCHEDULED` - Scheduled
       * * `ACTIVE` - Active
       * * `EXPIRED` - Expired
       * * `CANCELED` - Canceled
       */
      status?: ContractStatusEnum;
      /** Tender name */
      tenderName?: string;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
      /**
       * Valid from
       * @format date
       */
      validFromAfter?: string;
      /**
       * Valid from
       * @format date
       */
      validFromBefore?: string;
      /**
       * Valid to
       * @format date
       */
      validToAfter?: string;
      /**
       * Valid to
       * @format date
       */
      validToBefore?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedContractRouteRowList;
  }

  /**
   * @description ViewSet for Contract operations. URL: /api/v1/contracts/
   * @tags contracts
   * @name ContractsRoutesAutocomplete
   * @request GET:/api/v1/contracts/{id}/routes/autocomplete/
   * @secure
   * @response `200` `AutocompleteResponse`
   * @response `400` `void` No response body
   */
  export namespace ContractsRoutesAutocomplete {
    export type RequestParams = {
      /** A unique integer value identifying this contract. */
      id: number;
    };
    export type RequestQuery = {
      /**
       * * `city` - city
       * * `post_code` - post_code
       * * `street` - street
       */
      field: ContractsRoutesAutocompleteFieldEnum;
      /** @minLength 1 */
      term: string;
      /**
       * * `PICKUP` - Pickup
       * * `DELIVERY` - Delivery
       */
      waypointType: WaypointTypeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AutocompleteResponse;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags contracts
   * @name ContractsMatchingCheckOptionCreate
   * @request POST:/api/v1/contracts/matching/check-option/
   * @secure
   * @response `200` `ContractOptionEvaluation`
   */
  export namespace ContractsMatchingCheckOptionCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MatchingCheckOptionInput;
    export type RequestHeaders = {};
    export type ResponseBody = ContractOptionEvaluation;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags contracts
   * @name ContractsMatchingEvaluateCreate
   * @request POST:/api/v1/contracts/matching/evaluate/
   * @secure
   * @response `200` `PaginatedContractOptionRowList`
   */
  export namespace ContractsMatchingEvaluateCreate {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Carrier */
      carrierId?: number;
      /** Carrier name */
      carrierName?: string;
      /** Delivery city */
      deliveryCity?: string;
      /** Delivery country */
      deliveryCountry?: string;
      /** Delivery post code */
      deliveryPostCode?: string;
      /** Delivery street */
      deliveryStreet?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** Pickup city */
      pickupCity?: string;
      /** Pickup country */
      pickupCountry?: string;
      /** Pickup post code */
      pickupPostCode?: string;
      /** Pickup street */
      pickupStreet?: string;
      /** Price category */
      priceCategoryId?: number;
      /** Route */
      routeId?: number;
      /** Route identifier */
      routeIdentifier?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = MatchingEvaluateInput;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedContractOptionRowList;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags contracts
   * @name ContractsOptionsList
   * @request GET:/api/v1/contracts/options/
   * @secure
   * @response `200` `PaginatedContractOptionRowList`
   * @response `400` `void` No response body
   */
  export namespace ContractsOptionsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Carrier */
      carrierId?: number;
      /** Carrier name */
      carrierName?: string;
      /**
       * Start date for active contract filtering (YYYY-MM-DD).
       * @format date
       */
      date: string;
      /**
       * End date for active contract filtering (YYYY-MM-DD). Defaults to date when omitted.
       * @format date
       */
      dateEnd?: string;
      /** Delivery city */
      deliveryCity?: string;
      /** Delivery country */
      deliveryCountry?: string;
      /** Delivery post code */
      deliveryPostCode?: string;
      /** Delivery street */
      deliveryStreet?: string;
      /**
       * Route distance in km (e.g. 123.45). Required for per-km effective price calculation.
       * @min 0
       * @exclusiveMin true
       */
      distance?: number;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** Pickup city */
      pickupCity?: string;
      /** Pickup country */
      pickupCountry?: string;
      /** Pickup post code */
      pickupPostCode?: string;
      /** Pickup street */
      pickupStreet?: string;
      /** Price category */
      priceCategoryId?: number;
      /** Route */
      routeId?: number;
      /** Route identifier */
      routeIdentifier?: string;
      /** Search */
      search?: string;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedContractOptionRowList;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags contracts
   * @name ContractsOptionsAutocomplete
   * @request GET:/api/v1/contracts/options/autocomplete/
   * @secure
   * @response `200` `AutocompleteResponse`
   * @response `400` `void` No response body
   */
  export namespace ContractsOptionsAutocomplete {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date */
      date: string;
      /** @format date */
      dateEnd?: string;
      /**
       * * `city` - city
       * * `post_code` - post_code
       * * `street` - street
       */
      field: ContractsOptionsAutocompleteFieldEnum;
      /** @minLength 1 */
      term: string;
      /**
       * * `PICKUP` - Pickup
       * * `DELIVERY` - Delivery
       */
      waypointType: WaypointTypeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AutocompleteResponse;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags contracts
   * @name ContractsOptionsFilters
   * @request GET:/api/v1/contracts/options/filters/
   * @secure
   * @response `200` `ContractOptionsFilters`
   */
  export namespace ContractsOptionsFilters {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date */
      date: string;
      /** @format date */
      dateEnd?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractOptionsFilters;
  }

  /**
   * @description Listing for tenders. URL: /contracts/tenders/
   * @tags contracts
   * @name ContractsTendersList
   * @request GET:/api/v1/contracts/tenders/
   * @secure
   * @response `200` `PaginatedTenderListList`
   */
  export namespace ContractsTendersList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * * `EUR` - EUR
       * * `USD` - USD
       * * `CZK` - CZK
       * * `HUF` - HUF
       * * `PLN` - PLN
       * * `RON` - RON
       * * `GBP` - GBP
       * * `NOK` - NOK
       * * `DKK` - DKK
       * * `SEK` - SEK
       * * `ISK` - ISK
       * * `CHF` - CHF
       * * `CNY` - CNY
       */
      currency?: CurrencyEnum;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      search?: string;
      /**
       * Status
       *
       * * `DRAFT` - Draft
       * * `OPEN` - Open
       * * `EVALUATING` - Evaluating
       * * `FINISHED` - Finished
       * * `CANCELED` - Canceled
       */
      status?: TenderDisplayStatusEnum;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum[];
      /**
       * Valid from
       * @format date
       */
      validFromAfter?: string;
      /**
       * Valid from
       * @format date
       */
      validFromBefore?: string;
      /**
       * Valid to
       * @format date
       */
      validToAfter?: string;
      /**
       * Valid to
       * @format date
       */
      validToBefore?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedTenderListList;
  }

  /**
   * @description Listing for tenders. URL: /contracts/tenders/
   * @tags contracts
   * @name ContractsTendersRetrieve
   * @request GET:/api/v1/contracts/tenders/{id}/
   * @secure
   * @response `200` `TenderDetail`
   */
  export namespace ContractsTendersRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TenderDetail;
  }

  /**
   * @description Soft-delete a tender. Only allowed for tenders in DRAFT or CANCELED status. URL: /contracts/tenders/{id}/
   * @tags contracts
   * @name ContractsTendersDestroy
   * @request DELETE:/api/v1/contracts/tenders/{id}/
   * @secure
   * @response `204` `void` No response body
   * @response `400` `Record<string,any>`
   */
  export namespace ContractsTendersDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Cancel a tender. Admin-only action. URL: /contracts/tenders/{id}/cancel/
   * @tags contracts
   * @name ContractsTendersCancel
   * @request POST:/api/v1/contracts/tenders/{id}/cancel/
   * @secure
   * @response `200` `void` No response body
   * @response `400` `Record<string,any>`
   */
  export namespace ContractsTendersCancel {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description List contract proposals grouped by carrier for a tender. URL: /contracts/tenders/{id}/contract-proposals/
   * @tags contracts
   * @name ContractsTendersContractProposals
   * @request GET:/api/v1/contracts/tenders/{id}/contract-proposals/
   * @secure
   * @response `200` `(ContractProposalList)[]`
   */
  export namespace ContractsTendersContractProposals {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {
      /**
       * * `EUR` - EUR
       * * `USD` - USD
       * * `CZK` - CZK
       * * `HUF` - HUF
       * * `PLN` - PLN
       * * `RON` - RON
       * * `GBP` - GBP
       * * `NOK` - NOK
       * * `DKK` - DKK
       * * `SEK` - SEK
       * * `ISK` - ISK
       * * `CHF` - CHF
       * * `CNY` - CNY
       */
      currency?: CurrencyEnum;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
      /**
       * Status
       *
       * * `DRAFT` - Draft
       * * `OPEN` - Open
       * * `EVALUATING` - Evaluating
       * * `FINISHED` - Finished
       * * `CANCELED` - Canceled
       */
      status?: TenderDisplayStatusEnum;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum[];
      /**
       * Valid from
       * @format date
       */
      validFromAfter?: string;
      /**
       * Valid from
       * @format date
       */
      validFromBefore?: string;
      /**
       * Valid to
       * @format date
       */
      validToAfter?: string;
      /**
       * Valid to
       * @format date
       */
      validToBefore?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractProposalList[];
  }

  /**
   * @description Retrieve contract proposal for a specific carrier on a tender. URL: /contracts/tenders/{id}/contract-proposals/{carrier_id}/?route_id=1&vehicle_type_id=2
   * @tags contracts
   * @name ContractsTendersContractProposalDetail
   * @request GET:/api/v1/contracts/tenders/{id}/contract-proposals/{carrier_id}/
   * @secure
   * @response `200` `ContractProposalDetail`
   * @response `204` `void` No response body
   */
  export namespace ContractsTendersContractProposalDetail {
    export type RequestParams = {
      /** @pattern ^\d+$ */
      carrierId: string;
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {
      /** Filter by route ID */
      routeId?: number;
      /** Filter by vehicle type ID */
      vehicleTypeId?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ContractProposalDetail;
  }

  /**
   * @description List contracts grouped by carrier for a tender. URL: /contracts/tenders/{id}/contracts/
   * @tags contracts
   * @name ContractsTendersContracts
   * @request GET:/api/v1/contracts/tenders/{id}/contracts/
   * @secure
   * @response `200` `(TenderContractList)[]`
   */
  export namespace ContractsTendersContracts {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {
      /**
       * * `EUR` - EUR
       * * `USD` - USD
       * * `CZK` - CZK
       * * `HUF` - HUF
       * * `PLN` - PLN
       * * `RON` - RON
       * * `GBP` - GBP
       * * `NOK` - NOK
       * * `DKK` - DKK
       * * `SEK` - SEK
       * * `ISK` - ISK
       * * `CHF` - CHF
       * * `CNY` - CNY
       */
      currency?: CurrencyEnum;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
      /**
       * Status
       *
       * * `DRAFT` - Draft
       * * `OPEN` - Open
       * * `EVALUATING` - Evaluating
       * * `FINISHED` - Finished
       * * `CANCELED` - Canceled
       */
      status?: TenderDisplayStatusEnum;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum[];
      /**
       * Valid from
       * @format date
       */
      validFromAfter?: string;
      /**
       * Valid from
       * @format date
       */
      validFromBefore?: string;
      /**
       * Valid to
       * @format date
       */
      validToAfter?: string;
      /**
       * Valid to
       * @format date
       */
      validToBefore?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TenderContractList[];
  }

  /**
   * @description Return the total number of documents, contract proposals and confirmed contracts for a tender.
   * @tags contracts
   * @name ContractsTendersCounts
   * @request GET:/api/v1/contracts/tenders/{id}/counts/
   * @secure
   * @response `200` `TenderCountsResponse`
   */
  export namespace ContractsTendersCounts {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TenderCountsResponse;
  }

  /**
   * @description Listing for tenders. URL: /contracts/tenders/
   * @tags contracts
   * @name ContractsTendersFiltersRetrieve
   * @request GET:/api/v1/contracts/tenders/{id}/filters/
   * @secure
   * @response `200` `TenderDetailFilters`
   */
  export namespace ContractsTendersFiltersRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TenderDetailFilters;
  }

  /**
   * @description Finish a tender. Admin + Regular User action. URL: /contracts/tenders/{id}/finish/
   * @tags contracts
   * @name ContractsTendersFinish
   * @request POST:/api/v1/contracts/tenders/{id}/finish/
   * @secure
   * @response `200` `void` No response body
   * @response `400` `Record<string,any>`
   */
  export namespace ContractsTendersFinish {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Listing for tenders. URL: /contracts/tenders/
   * @tags contracts
   * @name ContractsTendersOfferExport
   * @request GET:/api/v1/contracts/tenders/{id}/offer-export/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace ContractsTendersOfferExport {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Overview of the tender creation steps. URL: /contracts/tenders/{id}/overview/
   * @tags contracts
   * @name ContractsTendersOverview
   * @request GET:/api/v1/contracts/tenders/{id}/overview/
   * @secure
   * @response `200` `TenderOverviewResponse`
   */
  export namespace ContractsTendersOverview {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TenderOverviewResponse;
  }

  /**
   * @description Paginated price offers (cells + routes) for a tender. URL: /contracts/tenders/{id}/price-offers/
   * @tags contracts
   * @name ContractsTendersPriceOffers
   * @request GET:/api/v1/contracts/tenders/{id}/price-offers/
   * @secure
   * @response `200` `TenderPriceOffersResponse`
   */
  export namespace ContractsTendersPriceOffers {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {
      carrierId?: number;
      deliveryCity?: string;
      deliveryCountry?: string;
      deliveryPostCode?: string;
      page?: number;
      pageSize?: number;
      participated?: boolean;
      pickupCity?: string;
      pickupCountry?: string;
      pickupPostCode?: string;
      priceCategoryId?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TenderPriceOffersResponse;
  }

  /**
   * @description Send contract proposals for selected carrier offers. URL: /contracts/tenders/{id}/propose-contract/
   * @tags contracts
   * @name ContractsTendersProposeContract
   * @request POST:/api/v1/contracts/tenders/{id}/propose-contract/
   * @secure
   * @response `200` `void` No response body
   * @response `400` `Record<string,any>`
   */
  export namespace ContractsTendersProposeContract {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = ProposeContract;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Publish a tender draft. URL: /contracts/tenders/{id}/publish/
   * @tags contracts
   * @name ContractsTendersPublish
   * @request POST:/api/v1/contracts/tenders/{id}/publish/
   * @secure
   * @response `200` `void` No response body
   * @response `400` `Record<string,any>`
   */
  export namespace ContractsTendersPublish {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Revert all contract proposal offers for a carrier back to pending state. URL: /contracts/tenders/{id}/revert-contract-proposals/{carrier_id}/
   * @tags contracts
   * @name ContractsTendersRevertContractProposals
   * @request POST:/api/v1/contracts/tenders/{id}/revert-contract-proposals/{carrier_id}/
   * @secure
   * @response `200` `void` No response body
   * @response `400` `Record<string,any>`
   */
  export namespace ContractsTendersRevertContractProposals {
    export type RequestParams = {
      /** @pattern ^\d+$ */
      carrierId: string;
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Save the fourth step of the tender creation (carriers). URL: /contracts/tenders/{id}/save-fourth-step/
   * @tags contracts
   * @name ContractsTendersSaveFourthStep
   * @request POST:/api/v1/contracts/tenders/{id}/save-fourth-step/
   * @secure
   * @response `200` `TenderFourthStepCarriers`
   */
  export namespace ContractsTendersSaveFourthStep {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = TenderFourthStepCarriers;
    export type RequestHeaders = {};
    export type ResponseBody = TenderFourthStepCarriers;
  }

  /**
   * @description Save the second step of the tender creation (routes). URL: /contracts/tenders/{id}/save-second-step/
   * @tags contracts
   * @name ContractsTendersSaveSecondStep
   * @request POST:/api/v1/contracts/tenders/{id}/save-second-step/
   * @secure
   * @response `200` `TenderSecondStepRoutes`
   */
  export namespace ContractsTendersSaveSecondStep {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = TenderSecondStepRoutes;
    export type RequestHeaders = {};
    export type ResponseBody = TenderSecondStepRoutes;
  }

  /**
   * @description Save the third step of the tender creation (pricing categories). URL: /contracts/tenders/{id}/save-third-step/
   * @tags contracts
   * @name ContractsTendersSaveThirdStep
   * @request POST:/api/v1/contracts/tenders/{id}/save-third-step/
   * @secure
   * @response `200` `TenderThirdStepPricingCategories`
   */
  export namespace ContractsTendersSaveThirdStep {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = TenderThirdStepPricingCategories;
    export type RequestHeaders = {};
    export type ResponseBody = TenderThirdStepPricingCategories;
  }

  /**
   * @description Update a published (OPEN/EVALUATING) tender. URL: /contracts/tenders/{id}/update/
   * @tags contracts
   * @name ContractsTendersUpdate
   * @request POST:/api/v1/contracts/tenders/{id}/update/
   * @secure
   * @response `200` `TenderDetail`
   * @response `400` `Record<string,any>`
   */
  export namespace ContractsTendersUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = TenderUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = TenderDetail;
  }

  /**
   * @description Validate whether a tender can be finished. URL: /contracts/tenders/{id}/validate-finish/
   * @tags contracts
   * @name ContractsTendersValidateFinish
   * @request POST:/api/v1/contracts/tenders/{id}/validate-finish/
   * @secure
   * @response `200` `void` No response body
   * @response `400` `Record<string,any>`
   */
  export namespace ContractsTendersValidateFinish {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Validate whether a tender is ready to be published. URL: /contracts/tenders/{id}/validate-publish/
   * @tags contracts
   * @name ContractsTendersValidatePublish
   * @request POST:/api/v1/contracts/tenders/{id}/validate-publish/
   * @secure
   * @response `200` `void` No response body
   * @response `400` `Record<string,any>`
   */
  export namespace ContractsTendersValidatePublish {
    export type RequestParams = {
      /** A unique integer value identifying this tender. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
   * @tags documents
   * @name ContractsTendersDocumentsList
   * @request GET:/api/v1/contracts/tenders/{tender_pk}/documents/
   * @secure
   * @response `200` `PaginatedDocumentList`
   */
  export namespace ContractsTendersDocumentsList {
    export type RequestParams = {
      tenderPk: number;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedDocumentList;
  }

  /**
   * @description Messages for a specific tender (shipper-facing).
   * @tags messages
   * @name ContractsTendersMessagesList
   * @request GET:/api/v1/contracts/tenders/{tender_pk}/messages/
   * @secure
   * @response `200` `PaginatedMessageList`
   */
  export namespace ContractsTendersMessagesList {
    export type RequestParams = {
      tenderPk: number;
    };
    export type RequestQuery = {
      carrier?: number;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedMessageList;
  }

  /**
   * @description Messages for a specific tender (shipper-facing).
   * @tags messages
   * @name ContractsTendersMessagesCreate
   * @request POST:/api/v1/contracts/tenders/{tender_pk}/messages/
   * @secure
   * @response `201` `Message`
   */
  export namespace ContractsTendersMessagesCreate {
    export type RequestParams = {
      tenderPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = Message;
    export type RequestHeaders = {};
    export type ResponseBody = Message;
  }

  /**
   * @description Messages for a specific tender (shipper-facing).
   * @tags messages
   * @name ContractsTendersMessagesCarriersList
   * @request GET:/api/v1/contracts/tenders/{tender_pk}/messages/carriers/
   * @secure
   * @response `200` `(TenderCarrierConversation)[]`
   */
  export namespace ContractsTendersMessagesCarriersList {
    export type RequestParams = {
      tenderPk: number;
    };
    export type RequestQuery = {
      carrier?: number;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TenderCarrierConversation[];
  }

  /**
   * @description Messages for a specific tender (shipper-facing).
   * @tags messages
   * @name ContractsTendersMessagesMarkAsReadCreate
   * @request POST:/api/v1/contracts/tenders/{tender_pk}/messages/mark-as-read/
   * @secure
   * @response `200` `MarkAsReadMessage`
   */
  export namespace ContractsTendersMessagesMarkAsReadCreate {
    export type RequestParams = {
      tenderPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = MarkAsReadMessage;
    export type RequestHeaders = {};
    export type ResponseBody = MarkAsReadMessage;
  }

  /**
   * @description Messages for a specific tender (shipper-facing).
   * @tags messages
   * @name ContractsTendersMessagesUnreadCountRetrieve
   * @request GET:/api/v1/contracts/tenders/{tender_pk}/messages/unread-count/
   * @secure
   * @response `200` `number`
   */
  export namespace ContractsTendersMessagesUnreadCountRetrieve {
    export type RequestParams = {
      tenderPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = number;
  }

  /**
   * @description Save the first step of the tender creation. Creates a new DRAFT tender when ``tender_id`` is not provided, otherwise updates the existing DRAFT tender so re-submitting step 1 from the wizard does not produce duplicate records. URL: /contracts/tenders/save-first-step/
   * @tags contracts
   * @name ContractsTendersSaveFirstStepCreate
   * @request POST:/api/v1/contracts/tenders/save-first-step/
   * @secure
   * @response `200` `TenderFirstStep`
   */
  export namespace ContractsTendersSaveFirstStepCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TenderFirstStep;
    export type RequestHeaders = {};
    export type ResponseBody = TenderFirstStep;
  }
}

export namespace Documents {
  /**
   * No description
   * @tags documents
   * @name DocumentsList
   * @request GET:/api/v1/documents/
   * @secure
   * @response `200` `PaginatedDocumentList`
   */
  export namespace DocumentsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedDocumentList;
  }

  /**
   * No description
   * @tags documents
   * @name DocumentsCreate
   * @request POST:/api/v1/documents/
   * @secure
   * @response `201` `Document`
   */
  export namespace DocumentsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DocumentCreate;
    export type RequestHeaders = {};
    export type ResponseBody = Document;
  }

  /**
   * No description
   * @tags documents
   * @name DocumentsRetrieve
   * @request GET:/api/v1/documents/{id}/
   * @secure
   * @response `200` `Document`
   */
  export namespace DocumentsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this document. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Document;
  }

  /**
   * No description
   * @tags documents
   * @name DocumentsUpdate
   * @request PUT:/api/v1/documents/{id}/
   * @secure
   * @response `200` `Document`
   */
  export namespace DocumentsUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this document. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = DocumentUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = Document;
  }

  /**
   * No description
   * @tags documents
   * @name DocumentsPartialUpdate
   * @request PATCH:/api/v1/documents/{id}/
   * @secure
   * @response `200` `DocumentUpdate`
   */
  export namespace DocumentsPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this document. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedDocumentUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = DocumentUpdate;
  }

  /**
   * No description
   * @tags documents
   * @name DocumentsDestroy
   * @request DELETE:/api/v1/documents/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace DocumentsDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this document. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace FeatureFlags {
  /**
   * No description
   * @tags core
   * @name FeatureFlagsStatusRetrieve
   * @request GET:/api/v1/feature-flags/status
   * @secure
   * @response `200` `FeatureFlagsStatus`
   */
  export namespace FeatureFlagsStatusRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FeatureFlagsStatus;
  }
}

export namespace FieldRules {
  /**
   * No description
   * @tags field-rules
   * @name FieldRulesRetrieve
   * @request GET:/api/v1/field-rules/{target_form}/
   * @secure
   * @response `200` `FieldRulesResponse`
   * @response `404` `void` Unknown target_form
   */
  export namespace FieldRulesRetrieve {
    export type RequestParams = {
      /** * `transport_request` - Transport request form */
      targetForm: FieldRulesFormEnum;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FieldRulesResponse;
  }
}

export namespace Info {
  /**
   * No description
   * @tags core
   * @name InfoRetrieve
   * @request GET:/api/v1/info/
   * @secure
   * @response `200` `AppInfo`
   */
  export namespace InfoRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AppInfo;
  }
}

export namespace Invitations {
  /**
   * No description
   * @tags invitations
   * @name InvitationsAcceptCreate
   * @request POST:/api/v1/invitations/accept/
   * @secure
   * @response `200` `JWT`
   */
  export namespace InvitationsAcceptCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AcceptInvitation;
    export type RequestHeaders = {};
    export type ResponseBody = JWT;
  }

  /**
   * No description
   * @tags invitations
   * @name InvitationsAcceptByUserCreate
   * @request POST:/api/v1/invitations/accept-by-user/
   * @secure
   * @response `200` `boolean`
   */
  export namespace InvitationsAcceptByUserCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ModifyInvitationByUser;
    export type RequestHeaders = {};
    export type ResponseBody = boolean;
  }

  /**
   * No description
   * @tags invitations
   * @name InvitationsBulkInviteCreate
   * @request POST:/api/v1/invitations/bulk-invite/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace InvitationsBulkInviteCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BulkInvitation;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags invitations
   * @name InvitationsPendingList
   * @request GET:/api/v1/invitations/pending/
   * @secure
   * @response `200` `(Invitation)[]`
   */
  export namespace InvitationsPendingList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Invitation[];
  }

  /**
   * No description
   * @tags invitations
   * @name InvitationsPendingByUserList
   * @request GET:/api/v1/invitations/pending-by-user/
   * @secure
   * @response `200` `(WorkspaceInvitation)[]`
   */
  export namespace InvitationsPendingByUserList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WorkspaceInvitation[];
  }

  /**
   * No description
   * @tags invitations
   * @name InvitationsRejectByUserCreate
   * @request POST:/api/v1/invitations/reject-by-user/
   * @secure
   * @response `200` `boolean`
   */
  export namespace InvitationsRejectByUserCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ModifyInvitationByUser;
    export type RequestHeaders = {};
    export type ResponseBody = boolean;
  }

  /**
   * No description
   * @tags invitations
   * @name InvitationsRemoveCreate
   * @request POST:/api/v1/invitations/remove/
   * @secure
   * @response `200` `boolean`
   */
  export namespace InvitationsRemoveCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = InvitationsRemoveCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = boolean;
  }
}

export namespace Locations {
  /**
   * No description
   * @tags locations
   * @name LocationsStaticMapCreate
   * @request POST:/api/v1/locations/static-map/
   * @secure
   * @response `200` `LocationData`
   */
  export namespace LocationsStaticMapCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TranslateLocations;
    export type RequestHeaders = {};
    export type ResponseBody = LocationData;
  }

  /**
   * No description
   * @tags locations
   * @name LocationsTranslateCreate
   * @request POST:/api/v1/locations/translate/
   * @secure
   * @response `200` `LocationData`
   */
  export namespace LocationsTranslateCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TranslateLocations;
    export type RequestHeaders = {};
    export type ResponseBody = LocationData;
  }
}

export namespace Messages {
  /**
   * @description List the inbox newest-first, one message per conversation (cursor paginated).
   * @tags messages
   * @name MessagesList
   * @request GET:/api/v1/messages/
   * @secure
   * @response `200` `PaginatedUserMessageList`
   */
  export namespace MessagesList {
    export type RequestParams = {};
    export type RequestQuery = {
      carrier?: number;
      /** The pagination cursor value. */
      cursor?: string;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedUserMessageList;
  }

  /**
   * @description Cursor-paginated cross-timeline message inbox.
   * @tags messages
   * @name MessagesMarkAsReadCreate
   * @request POST:/api/v1/messages/{id}/mark_as_read/
   * @secure
   * @response `200` `void` No response body
   */
  export namespace MessagesMarkAsReadCreate {
    export type RequestParams = {
      /** A unique integer value identifying this message. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Cursor-paginated cross-timeline message inbox.
   * @tags messages
   * @name MessagesMarkAllAsReadCreate
   * @request POST:/api/v1/messages/mark-all-as-read/
   * @secure
   * @response `200` `string`
   */
  export namespace MessagesMarkAllAsReadCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description Cursor-paginated cross-timeline message inbox.
   * @tags messages
   * @name MessagesUnreadCountRetrieve
   * @request GET:/api/v1/messages/unread-count/
   * @secure
   * @response `200` `number`
   */
  export namespace MessagesUnreadCountRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = number;
  }
}

export namespace MicrosoftGraph {
  /**
   * No description
   * @tags microsoft-graph
   * @name MicrosoftGraphAccessTokenCreate
   * @request POST:/api/v1/microsoft-graph/access_token/
   * @secure
   * @response `200` `MicrosoftAccessToken`
   */
  export namespace MicrosoftGraphAccessTokenCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MicrosoftTenant;
    export type RequestHeaders = {};
    export type ResponseBody = MicrosoftAccessToken;
  }

  /**
   * No description
   * @tags microsoft-graph
   * @name MicrosoftGraphGroupsCreate
   * @request POST:/api/v1/microsoft-graph/groups/
   * @secure
   * @response `200` `(MicrosoftGroup)[]`
   */
  export namespace MicrosoftGraphGroupsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MicrosoftTenant;
    export type RequestHeaders = {};
    export type ResponseBody = MicrosoftGroup[];
  }

  /**
   * No description
   * @tags microsoft-graph
   * @name MicrosoftGraphMembersCreate
   * @request POST:/api/v1/microsoft-graph/members/
   * @secure
   * @response `200` `(MicrosoftMember)[]`
   */
  export namespace MicrosoftGraphMembersCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MicrosoftMembersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = MicrosoftMember[];
  }
}

export namespace Notifications {
  /**
   * @description ViewSet for listing and marking notifications as read. Returns all notifications by default. If yoy want to get read/unread notifications, use the filter `is_read`.
   * @tags notifications
   * @name NotificationsList
   * @request GET:/api/v1/notifications/
   * @secure
   * @response `200` `PaginatedNotificationList`
   */
  export namespace NotificationsList {
    export type RequestParams = {};
    export type RequestQuery = {
      isRead?: boolean;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedNotificationList;
  }

  /**
   * @description ViewSet for listing and marking notifications as read. Returns all notifications by default. If yoy want to get read/unread notifications, use the filter `is_read`.
   * @tags notifications
   * @name NotificationsRetrieve
   * @request GET:/api/v1/notifications/{id}/
   * @secure
   * @response `200` `Notification`
   */
  export namespace NotificationsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this notification. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Notification;
  }

  /**
   * @description ViewSet for listing and marking notifications as read. Returns all notifications by default. If yoy want to get read/unread notifications, use the filter `is_read`.
   * @tags notifications
   * @name NotificationsMarkAsReadCreate
   * @request POST:/api/v1/notifications/{id}/mark-as-read/
   * @secure
   * @response `200` `string`
   */
  export namespace NotificationsMarkAsReadCreate {
    export type RequestParams = {
      /** A unique integer value identifying this notification. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description ViewSet for listing and marking notifications as read. Returns all notifications by default. If yoy want to get read/unread notifications, use the filter `is_read`.
   * @tags notifications
   * @name NotificationsMarkAllAsReadCreate
   * @request POST:/api/v1/notifications/mark-all-as-read/
   * @secure
   * @response `200` `string`
   */
  export namespace NotificationsMarkAllAsReadCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description ViewSet for listing and marking notifications as read. Returns all notifications by default. If yoy want to get read/unread notifications, use the filter `is_read`.
   * @tags notifications
   * @name NotificationsUserSettingsRetrieve
   * @request GET:/api/v1/notifications/user-settings/
   * @secure
   * @response `200` `UserNotificationSettings`
   */
  export namespace NotificationsUserSettingsRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserNotificationSettings;
  }

  /**
   * @description ViewSet for listing and marking notifications as read. Returns all notifications by default. If yoy want to get read/unread notifications, use the filter `is_read`.
   * @tags notifications
   * @name NotificationsUserSettingsCreate
   * @request POST:/api/v1/notifications/user-settings/
   * @secure
   * @response `200` `UserNotificationSettings`
   */
  export namespace NotificationsUserSettingsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UserNotificationSettings;
    export type RequestHeaders = {};
    export type ResponseBody = UserNotificationSettings;
  }
}

export namespace Options {
  /**
   * No description
   * @tags options
   * @name OptionsCargoCategoryKindsRetrieve
   * @request GET:/api/v1/options/cargo-category-kinds/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsCargoCategoryKindsRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsCargoCategoryUnitsRetrieve
   * @request GET:/api/v1/options/cargo-category-units/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsCargoCategoryUnitsRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsCargoLoadTypesRetrieve
   * @request GET:/api/v1/options/cargo-load-types/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsCargoLoadTypesRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsCargoTypesRetrieve
   * @request GET:/api/v1/options/cargo-types/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsCargoTypesRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsCountriesRetrieve
   * @request GET:/api/v1/options/countries/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsCountriesRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsCurrenciesRetrieve
   * @request GET:/api/v1/options/currencies/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsCurrenciesRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsFeatureSwitchTypesList
   * @request GET:/api/v1/options/feature-switch-types/
   * @secure
   * @response `200` `(FeatureSwitch)[]`
   */
  export namespace OptionsFeatureSwitchTypesList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FeatureSwitch[];
  }

  /**
   * No description
   * @tags options
   * @name OptionsIncotermsRetrieve
   * @request GET:/api/v1/options/incoterms/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsIncotermsRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsLengthUnitRetrieve
   * @request GET:/api/v1/options/length-unit/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsLengthUnitRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsMessageEventsRetrieve
   * @request GET:/api/v1/options/message-events/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsMessageEventsRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsPeriodicityRetrieve
   * @request GET:/api/v1/options/periodicity/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsPeriodicityRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsRouteTypesRetrieve
   * @request GET:/api/v1/options/route-types/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsRouteTypesRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsSpecialRequirementsRetrieve
   * @request GET:/api/v1/options/special-requirements/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsSpecialRequirementsRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsStackCountRetrieve
   * @request GET:/api/v1/options/stack-count/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsStackCountRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsTransportTypesRetrieve
   * @request GET:/api/v1/options/transport-types/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsTransportTypesRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsTransportationModesRetrieve
   * @request GET:/api/v1/options/transportation-modes/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsTransportationModesRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsVolumeUnitRetrieve
   * @request GET:/api/v1/options/volume-unit/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsVolumeUnitRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }

  /**
   * No description
   * @tags options
   * @name OptionsWeightUnitRetrieve
   * @request GET:/api/v1/options/weight-unit/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace OptionsWeightUnitRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }
}

export namespace Otp {
  /**
   * @description Create a new OTP for the given carrier's email and send it to that email
   * @tags otp
   * @name OtpCreate
   * @request POST:/api/v1/otp/
   * @secure
   * @response `200` `void` No response body
   */
  export namespace OtpCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = OneTimePasswordRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Verify and retrieve the given OTP by its hash
   * @tags otp
   * @name OtpRetrieve
   * @request GET:/api/v1/otp/{otp_hash}/
   * @secure
   * @response `200` `OneTimePassword`
   */
  export namespace OtpRetrieve {
    export type RequestParams = {
      otpHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OneTimePassword;
  }

  /**
   * No description
   * @tags otp
   * @name OtpSetLanguage
   * @request POST:/api/v1/otp/{otp_hash}/language/
   * @secure
   * @response `200` `OtpSetLanguage`
   */
  export namespace OtpSetLanguage {
    export type RequestParams = {
      otpHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = OtpSetLanguage;
    export type RequestHeaders = {};
    export type ResponseBody = OtpSetLanguage;
  }

  /**
   * No description
   * @tags otp
   * @name OtpUnpaidInvoicesRetrieve
   * @request GET:/api/v1/otp/{otp_hash}/unpaid-invoices/
   * @secure
   * @response `200` `UnpaidInvoices`
   */
  export namespace OtpUnpaidInvoicesRetrieve {
    export type RequestParams = {
      otpHash: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UnpaidInvoices;
  }

  /**
   * @description Invalidate the given OTP - set expires_at to now
   * @tags otp
   * @name OtpExpireCreate
   * @request POST:/api/v1/otp/expire/
   * @secure
   * @response `200` `OneTimePasswordVerify`
   */
  export namespace OtpExpireCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = OneTimePasswordVerify;
    export type RequestHeaders = {};
    export type ResponseBody = OneTimePasswordVerify;
  }
}

export namespace Payments {
  /**
   * No description
   * @tags payments
   * @name PaymentsCheckoutSessionCreate
   * @request POST:/api/v1/payments/checkout/session/
   * @secure
   * @response `200` `CheckoutResponseData`
   */
  export namespace PaymentsCheckoutSessionCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CheckoutRequestData;
    export type RequestHeaders = {};
    export type ResponseBody = CheckoutResponseData;
  }
}

export namespace Portal {
  /**
   * @description Get company details based on VAT ID and country code. For getting also insurance status, use `insurance_status_check=true. If Portal has not cached the status for the company, it makes an additional API call to the Coface API (which can be paid and slow).
   * @tags core
   * @name PortalCompanyInfoCreate
   * @request POST:/api/v1/portal/company-info/
   * @secure
   * @response `200` `PortalCompanyInfoResponse`
   */
  export namespace PortalCompanyInfoCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CompanyInfoPayload;
    export type RequestHeaders = {};
    export type ResponseBody = PortalCompanyInfoResponse;
  }

  /**
   * @description Get company details based on VAT ID or company name and country code from Coface.
   * @tags core
   * @name PortalExternalCompanyInfoCreate
   * @request POST:/api/v1/portal/external-company-info/
   * @secure
   * @response `200` `(CofaceCompanyInfoResponse)[]`
   */
  export namespace PortalExternalCompanyInfoCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CompanyInfoPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CofaceCompanyInfoResponse[];
  }
}

export namespace Privacy {
  /**
   * No description
   * @tags privacy
   * @name PrivacyConsentsRetrieve
   * @request GET:/api/v1/privacy/consents/{token}/
   * @secure
   * @response `200` `ConsentByTokenSetOutput`
   */
  export namespace PrivacyConsentsRetrieve {
    export type RequestParams = {
      token: string;
    };
    export type RequestQuery = {
      consentTypes?: ConsentTypesEnum[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ConsentByTokenSetOutput;
  }

  /**
   * No description
   * @tags privacy
   * @name PrivacyConsentsCreate
   * @request POST:/api/v1/privacy/consents/{token}/
   * @secure
   * @response `200` `ConsentByTokenSetOutput`
   */
  export namespace PrivacyConsentsCreate {
    export type RequestParams = {
      token: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PrivacyConsentsCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = ConsentByTokenSetOutput;
  }

  /**
   * No description
   * @tags privacy
   * @name PrivacyConsentsMarketingRetrieve
   * @request GET:/api/v1/privacy/consents/{token}/marketing/
   * @secure
   * @response `200` `MarketingConsentByToken`
   */
  export namespace PrivacyConsentsMarketingRetrieve {
    export type RequestParams = {
      token: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MarketingConsentByToken;
  }

  /**
   * No description
   * @tags privacy
   * @name PrivacyConsentsMarketingCreate
   * @request POST:/api/v1/privacy/consents/{token}/marketing/
   * @secure
   * @response `200` `MarketingConsentByToken`
   */
  export namespace PrivacyConsentsMarketingCreate {
    export type RequestParams = {
      token: string;
    };
    export type RequestQuery = {};
    export type RequestBody = MarketingInputOutput;
    export type RequestHeaders = {};
    export type ResponseBody = MarketingConsentByToken;
  }

  /**
   * No description
   * @tags privacy
   * @name PrivacyConsentsSettingsList
   * @request GET:/api/v1/privacy/consents/{token}/settings/
   * @secure
   * @response `200` `(ConsentsSettings)[]`
   */
  export namespace PrivacyConsentsSettingsList {
    export type RequestParams = {
      token: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ConsentsSettings[];
  }

  /**
   * No description
   * @tags privacy
   * @name PrivacyConsentsSettingsCreate
   * @request POST:/api/v1/privacy/consents/{token}/settings/
   * @secure
   * @response `200` `(ConsentsSettings)[]`
   */
  export namespace PrivacyConsentsSettingsCreate {
    export type RequestParams = {
      token: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PrivacyConsentsSettingsCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = ConsentsSettings[];
  }

  /**
   * No description
   * @tags privacy
   * @name PrivacyConsentsTermsRetrieve
   * @request GET:/api/v1/privacy/consents/{token}/terms/
   * @secure
   * @response `200` `TermsByTokenOutput`
   */
  export namespace PrivacyConsentsTermsRetrieve {
    export type RequestParams = {
      token: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TermsByTokenOutput;
  }

  /**
   * No description
   * @tags privacy
   * @name PrivacyConsentsTermsCreate
   * @request POST:/api/v1/privacy/consents/{token}/terms/
   * @secure
   * @response `200` `TermsByTokenOutput`
   */
  export namespace PrivacyConsentsTermsCreate {
    export type RequestParams = {
      token: string;
    };
    export type RequestQuery = {};
    export type RequestBody = PrivacyConsentsTermsCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = TermsByTokenOutput;
  }

  /**
   * No description
   * @tags privacy
   * @name PrivacyConsentsRequestResendCreate
   * @request POST:/api/v1/privacy/consents/request/resend/
   * @secure
   * @response `204` `any`
   * @response `400` `ConsentInfo`
   */
  export namespace PrivacyConsentsRequestResendCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ResendConsentRequestInput;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags privacy
   * @name PrivacyTermsAndConditionsList
   * @request GET:/api/v1/privacy/terms-and-conditions/
   * @secure
   * @response `200` `PaginatedTermsAndConditionsList`
   */
  export namespace PrivacyTermsAndConditionsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedTermsAndConditionsList;
  }

  /**
   * No description
   * @tags privacy
   * @name PrivacyTermsAndConditionsRetrieve
   * @request GET:/api/v1/privacy/terms-and-conditions/{id}/
   * @secure
   * @response `200` `TermsAndConditions`
   */
  export namespace PrivacyTermsAndConditionsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this terms and conditions. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TermsAndConditions;
  }
}

export namespace Push {
  /**
   * No description
   * @tags push
   * @name PushAuthorizeCreate
   * @request POST:/api/v1/push/authorize/
   * @secure
   * @response `200` `PushAuthorizeResponse`
   */
  export namespace PushAuthorizeCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PushAuthorizeRequest;
    export type RequestHeaders = {};
    export type ResponseBody = PushAuthorizeResponse;
  }

  /**
   * No description
   * @tags push
   * @name PushAuthorizeByHashCreate
   * @request POST:/api/v1/push/authorize-by-hash/
   * @secure
   * @response `200` `PushAuthorizeResponse`
   */
  export namespace PushAuthorizeByHashCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PushAuthorizeRequest;
    export type RequestHeaders = {};
    export type ResponseBody = PushAuthorizeResponse;
  }

  /**
   * No description
   * @tags push
   * @name PushAuthorizeByOtpHashCreate
   * @request POST:/api/v1/push/authorize-by-otp-hash/
   * @secure
   * @response `200` `PushAuthorizeResponse`
   */
  export namespace PushAuthorizeByOtpHashCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PushAuthorizeRequest;
    export type RequestHeaders = {};
    export type ResponseBody = PushAuthorizeResponse;
  }
}

export namespace Roles {
  /**
   * No description
   * @tags roles
   * @name RolesList
   * @request GET:/api/v1/roles/
   * @secure
   * @response `200` `(Role)[]`
   */
  export namespace RolesList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Role[];
  }

  /**
   * No description
   * @tags roles
   * @name RolesRetrieve
   * @request GET:/api/v1/roles/{id}/
   * @secure
   * @response `200` `Role`
   */
  export namespace RolesRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this role. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Role;
  }
}

export namespace RouteAddresses {
  /**
   * @description ViewSet providing CRUD operations for route addresses. URL: /contracts/route-addresses/
   * @tags route-addresses
   * @name RouteAddressesList
   * @request GET:/api/v1/route-addresses/
   * @secure
   * @response `200` `PaginatedRouteAddressList`
   */
  export namespace RouteAddressesList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedRouteAddressList;
  }

  /**
   * @description ViewSet providing CRUD operations for route addresses. URL: /contracts/route-addresses/
   * @tags route-addresses
   * @name RouteAddressesCreate
   * @request POST:/api/v1/route-addresses/
   * @secure
   * @response `201` `RouteAddress`
   */
  export namespace RouteAddressesCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RouteAddress;
    export type RequestHeaders = {};
    export type ResponseBody = RouteAddress;
  }

  /**
   * @description ViewSet providing CRUD operations for route addresses. URL: /contracts/route-addresses/
   * @tags route-addresses
   * @name RouteAddressesRetrieve
   * @request GET:/api/v1/route-addresses/{id}/
   * @secure
   * @response `200` `RouteAddress`
   */
  export namespace RouteAddressesRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this Route Address. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouteAddress;
  }

  /**
   * @description ViewSet providing CRUD operations for route addresses. URL: /contracts/route-addresses/
   * @tags route-addresses
   * @name RouteAddressesUpdate
   * @request PUT:/api/v1/route-addresses/{id}/
   * @secure
   * @response `200` `RouteAddress`
   */
  export namespace RouteAddressesUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this Route Address. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = RouteAddress;
    export type RequestHeaders = {};
    export type ResponseBody = RouteAddress;
  }

  /**
   * @description ViewSet providing CRUD operations for route addresses. URL: /contracts/route-addresses/
   * @tags route-addresses
   * @name RouteAddressesPartialUpdate
   * @request PATCH:/api/v1/route-addresses/{id}/
   * @secure
   * @response `200` `RouteAddress`
   */
  export namespace RouteAddressesPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this Route Address. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedRouteAddress;
    export type RequestHeaders = {};
    export type ResponseBody = RouteAddress;
  }

  /**
   * @description ViewSet providing CRUD operations for route addresses. URL: /contracts/route-addresses/
   * @tags route-addresses
   * @name RouteAddressesDestroy
   * @request DELETE:/api/v1/route-addresses/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace RouteAddressesDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this Route Address. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Routes {
  /**
   * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
   * @tags routes
   * @name RoutesList
   * @request GET:/api/v1/routes/
   * @secure
   * @response `200` `PaginatedRouteListList`
   */
  export namespace RoutesList {
    export type RequestParams = {};
    export type RequestQuery = {
      country?: string;
      deliveryCity?: string;
      deliveryCountry?: string;
      deliveryPostCode?: string;
      deliveryStreet?: string;
      /** Multiple values may be separated by commas. */
      ids?: number[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      pickupCity?: string;
      pickupCountry?: string;
      pickupPostCode?: string;
      pickupStreet?: string;
      /**
       * * `ONE_WAY` - One way
       * * `ROUND_TRIP` - Round trip
       */
      routeType?: RouteTypeEnum;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedRouteListList;
  }

  /**
   * @description Creates a route from the provided payload. Method isn't allowed. Use bulk_create instead.
   * @tags routes
   * @name RoutesCreate
   * @request POST:/api/v1/routes/
   * @secure
   * @response `201` `RouteCreate`
   */
  export namespace RoutesCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RouteCreate;
    export type RequestHeaders = {};
    export type ResponseBody = RouteCreate;
  }

  /**
   * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
   * @tags routes
   * @name RoutesRetrieve
   * @request GET:/api/v1/routes/{id}/
   * @secure
   * @response `200` `RouteList`
   */
  export namespace RoutesRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this route. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RouteList;
  }

  /**
   * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
   * @tags routes
   * @name RoutesUpdate
   * @request PUT:/api/v1/routes/{id}/
   * @secure
   * @response `200` `RouteUpdate`
   */
  export namespace RoutesUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this route. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = RouteUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = RouteUpdate;
  }

  /**
   * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
   * @tags routes
   * @name RoutesPartialUpdate
   * @request PATCH:/api/v1/routes/{id}/
   * @secure
   * @response `200` `RouteUpdate`
   */
  export namespace RoutesPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this route. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedRouteUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = RouteUpdate;
  }

  /**
   * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
   * @tags routes
   * @name RoutesDestroy
   * @request DELETE:/api/v1/routes/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace RoutesDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this route. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
   * @tags routes
   * @name RoutesAutocomplete
   * @request GET:/api/v1/routes/autocomplete/
   * @secure
   * @response `200` `AutocompleteResponse`
   * @response `400` `void` No response body
   */
  export namespace RoutesAutocomplete {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * * `city` - city
       * * `post_code` - post_code
       * * `street` - street
       */
      field: RoutesAutocompleteFieldEnum;
      /** @minLength 1 */
      term: string;
      /**
       * * `PICKUP` - Pickup
       * * `DELIVERY` - Delivery
       */
      waypointType: WaypointTypeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AutocompleteResponse;
  }

  /**
   * @description Creates multiple routes from the provided payload. Returns only the last 5 routes.
   * @tags routes
   * @name RoutesBulkCreateCreate
   * @request POST:/api/v1/routes/bulk-create/
   * @secure
   * @response `200` `RouteBulkCreate`
   */
  export namespace RoutesBulkCreateCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RouteBulkCreate;
    export type RequestHeaders = {};
    export type ResponseBody = RouteBulkCreate;
  }

  /**
   * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
   * @tags routes
   * @name RoutesBulkDelete
   * @request POST:/api/v1/routes/bulk-delete/
   * @secure
   * @response `200` `RouteBulkDelete`
   */
  export namespace RoutesBulkDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RouteBulkDelete;
    export type RequestHeaders = {};
    export type ResponseBody = RouteBulkDelete;
  }

  /**
   * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
   * @tags routes
   * @name RoutesCheckDraftUsage
   * @request POST:/api/v1/routes/check-draft-usage/
   * @secure
   * @response `200` `RouteCheckDraftUsageInput`
   */
  export namespace RoutesCheckDraftUsage {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RouteCheckDraftUsageInput;
    export type RequestHeaders = {};
    export type ResponseBody = RouteCheckDraftUsageInput;
  }
}

export namespace Schema {
  /**
   * @description OpenApi3 schema for this API. Format can be selected via content negotiation. - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
   * @tags schema
   * @name SchemaRetrieve
   * @request GET:/api/v1/schema/
   * @secure
   * @response `200` `Record<string,any>`
   */
  export namespace SchemaRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {
      format?: SchemaRetrieveFormatEnum;
      /**
       * * `en` - English
       * * `sk` - Slovak
       * * `de` - German
       * * `fr` - French
       * * `it` - Italian
       * * `cs` - Czech
       * * `es` - Spain
       */
      lang?: LanguageEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>;
  }
}

export namespace Stats {
  /**
   * No description
   * @tags stats
   * @name StatsOverviewRetrieve
   * @request GET:/api/v1/stats/overview/
   * @secure
   * @response `200` `CombinedOverviewStats`
   */
  export namespace StatsOverviewRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date */
      createdAtAfter?: string;
      /** @format date */
      createdAtBefore?: string;
      interval?: IntervalEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CombinedOverviewStats;
  }

  /**
   * No description
   * @tags stats
   * @name StatsRoutesRetrieve
   * @request GET:/api/v1/stats/routes/
   * @secure
   * @response `200` `RoutesOverviewStats`
   */
  export namespace StatsRoutesRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date */
      createdAtAfter?: string;
      /** @format date */
      createdAtBefore?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RoutesOverviewStats;
  }

  /**
   * No description
   * @tags stats
   * @name StatsTopCarriersRetrieve
   * @request GET:/api/v1/stats/top-carriers/
   * @secure
   * @response `200` `TopCarriersStats`
   */
  export namespace StatsTopCarriersRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {
      count?: number;
      /** @format date */
      createdAtAfter?: string;
      /** @format date */
      createdAtBefore?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TopCarriersStats;
  }

  /**
   * No description
   * @tags stats
   * @name StatsTopCountriesList
   * @request GET:/api/v1/stats/top-countries/
   * @secure
   * @response `200` `(TopCountryStats)[]`
   */
  export namespace StatsTopCountriesList {
    export type RequestParams = {};
    export type RequestQuery = {
      count?: number;
      /** @format date */
      createdAtAfter?: string;
      /** @format date */
      createdAtBefore?: string;
      waypointStatsType?: WaypointStatsTypeEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TopCountryStats[];
  }
}

export namespace Tags {
  /**
   * No description
   * @tags tags
   * @name TagsList
   * @request GET:/api/v1/tags/
   * @secure
   * @response `200` `PaginatedWorkspaceTagList`
   */
  export namespace TagsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedWorkspaceTagList;
  }

  /**
   * No description
   * @tags tags
   * @name TagsCreate
   * @request POST:/api/v1/tags/
   * @secure
   * @response `201` `WorkspaceTag`
   */
  export namespace TagsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = WorkspaceTag;
    export type RequestHeaders = {};
    export type ResponseBody = WorkspaceTag;
  }

  /**
   * No description
   * @tags tags
   * @name TagsRetrieve
   * @request GET:/api/v1/tags/{id}/
   * @secure
   * @response `200` `WorkspaceTag`
   */
  export namespace TagsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this workspace tag. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WorkspaceTag;
  }

  /**
   * No description
   * @tags tags
   * @name TagsUpdate
   * @request PUT:/api/v1/tags/{id}/
   * @secure
   * @response `200` `WorkspaceTag`
   */
  export namespace TagsUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this workspace tag. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = WorkspaceTag;
    export type RequestHeaders = {};
    export type ResponseBody = WorkspaceTag;
  }

  /**
   * No description
   * @tags tags
   * @name TagsPartialUpdate
   * @request PATCH:/api/v1/tags/{id}/
   * @secure
   * @response `200` `WorkspaceTag`
   */
  export namespace TagsPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this workspace tag. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedWorkspaceTag;
    export type RequestHeaders = {};
    export type ResponseBody = WorkspaceTag;
  }

  /**
   * No description
   * @tags tags
   * @name TagsAllList
   * @request GET:/api/v1/tags/all/
   * @secure
   * @response `200` `(WorkspaceTag)[]`
   */
  export namespace TagsAllList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WorkspaceTag[];
  }
}

export namespace TimeslotModulePromo {
  /**
   * @description Permanently dismiss the promo banner for the current user.
   * @tags module-promo
   * @name TimeslotModulePromoDismissCreate
   * @request POST:/api/v1/timeslot-module-promo/dismiss/
   * @secure
   * @response `200` `ModulePromoState`
   */
  export namespace TimeslotModulePromoDismissCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModulePromoState;
  }

  /**
   * @description Record that the current user opened the promo modal.
   * @tags module-promo
   * @name TimeslotModulePromoOpenCreate
   * @request POST:/api/v1/timeslot-module-promo/open/
   * @secure
   * @response `200` `ModulePromoState`
   */
  export namespace TimeslotModulePromoOpenCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModulePromoState;
  }

  /**
   * @description Send a module demo inquiry to support (throttled per user).
   * @tags module-promo
   * @name TimeslotModulePromoSendInquiryCreate
   * @request POST:/api/v1/timeslot-module-promo/send-inquiry/
   * @secure
   * @response `200` `ModulePromoState`
   * @response `400` `void` Throttled (inquiry sent recently), no workspace, or module already enabled.
   */
  export namespace TimeslotModulePromoSendInquiryCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModulePromoState;
  }

  /**
   * @description Return the module promo banner state for the current user.
   * @tags module-promo
   * @name TimeslotModulePromoStateRetrieve
   * @request GET:/api/v1/timeslot-module-promo/state/
   * @secure
   * @response `200` `ModulePromoState`
   */
  export namespace TimeslotModulePromoStateRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModulePromoState;
  }
}

export namespace TransportRequests {
  /**
   * No description
   * @tags transport-requests
   * @name TransportRequestsCreate
   * @request POST:/api/v1/transport-requests/
   * @secure
   * @response `201` `TransportRequest`
   */
  export namespace TransportRequestsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TransportRequest;
    export type RequestHeaders = {};
    export type ResponseBody = TransportRequest;
  }

  /**
   * No description
   * @tags transport-requests
   * @name TransportRequestsChangeTransportOptionCreate
   * @request POST:/api/v1/transport-requests/{id}/change-transport-option/
   * @secure
   * @response `200` `TransportRequest`
   */
  export namespace TransportRequestsChangeTransportOptionCreate {
    export type RequestParams = {
      /** A unique integer value identifying this transport request. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = TransportRequestChangeOption;
    export type RequestHeaders = {};
    export type ResponseBody = TransportRequest;
  }

  /**
   * No description
   * @tags transport-requests
   * @name TransportRequestsUpdateCreate
   * @request POST:/api/v1/transport-requests/{id}/update/
   * @secure
   * @response `200` `TransportRequest`
   */
  export namespace TransportRequestsUpdateCreate {
    export type RequestParams = {
      /** A unique integer value identifying this transport request. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedTransportRequestUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = TransportRequest;
  }

  /**
   * No description
   * @tags transport-requests
   * @name TransportRequestsUpdateActiveCreate
   * @request POST:/api/v1/transport-requests/{id}/update_active/
   * @secure
   * @response `200` `TransportRequest`
   */
  export namespace TransportRequestsUpdateActiveCreate {
    export type RequestParams = {
      /** A unique integer value identifying this transport request. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedTransportRequestUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = TransportRequest;
  }

  /**
   * No description
   * @tags transport-requests
   * @name TransportRequestsGetPriceFromPricerCreate
   * @request POST:/api/v1/transport-requests/get-price-from-pricer/
   * @secure
   * @response `200` `PricerResult`
   */
  export namespace TransportRequestsGetPriceFromPricerCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PricerRequest;
    export type RequestHeaders = {};
    export type ResponseBody = PricerResult;
  }

  /**
   * @description Validates the first step of a multi-step process. Parameters: request: The incoming request object. *args: Additional positional arguments. **kwargs: Additional keyword arguments. Returns: Response: A Response object containing serializer errors merged with custom one or serialized data.
   * @tags transport-requests
   * @name TransportRequestsValidateFirstStepCreate
   * @request POST:/api/v1/transport-requests/validate-first-step/
   * @secure
   * @response `200` `TransportOrTransportRequestFirstStep`
   */
  export namespace TransportRequestsValidateFirstStepCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TransportOrTransportRequestFirstStep;
    export type RequestHeaders = {};
    export type ResponseBody = TransportOrTransportRequestFirstStep;
  }

  /**
   * No description
   * @tags transport-requests
   * @name TransportRequestsValidateFourthStepCreate
   * @request POST:/api/v1/transport-requests/validate-fourth-step/
   * @secure
   * @response `200` `TransportRequestFourthStep`
   */
  export namespace TransportRequestsValidateFourthStepCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TransportRequestFourthStep;
    export type RequestHeaders = {};
    export type ResponseBody = TransportRequestFourthStep;
  }

  /**
   * No description
   * @tags transport-requests
   * @name TransportRequestsValidateSecondStepCreate
   * @request POST:/api/v1/transport-requests/validate-second-step/
   * @secure
   * @response `200` `TransportOrTransportRequestSecondStep`
   */
  export namespace TransportRequestsValidateSecondStepCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TransportOrTransportRequestSecondStep;
    export type RequestHeaders = {};
    export type ResponseBody = TransportOrTransportRequestSecondStep;
  }

  /**
   * No description
   * @tags transport-requests
   * @name TransportRequestsValidateThirdStepCreate
   * @request POST:/api/v1/transport-requests/validate-third-step/
   * @secure
   * @response `200` `TransportRequestThirdStep`
   */
  export namespace TransportRequestsValidateThirdStepCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TransportRequestThirdStep;
    export type RequestHeaders = {};
    export type ResponseBody = TransportRequestThirdStep;
  }
}

export namespace TransportStats {
  /**
   * No description
   * @tags transport-stats
   * @name TransportStatsOverviewRetrieve
   * @request GET:/api/v1/transport-stats/overview/
   * @secure
   * @response `200` `TransportOverviewStats`
   */
  export namespace TransportStatsOverviewRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {
      maxVolumeM3?: number;
      minVolumeM3?: number;
      airWaybillNumber?: string;
      airline?: string;
      /** Auction ID */
      auctionId?: number;
      billOfLadingNumber?: string;
      /** Carrier ID */
      carrierId?: number;
      carrierName?: string;
      containerNumber?: string;
      costCenter?: string;
      /** @format date-time */
      createdAtAfter?: string;
      /** @format date-time */
      createdAtBefore?: string;
      createdBy?: number;
      /**
       * Currency
       *
       * * `EUR` - EUR
       * * `USD` - USD
       * * `CZK` - CZK
       * * `HUF` - HUF
       * * `PLN` - PLN
       * * `RON` - RON
       * * `GBP` - GBP
       * * `NOK` - NOK
       * * `DKK` - DKK
       * * `SEK` - SEK
       * * `ISK` - ISK
       * * `CHF` - CHF
       * * `CNY` - CNY
       */
      currency?: CurrencyEnum;
      deliveryCity?: string;
      deliveryCountry?: string;
      /** @format date-time */
      deliveryDateAfter?: string;
      /** @format date-time */
      deliveryDateBefore?: string;
      deliveryName?: string;
      deliveryPostCode?: string;
      deliveryReference?: string;
      deliveryStreet?: string;
      driverName?: string;
      driverPhone?: string;
      flightNumber?: string;
      fromPlace?: string;
      /** Transport ID */
      id?: number;
      /**
       * Incoterms
       *
       * * `EXW` - EXW - Ex Works
       * * `FCA` - FCA - Free Carrier
       * * `CPT` - CPT - Carriage Paid To
       * * `CIP` - CIP - Carriage and Insurance Paid To
       * * `DAP` - DAP - Delivered at Place
       * * `DPU` - DPU - Delivered at Place Unloaded
       * * `DDP` - DDP - Delivered Duty Paid
       * * `FAS` - FAS - Free Alongside Ship
       * * `FOB` - FOB - Free On Board
       * * `CFR` - CFR - Cost and Freight
       * * `CIF` - CIF - Cost, Insurance and Freight
       */
      incoterms?: IncotermsEnum;
      interval?: IntervalEnum;
      /** Is past */
      isPast?: boolean;
      /**
       * Load type
       *
       * * `FTL` - Full Truck Load
       * * `LTL` - Less than Truck Load
       * * `FCL` - Full Container Load
       * * `LCL` - Less than Container Load
       * * `PARCEL` - Parcel
       * * `NOT_SPECIFIED` - Not specified
       */
      loadType?: CargoLoadTypeEnum[];
      maxWeightKg?: number;
      minWeightKg?: number;
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       * * `id` - Id
       * * `-id` - Id (descending)
       */
      order?: TransportStatsOverviewRetrieveOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      pickupCity?: string;
      pickupCountry?: string;
      /** @format date-time */
      pickupDateAfter?: string;
      /** @format date-time */
      pickupDateBefore?: string;
      pickupName?: string;
      pickupPostCode?: string;
      pickupReference?: string;
      pickupStreet?: string;
      plateNumber?: string;
      /** @format date-time */
      publishedAtAfter?: string;
      /** @format date-time */
      publishedAtBefore?: string;
      reference?: string;
      /**
       * Request type
       *
       * * `REFRIGERATED_GOODS` - Refrigerated goods
       * * `FROZEN_GOODS` - Frozen goods
       * * `METAL_GOODS` - Metal goods
       * * `OVERSIZED_LOAD` - Oversized load
       * * `BULK_MATERIAL` - Bulk material
       * * `LOOSE_MATERIAL` - Loose material
       * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
       * * `LIQUIDS` - Liquids
       * * `VEHICLES` - Vehicles
       * * `ADR` - ADR
       * * `OTHER` - Other
       * * `NOT_SPECIFIED` - Not specified
       */
      requestType?: CargoTypeEnum;
      responsibleUser?: number;
      /**
       * Route type
       *
       * * `ONE_WAY` - One way
       * * `ROUND_TRIP` - Round trip
       */
      routeType?: RouteTypeEnum;
      /** A search term. */
      search?: string;
      /**
       * STA
       * @format date-time
       */
      staAfter?: string;
      /**
       * STA
       * @format date-time
       */
      staBefore?: string;
      /**
       * STD
       * @format date-time
       */
      stdAfter?: string;
      /**
       * STD
       * @format date-time
       */
      stdBefore?: string;
      /** Multiple values may be separated by commas. */
      tag?: string[];
      toPlace?: string;
      trainNumber?: string;
      /**
       * Transport status
       *
       * * `PROCESSING` - Processing
       * * `FINISHED` - Finished
       * * `CANCELED` - Canceled
       * * `CANCELED_BY_CARRIER` - Canceled by carrier
       * * `CANCELED_BY_SUPPORT` - Canceled by support
       */
      transportStatus?: TransportStatusEnum;
      /**
       * Transport type
       *
       * * `SPOT` - Spot transport
       * * `CONTRACTED` - Contracted transport
       */
      transportType?: TransportTypeEnum;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
      vesselName?: string;
      voyageNumber?: string;
      wagonContainerNumber?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TransportOverviewStats;
  }
}

export namespace Transports {
  /**
   * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
   * @tags transports
   * @name TransportsList
   * @request GET:/api/v1/transports/
   * @secure
   * @response `200` `PaginatedTransportListList`
   */
  export namespace TransportsList {
    export type RequestParams = {};
    export type RequestQuery = {
      maxVolumeM3?: number;
      minVolumeM3?: number;
      airWaybillNumber?: string;
      airline?: string;
      /** Auction ID */
      auctionId?: number;
      billOfLadingNumber?: string;
      /** Carrier ID */
      carrierId?: number;
      carrierName?: string;
      containerNumber?: string;
      costCenter?: string;
      /** @format date-time */
      createdAtAfter?: string;
      /** @format date-time */
      createdAtBefore?: string;
      createdBy?: number;
      /**
       * Currency
       *
       * * `EUR` - EUR
       * * `USD` - USD
       * * `CZK` - CZK
       * * `HUF` - HUF
       * * `PLN` - PLN
       * * `RON` - RON
       * * `GBP` - GBP
       * * `NOK` - NOK
       * * `DKK` - DKK
       * * `SEK` - SEK
       * * `ISK` - ISK
       * * `CHF` - CHF
       * * `CNY` - CNY
       */
      currency?: CurrencyEnum;
      deliveryCity?: string;
      deliveryCountry?: string;
      /** @format date-time */
      deliveryDateAfter?: string;
      /** @format date-time */
      deliveryDateBefore?: string;
      deliveryName?: string;
      deliveryPostCode?: string;
      deliveryReference?: string;
      deliveryStreet?: string;
      driverName?: string;
      driverPhone?: string;
      flightNumber?: string;
      fromPlace?: string;
      /** Transport ID */
      id?: number;
      /**
       * Incoterms
       *
       * * `EXW` - EXW - Ex Works
       * * `FCA` - FCA - Free Carrier
       * * `CPT` - CPT - Carriage Paid To
       * * `CIP` - CIP - Carriage and Insurance Paid To
       * * `DAP` - DAP - Delivered at Place
       * * `DPU` - DPU - Delivered at Place Unloaded
       * * `DDP` - DDP - Delivered Duty Paid
       * * `FAS` - FAS - Free Alongside Ship
       * * `FOB` - FOB - Free On Board
       * * `CFR` - CFR - Cost and Freight
       * * `CIF` - CIF - Cost, Insurance and Freight
       */
      incoterms?: IncotermsEnum;
      /** Is past */
      isPast?: boolean;
      /**
       * Load type
       *
       * * `FTL` - Full Truck Load
       * * `LTL` - Less than Truck Load
       * * `FCL` - Full Container Load
       * * `LCL` - Less than Container Load
       * * `PARCEL` - Parcel
       * * `NOT_SPECIFIED` - Not specified
       */
      loadType?: CargoLoadTypeEnum[];
      maxWeightKg?: number;
      minWeightKg?: number;
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       * * `id` - Id
       * * `-id` - Id (descending)
       */
      order?: TransportsListOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      pickupCity?: string;
      pickupCountry?: string;
      /** @format date-time */
      pickupDateAfter?: string;
      /** @format date-time */
      pickupDateBefore?: string;
      pickupName?: string;
      pickupPostCode?: string;
      pickupReference?: string;
      pickupStreet?: string;
      plateNumber?: string;
      /** @format date-time */
      publishedAtAfter?: string;
      /** @format date-time */
      publishedAtBefore?: string;
      reference?: string;
      /**
       * Request type
       *
       * * `REFRIGERATED_GOODS` - Refrigerated goods
       * * `FROZEN_GOODS` - Frozen goods
       * * `METAL_GOODS` - Metal goods
       * * `OVERSIZED_LOAD` - Oversized load
       * * `BULK_MATERIAL` - Bulk material
       * * `LOOSE_MATERIAL` - Loose material
       * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
       * * `LIQUIDS` - Liquids
       * * `VEHICLES` - Vehicles
       * * `ADR` - ADR
       * * `OTHER` - Other
       * * `NOT_SPECIFIED` - Not specified
       */
      requestType?: CargoTypeEnum;
      responsibleUser?: number;
      /**
       * Route type
       *
       * * `ONE_WAY` - One way
       * * `ROUND_TRIP` - Round trip
       */
      routeType?: RouteTypeEnum;
      /** A search term. */
      search?: string;
      /**
       * STA
       * @format date-time
       */
      staAfter?: string;
      /**
       * STA
       * @format date-time
       */
      staBefore?: string;
      /**
       * STD
       * @format date-time
       */
      stdAfter?: string;
      /**
       * STD
       * @format date-time
       */
      stdBefore?: string;
      /** Multiple values may be separated by commas. */
      tag?: string[];
      toPlace?: string;
      trainNumber?: string;
      /**
       * Transport status
       *
       * * `PROCESSING` - Processing
       * * `FINISHED` - Finished
       * * `CANCELED` - Canceled
       * * `CANCELED_BY_CARRIER` - Canceled by carrier
       * * `CANCELED_BY_SUPPORT` - Canceled by support
       */
      transportStatus?: TransportStatusEnum;
      /**
       * Transport type
       *
       * * `SPOT` - Spot transport
       * * `CONTRACTED` - Contracted transport
       */
      transportType?: TransportTypeEnum;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
      vesselName?: string;
      voyageNumber?: string;
      wagonContainerNumber?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedTransportListList;
  }

  /**
   * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
   * @tags transports
   * @name TransportsRetrieve
   * @request GET:/api/v1/transports/{id}/
   * @secure
   * @response `200` `TransportWithBookings`
   */
  export namespace TransportsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this transport. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TransportWithBookings;
  }

  /**
   * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
   * @tags transports
   * @name TransportsUpdate
   * @request PUT:/api/v1/transports/{id}/
   * @secure
   * @response `200` `Transport`
   */
  export namespace TransportsUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this transport. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = Transport;
    export type RequestHeaders = {};
    export type ResponseBody = Transport;
  }

  /**
   * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
   * @tags transports
   * @name TransportsPartialUpdate
   * @request PATCH:/api/v1/transports/{id}/
   * @secure
   * @response `200` `Transport`
   */
  export namespace TransportsPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this transport. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedTransport;
    export type RequestHeaders = {};
    export type ResponseBody = Transport;
  }

  /**
   * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
   * @tags transports
   * @name TransportsDestroy
   * @request DELETE:/api/v1/transports/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace TransportsDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this transport. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Dry run of the update: the open time slot bookings the save would cancel. Saves nothing.
   * @tags transports
   * @name TransportsBookingImpact
   * @request POST:/api/v1/transports/{id}/booking-impact/
   * @secure
   * @response `200` `PaginatedBookingImpactList`
   */
  export namespace TransportsBookingImpact {
    export type RequestParams = {
      /** A unique integer value identifying this transport. */
      id: number;
    };
    export type RequestQuery = {
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
    };
    export type RequestBody = TransportBookingImpact;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedBookingImpactList;
  }

  /**
   * @description Contacts invited to this transport's auction — the booking wizard's dropdown.
   * @tags transports
   * @name TransportsContactsList
   * @request GET:/api/v1/transports/{id}/contacts/
   * @secure
   * @response `200` `(TransportContact)[]`
   */
  export namespace TransportsContactsList {
    export type RequestParams = {
      /** A unique integer value identifying this transport. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TransportContact[];
  }

  /**
   * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
   * @tags transports
   * @name TransportsDownloadOrderRetrieve
   * @request GET:/api/v1/transports/{id}/download-transport-order/
   * @secure
   * @response `200` `File`
   */
  export namespace TransportsDownloadOrderRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this transport. */
      id: number;
    };
    export type RequestQuery = {
      maxVolumeM3?: number;
      minVolumeM3?: number;
      airWaybillNumber?: string;
      airline?: string;
      /** Auction ID */
      auctionId?: number;
      billOfLadingNumber?: string;
      /** Carrier ID */
      carrierId?: number;
      carrierName?: string;
      containerNumber?: string;
      costCenter?: string;
      /** @format date-time */
      createdAtAfter?: string;
      /** @format date-time */
      createdAtBefore?: string;
      createdBy?: number;
      /**
       * Currency
       *
       * * `EUR` - EUR
       * * `USD` - USD
       * * `CZK` - CZK
       * * `HUF` - HUF
       * * `PLN` - PLN
       * * `RON` - RON
       * * `GBP` - GBP
       * * `NOK` - NOK
       * * `DKK` - DKK
       * * `SEK` - SEK
       * * `ISK` - ISK
       * * `CHF` - CHF
       * * `CNY` - CNY
       */
      currency?: CurrencyEnum;
      deliveryCity?: string;
      deliveryCountry?: string;
      /** @format date-time */
      deliveryDateAfter?: string;
      /** @format date-time */
      deliveryDateBefore?: string;
      deliveryName?: string;
      deliveryPostCode?: string;
      deliveryReference?: string;
      deliveryStreet?: string;
      driverName?: string;
      driverPhone?: string;
      flightNumber?: string;
      fromPlace?: string;
      /** Transport ID */
      id?: number;
      /**
       * Incoterms
       *
       * * `EXW` - EXW - Ex Works
       * * `FCA` - FCA - Free Carrier
       * * `CPT` - CPT - Carriage Paid To
       * * `CIP` - CIP - Carriage and Insurance Paid To
       * * `DAP` - DAP - Delivered at Place
       * * `DPU` - DPU - Delivered at Place Unloaded
       * * `DDP` - DDP - Delivered Duty Paid
       * * `FAS` - FAS - Free Alongside Ship
       * * `FOB` - FOB - Free On Board
       * * `CFR` - CFR - Cost and Freight
       * * `CIF` - CIF - Cost, Insurance and Freight
       */
      incoterms?: IncotermsEnum;
      /** Is past */
      isPast?: boolean;
      /**
       * Load type
       *
       * * `FTL` - Full Truck Load
       * * `LTL` - Less than Truck Load
       * * `FCL` - Full Container Load
       * * `LCL` - Less than Container Load
       * * `PARCEL` - Parcel
       * * `NOT_SPECIFIED` - Not specified
       */
      loadType?: CargoLoadTypeEnum[];
      maxWeightKg?: number;
      minWeightKg?: number;
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       * * `id` - Id
       * * `-id` - Id (descending)
       */
      order?: TransportsDownloadOrderRetrieveOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      pickupCity?: string;
      pickupCountry?: string;
      /** @format date-time */
      pickupDateAfter?: string;
      /** @format date-time */
      pickupDateBefore?: string;
      pickupName?: string;
      pickupPostCode?: string;
      pickupReference?: string;
      pickupStreet?: string;
      plateNumber?: string;
      /** @format date-time */
      publishedAtAfter?: string;
      /** @format date-time */
      publishedAtBefore?: string;
      reference?: string;
      /**
       * Request type
       *
       * * `REFRIGERATED_GOODS` - Refrigerated goods
       * * `FROZEN_GOODS` - Frozen goods
       * * `METAL_GOODS` - Metal goods
       * * `OVERSIZED_LOAD` - Oversized load
       * * `BULK_MATERIAL` - Bulk material
       * * `LOOSE_MATERIAL` - Loose material
       * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
       * * `LIQUIDS` - Liquids
       * * `VEHICLES` - Vehicles
       * * `ADR` - ADR
       * * `OTHER` - Other
       * * `NOT_SPECIFIED` - Not specified
       */
      requestType?: CargoTypeEnum;
      responsibleUser?: number;
      /**
       * Route type
       *
       * * `ONE_WAY` - One way
       * * `ROUND_TRIP` - Round trip
       */
      routeType?: RouteTypeEnum;
      /** A search term. */
      search?: string;
      /**
       * STA
       * @format date-time
       */
      staAfter?: string;
      /**
       * STA
       * @format date-time
       */
      staBefore?: string;
      /**
       * STD
       * @format date-time
       */
      stdAfter?: string;
      /**
       * STD
       * @format date-time
       */
      stdBefore?: string;
      /** Multiple values may be separated by commas. */
      tag?: string[];
      toPlace?: string;
      trainNumber?: string;
      /**
       * Transport status
       *
       * * `PROCESSING` - Processing
       * * `FINISHED` - Finished
       * * `CANCELED` - Canceled
       * * `CANCELED_BY_CARRIER` - Canceled by carrier
       * * `CANCELED_BY_SUPPORT` - Canceled by support
       */
      transportStatus?: TransportStatusEnum;
      /**
       * Transport type
       *
       * * `SPOT` - Spot transport
       * * `CONTRACTED` - Contracted transport
       */
      transportType?: TransportTypeEnum;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
      vesselName?: string;
      voyageNumber?: string;
      wagonContainerNumber?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Blob;
  }

  /**
   * @description Answers in the detail shape: the transport detail writes this response into its page state, and its waypoint booking bars read annotations the bare row does not carry.
   * @tags transports
   * @name TransportsStatusCreate
   * @request POST:/api/v1/transports/{id}/status/
   * @secure
   * @response `200` `TransportWithBookings`
   */
  export namespace TransportsStatusCreate {
    export type RequestParams = {
      /** A unique integer value identifying this transport. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = TransportUpdateStatus;
    export type RequestHeaders = {};
    export type ResponseBody = TransportWithBookings;
  }

  /**
   * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
   * @tags transport-details
   * @name TransportsTransportDetailsRetrieve
   * @request GET:/api/v1/transports/{id}/transport-details/
   * @secure
   * @response `200` `TransportDetail`
   */
  export namespace TransportsTransportDetailsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this transport. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TransportDetail;
  }

  /**
   * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
   * @tags transport-details
   * @name TransportsTransportDetailsCreate
   * @request POST:/api/v1/transports/{id}/transport-details/
   * @secure
   * @response `200` `TransportDetail`
   */
  export namespace TransportsTransportDetailsCreate {
    export type RequestParams = {
      /** A unique integer value identifying this transport. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = TransportDetail;
    export type RequestHeaders = {};
    export type ResponseBody = TransportDetail;
  }

  /**
   * No description
   * @tags transport, updates
   * @name TransportsBatchUpdatesList
   * @request GET:/api/v1/transports/{transport_pk}/batch-updates/
   * @secure
   * @response `200` `PaginatedTransportBatchUpdateList`
   */
  export namespace TransportsBatchUpdatesList {
    export type RequestParams = {
      transportPk: number;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedTransportBatchUpdateList;
  }

  /**
   * No description
   * @tags transport, updates
   * @name TransportsBatchUpdatesCreate
   * @request POST:/api/v1/transports/{transport_pk}/batch-updates/
   * @secure
   * @response `201` `TransportBatchUpdate`
   */
  export namespace TransportsBatchUpdatesCreate {
    export type RequestParams = {
      transportPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = TransportBatchUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = TransportBatchUpdate;
  }

  /**
   * No description
   * @tags documents
   * @name TransportsDocumentsList
   * @request GET:/api/v1/transports/{transport_pk}/documents/
   * @secure
   * @response `200` `PaginatedDocumentList`
   */
  export namespace TransportsDocumentsList {
    export type RequestParams = {
      transportPk: number;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedDocumentList;
  }

  /**
   * No description
   * @tags messages
   * @name TransportsMessagesList
   * @request GET:/api/v1/transports/{transport_pk}/messages/
   * @secure
   * @response `200` `PaginatedMessageList`
   */
  export namespace TransportsMessagesList {
    export type RequestParams = {
      transportPk: number;
    };
    export type RequestQuery = {
      carrier?: number;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedMessageList;
  }

  /**
   * No description
   * @tags messages
   * @name TransportsMessagesCreate
   * @request POST:/api/v1/transports/{transport_pk}/messages/
   * @secure
   * @response `201` `Message`
   */
  export namespace TransportsMessagesCreate {
    export type RequestParams = {
      transportPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = Message;
    export type RequestHeaders = {};
    export type ResponseBody = Message;
  }

  /**
   * No description
   * @tags messages
   * @name TransportsMessagesMarkAsReadCreate
   * @request POST:/api/v1/transports/{transport_pk}/messages/mark-as-read/
   * @secure
   * @response `200` `void` No response body
   */
  export namespace TransportsMessagesMarkAsReadCreate {
    export type RequestParams = {
      transportPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags messages
   * @name TransportsMessagesUnreadCountRetrieve
   * @request GET:/api/v1/transports/{transport_pk}/messages/unread-count/
   * @secure
   * @response `200` `number`
   */
  export namespace TransportsMessagesUnreadCountRetrieve {
    export type RequestParams = {
      transportPk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = number;
  }

  /**
   * No description
   * @tags transport, updates
   * @name TransportsUpdatesListLatestList
   * @request GET:/api/v1/transports/{transport_pk}/updates/list-latest/
   * @secure
   * @response `200` `(TransportLatestUpdate)[]`
   */
  export namespace TransportsUpdatesListLatestList {
    export type RequestParams = {
      transportPk: number;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TransportLatestUpdate[];
  }

  /**
   * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
   * @tags transports
   * @name TransportsExportRetrieve
   * @request GET:/api/v1/transports/export/
   * @secure
   * @response `200` `File`
   * @response `204` `void` No response body
   */
  export namespace TransportsExportRetrieve {
    export type RequestParams = {};
    export type RequestQuery = {
      maxVolumeM3?: number;
      minVolumeM3?: number;
      airWaybillNumber?: string;
      airline?: string;
      /** Auction ID */
      auctionId?: number;
      billOfLadingNumber?: string;
      /** Carrier ID */
      carrierId?: number;
      carrierName?: string;
      containerNumber?: string;
      costCenter?: string;
      /** @format date-time */
      createdAtAfter?: string;
      /** @format date-time */
      createdAtBefore?: string;
      createdBy?: number;
      /**
       * Currency
       *
       * * `EUR` - EUR
       * * `USD` - USD
       * * `CZK` - CZK
       * * `HUF` - HUF
       * * `PLN` - PLN
       * * `RON` - RON
       * * `GBP` - GBP
       * * `NOK` - NOK
       * * `DKK` - DKK
       * * `SEK` - SEK
       * * `ISK` - ISK
       * * `CHF` - CHF
       * * `CNY` - CNY
       */
      currency?: CurrencyEnum;
      deliveryCity?: string;
      deliveryCountry?: string;
      /** @format date-time */
      deliveryDateAfter?: string;
      /** @format date-time */
      deliveryDateBefore?: string;
      deliveryName?: string;
      deliveryPostCode?: string;
      deliveryReference?: string;
      deliveryStreet?: string;
      driverName?: string;
      driverPhone?: string;
      flightNumber?: string;
      fromPlace?: string;
      /** Transport ID */
      id?: number;
      /**
       * Incoterms
       *
       * * `EXW` - EXW - Ex Works
       * * `FCA` - FCA - Free Carrier
       * * `CPT` - CPT - Carriage Paid To
       * * `CIP` - CIP - Carriage and Insurance Paid To
       * * `DAP` - DAP - Delivered at Place
       * * `DPU` - DPU - Delivered at Place Unloaded
       * * `DDP` - DDP - Delivered Duty Paid
       * * `FAS` - FAS - Free Alongside Ship
       * * `FOB` - FOB - Free On Board
       * * `CFR` - CFR - Cost and Freight
       * * `CIF` - CIF - Cost, Insurance and Freight
       */
      incoterms?: IncotermsEnum;
      /** Is past */
      isPast?: boolean;
      /**
       * Load type
       *
       * * `FTL` - Full Truck Load
       * * `LTL` - Less than Truck Load
       * * `FCL` - Full Container Load
       * * `LCL` - Less than Container Load
       * * `PARCEL` - Parcel
       * * `NOT_SPECIFIED` - Not specified
       */
      loadType?: CargoLoadTypeEnum[];
      maxWeightKg?: number;
      minWeightKg?: number;
      /**
       * Ordering
       *
       * * `created_at` - Created at
       * * `-created_at` - Created at (descending)
       * * `earliest_waypoint_date` - Earliest waypoint date
       * * `-earliest_waypoint_date` - Earliest waypoint date (descending)
       * * `id` - Id
       * * `-id` - Id (descending)
       */
      order?: TransportsExportRetrieveOrderEnum[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      pickupCity?: string;
      pickupCountry?: string;
      /** @format date-time */
      pickupDateAfter?: string;
      /** @format date-time */
      pickupDateBefore?: string;
      pickupName?: string;
      pickupPostCode?: string;
      pickupReference?: string;
      pickupStreet?: string;
      plateNumber?: string;
      /** @format date-time */
      publishedAtAfter?: string;
      /** @format date-time */
      publishedAtBefore?: string;
      reference?: string;
      /**
       * Request type
       *
       * * `REFRIGERATED_GOODS` - Refrigerated goods
       * * `FROZEN_GOODS` - Frozen goods
       * * `METAL_GOODS` - Metal goods
       * * `OVERSIZED_LOAD` - Oversized load
       * * `BULK_MATERIAL` - Bulk material
       * * `LOOSE_MATERIAL` - Loose material
       * * `MACHINES_AND_EQUIPMENT` - Machines and equipment
       * * `LIQUIDS` - Liquids
       * * `VEHICLES` - Vehicles
       * * `ADR` - ADR
       * * `OTHER` - Other
       * * `NOT_SPECIFIED` - Not specified
       */
      requestType?: CargoTypeEnum;
      responsibleUser?: number;
      /**
       * Route type
       *
       * * `ONE_WAY` - One way
       * * `ROUND_TRIP` - Round trip
       */
      routeType?: RouteTypeEnum;
      /** A search term. */
      search?: string;
      /**
       * STA
       * @format date-time
       */
      staAfter?: string;
      /**
       * STA
       * @format date-time
       */
      staBefore?: string;
      /**
       * STD
       * @format date-time
       */
      stdAfter?: string;
      /**
       * STD
       * @format date-time
       */
      stdBefore?: string;
      /** Multiple values may be separated by commas. */
      tag?: string[];
      toPlace?: string;
      trainNumber?: string;
      /**
       * Transport status
       *
       * * `PROCESSING` - Processing
       * * `FINISHED` - Finished
       * * `CANCELED` - Canceled
       * * `CANCELED_BY_CARRIER` - Canceled by carrier
       * * `CANCELED_BY_SUPPORT` - Canceled by support
       */
      transportStatus?: TransportStatusEnum;
      /**
       * Transport type
       *
       * * `SPOT` - Spot transport
       * * `CONTRACTED` - Contracted transport
       */
      transportType?: TransportTypeEnum;
      /**
       * Transportation mode
       *
       * * `ROAD` - Road
       * * `AIR` - Air
       * * `SEA` - Sea
       * * `RAIL` - Rail
       * * `INTERMODAL` - Intermodal
       */
      transportationMode?: TransportationModeEnum;
      vesselName?: string;
      voyageNumber?: string;
      wagonContainerNumber?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Blob;
  }

  /**
   * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
   * @tags transports
   * @name TransportsValidateFirstStepCreate
   * @request POST:/api/v1/transports/validate-first-step/
   * @secure
   * @response `200` `TransportOrTransportRequestFirstStep`
   */
  export namespace TransportsValidateFirstStepCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TransportOrTransportRequestFirstStep;
    export type RequestHeaders = {};
    export type ResponseBody = TransportOrTransportRequestFirstStep;
  }

  /**
   * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
   * @tags transports
   * @name TransportsValidateSecondStepCreate
   * @request POST:/api/v1/transports/validate-second-step/
   * @secure
   * @response `200` `TransportOrTransportRequestSecondStep`
   */
  export namespace TransportsValidateSecondStepCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TransportOrTransportRequestSecondStep;
    export type RequestHeaders = {};
    export type ResponseBody = TransportOrTransportRequestSecondStep;
  }

  /**
   * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
   * @tags transports
   * @name TransportsValidateThirdStepCreate
   * @request POST:/api/v1/transports/validate-third-step/
   * @secure
   * @response `200` `TransportThirdStep`
   */
  export namespace TransportsValidateThirdStepCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TransportThirdStep;
    export type RequestHeaders = {};
    export type ResponseBody = TransportThirdStep;
  }
}

export namespace Users {
  /**
   * No description
   * @tags users
   * @name UsersList
   * @request GET:/api/v1/users/
   * @secure
   * @response `200` `PaginatedUserList`
   */
  export namespace UsersList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Number of results to return per page. */
      limit?: number;
      /** The initial index from which to return the results. */
      offset?: number;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedUserList;
  }

  /**
   * No description
   * @tags users
   * @name UsersRetrieve
   * @request GET:/api/v1/users/{id}/
   * @secure
   * @response `200` `User`
   */
  export namespace UsersRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this user. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = User;
  }

  /**
   * No description
   * @tags users
   * @name UsersUpdate
   * @request PUT:/api/v1/users/{id}/
   * @secure
   * @response `200` `User`
   */
  export namespace UsersUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this user. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = User;
    export type RequestHeaders = {};
    export type ResponseBody = User;
  }

  /**
   * No description
   * @tags users
   * @name UsersPartialUpdate
   * @request PATCH:/api/v1/users/{id}/
   * @secure
   * @response `200` `User`
   */
  export namespace UsersPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this user. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedUser;
    export type RequestHeaders = {};
    export type ResponseBody = User;
  }

  /**
   * No description
   * @tags users
   * @name UsersDestroy
   * @request DELETE:/api/v1/users/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace UsersDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this user. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags users
   * @name UsersPermissionsRetrieve
   * @request GET:/api/v1/users/{id}/permissions/
   * @secure
   * @response `200` `UserPermissions`
   */
  export namespace UsersPermissionsRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this user. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserPermissions;
  }

  /**
   * No description
   * @tags users
   * @name UsersAllList
   * @request GET:/api/v1/users/all/
   * @secure
   * @response `200` `(UserGeneralInfo)[]`
   */
  export namespace UsersAllList {
    export type RequestParams = {};
    export type RequestQuery = {
      excludeRoles?: string[];
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserGeneralInfo[];
  }
}

export namespace VehicleTypes {
  /**
   * @description ViewSet providing CRUD operations for a vehicle type. URL: /vehicle-types/
   * @tags vehicle-types
   * @name VehicleTypesList
   * @request GET:/api/v1/vehicle-types/
   * @secure
   * @response `200` `PaginatedVehicleTypeList`
   */
  export namespace VehicleTypesList {
    export type RequestParams = {};
    export type RequestQuery = {
      name?: string;
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedVehicleTypeList;
  }

  /**
   * @description ViewSet providing CRUD operations for a vehicle type. URL: /vehicle-types/
   * @tags vehicle-types
   * @name VehicleTypesCreate
   * @request POST:/api/v1/vehicle-types/
   * @secure
   * @response `201` `VehicleType`
   */
  export namespace VehicleTypesCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = VehicleType;
    export type RequestHeaders = {};
    export type ResponseBody = VehicleType;
  }

  /**
   * @description ViewSet providing CRUD operations for a vehicle type. URL: /vehicle-types/
   * @tags vehicle-types
   * @name VehicleTypesRetrieve
   * @request GET:/api/v1/vehicle-types/{id}/
   * @secure
   * @response `200` `VehicleType`
   */
  export namespace VehicleTypesRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this Vehicle Type. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = VehicleType;
  }

  /**
   * @description ViewSet providing CRUD operations for a vehicle type. URL: /vehicle-types/
   * @tags vehicle-types
   * @name VehicleTypesUpdate
   * @request PUT:/api/v1/vehicle-types/{id}/
   * @secure
   * @response `200` `VehicleType`
   */
  export namespace VehicleTypesUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this Vehicle Type. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = VehicleType;
    export type RequestHeaders = {};
    export type ResponseBody = VehicleType;
  }

  /**
   * @description ViewSet providing CRUD operations for a vehicle type. URL: /vehicle-types/
   * @tags vehicle-types
   * @name VehicleTypesPartialUpdate
   * @request PATCH:/api/v1/vehicle-types/{id}/
   * @secure
   * @response `200` `VehicleType`
   */
  export namespace VehicleTypesPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this Vehicle Type. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedVehicleType;
    export type RequestHeaders = {};
    export type ResponseBody = VehicleType;
  }

  /**
   * @description ViewSet providing CRUD operations for a vehicle type. URL: /vehicle-types/
   * @tags vehicle-types
   * @name VehicleTypesDestroy
   * @request DELETE:/api/v1/vehicle-types/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace VehicleTypesDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this Vehicle Type. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Bulk create/update/delete vehicle types. POST /vehicle-types/bulk/
   * @tags vehicle-types
   * @name VehicleTypesBulkCreate
   * @request POST:/api/v1/vehicle-types/bulk/
   * @secure
   * @response `200` `(VehicleType)[]`
   */
  export namespace VehicleTypesBulkCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = VehicleTypeBulk;
    export type RequestHeaders = {};
    export type ResponseBody = VehicleType[];
  }
}

export namespace Waypoints {
  /**
   * No description
   * @tags waypoints
   * @name WaypointsAutocompleteCreate
   * @request POST:/api/v1/waypoints/autocomplete/
   * @secure
   * @response `200` `AutocompleteResponse`
   */
  export namespace WaypointsAutocompleteCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = WaypointAutocompleteRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AutocompleteResponse;
  }
}

export namespace Webhooks {
  /**
   * @description Handle POST request from Brevo webhook
   * @tags webhooks
   * @name WebhooksBrevoCreate
   * @request POST:/api/v1/webhooks/brevo/
   * @secure
   * @response `200` `void` No response body
   */
  export namespace WebhooksBrevoCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Handle POST request from Mailgun outbound webhook. This webhook receives delivery status updates for emails sent via Mailgun (accepted, delivered, opened, clicked, etc.).
   * @tags webhooks
   * @name WebhooksMailgunCreate
   * @request POST:/api/v1/webhooks/mailgun/
   * @secure
   * @response `200` `void` No response body
   */
  export namespace WebhooksMailgunCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Authenticate a Mailgun delivery to ws+<hash>@domain, then process it into a draft.
   * @tags webhooks
   * @name WebhooksMailgunInboundCreate
   * @request POST:/api/v1/webhooks/mailgun-inbound/
   * @secure
   * @response `200` `void` No response body
   */
  export namespace WebhooksMailgunInboundCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags webhooks
   * @name WebhooksStripeCreate
   * @request POST:/api/v1/webhooks/stripe/
   * @secure
   * @response `200` `void` No response body
   */
  export namespace WebhooksStripeCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Workspace {
  /**
   * No description
   * @tags workspace
   * @name WorkspaceCreate
   * @request POST:/api/v1/workspace/
   * @secure
   * @response `201` `Workspace`
   */
  export namespace WorkspaceCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Workspace;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * No description
   * @tags workspace
   * @name WorkspaceRetrieve
   * @request GET:/api/v1/workspace/{id}/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspaceRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this workspace. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * No description
   * @tags workspace
   * @name WorkspaceUpdate
   * @request PUT:/api/v1/workspace/{id}/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspaceUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this workspace. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = WorkspaceUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * No description
   * @tags workspace
   * @name WorkspacePartialUpdate
   * @request PATCH:/api/v1/workspace/{id}/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspacePartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this workspace. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedWorkspaceUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * No description
   * @tags workspace
   * @name WorkspaceDownloadSampleTransportOrderRetrieve
   * @request GET:/api/v1/workspace/{id}/download-sample-transport-order/
   * @secure
   * @response `200` `File`
   */
  export namespace WorkspaceDownloadSampleTransportOrderRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this workspace. */
      id: number;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Blob;
  }

  /**
   * No description
   * @tags workspace
   * @name WorkspaceLogoutAllUsersCreate
   * @request POST:/api/v1/workspace/{id}/logout-all-users/
   * @secure
   * @response `200` `Workspace`
   */
  export namespace WorkspaceLogoutAllUsersCreate {
    export type RequestParams = {
      /** A unique integer value identifying this workspace. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = ForceLogoutRequest;
    export type RequestHeaders = {};
    export type ResponseBody = Workspace;
  }

  /**
   * No description
   * @tags workspace
   * @name WorkspaceUploadLogoCreate
   * @request POST:/api/v1/workspace/{id}/upload-logo/
   * @secure
   * @response `200` `WorkspaceLogo`
   */
  export namespace WorkspaceUploadLogoCreate {
    export type RequestParams = {
      /** A unique integer value identifying this workspace. */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = WorkspaceLogo;
    export type RequestHeaders = {};
    export type ResponseBody = WorkspaceLogo;
  }

  /**
   * No description
   * @tags workspace
   * @name WorkspaceScheduledTasksList
   * @request GET:/api/v1/workspace/{workspace_pk}/scheduled-tasks/
   * @secure
   * @response `200` `PaginatedScheduledUserTaskList`
   */
  export namespace WorkspaceScheduledTasksList {
    export type RequestParams = {
      workspacePk: number;
    };
    export type RequestQuery = {
      /** Which field to use when ordering the results. */
      ordering?: string;
      /** A page number within the paginated result set. */
      page?: number;
      /** Number of results to return per page. */
      pageSize?: number;
      /** A search term. */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PaginatedScheduledUserTaskList;
  }

  /**
   * No description
   * @tags workspace
   * @name WorkspaceScheduledTasksCreate
   * @request POST:/api/v1/workspace/{workspace_pk}/scheduled-tasks/
   * @secure
   * @response `201` `ScheduledUserTask`
   */
  export namespace WorkspaceScheduledTasksCreate {
    export type RequestParams = {
      workspacePk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = ScheduledUserTask;
    export type RequestHeaders = {};
    export type ResponseBody = ScheduledUserTask;
  }

  /**
   * No description
   * @tags workspace
   * @name WorkspaceScheduledTasksRetrieve
   * @request GET:/api/v1/workspace/{workspace_pk}/scheduled-tasks/{id}/
   * @secure
   * @response `200` `ScheduledUserTask`
   */
  export namespace WorkspaceScheduledTasksRetrieve {
    export type RequestParams = {
      /** A unique integer value identifying this scheduled user task. */
      id: number;
      workspacePk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ScheduledUserTask;
  }

  /**
   * No description
   * @tags workspace
   * @name WorkspaceScheduledTasksUpdate
   * @request PUT:/api/v1/workspace/{workspace_pk}/scheduled-tasks/{id}/
   * @secure
   * @response `200` `ScheduledUserTask`
   */
  export namespace WorkspaceScheduledTasksUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this scheduled user task. */
      id: number;
      workspacePk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = ScheduledUserTask;
    export type RequestHeaders = {};
    export type ResponseBody = ScheduledUserTask;
  }

  /**
   * No description
   * @tags workspace
   * @name WorkspaceScheduledTasksPartialUpdate
   * @request PATCH:/api/v1/workspace/{workspace_pk}/scheduled-tasks/{id}/
   * @secure
   * @response `200` `ScheduledUserTask`
   */
  export namespace WorkspaceScheduledTasksPartialUpdate {
    export type RequestParams = {
      /** A unique integer value identifying this scheduled user task. */
      id: number;
      workspacePk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PatchedScheduledUserTask;
    export type RequestHeaders = {};
    export type ResponseBody = ScheduledUserTask;
  }

  /**
   * No description
   * @tags workspace
   * @name WorkspaceScheduledTasksDestroy
   * @request DELETE:/api/v1/workspace/{workspace_pk}/scheduled-tasks/{id}/
   * @secure
   * @response `204` `void` No response body
   */
  export namespace WorkspaceScheduledTasksDestroy {
    export type RequestParams = {
      /** A unique integer value identifying this scheduled user task. */
      id: number;
      workspacePk: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title 4Shipper API
 * @version 1.0.0 (v1)
 *
 * Documentation of API endpoints of 4Shipper by Transportly
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  addresses = {
    /**
     * No description
     *
     * @tags addresses
     * @name AddressesList
     * @request GET:/api/v1/addresses/
     * @secure
     * @response `200` `PaginatedAddressListList`
     */
    addressesList: (
      query: AddressesListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAddressListList, any>({
        path: `/api/v1/addresses/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags addresses
     * @name AddressesCreate
     * @request POST:/api/v1/addresses/
     * @secure
     * @response `201` `Address`
     */
    addressesCreate: (data: Address, params: RequestParams = {}) =>
      this.request<Address, any>({
        path: `/api/v1/addresses/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The bookable start times at this address on one date. Scoping comes from the mixin.
     *
     * @tags time-slots
     * @name AddressesAvailableSlotsList
     * @request GET:/api/v1/addresses/{address_pk}/available-slots/
     * @secure
     * @response `200` `AvailableSlots`
     * @response `400` `Record<string,any>`
     */
    addressesAvailableSlotsList: (
      { addressPk, ...query }: AddressesAvailableSlotsListParams,
      params: RequestParams = {},
    ) =>
      this.request<AvailableSlots, AddressesAvailableSlotsListError>({
        path: `/api/v1/addresses/${addressPk}/available-slots/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags time-slots
     * @name AddressesExceptionsList
     * @request GET:/api/v1/addresses/{address_pk}/exceptions/
     * @secure
     * @response `200` `PaginatedOperatingHoursExceptionListList`
     */
    addressesExceptionsList: (
      { addressPk, ...query }: AddressesExceptionsListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedOperatingHoursExceptionListList, any>({
        path: `/api/v1/addresses/${addressPk}/exceptions/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags time-slots
     * @name AddressesExceptionsCreate
     * @request POST:/api/v1/addresses/{address_pk}/exceptions/
     * @secure
     * @response `201` `OperatingHoursExceptionList`
     */
    addressesExceptionsCreate: (
      { addressPk }: AddressesExceptionsCreateParams,
      data: OperatingHoursExceptionWrite,
      params: RequestParams = {},
    ) =>
      this.request<OperatingHoursExceptionList, any>({
        path: `/api/v1/addresses/${addressPk}/exceptions/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags time-slots
     * @name AddressesExceptionsUpdate
     * @request PUT:/api/v1/addresses/{address_pk}/exceptions/{id}/
     * @secure
     * @response `200` `OperatingHoursExceptionList`
     */
    addressesExceptionsUpdate: (
      { addressPk, id }: AddressesExceptionsUpdateParams,
      data: OperatingHoursExceptionWrite,
      params: RequestParams = {},
    ) =>
      this.request<OperatingHoursExceptionList, any>({
        path: `/api/v1/addresses/${addressPk}/exceptions/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags time-slots
     * @name AddressesExceptionsDestroy
     * @request DELETE:/api/v1/addresses/{address_pk}/exceptions/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    addressesExceptionsDestroy: (
      { addressPk, id }: AddressesExceptionsDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/addresses/${addressPk}/exceptions/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Dry run of the exception delete: upcoming bookings the change affects. Deletes nothing.
     *
     * @tags time-slots
     * @name AddressesExceptionsDeleteImpact
     * @request POST:/api/v1/addresses/{address_pk}/exceptions/{id}/delete-impact/
     * @secure
     * @response `200` `PaginatedBookingImpactList`
     */
    addressesExceptionsDeleteImpact: (
      { addressPk, id, ...query }: AddressesExceptionsDeleteImpactParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedBookingImpactList, any>({
        path: `/api/v1/addresses/${addressPk}/exceptions/${id}/delete-impact/`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Dry run of the exception update: upcoming bookings the change affects. Saves nothing.
     *
     * @tags time-slots
     * @name AddressesExceptionsUpdateImpact
     * @request POST:/api/v1/addresses/{address_pk}/exceptions/{id}/impact/
     * @secure
     * @response `200` `PaginatedBookingImpactList`
     */
    addressesExceptionsUpdateImpact: (
      { addressPk, id, ...query }: AddressesExceptionsUpdateImpactParams,
      data: OperatingHoursExceptionWrite,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedBookingImpactList, any>({
        path: `/api/v1/addresses/${addressPk}/exceptions/${id}/impact/`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Dry run of the exception create: upcoming bookings the change affects. Saves nothing.
     *
     * @tags time-slots
     * @name AddressesExceptionsCreateImpact
     * @request POST:/api/v1/addresses/{address_pk}/exceptions/impact/
     * @secure
     * @response `200` `PaginatedBookingImpactList`
     */
    addressesExceptionsCreateImpact: (
      { addressPk, ...query }: AddressesExceptionsCreateImpactParams,
      data: OperatingHoursExceptionWrite,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedBookingImpactList, any>({
        path: `/api/v1/addresses/${addressPk}/exceptions/impact/`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags time-slots
     * @name AddressesGatesList
     * @request GET:/api/v1/addresses/{address_pk}/gates/
     * @secure
     * @response `200` `(Gate)[]`
     */
    addressesGatesList: (
      { addressPk }: AddressesGatesListParams,
      params: RequestParams = {},
    ) =>
      this.request<Gate[], any>({
        path: `/api/v1/addresses/${addressPk}/gates/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Replace the whole gate set for the address.
     *
     * @tags time-slots
     * @name AddressesGatesBulkUpdate
     * @request PUT:/api/v1/addresses/{address_pk}/gates/bulk/
     * @secure
     * @response `200` `(Gate)[]`
     */
    addressesGatesBulkUpdate: (
      { addressPk }: AddressesGatesBulkUpdateParams,
      data: GateListWrite,
      params: RequestParams = {},
    ) =>
      this.request<Gate[], any>({
        path: `/api/v1/addresses/${addressPk}/gates/bulk/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Dry run of the gate replacement: upcoming bookings the change affects. Saves nothing.
     *
     * @tags time-slots
     * @name AddressesGatesBulkImpact
     * @request POST:/api/v1/addresses/{address_pk}/gates/bulk-impact/
     * @secure
     * @response `200` `PaginatedBookingImpactList`
     */
    addressesGatesBulkImpact: (
      { addressPk, ...query }: AddressesGatesBulkImpactParams,
      data: GateListWrite,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedBookingImpactList, any>({
        path: `/api/v1/addresses/${addressPk}/gates/bulk-impact/`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags time-slots
     * @name AddressesOperatingHoursList
     * @request GET:/api/v1/addresses/{address_pk}/operating-hours/
     * @secure
     * @response `200` `(OperatingHoursList)[]`
     */
    addressesOperatingHoursList: (
      { addressPk }: AddressesOperatingHoursListParams,
      params: RequestParams = {},
    ) =>
      this.request<OperatingHoursList[], any>({
        path: `/api/v1/addresses/${addressPk}/operating-hours/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Replace the whole week for the address.
     *
     * @tags time-slots
     * @name AddressesOperatingHoursBulkUpdate
     * @request PUT:/api/v1/addresses/{address_pk}/operating-hours/bulk/
     * @secure
     * @response `200` `(OperatingHoursList)[]`
     */
    addressesOperatingHoursBulkUpdate: (
      { addressPk }: AddressesOperatingHoursBulkUpdateParams,
      data: OperatingHoursListWrite,
      params: RequestParams = {},
    ) =>
      this.request<OperatingHoursList[], any>({
        path: `/api/v1/addresses/${addressPk}/operating-hours/bulk/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Dry run of the week replacement: upcoming bookings the change affects. Saves nothing.
     *
     * @tags time-slots
     * @name AddressesOperatingHoursBulkImpact
     * @request POST:/api/v1/addresses/{address_pk}/operating-hours/bulk-impact/
     * @secure
     * @response `200` `PaginatedBookingImpactList`
     */
    addressesOperatingHoursBulkImpact: (
      { addressPk, ...query }: AddressesOperatingHoursBulkImpactParams,
      data: OperatingHoursListWrite,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedBookingImpactList, any>({
        path: `/api/v1/addresses/${addressPk}/operating-hours/bulk-impact/`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description An address has exactly one settings record, so it is addressed by address alone.
     *
     * @tags time-slots
     * @name AddressesTimeSlotSettingsList
     * @request GET:/api/v1/addresses/{address_pk}/time-slot-settings/
     * @secure
     * @response `200` `AddressTimeSlotSettings`
     */
    addressesTimeSlotSettingsList: (
      { addressPk }: AddressesTimeSlotSettingsListParams,
      params: RequestParams = {},
    ) =>
      this.request<AddressTimeSlotSettings, any>({
        path: `/api/v1/addresses/${addressPk}/time-slot-settings/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description An address has exactly one settings record, so it is addressed by address alone.
     *
     * @tags time-slots
     * @name AddressesTimeSlotSettingsCreate
     * @request POST:/api/v1/addresses/{address_pk}/time-slot-settings/
     * @secure
     * @response `201` `AddressTimeSlotSettings`
     */
    addressesTimeSlotSettingsCreate: (
      { addressPk }: AddressesTimeSlotSettingsCreateParams,
      data: AddressTimeSlotSettingsWrite,
      params: RequestParams = {},
    ) =>
      this.request<AddressTimeSlotSettings, any>({
        path: `/api/v1/addresses/${addressPk}/time-slot-settings/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Future bookings and open links that deleting the address or turning its time slots off would close.
     *
     * @tags time-slots
     * @name AddressesTimeSlotSettingsDeactivationPreview
     * @request GET:/api/v1/addresses/{address_pk}/time-slot-settings/deactivation-preview/
     * @secure
     * @response `200` `PaginatedAddressDeactivationImpactList`
     */
    addressesTimeSlotSettingsDeactivationPreview: (
      {
        addressPk,
        ...query
      }: AddressesTimeSlotSettingsDeactivationPreviewParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAddressDeactivationImpactList, any>({
        path: `/api/v1/addresses/${addressPk}/time-slot-settings/deactivation-preview/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Dry run of the update: upcoming bookings the change affects. Saves nothing.
     *
     * @tags time-slots
     * @name AddressesTimeSlotSettingsImpact
     * @request POST:/api/v1/addresses/{address_pk}/time-slot-settings/impact/
     * @secure
     * @response `200` `PaginatedBookingImpactList`
     */
    addressesTimeSlotSettingsImpact: (
      { addressPk, ...query }: AddressesTimeSlotSettingsImpactParams,
      data: AddressTimeSlotSettingsWrite,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedBookingImpactList, any>({
        path: `/api/v1/addresses/${addressPk}/time-slot-settings/impact/`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Enable time slots for the address in one call: settings, gates and operating hours together.
     *
     * @tags time-slots
     * @name AddressesTimeSlotSettingsSetupCreate
     * @request POST:/api/v1/addresses/{address_pk}/time-slot-settings/setup/
     * @secure
     * @response `201` `AddressTimeSlotSettings`
     */
    addressesTimeSlotSettingsSetupCreate: (
      { addressPk }: AddressesTimeSlotSettingsSetupCreateParams,
      data: TimeSlotSetup,
      params: RequestParams = {},
    ) =>
      this.request<AddressTimeSlotSettings, any>({
        path: `/api/v1/addresses/${addressPk}/time-slot-settings/setup/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description An address has exactly one settings record, so it is addressed by address alone.
     *
     * @tags time-slots
     * @name AddressesTimeSlotSettingsTurnOff
     * @request POST:/api/v1/addresses/{address_pk}/time-slot-settings/turn-off/
     * @secure
     * @response `200` `AddressTimeSlotSettings`
     */
    addressesTimeSlotSettingsTurnOff: (
      { addressPk }: AddressesTimeSlotSettingsTurnOffParams,
      params: RequestParams = {},
    ) =>
      this.request<AddressTimeSlotSettings, any>({
        path: `/api/v1/addresses/${addressPk}/time-slot-settings/turn-off/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description An address has exactly one settings record, so it is addressed by address alone.
     *
     * @tags time-slots
     * @name AddressesTimeSlotSettingsTurnOn
     * @request POST:/api/v1/addresses/{address_pk}/time-slot-settings/turn-on/
     * @secure
     * @response `200` `AddressTimeSlotSettings`
     */
    addressesTimeSlotSettingsTurnOn: (
      { addressPk }: AddressesTimeSlotSettingsTurnOnParams,
      params: RequestParams = {},
    ) =>
      this.request<AddressTimeSlotSettings, any>({
        path: `/api/v1/addresses/${addressPk}/time-slot-settings/turn-on/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description An address has exactly one settings record, so it is addressed by address alone.
     *
     * @tags time-slots
     * @name AddressesTimeSlotSettingsUpdate
     * @request PUT:/api/v1/addresses/{address_pk}/time-slot-settings/update/
     * @secure
     * @response `200` `AddressTimeSlotSettings`
     */
    addressesTimeSlotSettingsUpdate: (
      { addressPk }: AddressesTimeSlotSettingsUpdateParams,
      data: AddressTimeSlotSettingsWrite,
      params: RequestParams = {},
    ) =>
      this.request<AddressTimeSlotSettings, any>({
        path: `/api/v1/addresses/${addressPk}/time-slot-settings/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags addresses
     * @name AddressesRetrieve
     * @request GET:/api/v1/addresses/{id}/
     * @secure
     * @response `200` `Address`
     */
    addressesRetrieve: (
      { id }: AddressesRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<Address, any>({
        path: `/api/v1/addresses/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags addresses
     * @name AddressesUpdate
     * @request PUT:/api/v1/addresses/{id}/
     * @secure
     * @response `200` `Address`
     */
    addressesUpdate: (
      { id }: AddressesUpdateParams,
      data: Address,
      params: RequestParams = {},
    ) =>
      this.request<Address, any>({
        path: `/api/v1/addresses/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags addresses
     * @name AddressesPartialUpdate
     * @request PATCH:/api/v1/addresses/{id}/
     * @secure
     * @response `200` `Address`
     */
    addressesPartialUpdate: (
      { id }: AddressesPartialUpdateParams,
      data: PatchedAddress,
      params: RequestParams = {},
    ) =>
      this.request<Address, any>({
        path: `/api/v1/addresses/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags addresses
     * @name AddressesDestroy
     * @request DELETE:/api/v1/addresses/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    addressesDestroy: (
      { id }: AddressesDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/addresses/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  ai = {
    /**
     * @description Refuse before anything is spent: the chatbot's calls are billed and metered by nothing. Raised ahead of authentication and validation on purpose — the action is ``AllowAny``, and an unimplemented endpoint owes every caller the same answer.
     *
     * @tags ai
     * @name AiChatBotStreamCreate
     * @request POST:/api/v1/ai/chat-bot-stream/
     * @secure
     * @response `501` `void` The AI assistant is not in service.
     */
    aiChatBotStreamCreate: (data: ChatBot, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/api/v1/ai/chat-bot-stream/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ai
     * @name AiExtractRequestDataFromDocumentCreate
     * @request POST:/api/v1/ai/extract-request-data-from-document/
     * @secure
     * @response `200` `DocumentUploadResponse`
     * @response `403` `void` The caller has no active workspace.
     * @response `429` `AIRequestLimitReached`
     */
    aiExtractRequestDataFromDocumentCreate: (
      data: DocumentUpload,
      params: RequestParams = {},
    ) =>
      this.request<
        DocumentUploadResponse,
        AiExtractRequestDataFromDocumentCreateError
      >({
        path: `/api/v1/ai/extract-request-data-from-document/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Report the caller's own AI usage so a client can warn before it refuses, not after.
     *
     * @tags ai
     * @name AiRateLimitStatusRetrieve
     * @request GET:/api/v1/ai/rate-limit-status/
     * @secure
     * @response `200` `AIRateLimitStatus`
     * @response `403` `void` The caller has no active workspace.
     */
    aiRateLimitStatusRetrieve: (params: RequestParams = {}) =>
      this.request<AIRateLimitStatus, void>({
        path: `/api/v1/ai/rate-limit-status/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  auctionStats = {
    /**
     * No description
     *
     * @tags auction-stats
     * @name AuctionStatsOverviewRetrieve
     * @request GET:/api/v1/auction-stats/overview/
     * @secure
     * @response `200` `AuctionOverviewStats`
     */
    auctionStatsOverviewRetrieve: (
      query: AuctionStatsOverviewRetrieveParams = {},
      params: RequestParams = {},
    ) =>
      this.request<AuctionOverviewStats, any>({
        path: `/api/v1/auction-stats/overview/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  auctions = {
    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsList
     * @request GET:/api/v1/auctions/
     * @secure
     * @response `200` `PaginatedAuctionListList`
     */
    auctionsList: (
      query: AuctionsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAuctionListList, any>({
        path: `/api/v1/auctions/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsCreate
     * @request POST:/api/v1/auctions/
     * @secure
     * @response `201` `Auction`
     */
    auctionsCreate: (data: Auction, params: RequestParams = {}) =>
      this.request<Auction, any>({
        path: `/api/v1/auctions/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for Bid model just for logged in user.
     *
     * @tags bids
     * @name AuctionsBidsList
     * @request GET:/api/v1/auctions/{auction_pk}/bids/
     * @secure
     * @response `200` `(Bid)[]`
     */
    auctionsBidsList: (
      { auctionPk, ...query }: AuctionsBidsListParams,
      params: RequestParams = {},
    ) =>
      this.request<Bid[], any>({
        path: `/api/v1/auctions/${auctionPk}/bids/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginated, read-only bidding history: all bids for an auction.
     *
     * @tags bids
     * @name AuctionBidsHistoryList
     * @request GET:/api/v1/auctions/{auction_pk}/bids-history/
     * @secure
     * @response `200` `PaginatedBidHistoryList`
     */
    auctionBidsHistoryList: (
      { auctionPk, ...query }: AuctionBidsHistoryListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedBidHistoryList, any>({
        path: `/api/v1/auctions/${auctionPk}/bids-history/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Distinct carriers that placed a bid in this auction — options for the carrier filter.
     *
     * @tags auctions
     * @name AuctionsBidsHistoryBiddersList
     * @request GET:/api/v1/auctions/{auction_pk}/bids-history/bidders/
     * @secure
     * @response `200` `(BidHistoryBidder)[]`
     */
    auctionsBidsHistoryBiddersList: (
      { auctionPk }: AuctionsBidsHistoryBiddersListParams,
      params: RequestParams = {},
    ) =>
      this.request<BidHistoryBidder[], any>({
        path: `/api/v1/auctions/${auctionPk}/bids-history/bidders/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for Bid model just for logged in user.
     *
     * @tags bids
     * @name AuctionsBidsRetrieve
     * @request GET:/api/v1/auctions/{auction_pk}/bids/{id}/
     * @secure
     * @response `200` `Bid`
     */
    auctionsBidsRetrieve: (
      { auctionPk, id }: AuctionsBidsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<Bid, any>({
        path: `/api/v1/auctions/${auctionPk}/bids/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for Bid model just for logged in user.
     *
     * @tags bids
     * @name AuctionsBidsUpdate
     * @request PUT:/api/v1/auctions/{auction_pk}/bids/{id}/
     * @secure
     * @response `200` `UpdateBid`
     */
    auctionsBidsUpdate: (
      { auctionPk, id }: AuctionsBidsUpdateParams,
      data: UpdateBid,
      params: RequestParams = {},
    ) =>
      this.request<UpdateBid, any>({
        path: `/api/v1/auctions/${auctionPk}/bids/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for Bid model just for logged in user.
     *
     * @tags bids
     * @name AuctionsBidsPartialUpdate
     * @request PATCH:/api/v1/auctions/{auction_pk}/bids/{id}/
     * @secure
     * @response `200` `UpdateBid`
     */
    auctionsBidsPartialUpdate: (
      { auctionPk, id }: AuctionsBidsPartialUpdateParams,
      data: PatchedUpdateBid,
      params: RequestParams = {},
    ) =>
      this.request<UpdateBid, any>({
        path: `/api/v1/auctions/${auctionPk}/bids/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for Bid model just for logged in user.
     *
     * @tags bids
     * @name AuctionsBidsExcludeFromStatsCreate
     * @request POST:/api/v1/auctions/{auction_pk}/bids/{id}/exclude-from-stats/
     * @secure
     * @response `200` `Bid`
     */
    auctionsBidsExcludeFromStatsCreate: (
      { auctionPk, id }: AuctionsBidsExcludeFromStatsCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<Bid, any>({
        path: `/api/v1/auctions/${auctionPk}/bids/${id}/exclude-from-stats/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for Bid model just for logged in user.
     *
     * @tags bids
     * @name AuctionsBidsIncludeInStatsCreate
     * @request POST:/api/v1/auctions/{auction_pk}/bids/{id}/include-in-stats/
     * @secure
     * @response `200` `Bid`
     */
    auctionsBidsIncludeInStatsCreate: (
      { auctionPk, id }: AuctionsBidsIncludeInStatsCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<Bid, any>({
        path: `/api/v1/auctions/${auctionPk}/bids/${id}/include-in-stats/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents
     * @name AuctionsDocumentsList
     * @request GET:/api/v1/auctions/{auction_pk}/documents/
     * @secure
     * @response `200` `PaginatedDocumentList`
     */
    auctionsDocumentsList: (
      { auctionPk, ...query }: AuctionsDocumentsListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDocumentList, any>({
        path: `/api/v1/auctions/${auctionPk}/documents/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags messages
     * @name AuctionsMessagesList
     * @request GET:/api/v1/auctions/{auction_pk}/messages/
     * @secure
     * @response `200` `PaginatedMessageList`
     */
    auctionsMessagesList: (
      { auctionPk, ...query }: AuctionsMessagesListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedMessageList, any>({
        path: `/api/v1/auctions/${auctionPk}/messages/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags messages
     * @name AuctionsMessagesCreate
     * @request POST:/api/v1/auctions/{auction_pk}/messages/
     * @secure
     * @response `201` `Message`
     */
    auctionsMessagesCreate: (
      { auctionPk }: AuctionsMessagesCreateParams,
      data: Message,
      params: RequestParams = {},
    ) =>
      this.request<Message, any>({
        path: `/api/v1/auctions/${auctionPk}/messages/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags messages
     * @name AuctionsMessagesMarkAsReadCreate
     * @request POST:/api/v1/auctions/{auction_pk}/messages/mark-as-read/
     * @secure
     * @response `200` `MarkAsReadMessage`
     */
    auctionsMessagesMarkAsReadCreate: (
      { auctionPk }: AuctionsMessagesMarkAsReadCreateParams,
      data: MarkAsReadMessage,
      params: RequestParams = {},
    ) =>
      this.request<MarkAsReadMessage, any>({
        path: `/api/v1/auctions/${auctionPk}/messages/mark-as-read/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auctions
     * @name AuctionsParticipantsList
     * @request GET:/api/v1/auctions/{auction_pk}/participants/
     * @secure
     * @response `200` `(AuctionParticipant)[]`
     */
    auctionsParticipantsList: (
      { auctionPk, ...query }: AuctionsParticipantsListParams,
      params: RequestParams = {},
    ) =>
      this.request<AuctionParticipant[], any>({
        path: `/api/v1/auctions/${auctionPk}/participants/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auctions
     * @name AuctionsParticipantsRetrieve
     * @request GET:/api/v1/auctions/{auction_pk}/participants/{id}/
     * @secure
     * @response `200` `AuctionParticipant`
     */
    auctionsParticipantsRetrieve: (
      { auctionPk, id }: AuctionsParticipantsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<AuctionParticipant, any>({
        path: `/api/v1/auctions/${auctionPk}/participants/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auctions
     * @name AuctionsParticipantsResendInvitationCreate
     * @request POST:/api/v1/auctions/{auction_pk}/participants/{id}/resend-invitation/
     * @secure
     * @response `200` `AuctionParticipantResendInvitation`
     */
    auctionsParticipantsResendInvitationCreate: (
      { auctionPk, id }: AuctionsParticipantsResendInvitationCreateParams,
      data: AuctionParticipantResendInvitation,
      params: RequestParams = {},
    ) =>
      this.request<AuctionParticipantResendInvitation, any>({
        path: `/api/v1/auctions/${auctionPk}/participants/${id}/resend-invitation/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auctions
     * @name AuctionsParticipantsStatusCreate
     * @request POST:/api/v1/auctions/{auction_pk}/participants/{id}/status/
     * @secure
     * @response `200` `AuctionSetParticipantStatus`
     */
    auctionsParticipantsStatusCreate: (
      { auctionPk, id }: AuctionsParticipantsStatusCreateParams,
      data: AuctionSetParticipantStatus,
      params: RequestParams = {},
    ) =>
      this.request<AuctionSetParticipantStatus, any>({
        path: `/api/v1/auctions/${auctionPk}/participants/${id}/status/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsRetrieve
     * @request GET:/api/v1/auctions/{id}/
     * @secure
     * @response `200` `Auction`
     */
    auctionsRetrieve: (
      { id }: AuctionsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<Auction, any>({
        path: `/api/v1/auctions/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsUpdate
     * @request PUT:/api/v1/auctions/{id}/
     * @secure
     * @response `200` `AuctionUpdate`
     */
    auctionsUpdate: (
      { id }: AuctionsUpdateParams,
      data: AuctionUpdate,
      params: RequestParams = {},
    ) =>
      this.request<AuctionUpdate, any>({
        path: `/api/v1/auctions/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsPartialUpdate
     * @request PATCH:/api/v1/auctions/{id}/
     * @secure
     * @response `200` `AuctionUpdate`
     */
    auctionsPartialUpdate: (
      { id }: AuctionsPartialUpdateParams,
      data: PatchedAuctionUpdate,
      params: RequestParams = {},
    ) =>
      this.request<AuctionUpdate, any>({
        path: `/api/v1/auctions/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsDestroy
     * @request DELETE:/api/v1/auctions/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    auctionsDestroy: (
      { id, ...query }: AuctionsDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/auctions/${id}/`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsCancelCreate
     * @request POST:/api/v1/auctions/{id}/cancel/
     * @secure
     * @response `200` `Auction`
     */
    auctionsCancelCreate: (
      { id }: AuctionsCancelCreateParams,
      data: Auction,
      params: RequestParams = {},
    ) =>
      this.request<Auction, any>({
        path: `/api/v1/auctions/${id}/cancel/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsChangePaymentMethodCreate
     * @request POST:/api/v1/auctions/{id}/change-payment-method/
     * @secure
     * @response `200` `AuctionChangePaymentMethod`
     */
    auctionsChangePaymentMethodCreate: (
      { id }: AuctionsChangePaymentMethodCreateParams,
      data: AuctionChangePaymentMethod,
      params: RequestParams = {},
    ) =>
      this.request<AuctionChangePaymentMethod, any>({
        path: `/api/v1/auctions/${id}/change-payment-method/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsContractOptionRetrieve
     * @request GET:/api/v1/auctions/{id}/contract-option/
     * @secure
     * @response `200` `ContractOptionRow`
     */
    auctionsContractOptionRetrieve: (
      { id }: AuctionsContractOptionRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractOptionRow, any>({
        path: `/api/v1/auctions/${id}/contract-option/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsMergedList
     * @request GET:/api/v1/auctions/{id}/merged/
     * @secure
     * @response `200` `(AuctionList)[]`
     */
    auctionsMergedList: (
      { id, ...query }: AuctionsMergedListParams,
      params: RequestParams = {},
    ) =>
      this.request<AuctionList[], any>({
        path: `/api/v1/auctions/${id}/merged/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsPublishCreate
     * @request POST:/api/v1/auctions/{id}/publish/
     * @secure
     * @response `200` `Auction`
     */
    auctionsPublishCreate: (
      { id }: AuctionsPublishCreateParams,
      data: Auction,
      params: RequestParams = {},
    ) =>
      this.request<Auction, any>({
        path: `/api/v1/auctions/${id}/publish/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsTakeInstantOrderCreate
     * @request POST:/api/v1/auctions/{id}/take-instant-order/
     * @secure
     * @response `200` `AuctionTakeInstantOrder`
     */
    auctionsTakeInstantOrderCreate: (
      { id }: AuctionsTakeInstantOrderCreateParams,
      data: AuctionTakeInstantOrder,
      params: RequestParams = {},
    ) =>
      this.request<AuctionTakeInstantOrder, any>({
        path: `/api/v1/auctions/${id}/take-instant-order/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsUnlinkMergedCreate
     * @request POST:/api/v1/auctions/{id}/unlink-merged/
     * @secure
     * @response `200` `AuctionUnlinkMerged`
     */
    auctionsUnlinkMergedCreate: (
      { id }: AuctionsUnlinkMergedCreateParams,
      data: AuctionUnlinkMerged,
      params: RequestParams = {},
    ) =>
      this.request<AuctionUnlinkMerged, any>({
        path: `/api/v1/auctions/${id}/unlink-merged/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsExportRetrieve
     * @request GET:/api/v1/auctions/export/
     * @secure
     * @response `200` `File`
     * @response `204` `void` No response body
     */
    auctionsExportRetrieve: (
      query: AuctionsExportRetrieveParams = {},
      params: RequestParams = {},
    ) =>
      this.request<Blob, any>({
        path: `/api/v1/auctions/export/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags auctions
     * @name AuctionsListToMergeList
     * @request GET:/api/v1/auctions/list-to-merge/
     * @secure
     * @response `200` `(Auction)[]`
     */
    auctionsListToMergeList: (
      query: AuctionsListToMergeListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<Auction[], any>({
        path: `/api/v1/auctions/list-to-merge/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  auth = {
    /**
     * @description Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework Accept the following POST parameters: username, password Return the REST Framework Token Object's key.
     *
     * @tags auth
     * @name AuthLoginCreate
     * @request POST:/api/v1/auth/login/
     * @secure
     * @response `200` `JWT`
     */
    authLoginCreate: (data: Login, params: RequestParams = {}) =>
      this.request<JWT, any>({
        path: `/api/v1/auth/login/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Calls Django logout method and delete the Token object assigned to the current User object. Accepts/Returns nothing.
     *
     * @tags auth
     * @name AuthLogoutCreate
     * @request POST:/api/v1/auth/logout/
     * @secure
     * @response `200` `RestAuthDetail`
     */
    authLogoutCreate: (data: Logout, params: RequestParams = {}) =>
      this.request<RestAuthDetail, any>({
        path: `/api/v1/auth/logout/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Calls Django Auth SetPasswordForm save method. Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
     *
     * @tags auth
     * @name AuthPasswordChangeCreate
     * @request POST:/api/v1/auth/password/change/
     * @secure
     * @response `200` `RestAuthDetail`
     */
    authPasswordChangeCreate: (
      data: PasswordChange,
      params: RequestParams = {},
    ) =>
      this.request<RestAuthDetail, any>({
        path: `/api/v1/auth/password/change/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Calls Django Auth PasswordResetForm save method. Accepts the following POST parameters: email Returns the success/fail message.
     *
     * @tags auth
     * @name AuthPasswordResetCreate
     * @request POST:/api/v1/auth/password/reset/
     * @secure
     * @response `200` `RestAuthDetail`
     */
    authPasswordResetCreate: (
      data: PasswordReset,
      params: RequestParams = {},
    ) =>
      this.request<RestAuthDetail, any>({
        path: `/api/v1/auth/password/reset/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Password reset e-mail link is confirmed, therefore this resets the user's password. Accepts the following POST parameters: token, uid, new_password1, new_password2 Returns the success/fail message.
     *
     * @tags auth
     * @name AuthPasswordResetConfirmCreate
     * @request POST:/api/v1/auth/password/reset/confirm/
     * @secure
     * @response `200` `RestAuthDetail`
     */
    authPasswordResetConfirmCreate: (
      data: PasswordResetConfirm,
      params: RequestParams = {},
    ) =>
      this.request<RestAuthDetail, any>({
        path: `/api/v1/auth/password/reset/confirm/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Registers a new user. Accepts the following POST parameters: username, email, password1, password2.
     *
     * @tags auth
     * @name AuthRegisterCreate
     * @request POST:/api/v1/auth/register/
     * @secure
     * @response `201` `JWT`
     */
    authRegisterCreate: (data: Register, params: RequestParams = {}) =>
      this.request<JWT, any>({
        path: `/api/v1/auth/register/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Resends another email to an unverified email. Accepts the following POST parameter: email.
     *
     * @tags auth
     * @name AuthRegisterResendEmailCreate
     * @request POST:/api/v1/auth/register/resend-email/
     * @secure
     * @response `201` `RestAuthDetail`
     */
    authRegisterResendEmailCreate: (
      data: ResendEmailVerification,
      params: RequestParams = {},
    ) =>
      this.request<RestAuthDetail, any>({
        path: `/api/v1/auth/register/resend-email/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Verifies the email associated with the provided key. Accepts the following POST parameter: key.
     *
     * @tags auth
     * @name AuthRegisterVerifyEmailCreate
     * @request POST:/api/v1/auth/register/verify-email/
     * @secure
     * @response `200` `RestAuthDetail`
     */
    authRegisterVerifyEmailCreate: (
      data: VerifyEmail,
      params: RequestParams = {},
    ) =>
      this.request<RestAuthDetail, any>({
        path: `/api/v1/auth/register/verify-email/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter class FacebookLogin(SocialLoginView): adapter_class = FacebookOAuth2Adapter ------------- example usage for facebook with code ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client class FacebookLogin(SocialLoginView): adapter_class = FacebookOAuth2Adapter client_class = OAuth2Client callback_url = 'localhost:8000' -------------
     *
     * @tags auth
     * @name AuthSocialMicrosoftCreate
     * @request POST:/api/v1/auth/social/microsoft/
     * @secure
     * @response `200` `JWT`
     */
    authSocialMicrosoftCreate: (
      data: MicrosoftLogin,
      params: RequestParams = {},
    ) =>
      this.request<JWT, any>({
        path: `/api/v1/auth/social/microsoft/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter class FacebookLogin(SocialLoginView): adapter_class = FacebookOAuth2Adapter ------------- example usage for facebook with code ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client class FacebookLogin(SocialLoginView): adapter_class = FacebookOAuth2Adapter client_class = OAuth2Client callback_url = 'localhost:8000' -------------
     *
     * @tags auth
     * @name AuthSocialMicrosoftAccessTokenCreate
     * @request POST:/api/v1/auth/social/microsoft/access_token
     * @secure
     * @response `200` `MicrosoftAccessToken`
     */
    authSocialMicrosoftAccessTokenCreate: (
      data: MicrosoftLogin,
      params: RequestParams = {},
    ) =>
      this.request<MicrosoftAccessToken, any>({
        path: `/api/v1/auth/social/microsoft/access_token`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthSocialMicrosoftInfoCreate
     * @request POST:/api/v1/auth/social/microsoft/info
     * @secure
     * @response `200` `MicrosoftTenantResponse`
     */
    authSocialMicrosoftInfoCreate: (
      data: MicrosoftTenantRequest,
      params: RequestParams = {},
    ) =>
      this.request<MicrosoftTenantResponse, any>({
        path: `/api/v1/auth/social/microsoft/info`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     *
     * @tags auth
     * @name AuthTokenRefreshCreate
     * @request POST:/api/v1/auth/token/refresh/
     * @response `200` `TokenRefresh`
     */
    authTokenRefreshCreate: (data: TokenRefresh, params: RequestParams = {}) =>
      this.request<TokenRefresh, any>({
        path: `/api/v1/auth/token/refresh/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Takes a token and indicates if it is valid.  This view provides no information about a token's fitness for a particular use.
     *
     * @tags auth
     * @name AuthTokenVerifyCreate
     * @request POST:/api/v1/auth/token/verify/
     * @response `200` `TokenVerify`
     */
    authTokenVerifyCreate: (data: TokenVerify, params: RequestParams = {}) =>
      this.request<TokenVerify, any>({
        path: `/api/v1/auth/token/verify/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Reads and updates UserModel fields Accepts GET, PUT, PATCH methods. Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email Returns UserModel fields.
     *
     * @tags auth
     * @name AuthUserRetrieve
     * @request GET:/api/v1/auth/user/
     * @secure
     * @response `200` `UserDetails`
     */
    authUserRetrieve: (params: RequestParams = {}) =>
      this.request<UserDetails, any>({
        path: `/api/v1/auth/user/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Reads and updates UserModel fields Accepts GET, PUT, PATCH methods. Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email Returns UserModel fields.
     *
     * @tags auth
     * @name AuthUserUpdate
     * @request PUT:/api/v1/auth/user/
     * @secure
     * @response `200` `UserDetails`
     */
    authUserUpdate: (data: UserDetails, params: RequestParams = {}) =>
      this.request<UserDetails, any>({
        path: `/api/v1/auth/user/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Reads and updates UserModel fields Accepts GET, PUT, PATCH methods. Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email Returns UserModel fields.
     *
     * @tags auth
     * @name AuthUserPartialUpdate
     * @request PATCH:/api/v1/auth/user/
     * @secure
     * @response `200` `UserDetails`
     */
    authUserPartialUpdate: (
      data: PatchedUserDetails,
      params: RequestParams = {},
    ) =>
      this.request<UserDetails, any>({
        path: `/api/v1/auth/user/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  bookingLinks = {
    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags time-slots
     * @name BookingLinksList
     * @request GET:/api/v1/booking-links/
     * @secure
     * @response `200` `PaginatedBookingLinkListList`
     */
    bookingLinksList: (
      query: BookingLinksListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedBookingLinkListList, any>({
        path: `/api/v1/booking-links/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags time-slots
     * @name BookingLinksCreate
     * @request POST:/api/v1/booking-links/
     * @secure
     * @response `201` `BookingLinkList`
     * @response `400` `Record<string,any>`
     */
    bookingLinksCreate: (data: BookingLinkCreate, params: RequestParams = {}) =>
      this.request<BookingLinkList, BookingLinksCreateError>({
        path: `/api/v1/booking-links/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags time-slots
     * @name BookingLinksDestroy
     * @request DELETE:/api/v1/booking-links/{id}/
     * @secure
     * @response `204` `void` No response body
     * @response `400` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    bookingLinksDestroy: (
      { id }: BookingLinksDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, BookingLinksDestroyError>({
        path: `/api/v1/booking-links/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description E-mail a link not booked or revoked yet again with a fresh validity, within the send limit.
     *
     * @tags time-slots
     * @name BookingLinksResend
     * @request POST:/api/v1/booking-links/{id}/resend/
     * @secure
     * @response `200` `BookingLinkList`
     * @response `400` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    bookingLinksResend: (
      { id }: BookingLinksResendParams,
      params: RequestParams = {},
    ) =>
      this.request<BookingLinkList, BookingLinksResendError>({
        path: `/api/v1/booking-links/${id}/resend/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Take back a link that has not expired yet; idempotent for an already revoked one.
     *
     * @tags time-slots
     * @name BookingLinksRevoke
     * @request POST:/api/v1/booking-links/{id}/revoke/
     * @secure
     * @response `200` `BookingLinkList`
     * @response `400` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    bookingLinksRevoke: (
      { id }: BookingLinksRevokeParams,
      params: RequestParams = {},
    ) =>
      this.request<BookingLinkList, BookingLinksRevokeError>({
        path: `/api/v1/booking-links/${id}/revoke/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags time-slots
     * @name BookingLinksCountsRetrieve
     * @request GET:/api/v1/booking-links/counts/
     * @secure
     * @response `200` `BookingLinkCounts`
     */
    bookingLinksCountsRetrieve: (
      query: BookingLinksCountsRetrieveParams = {},
      params: RequestParams = {},
    ) =>
      this.request<BookingLinkCounts, any>({
        path: `/api/v1/booking-links/counts/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  bookings = {
    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags time-slots
     * @name BookingsList
     * @request GET:/api/v1/bookings/
     * @secure
     * @response `200` `PaginatedTimeSlotBookingListList`
     */
    bookingsList: (
      query: BookingsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedTimeSlotBookingListList, any>({
        path: `/api/v1/bookings/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags time-slots
     * @name BookingsCreate
     * @request POST:/api/v1/bookings/
     * @secure
     * @response `201` `TimeSlotBookingList`
     * @response `400` `Record<string,any>`
     */
    bookingsCreate: (data: TimeSlotBookingCreate, params: RequestParams = {}) =>
      this.request<TimeSlotBookingList, BookingsCreateError>({
        path: `/api/v1/bookings/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags time-slots
     * @name BookingsRetrieve
     * @request GET:/api/v1/bookings/{id}/
     * @secure
     * @response `200` `TimeSlotBookingDetail`
     * @response `404` `Record<string,any>`
     */
    bookingsRetrieve: (
      { id }: BookingsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<TimeSlotBookingDetail, BookingsRetrieveError>({
        path: `/api/v1/bookings/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Edit a stored-PENDING or stored-APPROVED booking in one request: slot, gate, vehicle type, contact and cargo.
     *
     * @tags time-slots
     * @name BookingsUpdate
     * @request PUT:/api/v1/bookings/{id}/
     * @secure
     * @response `200` `TimeSlotBookingDetail`
     * @response `400` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    bookingsUpdate: (
      { id }: BookingsUpdateParams,
      data: TimeSlotBookingUpdate,
      params: RequestParams = {},
    ) =>
      this.request<TimeSlotBookingDetail, BookingsUpdateError>({
        path: `/api/v1/bookings/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Approve a stored-PENDING booking onto the chosen gate; idempotent on the same gate.
     *
     * @tags time-slots
     * @name BookingsApprove
     * @request POST:/api/v1/bookings/{id}/approve/
     * @secure
     * @response `200` `TimeSlotBookingList`
     * @response `400` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    bookingsApprove: (
      { id }: BookingsApproveParams,
      data: TimeSlotBookingApprove,
      params: RequestParams = {},
    ) =>
      this.request<TimeSlotBookingList, BookingsApproveError>({
        path: `/api/v1/bookings/${id}/approve/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The gates this booking may move to - what the change-gate dialog offers.
     *
     * @tags time-slots
     * @name BookingsAvailableGates
     * @request GET:/api/v1/bookings/{id}/available-gates/
     * @secure
     * @response `200` `(GateNested)[]`
     * @response `404` `Record<string,any>`
     */
    bookingsAvailableGates: (
      { id }: BookingsAvailableGatesParams,
      params: RequestParams = {},
    ) =>
      this.request<GateNested[], BookingsAvailableGatesError>({
        path: `/api/v1/bookings/${id}/available-gates/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Cancel a stored-APPROVED booking; idempotent for an already canceled one.
     *
     * @tags time-slots
     * @name BookingsCancel
     * @request POST:/api/v1/bookings/{id}/cancel/
     * @secure
     * @response `200` `TimeSlotBookingList`
     * @response `400` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    bookingsCancel: (
      { id }: BookingsCancelParams,
      params: RequestParams = {},
    ) =>
      this.request<TimeSlotBookingList, BookingsCancelError>({
        path: `/api/v1/bookings/${id}/cancel/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Move the booking to another gate at its address; idempotent for its current gate.
     *
     * @tags time-slots
     * @name BookingsChangeGate
     * @request POST:/api/v1/bookings/{id}/change-gate/
     * @secure
     * @response `200` `TimeSlotBookingDetail`
     * @response `400` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    bookingsChangeGate: (
      { id }: BookingsChangeGateParams,
      data: TimeSlotBookingChangeGate,
      params: RequestParams = {},
    ) =>
      this.request<TimeSlotBookingDetail, BookingsChangeGateError>({
        path: `/api/v1/bookings/${id}/change-gate/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The compact read-only booking the timeline's modal shows.
     *
     * @tags time-slots
     * @name BookingsPreview
     * @request GET:/api/v1/bookings/{id}/preview/
     * @secure
     * @response `200` `TimeSlotBookingPreview`
     * @response `404` `Record<string,any>`
     */
    bookingsPreview: (
      { id }: BookingsPreviewParams,
      params: RequestParams = {},
    ) =>
      this.request<TimeSlotBookingPreview, BookingsPreviewError>({
        path: `/api/v1/bookings/${id}/preview/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Reject a stored-PENDING booking; idempotent for an already rejected one.
     *
     * @tags time-slots
     * @name BookingsReject
     * @request POST:/api/v1/bookings/{id}/reject/
     * @secure
     * @response `200` `TimeSlotBookingList`
     * @response `400` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    bookingsReject: (
      { id }: BookingsRejectParams,
      params: RequestParams = {},
    ) =>
      this.request<TimeSlotBookingList, BookingsRejectError>({
        path: `/api/v1/bookings/${id}/reject/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The bookings filter's address -> gates tree, deleted and turned-off addresses and deleted gates included.
     *
     * @tags time-slots
     * @name BookingsAddressGateOptionsList
     * @request GET:/api/v1/bookings/address-gate-options/
     * @secure
     * @response `200` `(BookingAddressGateOption)[]`
     */
    bookingsAddressGateOptionsList: (params: RequestParams = {}) =>
      this.request<BookingAddressGateOption[], any>({
        path: `/api/v1/bookings/address-gate-options/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description One date's gate timeline across every address with time slots turned on.
     *
     * @tags time-slots
     * @name BookingsTimeline
     * @request GET:/api/v1/bookings/timeline/
     * @secure
     * @response `200` `DayTimeline`
     * @response `400` `Record<string,any>`
     */
    bookingsTimeline: (
      query: BookingsTimelineParams,
      params: RequestParams = {},
    ) =>
      this.request<DayTimeline, BookingsTimelineError>({
        path: `/api/v1/bookings/timeline/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  byEmail = {
    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags by-email
     * @name ByEmailAuctionsList
     * @request GET:/api/v1/by-email/auctions/
     * @secure
     * @response `200` `PaginatedAuctionByEmailList`
     */
    byEmailAuctionsList: (
      query: ByEmailAuctionsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAuctionByEmailList, any>({
        path: `/api/v1/by-email/auctions/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags by-email
     * @name ByEmailAuctionsAutocompleteCreate
     * @request POST:/api/v1/by-email/auctions/autocomplete/
     * @secure
     * @response `200` `AutocompleteResponse`
     */
    byEmailAuctionsAutocompleteCreate: (
      data: AutocompleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<AutocompleteResponse, any>({
        path: `/api/v1/by-email/auctions/autocomplete/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags by-email
     * @name ByEmailAuctionsCountsRetrieve
     * @request GET:/api/v1/by-email/auctions/counts/
     * @secure
     * @response `200` `CarrierAuctionsCounts`
     */
    byEmailAuctionsCountsRetrieve: (params: RequestParams = {}) =>
      this.request<CarrierAuctionsCounts, any>({
        path: `/api/v1/by-email/auctions/counts/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Every booking on a transport the carrier won, on an auction its signed-in email was invited to, and every booking made through a booking link sent to that email. Read-only: every write goes through the by-hash auction link.
     *
     * @tags time-slots, by-email
     * @name ByEmailBookingsList
     * @request GET:/api/v1/by-email/bookings/
     * @secure
     * @response `200` `PaginatedCarrierBookingList`
     */
    byEmailBookingsList: (
      query: ByEmailBookingsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCarrierBookingList, any>({
        path: `/api/v1/by-email/bookings/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Every booking on a transport the carrier won, on an auction its signed-in email was invited to, and every booking made through a booking link sent to that email. Read-only: every write goes through the by-hash auction link.
     *
     * @tags time-slots, by-email
     * @name ByEmailBookingsRetrieve
     * @request GET:/api/v1/by-email/bookings/{hash}/
     * @secure
     * @response `200` `CarrierBookingDetail`
     */
    byEmailBookingsRetrieve: (
      { hash }: ByEmailBookingsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<CarrierBookingDetail, any>({
        path: `/api/v1/by-email/bookings/${hash}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The addresses this carrier's own bookings sit at - what the `address` filter picks from.
     *
     * @tags time-slots, by-email
     * @name ByEmailBookingsAddressesList
     * @request GET:/api/v1/by-email/bookings/addresses/
     * @secure
     * @response `200` `PaginatedBookingAddressNestedList`
     */
    byEmailBookingsAddressesList: (
      query: ByEmailBookingsAddressesListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedBookingAddressNestedList, any>({
        path: `/api/v1/by-email/bookings/addresses/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The shipper names on this carrier's own bookings - what the quick `shipper` filter offers.
     *
     * @tags time-slots, by-email
     * @name ByEmailBookingsShippersRetrieve
     * @request GET:/api/v1/by-email/bookings/shippers/
     * @secure
     * @response `200` `AutocompleteResponse`
     */
    byEmailBookingsShippersRetrieve: (params: RequestParams = {}) =>
      this.request<AutocompleteResponse, any>({
        path: `/api/v1/by-email/bookings/shippers/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-contracts, by-email
     * @name ByEmailContractsList
     * @request GET:/api/v1/by-email/contracts/
     * @secure
     * @response `200` `PaginatedCarrierContractListList`
     */
    byEmailContractsList: (
      query: ByEmailContractsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCarrierContractListList, any>({
        path: `/api/v1/by-email/contracts/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-contracts, by-email
     * @name ByEmailContractsRetrieve
     * @request GET:/api/v1/by-email/contracts/{hash}/
     * @secure
     * @response `200` `CarrierContractDetail`
     */
    byEmailContractsRetrieve: (
      { hash }: ByEmailContractsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<CarrierContractDetail, any>({
        path: `/api/v1/by-email/contracts/${hash}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-contracts, by-email
     * @name CarrierContractsPricesRetrieve
     * @request GET:/api/v1/by-email/contracts/{hash}/contract-prices/
     * @secure
     * @response `200` `ContractPrices`
     */
    carrierContractsPricesRetrieve: (
      { hash }: CarrierContractsPricesRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractPrices, any>({
        path: `/api/v1/by-email/contracts/${hash}/contract-prices/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-contracts, by-email
     * @name CarrierContractsRoutesList
     * @request GET:/api/v1/by-email/contracts/{hash}/routes/
     * @secure
     * @response `200` `PaginatedContractRouteRowList`
     */
    carrierContractsRoutesList: (
      { hash, ...query }: CarrierContractsRoutesListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedContractRouteRowList, any>({
        path: `/api/v1/by-email/contracts/${hash}/routes/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-contracts, by-email
     * @name CarrierContractsRoutesAutocomplete
     * @request GET:/api/v1/by-email/contracts/{hash}/routes/autocomplete/
     * @secure
     * @response `200` `AutocompleteResponse`
     * @response `400` `void` No response body
     */
    carrierContractsRoutesAutocomplete: (
      { hash, ...query }: CarrierContractsRoutesAutocompleteParams,
      params: RequestParams = {},
    ) =>
      this.request<AutocompleteResponse, void>({
        path: `/api/v1/by-email/contracts/${hash}/routes/autocomplete/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List the inbox newest-first, one message per conversation (cursor paginated).
     *
     * @tags messages, by-email
     * @name ByEmailMessagesList
     * @request GET:/api/v1/by-email/messages/
     * @secure
     * @response `200` `PaginatedCarrierMessageList`
     */
    byEmailMessagesList: (
      { email, ...query }: ByEmailMessagesListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCarrierMessageList, any>({
        path: `/api/v1/by-email/messages/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Cursor-paginated cross-timeline message inbox.
     *
     * @tags messages, by-email
     * @name ByEmailMessagesMarkAsReadCreate
     * @request POST:/api/v1/by-email/messages/{id}/mark_as_read/
     * @secure
     * @response `200` `void` No response body
     */
    byEmailMessagesMarkAsReadCreate: (
      { email, id }: ByEmailMessagesMarkAsReadCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/by-email/messages/${id}/mark_as_read/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Cursor-paginated cross-timeline message inbox.
     *
     * @tags messages, by-email
     * @name ByEmailMessagesMarkAllAsReadCreate
     * @request POST:/api/v1/by-email/messages/mark-all-as-read/
     * @secure
     * @response `200` `string`
     */
    byEmailMessagesMarkAllAsReadCreate: (
      { email }: ByEmailMessagesMarkAllAsReadCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/by-email/messages/mark-all-as-read/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Cursor-paginated cross-timeline message inbox.
     *
     * @tags messages, by-email
     * @name ByEmailMessagesUnreadCountRetrieve
     * @request GET:/api/v1/by-email/messages/unread-count/
     * @secure
     * @response `200` `number`
     */
    byEmailMessagesUnreadCountRetrieve: (
      { email }: ByEmailMessagesUnreadCountRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/api/v1/by-email/messages/unread-count/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-tenders, by-email
     * @name ByEmailTendersList
     * @request GET:/api/v1/by-email/tenders/
     * @secure
     * @response `200` `PaginatedCarrierTenderListList`
     */
    byEmailTendersList: (
      query: ByEmailTendersListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCarrierTenderListList, any>({
        path: `/api/v1/by-email/tenders/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-tenders, by-email
     * @name ByEmailTendersRetrieve
     * @request GET:/api/v1/by-email/tenders/{hash}/
     * @secure
     * @response `200` `CarrierTender`
     */
    byEmailTendersRetrieve: (
      { hash }: ByEmailTendersRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<CarrierTender, any>({
        path: `/api/v1/by-email/tenders/${hash}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-tenders, by-email
     * @name CarrierTendersProposalAccept
     * @request POST:/api/v1/by-email/tenders/{hash}/accept-proposal/
     * @secure
     * @response `200` `ContractAcceptedByCarrier`
     */
    carrierTendersProposalAccept: (
      { hash }: CarrierTendersProposalAcceptParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractAcceptedByCarrier, any>({
        path: `/api/v1/by-email/tenders/${hash}/accept-proposal/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-tenders, by-email
     * @name CarrierTendersCategoriesRetrieve
     * @request GET:/api/v1/by-email/tenders/{hash}/categories/
     * @secure
     * @response `200` `(TenderPriceCategoryCol)[]`
     */
    carrierTendersCategoriesRetrieve: (
      { hash, ...query }: CarrierTendersCategoriesRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<TenderPriceCategoryCol[], any>({
        path: `/api/v1/by-email/tenders/${hash}/categories/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-tenders, by-email
     * @name CarrierTendersConfirmedContractRetrieve
     * @request GET:/api/v1/by-email/tenders/{hash}/confirmed-contract/
     * @secure
     * @response `200` `ContractPrices`
     * @response `204` `void` No response body
     */
    carrierTendersConfirmedContractRetrieve: (
      { hash }: CarrierTendersConfirmedContractRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractPrices, any>({
        path: `/api/v1/by-email/tenders/${hash}/confirmed-contract/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-tenders, by-email
     * @name CarrierTendersContractProposalRetrieve
     * @request GET:/api/v1/by-email/tenders/{hash}/contract-proposal/
     * @secure
     * @response `200` `ContractProposal`
     * @response `204` `void` No response body
     */
    carrierTendersContractProposalRetrieve: (
      { hash }: CarrierTendersContractProposalRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractProposal, any>({
        path: `/api/v1/by-email/tenders/${hash}/contract-proposal/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-tenders, by-email
     * @name CarrierTendersHistoryOffersRetrieve
     * @request GET:/api/v1/by-email/tenders/{hash}/history-offers/
     * @secure
     * @response `200` `(CarrierHistoryOfferCell)[]`
     */
    carrierTendersHistoryOffersRetrieve: (
      { hash, ...query }: CarrierTendersHistoryOffersRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<CarrierHistoryOfferCell[], any>({
        path: `/api/v1/by-email/tenders/${hash}/history-offers/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-tenders, by-email
     * @name CarrierTendersOffersRetrieve
     * @request GET:/api/v1/by-email/tenders/{hash}/price-offers/
     * @secure
     * @response `200` `CarrierTenderPriceOffers`
     */
    carrierTendersOffersRetrieve: (
      { hash }: CarrierTendersOffersRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<CarrierTenderPriceOffers, any>({
        path: `/api/v1/by-email/tenders/${hash}/price-offers/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-tenders, by-email
     * @name CarrierTendersProposalReject
     * @request POST:/api/v1/by-email/tenders/{hash}/reject-proposal/
     * @secure
     * @response `204` `void` No response body
     */
    carrierTendersProposalReject: (
      { hash }: CarrierTendersProposalRejectParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/by-email/tenders/${hash}/reject-proposal/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-tenders, by-email
     * @name CarrierTendersRoutesRetrieve
     * @request GET:/api/v1/by-email/tenders/{hash}/routes/
     * @secure
     * @response `200` `(TenderRoute)[]`
     */
    carrierTendersRoutesRetrieve: (
      { hash, ...query }: CarrierTendersRoutesRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<TenderRoute[], any>({
        path: `/api/v1/by-email/tenders/${hash}/routes/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-tenders, by-email
     * @name ByEmailTendersSavePricesCreate
     * @request POST:/api/v1/by-email/tenders/{hash}/save-prices/
     * @secure
     * @response `200` `CarrierOfferBulkSave`
     */
    byEmailTendersSavePricesCreate: (
      { hash }: ByEmailTendersSavePricesCreateParams,
      data: CarrierOfferBulkSave,
      params: RequestParams = {},
    ) =>
      this.request<CarrierOfferBulkSave, any>({
        path: `/api/v1/by-email/tenders/${hash}/save-prices/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-tenders, by-email
     * @name ByEmailTendersSubmitPricesCreate
     * @request POST:/api/v1/by-email/tenders/{hash}/submit-prices/
     * @secure
     * @response `200` `CarrierOfferBulkSubmit`
     */
    byEmailTendersSubmitPricesCreate: (
      { hash }: ByEmailTendersSubmitPricesCreateParams,
      data: CarrierOfferBulkSubmit,
      params: RequestParams = {},
    ) =>
      this.request<CarrierOfferBulkSubmit, any>({
        path: `/api/v1/by-email/tenders/${hash}/submit-prices/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, by-email
     * @name ByEmailTendersDocumentsList
     * @request GET:/api/v1/by-email/tenders/{tender_hash}/documents/
     * @secure
     * @response `200` `PaginatedDocumentList`
     */
    byEmailTendersDocumentsList: (
      { tenderHash, ...query }: ByEmailTendersDocumentsListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDocumentList, any>({
        path: `/api/v1/by-email/tenders/${tenderHash}/documents/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, by-email
     * @name ByEmailTendersDocumentsRetrieve
     * @request GET:/api/v1/by-email/tenders/{tender_hash}/documents/{id}/
     * @secure
     * @response `200` `Document`
     */
    byEmailTendersDocumentsRetrieve: (
      { id, tenderHash }: ByEmailTendersDocumentsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<Document, any>({
        path: `/api/v1/by-email/tenders/${tenderHash}/documents/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Messages for a specific tender (carrier-facing, OTP auth).
     *
     * @tags messages, by-email
     * @name ByEmailTendersMessagesList
     * @request GET:/api/v1/by-email/tenders/{tender_hash}/messages/
     * @secure
     * @response `200` `PaginatedMessageList`
     */
    byEmailTendersMessagesList: (
      { tenderHash, ...query }: ByEmailTendersMessagesListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedMessageList, any>({
        path: `/api/v1/by-email/tenders/${tenderHash}/messages/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Messages for a specific tender (carrier-facing, OTP auth).
     *
     * @tags messages, by-email
     * @name ByEmailTendersMessagesCreate
     * @request POST:/api/v1/by-email/tenders/{tender_hash}/messages/
     * @secure
     * @response `201` `Message`
     */
    byEmailTendersMessagesCreate: (
      { tenderHash }: ByEmailTendersMessagesCreateParams,
      data: Message,
      params: RequestParams = {},
    ) =>
      this.request<Message, any>({
        path: `/api/v1/by-email/tenders/${tenderHash}/messages/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Messages for a specific tender (carrier-facing, OTP auth).
     *
     * @tags messages, by-email
     * @name ByEmailTendersMessagesMarkAsReadCreate
     * @request POST:/api/v1/by-email/tenders/{tender_hash}/messages/mark-as-read/
     * @secure
     * @response `200` `void` No response body
     */
    byEmailTendersMessagesMarkAsReadCreate: (
      { tenderHash }: ByEmailTendersMessagesMarkAsReadCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/by-email/tenders/${tenderHash}/messages/mark-as-read/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Messages for a specific tender (carrier-facing, OTP auth).
     *
     * @tags messages, by-email
     * @name ByEmailTendersMessagesUnreadCountRetrieve
     * @request GET:/api/v1/by-email/tenders/{tender_hash}/messages/unread-count/
     * @secure
     * @response `200` `number`
     */
    byEmailTendersMessagesUnreadCountRetrieve: (
      { tenderHash }: ByEmailTendersMessagesUnreadCountRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/api/v1/by-email/tenders/${tenderHash}/messages/unread-count/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-tenders, by-email
     * @name ByEmailTendersAutocompleteCreate
     * @request POST:/api/v1/by-email/tenders/autocomplete/
     * @secure
     * @response `200` `AutocompleteResponse`
     */
    byEmailTendersAutocompleteCreate: (
      data: AutocompleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<AutocompleteResponse, any>({
        path: `/api/v1/by-email/tenders/autocomplete/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags by-email
     * @name ByEmailTransportsList
     * @request GET:/api/v1/by-email/transports/
     * @secure
     * @response `200` `PaginatedTransportByEmailList`
     */
    byEmailTransportsList: (
      query: ByEmailTransportsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedTransportByEmailList, any>({
        path: `/api/v1/by-email/transports/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags by-email
     * @name ByEmailTransportsAutocompleteCreate
     * @request POST:/api/v1/by-email/transports/autocomplete/
     * @secure
     * @response `200` `AutocompleteResponse`
     */
    byEmailTransportsAutocompleteCreate: (
      data: AutocompleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<AutocompleteResponse, any>({
        path: `/api/v1/by-email/transports/autocomplete/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags by-email
     * @name ByEmailTransportsCountsRetrieve
     * @request GET:/api/v1/by-email/transports/counts/
     * @secure
     * @response `200` `CarrierTransportsCounts`
     */
    byEmailTransportsCountsRetrieve: (params: RequestParams = {}) =>
      this.request<CarrierTransportsCounts, any>({
        path: `/api/v1/by-email/transports/counts/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginates an id-only query, then loads just that page through ``get_queryset()``. For list querysets with wide ``select_related`` chains: sorting and paging the ids keeps those joins off every filtered row, so they are paid only for the page that is returned.
     *
     * @tags by-email
     * @name ByEmailTransportsTransportRetrieve
     * @request GET:/api/v1/by-email/transports/transport/
     * @secure
     * @response `200` `TransportByEmail`
     */
    byEmailTransportsTransportRetrieve: (
      query: ByEmailTransportsTransportRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<TransportByEmail, any>({
        path: `/api/v1/by-email/transports/transport/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags by-email
     * @name ByEmailWaypointsAutocompleteCreate
     * @request POST:/api/v1/by-email/waypoints/autocomplete/
     * @secure
     * @response `200` `AutocompleteResponse`
     */
    byEmailWaypointsAutocompleteCreate: (
      data: WaypointAutocompleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<AutocompleteResponse, any>({
        path: `/api/v1/by-email/waypoints/autocomplete/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  byHash = {
    /**
     * @description Active cargo units of the link's shipper, for the booking form of a usable link and the edit form of the booking made through a used one. An expired or revoked link answers 400 with ``code`` ``link_expired`` or ``link_revoked``.
     *
     * @tags by-hash
     * @name ByHashBookingLinksCargoItemUnitsList
     * @request GET:/api/v1/by-hash/booking-links/{booking_link_hash}/cargo-item-units/
     * @response `200` `(CargoItemUnit)[]`
     * @response `400` `Record<string,any>`
     * @response `403` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    byHashBookingLinksCargoItemUnitsList: (
      { bookingLinkHash }: ByHashBookingLinksCargoItemUnitsListParams,
      params: RequestParams = {},
    ) =>
      this.request<CargoItemUnit[], ByHashBookingLinksCargoItemUnitsListError>({
        path: `/api/v1/by-hash/booking-links/${bookingLinkHash}/cargo-item-units/`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description A booking link opened by its recipient. The hash is the only credential.
     *
     * @tags time-slots, by-hash
     * @name ByHashBookingLinksRetrieve
     * @request GET:/api/v1/by-hash/booking-links/{hash}/
     * @response `200` `BookingLinkByHash`
     * @response `403` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    byHashBookingLinksRetrieve: (
      { hash }: ByHashBookingLinksRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<BookingLinkByHash, ByHashBookingLinksRetrieveError>({
        path: `/api/v1/by-hash/booking-links/${hash}/`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Free starts at the link's address: for the booking form of a usable link, or for the edit form of the pending booking made through it, whose own slot is not counted as taken. An expired or revoked link answers 400 with ``code`` ``link_expired`` or ``link_revoked``; a settled booking with ``non_field_errors``.
     *
     * @tags time-slots, by-hash
     * @name ByHashBookingLinksAvailableSlotsRetrieve
     * @request GET:/api/v1/by-hash/booking-links/{hash}/available-slots/
     * @response `200` `CarrierAvailableSlots`
     * @response `400` `Record<string,any>`
     * @response `403` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    byHashBookingLinksAvailableSlotsRetrieve: (
      { hash, ...query }: ByHashBookingLinksAvailableSlotsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<
        CarrierAvailableSlots,
        ByHashBookingLinksAvailableSlotsRetrieveError
      >({
        path: `/api/v1/by-hash/booking-links/${hash}/available-slots/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description The booking made through the link, also past the link's expiry; 404 for a link without one.
     *
     * @tags time-slots, by-hash
     * @name ByHashBookingLinksBookingRetrieve
     * @request GET:/api/v1/by-hash/booking-links/{hash}/booking/
     * @response `200` `CarrierBookingDetail`
     * @response `403` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    byHashBookingLinksBookingRetrieve: (
      { hash }: ByHashBookingLinksBookingRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<
        CarrierBookingDetail,
        ByHashBookingLinksBookingRetrieveError
      >({
        path: `/api/v1/by-hash/booking-links/${hash}/booking/`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Book a slot at the link's address, once per link. An unusable link answers 400 with ``code`` ``link_used``, ``link_expired`` or ``link_revoked``.
     *
     * @tags time-slots, by-hash
     * @name ByHashBookingLinksBookingCreate
     * @request POST:/api/v1/by-hash/booking-links/{hash}/booking/
     * @response `201` `CarrierBookingDetail`
     * @response `400` `Record<string,any>`
     * @response `403` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    byHashBookingLinksBookingCreate: (
      { hash }: ByHashBookingLinksBookingCreateParams,
      data: BookingLinkBookingCreate,
      params: RequestParams = {},
    ) =>
      this.request<CarrierBookingDetail, ByHashBookingLinksBookingCreateError>({
        path: `/api/v1/by-hash/booking-links/${hash}/booking/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Edit the booking made through the link while it is still pending, the whole form again; also past the link's expiry. 404 for a link without a booking, 400 once the shipper has settled it.
     *
     * @tags time-slots, by-hash
     * @name ByHashBookingLinksBookingUpdate
     * @request PUT:/api/v1/by-hash/booking-links/{hash}/booking/
     * @response `200` `CarrierBookingDetail`
     * @response `400` `Record<string,any>`
     * @response `403` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    byHashBookingLinksBookingUpdate: (
      { hash }: ByHashBookingLinksBookingUpdateParams,
      data: BookingLinkBookingUpdate,
      params: RequestParams = {},
    ) =>
      this.request<CarrierBookingDetail, ByHashBookingLinksBookingUpdateError>({
        path: `/api/v1/by-hash/booking-links/${hash}/booking/`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport, updates, by-hash
     * @name ByHashContactsAuctionsBatchUpdatesList
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/batch-updates/
     * @secure
     * @response `200` `PaginatedTransportBatchUpdateList`
     */
    byHashContactsAuctionsBatchUpdatesList: (
      {
        auctionHash,
        contactHash,
        ...query
      }: ByHashContactsAuctionsBatchUpdatesListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedTransportBatchUpdateList, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/batch-updates/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport, updates, by-hash
     * @name ByHashContactsAuctionsBatchUpdatesCreate
     * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/batch-updates/
     * @secure
     * @response `201` `TransportBatchUpdate`
     */
    byHashContactsAuctionsBatchUpdatesCreate: (
      {
        auctionHash,
        contactHash,
      }: ByHashContactsAuctionsBatchUpdatesCreateParams,
      data: TransportBatchUpdate,
      params: RequestParams = {},
    ) =>
      this.request<TransportBatchUpdate, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/batch-updates/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags bids, by-hash
     * @name ByHashContactsAuctionsBidsList
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bids/
     * @secure
     * @response `200` `PaginatedBidByHashList`
     */
    byHashContactsAuctionsBidsList: (
      {
        auctionHash,
        contactHash,
        ...query
      }: ByHashContactsAuctionsBidsListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedBidByHashList, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/bids/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags bids, by-hash
     * @name ByHashContactsAuctionsBidsCreate
     * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bids/
     * @secure
     * @response `201` `BidByHash`
     */
    byHashContactsAuctionsBidsCreate: (
      { auctionHash, contactHash }: ByHashContactsAuctionsBidsCreateParams,
      data: BidByHash,
      params: RequestParams = {},
    ) =>
      this.request<BidByHash, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/bids/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags bids, by-hash
     * @name ByHashContactsAuctionsBidsRetrieve
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bids/{hash}/
     * @secure
     * @response `200` `BidByHash`
     */
    byHashContactsAuctionsBidsRetrieve: (
      {
        auctionHash,
        contactHash,
        hash,
      }: ByHashContactsAuctionsBidsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<BidByHash, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/bids/${hash}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags bids, by-hash
     * @name ByHashContactsAuctionsBidsUpdate
     * @request PUT:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bids/{hash}/
     * @secure
     * @response `200` `UpdateBidByHash`
     */
    byHashContactsAuctionsBidsUpdate: (
      {
        auctionHash,
        contactHash,
        hash,
      }: ByHashContactsAuctionsBidsUpdateParams,
      data: UpdateBidByHash,
      params: RequestParams = {},
    ) =>
      this.request<UpdateBidByHash, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/bids/${hash}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags bids, by-hash
     * @name ByHashContactsAuctionsBidsPartialUpdate
     * @request PATCH:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bids/{hash}/
     * @secure
     * @response `200` `UpdateBidByHash`
     */
    byHashContactsAuctionsBidsPartialUpdate: (
      {
        auctionHash,
        contactHash,
        hash,
      }: ByHashContactsAuctionsBidsPartialUpdateParams,
      data: PatchedUpdateBidByHash,
      params: RequestParams = {},
    ) =>
      this.request<UpdateBidByHash, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/bids/${hash}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auctions
     * @name ByHashContactsAuctionsBidsFeePreviewCreate
     * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bids/fee-preview/
     * @secure
     * @response `200` `FeePreviewOutput`
     */
    byHashContactsAuctionsBidsFeePreviewCreate: (
      {
        auctionHash,
        contactHash,
      }: ByHashContactsAuctionsBidsFeePreviewCreateParams,
      data: FeePreviewInput,
      params: RequestParams = {},
    ) =>
      this.request<FeePreviewOutput, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/bids/fee-preview/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Bookable starts at a stop of the auction's own transport - its own viewset, since the bookings one is booking-shaped (hash lookup, serializer map).
     *
     * @tags time-slots, by-hash
     * @name ByHashContactsAuctionsBookingSlotsAvailableSlotsRetrieve
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/booking-slots/available-slots/
     * @secure
     * @response `200` `CarrierAvailableSlots`
     * @response `400` `Record<string,any>`
     */
    byHashContactsAuctionsBookingSlotsAvailableSlotsRetrieve: (
      {
        auctionHash,
        contactHash,
        ...query
      }: ByHashContactsAuctionsBookingSlotsAvailableSlotsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<
        CarrierAvailableSlots,
        ByHashContactsAuctionsBookingSlotsAvailableSlotsRetrieveError
      >({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/booking-slots/available-slots/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Book a slot for one stop of the auction's transport.
     *
     * @tags time-slots, by-hash
     * @name ByHashContactsAuctionsBookingsCreate
     * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bookings/
     * @secure
     * @response `201` `CarrierBookingDetail`
     * @response `400` `Record<string,any>`
     */
    byHashContactsAuctionsBookingsCreate: (
      { auctionHash, contactHash }: ByHashContactsAuctionsBookingsCreateParams,
      data: TimeSlotBookingCarrierCreate,
      params: RequestParams = {},
    ) =>
      this.request<
        CarrierBookingDetail,
        ByHashContactsAuctionsBookingsCreateError
      >({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/bookings/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create, read, edit and cancel a booking on the auction's own transport.
     *
     * @tags time-slots, by-hash
     * @name ByHashContactsAuctionsBookingsRetrieve
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bookings/{hash}/
     * @secure
     * @response `200` `CarrierBookingDetail`
     */
    byHashContactsAuctionsBookingsRetrieve: (
      {
        auctionHash,
        contactHash,
        hash,
      }: ByHashContactsAuctionsBookingsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<CarrierBookingDetail, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/bookings/${hash}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Edit a pending booking on the auction's transport.
     *
     * @tags time-slots, by-hash
     * @name ByHashContactsAuctionsBookingsUpdate
     * @request PUT:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bookings/{hash}/
     * @secure
     * @response `200` `CarrierBookingDetail`
     * @response `400` `Record<string,any>`
     */
    byHashContactsAuctionsBookingsUpdate: (
      {
        auctionHash,
        contactHash,
        hash,
      }: ByHashContactsAuctionsBookingsUpdateParams,
      data: TimeSlotBookingCarrierUpdate,
      params: RequestParams = {},
    ) =>
      this.request<
        CarrierBookingDetail,
        ByHashContactsAuctionsBookingsUpdateError
      >({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/bookings/${hash}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create, read, edit and cancel a booking on the auction's own transport.
     *
     * @tags time-slots, by-hash
     * @name ByHashContactsAuctionsBookingsCancelCreate
     * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bookings/{hash}/cancel/
     * @secure
     * @response `204` `void` No response body
     */
    byHashContactsAuctionsBookingsCancelCreate: (
      {
        auctionHash,
        contactHash,
        hash,
      }: ByHashContactsAuctionsBookingsCancelCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/bookings/${hash}/cancel/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Everything the Add-new-booking form starts from, for one stop of the auction's transport.
     *
     * @tags time-slots, by-hash
     * @name ByHashContactsAuctionsBookingsPrefillRetrieve
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/bookings/prefill/
     * @secure
     * @response `200` `BookingPrefill`
     * @response `400` `Record<string,any>`
     * @response `404` `Record<string,any>`
     */
    byHashContactsAuctionsBookingsPrefillRetrieve: (
      {
        auctionHash,
        contactHash,
        ...query
      }: ByHashContactsAuctionsBookingsPrefillRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<
        BookingPrefill,
        ByHashContactsAuctionsBookingsPrefillRetrieveError
      >({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/bookings/prefill/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, by-hash
     * @name ByHashContactsAuctionsDocumentsList
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/documents/
     * @secure
     * @response `200` `PaginatedDocumentList`
     */
    byHashContactsAuctionsDocumentsList: (
      {
        auctionHash,
        contactHash,
        ...query
      }: ByHashContactsAuctionsDocumentsListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDocumentList, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/documents/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, by-hash
     * @name ByHashContactsAuctionsDocumentsCreate
     * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/documents/
     * @secure
     * @response `201` `Document`
     */
    byHashContactsAuctionsDocumentsCreate: (
      { auctionHash, contactHash }: ByHashContactsAuctionsDocumentsCreateParams,
      data: CarrierDocumentCreate,
      params: RequestParams = {},
    ) =>
      this.request<Document, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents, by-hash
     * @name ByHashContactsAuctionsDocumentsRetrieve
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/documents/{id}/
     * @secure
     * @response `200` `Document`
     */
    byHashContactsAuctionsDocumentsRetrieve: (
      {
        auctionHash,
        contactHash,
        id,
      }: ByHashContactsAuctionsDocumentsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<Document, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/documents/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags messages, by-hash
     * @name ByHashContactsAuctionsMessagesList
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/messages/
     * @secure
     * @response `200` `PaginatedMessageList`
     */
    byHashContactsAuctionsMessagesList: (
      {
        auctionHash,
        contactHash,
        ...query
      }: ByHashContactsAuctionsMessagesListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedMessageList, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/messages/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags messages, by-hash
     * @name ByHashContactsAuctionsMessagesCreate
     * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/messages/
     * @secure
     * @response `201` `Message`
     */
    byHashContactsAuctionsMessagesCreate: (
      { auctionHash, contactHash }: ByHashContactsAuctionsMessagesCreateParams,
      data: Message,
      params: RequestParams = {},
    ) =>
      this.request<Message, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/messages/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags messages, by-hash
     * @name ByHashContactsAuctionsMessagesMarkAsReadCreate
     * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/messages/mark_as_read/
     * @secure
     * @response `200` `void` No response body
     */
    byHashContactsAuctionsMessagesMarkAsReadCreate: (
      {
        auctionHash,
        contactHash,
      }: ByHashContactsAuctionsMessagesMarkAsReadCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/messages/mark_as_read/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags messages, by-hash
     * @name ByHashContactsAuctionsMessagesUnreadCountRetrieve
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/messages/unread-count/
     * @secure
     * @response `200` `number`
     */
    byHashContactsAuctionsMessagesUnreadCountRetrieve: (
      {
        auctionHash,
        contactHash,
      }: ByHashContactsAuctionsMessagesUnreadCountRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/messages/unread-count/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport, updates, by-hash
     * @name ByHashContactsAuctionsUpdatesListLatestList
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{auction_hash}/updates/list-latest/
     * @secure
     * @response `200` `(TransportLatestUpdate)[]`
     */
    byHashContactsAuctionsUpdatesListLatestList: (
      {
        auctionHash,
        contactHash,
        ...query
      }: ByHashContactsAuctionsUpdatesListLatestListParams,
      params: RequestParams = {},
    ) =>
      this.request<TransportLatestUpdate[], any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${auctionHash}/updates/list-latest/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auctions, by-hash
     * @name ByHashContactsAuctionsRetrieve
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{hash}/
     * @secure
     * @response `200` `AuctionByHash`
     */
    byHashContactsAuctionsRetrieve: (
      { contactHash, hash }: ByHashContactsAuctionsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<AuctionByHash, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${hash}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auctions, by-hash
     * @name ByHashContactsAuctionsDownloadTransportOrderRetrieve
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{hash}/download-transport-order/
     * @secure
     * @response `200` `File`
     */
    byHashContactsAuctionsDownloadTransportOrderRetrieve: (
      {
        contactHash,
        hash,
        ...query
      }: ByHashContactsAuctionsDownloadTransportOrderRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<Blob, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${hash}/download-transport-order/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags auctions, by-hash
     * @name ByHashContactsAuctionsStatusCreate
     * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{hash}/status/
     * @secure
     * @response `200` `AuctionSetParticipantStatus`
     */
    byHashContactsAuctionsStatusCreate: (
      { contactHash, hash }: ByHashContactsAuctionsStatusCreateParams,
      data: AuctionSetParticipantStatus,
      params: RequestParams = {},
    ) =>
      this.request<AuctionSetParticipantStatus, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${hash}/status/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport-cancel-request, auctions
     * @name ByHashContactsAuctionsTransportCancelRequestCreate
     * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{hash}/transport-cancel-request/
     * @secure
     * @response `200` `TransportCancelRequestCreate`
     */
    byHashContactsAuctionsTransportCancelRequestCreate: (
      {
        contactHash,
        hash,
      }: ByHashContactsAuctionsTransportCancelRequestCreateParams,
      data: TransportCancelRequestCreate,
      params: RequestParams = {},
    ) =>
      this.request<TransportCancelRequestCreate, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${hash}/transport-cancel-request/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport-details
     * @name ByHashContactsAuctionsTransportDetailsRetrieve
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/auctions/{hash}/transport-details/
     * @secure
     * @response `200` `TransportDetailByHash`
     */
    byHashContactsAuctionsTransportDetailsRetrieve: (
      {
        contactHash,
        hash,
      }: ByHashContactsAuctionsTransportDetailsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<TransportDetailByHash, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${hash}/transport-details/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport-details
     * @name ByHashContactsAuctionsTransportDetailsCreate
     * @request POST:/api/v1/by-hash/contacts/{contact_hash}/auctions/{hash}/transport-details/
     * @secure
     * @response `200` `TransportDetailByHash`
     */
    byHashContactsAuctionsTransportDetailsCreate: (
      { contactHash, hash }: ByHashContactsAuctionsTransportDetailsCreateParams,
      data: TransportDetailByHash,
      params: RequestParams = {},
    ) =>
      this.request<TransportDetailByHash, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/auctions/${hash}/transport-details/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This must be a viewset, because i want to use it in carrier by hash router
     *
     * @tags billing, by-hash
     * @name ByHashContactsBillingDetailsList
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/billing-details/
     * @secure
     * @response `200` `PaginatedCarrierBillingDetailsByHashInputList`
     */
    byHashContactsBillingDetailsList: (
      { contactHash, ...query }: ByHashContactsBillingDetailsListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCarrierBillingDetailsByHashInputList, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/billing-details/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This must be a viewset, because i want to use it in carrier by hash router
     *
     * @tags billing, by-hash
     * @name ByHashContactsBillingDetailsCreate
     * @request POST:/api/v1/by-hash/contacts/{contact_hash}/billing-details/
     * @secure
     * @response `201` `CarrierBillingDetailsByHashOutput`
     */
    byHashContactsBillingDetailsCreate: (
      { contactHash }: ByHashContactsBillingDetailsCreateParams,
      data: CarrierBillingDetailsByHashInput,
      params: RequestParams = {},
    ) =>
      this.request<CarrierBillingDetailsByHashOutput, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/billing-details/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This must be a viewset, because i want to use it in carrier by hash router
     *
     * @tags billing, by-hash
     * @name ByHashContactsBillingDetailsRetrieve
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/billing-details/{id}/
     * @secure
     * @response `200` `CarrierBillingDetailsByHashInput`
     */
    byHashContactsBillingDetailsRetrieve: (
      { contactHash, id }: ByHashContactsBillingDetailsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<CarrierBillingDetailsByHashInput, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/billing-details/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This must be a viewset, because i want to use it in carrier by hash router
     *
     * @tags billing, by-hash
     * @name ByHashContactsBillingDetailsApproveCreate
     * @request POST:/api/v1/by-hash/contacts/{contact_hash}/billing-details/{id}/approve/
     * @secure
     * @response `200` `CarrierBillingDetailsByHashOutput`
     */
    byHashContactsBillingDetailsApproveCreate: (
      { contactHash, id }: ByHashContactsBillingDetailsApproveCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<CarrierBillingDetailsByHashOutput, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/billing-details/${id}/approve/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags by-hash
     * @name ByHashContactsCargoItemUnitsList
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/cargo-item-units/
     * @secure
     * @response `200` `PaginatedCargoItemUnitList`
     */
    byHashContactsCargoItemUnitsList: (
      { contactHash, ...query }: ByHashContactsCargoItemUnitsListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCargoItemUnitList, any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/cargo-item-units/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags by-hash
     * @name ByHashContactsCargoItemUnitsAllList
     * @request GET:/api/v1/by-hash/contacts/{contact_hash}/cargo-item-units/all/
     * @secure
     * @response `200` `(CargoItemUnit)[]`
     */
    byHashContactsCargoItemUnitsAllList: (
      { contactHash, ...query }: ByHashContactsCargoItemUnitsAllListParams,
      params: RequestParams = {},
    ) =>
      this.request<CargoItemUnit[], any>({
        path: `/api/v1/by-hash/contacts/${contactHash}/cargo-item-units/all/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers, by-hash
     * @name ByHashContactsRetrieve
     * @request GET:/api/v1/by-hash/contacts/{hash}/
     * @secure
     * @response `200` `ContactByHash`
     */
    byHashContactsRetrieve: (
      { hash }: ByHashContactsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<ContactByHash, any>({
        path: `/api/v1/by-hash/contacts/${hash}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers, by-hash
     * @name ByHashContactsUpdate
     * @request PUT:/api/v1/by-hash/contacts/{hash}/
     * @secure
     * @response `200` `ContactByHash`
     */
    byHashContactsUpdate: (
      { hash }: ByHashContactsUpdateParams,
      data: ContactByHash,
      params: RequestParams = {},
    ) =>
      this.request<ContactByHash, any>({
        path: `/api/v1/by-hash/contacts/${hash}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers, by-hash
     * @name ByHashContactsPartialUpdate
     * @request PATCH:/api/v1/by-hash/contacts/{hash}/
     * @secure
     * @response `200` `ContactByHash`
     */
    byHashContactsPartialUpdate: (
      { hash }: ByHashContactsPartialUpdateParams,
      data: PatchedContactByHash,
      params: RequestParams = {},
    ) =>
      this.request<ContactByHash, any>({
        path: `/api/v1/by-hash/contacts/${hash}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  captcha = {
    /**
     * No description
     *
     * @tags core
     * @name CaptchaVerifyCreate
     * @request POST:/api/v1/captcha/verify/
     * @secure
     * @response `200` `RecaptchaVerifyResult`
     */
    captchaVerifyCreate: (
      data: CaptchaVerifyCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<RecaptchaVerifyResult, any>({
        path: `/api/v1/captcha/verify/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  cargoCategories = {
    /**
     * @description ViewSet providing CRUD operations for a cargo category. URL: /cargo-categories/
     *
     * @tags cargo-categories
     * @name CargoCategoriesList
     * @request GET:/api/v1/cargo-categories/
     * @secure
     * @response `200` `PaginatedCargoCategoryList`
     */
    cargoCategoriesList: (
      query: CargoCategoriesListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCargoCategoryList, any>({
        path: `/api/v1/cargo-categories/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a cargo category. URL: /cargo-categories/
     *
     * @tags cargo-categories
     * @name CargoCategoriesCreate
     * @request POST:/api/v1/cargo-categories/
     * @secure
     * @response `201` `CargoCategory`
     */
    cargoCategoriesCreate: (data: CargoCategory, params: RequestParams = {}) =>
      this.request<CargoCategory, any>({
        path: `/api/v1/cargo-categories/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a cargo category. URL: /cargo-categories/
     *
     * @tags cargo-categories
     * @name CargoCategoriesRetrieve
     * @request GET:/api/v1/cargo-categories/{id}/
     * @secure
     * @response `200` `CargoCategory`
     */
    cargoCategoriesRetrieve: (
      { id }: CargoCategoriesRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<CargoCategory, any>({
        path: `/api/v1/cargo-categories/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a cargo category. URL: /cargo-categories/
     *
     * @tags cargo-categories
     * @name CargoCategoriesUpdate
     * @request PUT:/api/v1/cargo-categories/{id}/
     * @secure
     * @response `200` `CargoCategory`
     */
    cargoCategoriesUpdate: (
      { id }: CargoCategoriesUpdateParams,
      data: CargoCategory,
      params: RequestParams = {},
    ) =>
      this.request<CargoCategory, any>({
        path: `/api/v1/cargo-categories/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a cargo category. URL: /cargo-categories/
     *
     * @tags cargo-categories
     * @name CargoCategoriesPartialUpdate
     * @request PATCH:/api/v1/cargo-categories/{id}/
     * @secure
     * @response `200` `CargoCategory`
     */
    cargoCategoriesPartialUpdate: (
      { id }: CargoCategoriesPartialUpdateParams,
      data: PatchedCargoCategory,
      params: RequestParams = {},
    ) =>
      this.request<CargoCategory, any>({
        path: `/api/v1/cargo-categories/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a cargo category. URL: /cargo-categories/
     *
     * @tags cargo-categories
     * @name CargoCategoriesDestroy
     * @request DELETE:/api/v1/cargo-categories/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    cargoCategoriesDestroy: (
      { id }: CargoCategoriesDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/cargo-categories/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  cargoItemUnits = {
    /**
     * No description
     *
     * @tags cargo-item-units
     * @name CargoItemUnitsList
     * @request GET:/api/v1/cargo-item-units/
     * @secure
     * @response `200` `PaginatedCargoItemUnitList`
     */
    cargoItemUnitsList: (
      query: CargoItemUnitsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCargoItemUnitList, any>({
        path: `/api/v1/cargo-item-units/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags cargo-item-units
     * @name CargoItemUnitsCreate
     * @request POST:/api/v1/cargo-item-units/
     * @secure
     * @response `201` `CargoItemUnit`
     */
    cargoItemUnitsCreate: (data: CargoItemUnit, params: RequestParams = {}) =>
      this.request<CargoItemUnit, any>({
        path: `/api/v1/cargo-item-units/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags cargo-item-units
     * @name CargoItemUnitsRetrieve
     * @request GET:/api/v1/cargo-item-units/{id}/
     * @secure
     * @response `200` `CargoItemUnit`
     */
    cargoItemUnitsRetrieve: (
      { id }: CargoItemUnitsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<CargoItemUnit, any>({
        path: `/api/v1/cargo-item-units/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags cargo-item-units
     * @name CargoItemUnitsUpdate
     * @request PUT:/api/v1/cargo-item-units/{id}/
     * @secure
     * @response `200` `CargoItemUnit`
     */
    cargoItemUnitsUpdate: (
      { id }: CargoItemUnitsUpdateParams,
      data: CargoItemUnit,
      params: RequestParams = {},
    ) =>
      this.request<CargoItemUnit, any>({
        path: `/api/v1/cargo-item-units/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags cargo-item-units
     * @name CargoItemUnitsPartialUpdate
     * @request PATCH:/api/v1/cargo-item-units/{id}/
     * @secure
     * @response `200` `CargoItemUnit`
     */
    cargoItemUnitsPartialUpdate: (
      { id }: CargoItemUnitsPartialUpdateParams,
      data: PatchedCargoItemUnit,
      params: RequestParams = {},
    ) =>
      this.request<CargoItemUnit, any>({
        path: `/api/v1/cargo-item-units/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tags
     * @name CargoItemUnitsAllList
     * @request GET:/api/v1/cargo-item-units/all/
     * @secure
     * @response `200` `(CargoItemUnit)[]`
     */
    cargoItemUnitsAllList: (
      query: CargoItemUnitsAllListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<CargoItemUnit[], any>({
        path: `/api/v1/cargo-item-units/all/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  carrierContacts = {
    /**
     * No description
     *
     * @tags carriers, contacts
     * @name CarrierContactsList
     * @request GET:/api/v1/carrier-contacts/
     * @secure
     * @response `200` `PaginatedContactList`
     */
    carrierContactsList: (
      query: CarrierContactsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedContactList, any>({
        path: `/api/v1/carrier-contacts/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers, contacts
     * @name CarrierContactsCreate
     * @request POST:/api/v1/carrier-contacts/
     * @secure
     * @response `201` `Contact`
     */
    carrierContactsCreate: (data: Contact, params: RequestParams = {}) =>
      this.request<Contact, any>({
        path: `/api/v1/carrier-contacts/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers, contacts
     * @name CarrierContactsRetrieve
     * @request GET:/api/v1/carrier-contacts/{id}/
     * @secure
     * @response `200` `Contact`
     */
    carrierContactsRetrieve: (
      { id }: CarrierContactsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<Contact, any>({
        path: `/api/v1/carrier-contacts/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers, contacts
     * @name CarrierContactsUpdate
     * @request PUT:/api/v1/carrier-contacts/{id}/
     * @secure
     * @response `200` `Contact`
     */
    carrierContactsUpdate: (
      { id }: CarrierContactsUpdateParams,
      data: Contact,
      params: RequestParams = {},
    ) =>
      this.request<Contact, any>({
        path: `/api/v1/carrier-contacts/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers, contacts
     * @name CarrierContactsPartialUpdate
     * @request PATCH:/api/v1/carrier-contacts/{id}/
     * @secure
     * @response `200` `Contact`
     */
    carrierContactsPartialUpdate: (
      { id }: CarrierContactsPartialUpdateParams,
      data: PatchedContact,
      params: RequestParams = {},
    ) =>
      this.request<Contact, any>({
        path: `/api/v1/carrier-contacts/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers, contacts
     * @name CarrierContactsDestroy
     * @request DELETE:/api/v1/carrier-contacts/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    carrierContactsDestroy: (
      { id }: CarrierContactsDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/carrier-contacts/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  carrierGroups = {
    /**
     * No description
     *
     * @tags carriers
     * @name CarrierGroupsList
     * @request GET:/api/v1/carrier-groups/
     * @secure
     * @response `200` `PaginatedCarrierGroupList`
     */
    carrierGroupsList: (
      query: CarrierGroupsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCarrierGroupList, any>({
        path: `/api/v1/carrier-groups/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarrierGroupsCreate
     * @request POST:/api/v1/carrier-groups/
     * @secure
     * @response `201` `CarrierGroup`
     */
    carrierGroupsCreate: (data: CarrierGroup, params: RequestParams = {}) =>
      this.request<CarrierGroup, any>({
        path: `/api/v1/carrier-groups/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarrierGroupsRetrieve
     * @request GET:/api/v1/carrier-groups/{id}/
     * @secure
     * @response `200` `CarrierGroup`
     */
    carrierGroupsRetrieve: (
      { id }: CarrierGroupsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<CarrierGroup, any>({
        path: `/api/v1/carrier-groups/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarrierGroupsUpdate
     * @request PUT:/api/v1/carrier-groups/{id}/
     * @secure
     * @response `200` `CarrierGroup`
     */
    carrierGroupsUpdate: (
      { id }: CarrierGroupsUpdateParams,
      data: CarrierGroup,
      params: RequestParams = {},
    ) =>
      this.request<CarrierGroup, any>({
        path: `/api/v1/carrier-groups/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarrierGroupsPartialUpdate
     * @request PATCH:/api/v1/carrier-groups/{id}/
     * @secure
     * @response `200` `CarrierGroup`
     */
    carrierGroupsPartialUpdate: (
      { id }: CarrierGroupsPartialUpdateParams,
      data: PatchedCarrierGroup,
      params: RequestParams = {},
    ) =>
      this.request<CarrierGroup, any>({
        path: `/api/v1/carrier-groups/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarrierGroupsDestroy
     * @request DELETE:/api/v1/carrier-groups/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    carrierGroupsDestroy: (
      { id }: CarrierGroupsDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/carrier-groups/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarrierGroupsAllList
     * @request GET:/api/v1/carrier-groups/all/
     * @secure
     * @response `200` `(CarrierGroupGeneralInfo)[]`
     */
    carrierGroupsAllList: (
      query: CarrierGroupsAllListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<CarrierGroupGeneralInfo[], any>({
        path: `/api/v1/carrier-groups/all/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  carrierStats = {
    /**
     * No description
     *
     * @tags carrier-stats
     * @name CarrierStatsCostsRetrieve
     * @request GET:/api/v1/carrier-stats/{id}/costs/
     * @secure
     * @response `200` `CarrierCostsStats`
     */
    carrierStatsCostsRetrieve: (
      { id, ...query }: CarrierStatsCostsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<CarrierCostsStats, any>({
        path: `/api/v1/carrier-stats/${id}/costs/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carrier-stats
     * @name CarrierStatsOverviewRetrieve
     * @request GET:/api/v1/carrier-stats/overview/
     * @secure
     * @response `200` `PaginatedCarrierStatsResponse`
     */
    carrierStatsOverviewRetrieve: (
      query: CarrierStatsOverviewRetrieveParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCarrierStatsResponse, any>({
        path: `/api/v1/carrier-stats/overview/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  carriers = {
    /**
     * No description
     *
     * @tags carriers
     * @name CarriersList
     * @request GET:/api/v1/carriers/
     * @secure
     * @response `200` `PaginatedCarrierList`
     */
    carriersList: (
      query: CarriersListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCarrierList, any>({
        path: `/api/v1/carriers/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarriersCreate
     * @request POST:/api/v1/carriers/
     * @secure
     * @response `201` `Carrier`
     */
    carriersCreate: (data: CarrierCreate, params: RequestParams = {}) =>
      this.request<Carrier, any>({
        path: `/api/v1/carriers/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarriersRetrieve
     * @request GET:/api/v1/carriers/{id}/
     * @secure
     * @response `200` `Carrier`
     */
    carriersRetrieve: (
      { id }: CarriersRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<Carrier, any>({
        path: `/api/v1/carriers/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarriersUpdate
     * @request PUT:/api/v1/carriers/{id}/
     * @secure
     * @response `200` `Carrier`
     */
    carriersUpdate: (
      { id }: CarriersUpdateParams,
      data: CarrierUpdate,
      params: RequestParams = {},
    ) =>
      this.request<Carrier, any>({
        path: `/api/v1/carriers/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarriersPartialUpdate
     * @request PATCH:/api/v1/carriers/{id}/
     * @secure
     * @response `200` `Carrier`
     */
    carriersPartialUpdate: (
      { id }: CarriersPartialUpdateParams,
      data: PatchedCarrierUpdate,
      params: RequestParams = {},
    ) =>
      this.request<Carrier, any>({
        path: `/api/v1/carriers/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarriersDestroy
     * @request DELETE:/api/v1/carriers/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    carriersDestroy: (
      { id }: CarriersDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/carriers/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarriersContactsList
     * @request GET:/api/v1/carriers/{id}/contacts/
     * @secure
     * @response `200` `(ContactGeneralInfo)[]`
     */
    carriersContactsList: (
      { id, ...query }: CarriersContactsListParams,
      params: RequestParams = {},
    ) =>
      this.request<ContactGeneralInfo[], any>({
        path: `/api/v1/carriers/${id}/contacts/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarriersIsActivePartialUpdate
     * @request PATCH:/api/v1/carriers/{id}/is_active/
     * @secure
     * @response `200` `Carrier`
     */
    carriersIsActivePartialUpdate: (
      { id }: CarriersIsActivePartialUpdateParams,
      data: PatchedCarrierUpdateIsActive,
      params: RequestParams = {},
    ) =>
      this.request<Carrier, any>({
        path: `/api/v1/carriers/${id}/is_active/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarriersAllList
     * @request GET:/api/v1/carriers/all/
     * @secure
     * @response `200` `(CarrierGeneralInfo)[]`
     */
    carriersAllList: (
      query: CarriersAllListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<CarrierGeneralInfo[], any>({
        path: `/api/v1/carriers/all/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarriersAutocompleteCreate
     * @request POST:/api/v1/carriers/autocomplete/
     * @secure
     * @response `200` `AutocompleteResponse`
     */
    carriersAutocompleteCreate: (
      data: AutocompleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<AutocompleteResponse, any>({
        path: `/api/v1/carriers/autocomplete/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags carriers
     * @name CarriersValidateFirstStepCreate
     * @request POST:/api/v1/carriers/validate-first-step/
     * @secure
     * @response `200` `CarrierCreateFirstStep`
     */
    carriersValidateFirstStepCreate: (
      data: CarrierCreateFirstStep,
      params: RequestParams = {},
    ) =>
      this.request<CarrierCreateFirstStep, any>({
        path: `/api/v1/carriers/validate-first-step/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  contractModulePromo = {
    /**
     * @description Permanently dismiss the promo banner for the current user.
     *
     * @tags module-promo
     * @name ContractModulePromoDismissCreate
     * @request POST:/api/v1/contract-module-promo/dismiss/
     * @secure
     * @response `200` `ModulePromoState`
     */
    contractModulePromoDismissCreate: (params: RequestParams = {}) =>
      this.request<ModulePromoState, any>({
        path: `/api/v1/contract-module-promo/dismiss/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Send a module demo inquiry to support (throttled per user).
     *
     * @tags module-promo
     * @name ContractModulePromoSendInquiryCreate
     * @request POST:/api/v1/contract-module-promo/send-inquiry/
     * @secure
     * @response `200` `ModulePromoState`
     * @response `400` `void` Throttled (inquiry sent recently), no workspace, or module already enabled.
     */
    contractModulePromoSendInquiryCreate: (params: RequestParams = {}) =>
      this.request<ModulePromoState, void>({
        path: `/api/v1/contract-module-promo/send-inquiry/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Return the module promo banner state for the current user.
     *
     * @tags module-promo
     * @name ContractModulePromoStateRetrieve
     * @request GET:/api/v1/contract-module-promo/state/
     * @secure
     * @response `200` `ModulePromoState`
     */
    contractModulePromoStateRetrieve: (params: RequestParams = {}) =>
      this.request<ModulePromoState, any>({
        path: `/api/v1/contract-module-promo/state/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  contracts = {
    /**
     * @description ViewSet for Contract operations. URL: /api/v1/contracts/
     *
     * @tags contracts
     * @name ContractsList
     * @request GET:/api/v1/contracts/
     * @secure
     * @response `200` `PaginatedContractListList`
     */
    contractsList: (
      query: ContractsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedContractListList, any>({
        path: `/api/v1/contracts/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for Contract operations. URL: /api/v1/contracts/
     *
     * @tags contracts
     * @name ContractsRetrieve
     * @request GET:/api/v1/contracts/{id}/
     * @secure
     * @response `200` `ContractDetail`
     */
    contractsRetrieve: (
      { id }: ContractsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractDetail, any>({
        path: `/api/v1/contracts/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Cancel a contract. URL: /api/v1/contracts/{id}/cancel/
     *
     * @tags contracts
     * @name ContractsCancel
     * @request POST:/api/v1/contracts/{id}/cancel/
     * @secure
     * @response `200` `ContractAction`
     * @response `400` `void` No response body
     * @response `404` `void` No response body
     */
    contractsCancel: (
      { id }: ContractsCancelParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractAction, void>({
        path: `/api/v1/contracts/${id}/cancel/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for Contract operations. URL: /api/v1/contracts/
     *
     * @tags contracts
     * @name ContractsRoutesList
     * @request GET:/api/v1/contracts/{id}/routes/
     * @secure
     * @response `200` `PaginatedContractRouteRowList`
     */
    contractsRoutesList: (
      { id, ...query }: ContractsRoutesListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedContractRouteRowList, any>({
        path: `/api/v1/contracts/${id}/routes/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for Contract operations. URL: /api/v1/contracts/
     *
     * @tags contracts
     * @name ContractsRoutesAutocomplete
     * @request GET:/api/v1/contracts/{id}/routes/autocomplete/
     * @secure
     * @response `200` `AutocompleteResponse`
     * @response `400` `void` No response body
     */
    contractsRoutesAutocomplete: (
      { id, ...query }: ContractsRoutesAutocompleteParams,
      params: RequestParams = {},
    ) =>
      this.request<AutocompleteResponse, void>({
        path: `/api/v1/contracts/${id}/routes/autocomplete/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags contracts
     * @name ContractsMatchingCheckOptionCreate
     * @request POST:/api/v1/contracts/matching/check-option/
     * @secure
     * @response `200` `ContractOptionEvaluation`
     */
    contractsMatchingCheckOptionCreate: (
      data: MatchingCheckOptionInput,
      params: RequestParams = {},
    ) =>
      this.request<ContractOptionEvaluation, any>({
        path: `/api/v1/contracts/matching/check-option/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags contracts
     * @name ContractsMatchingEvaluateCreate
     * @request POST:/api/v1/contracts/matching/evaluate/
     * @secure
     * @response `200` `PaginatedContractOptionRowList`
     */
    contractsMatchingEvaluateCreate: (
      query: ContractsMatchingEvaluateCreateParams = {},
      data: MatchingEvaluateInput,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedContractOptionRowList, any>({
        path: `/api/v1/contracts/matching/evaluate/`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags contracts
     * @name ContractsOptionsList
     * @request GET:/api/v1/contracts/options/
     * @secure
     * @response `200` `PaginatedContractOptionRowList`
     * @response `400` `void` No response body
     */
    contractsOptionsList: (
      query: ContractsOptionsListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedContractOptionRowList, void>({
        path: `/api/v1/contracts/options/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags contracts
     * @name ContractsOptionsAutocomplete
     * @request GET:/api/v1/contracts/options/autocomplete/
     * @secure
     * @response `200` `AutocompleteResponse`
     * @response `400` `void` No response body
     */
    contractsOptionsAutocomplete: (
      query: ContractsOptionsAutocompleteParams,
      params: RequestParams = {},
    ) =>
      this.request<AutocompleteResponse, void>({
        path: `/api/v1/contracts/options/autocomplete/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags contracts
     * @name ContractsOptionsFilters
     * @request GET:/api/v1/contracts/options/filters/
     * @secure
     * @response `200` `ContractOptionsFilters`
     */
    contractsOptionsFilters: (
      query: ContractsOptionsFiltersParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractOptionsFilters, any>({
        path: `/api/v1/contracts/options/filters/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Listing for tenders. URL: /contracts/tenders/
     *
     * @tags contracts
     * @name ContractsTendersList
     * @request GET:/api/v1/contracts/tenders/
     * @secure
     * @response `200` `PaginatedTenderListList`
     */
    contractsTendersList: (
      query: ContractsTendersListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedTenderListList, any>({
        path: `/api/v1/contracts/tenders/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Listing for tenders. URL: /contracts/tenders/
     *
     * @tags contracts
     * @name ContractsTendersRetrieve
     * @request GET:/api/v1/contracts/tenders/{id}/
     * @secure
     * @response `200` `TenderDetail`
     */
    contractsTendersRetrieve: (
      { id }: ContractsTendersRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<TenderDetail, any>({
        path: `/api/v1/contracts/tenders/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Soft-delete a tender. Only allowed for tenders in DRAFT or CANCELED status. URL: /contracts/tenders/{id}/
     *
     * @tags contracts
     * @name ContractsTendersDestroy
     * @request DELETE:/api/v1/contracts/tenders/{id}/
     * @secure
     * @response `204` `void` No response body
     * @response `400` `Record<string,any>`
     */
    contractsTendersDestroy: (
      { id }: ContractsTendersDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, ContractsTendersDestroyError>({
        path: `/api/v1/contracts/tenders/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Cancel a tender. Admin-only action. URL: /contracts/tenders/{id}/cancel/
     *
     * @tags contracts
     * @name ContractsTendersCancel
     * @request POST:/api/v1/contracts/tenders/{id}/cancel/
     * @secure
     * @response `200` `void` No response body
     * @response `400` `Record<string,any>`
     */
    contractsTendersCancel: (
      { id }: ContractsTendersCancelParams,
      params: RequestParams = {},
    ) =>
      this.request<void, ContractsTendersCancelError>({
        path: `/api/v1/contracts/tenders/${id}/cancel/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description List contract proposals grouped by carrier for a tender. URL: /contracts/tenders/{id}/contract-proposals/
     *
     * @tags contracts
     * @name ContractsTendersContractProposals
     * @request GET:/api/v1/contracts/tenders/{id}/contract-proposals/
     * @secure
     * @response `200` `(ContractProposalList)[]`
     */
    contractsTendersContractProposals: (
      { id, ...query }: ContractsTendersContractProposalsParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractProposalList[], any>({
        path: `/api/v1/contracts/tenders/${id}/contract-proposals/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve contract proposal for a specific carrier on a tender. URL: /contracts/tenders/{id}/contract-proposals/{carrier_id}/?route_id=1&vehicle_type_id=2
     *
     * @tags contracts
     * @name ContractsTendersContractProposalDetail
     * @request GET:/api/v1/contracts/tenders/{id}/contract-proposals/{carrier_id}/
     * @secure
     * @response `200` `ContractProposalDetail`
     * @response `204` `void` No response body
     */
    contractsTendersContractProposalDetail: (
      { carrierId, id, ...query }: ContractsTendersContractProposalDetailParams,
      params: RequestParams = {},
    ) =>
      this.request<ContractProposalDetail, any>({
        path: `/api/v1/contracts/tenders/${id}/contract-proposals/${carrierId}/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List contracts grouped by carrier for a tender. URL: /contracts/tenders/{id}/contracts/
     *
     * @tags contracts
     * @name ContractsTendersContracts
     * @request GET:/api/v1/contracts/tenders/{id}/contracts/
     * @secure
     * @response `200` `(TenderContractList)[]`
     */
    contractsTendersContracts: (
      { id, ...query }: ContractsTendersContractsParams,
      params: RequestParams = {},
    ) =>
      this.request<TenderContractList[], any>({
        path: `/api/v1/contracts/tenders/${id}/contracts/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Return the total number of documents, contract proposals and confirmed contracts for a tender.
     *
     * @tags contracts
     * @name ContractsTendersCounts
     * @request GET:/api/v1/contracts/tenders/{id}/counts/
     * @secure
     * @response `200` `TenderCountsResponse`
     */
    contractsTendersCounts: (
      { id }: ContractsTendersCountsParams,
      params: RequestParams = {},
    ) =>
      this.request<TenderCountsResponse, any>({
        path: `/api/v1/contracts/tenders/${id}/counts/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Listing for tenders. URL: /contracts/tenders/
     *
     * @tags contracts
     * @name ContractsTendersFiltersRetrieve
     * @request GET:/api/v1/contracts/tenders/{id}/filters/
     * @secure
     * @response `200` `TenderDetailFilters`
     */
    contractsTendersFiltersRetrieve: (
      { id }: ContractsTendersFiltersRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<TenderDetailFilters, any>({
        path: `/api/v1/contracts/tenders/${id}/filters/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finish a tender. Admin + Regular User action. URL: /contracts/tenders/{id}/finish/
     *
     * @tags contracts
     * @name ContractsTendersFinish
     * @request POST:/api/v1/contracts/tenders/{id}/finish/
     * @secure
     * @response `200` `void` No response body
     * @response `400` `Record<string,any>`
     */
    contractsTendersFinish: (
      { id }: ContractsTendersFinishParams,
      params: RequestParams = {},
    ) =>
      this.request<void, ContractsTendersFinishError>({
        path: `/api/v1/contracts/tenders/${id}/finish/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Listing for tenders. URL: /contracts/tenders/
     *
     * @tags contracts
     * @name ContractsTendersOfferExport
     * @request GET:/api/v1/contracts/tenders/{id}/offer-export/
     * @secure
     * @response `204` `void` No response body
     */
    contractsTendersOfferExport: (
      { id }: ContractsTendersOfferExportParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/contracts/tenders/${id}/offer-export/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Overview of the tender creation steps. URL: /contracts/tenders/{id}/overview/
     *
     * @tags contracts
     * @name ContractsTendersOverview
     * @request GET:/api/v1/contracts/tenders/{id}/overview/
     * @secure
     * @response `200` `TenderOverviewResponse`
     */
    contractsTendersOverview: (
      { id }: ContractsTendersOverviewParams,
      params: RequestParams = {},
    ) =>
      this.request<TenderOverviewResponse, any>({
        path: `/api/v1/contracts/tenders/${id}/overview/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Paginated price offers (cells + routes) for a tender. URL: /contracts/tenders/{id}/price-offers/
     *
     * @tags contracts
     * @name ContractsTendersPriceOffers
     * @request GET:/api/v1/contracts/tenders/{id}/price-offers/
     * @secure
     * @response `200` `TenderPriceOffersResponse`
     */
    contractsTendersPriceOffers: (
      { id, ...query }: ContractsTendersPriceOffersParams,
      params: RequestParams = {},
    ) =>
      this.request<TenderPriceOffersResponse, any>({
        path: `/api/v1/contracts/tenders/${id}/price-offers/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Send contract proposals for selected carrier offers. URL: /contracts/tenders/{id}/propose-contract/
     *
     * @tags contracts
     * @name ContractsTendersProposeContract
     * @request POST:/api/v1/contracts/tenders/{id}/propose-contract/
     * @secure
     * @response `200` `void` No response body
     * @response `400` `Record<string,any>`
     */
    contractsTendersProposeContract: (
      { id }: ContractsTendersProposeContractParams,
      data: ProposeContract,
      params: RequestParams = {},
    ) =>
      this.request<void, ContractsTendersProposeContractError>({
        path: `/api/v1/contracts/tenders/${id}/propose-contract/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Publish a tender draft. URL: /contracts/tenders/{id}/publish/
     *
     * @tags contracts
     * @name ContractsTendersPublish
     * @request POST:/api/v1/contracts/tenders/{id}/publish/
     * @secure
     * @response `200` `void` No response body
     * @response `400` `Record<string,any>`
     */
    contractsTendersPublish: (
      { id }: ContractsTendersPublishParams,
      params: RequestParams = {},
    ) =>
      this.request<void, ContractsTendersPublishError>({
        path: `/api/v1/contracts/tenders/${id}/publish/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Revert all contract proposal offers for a carrier back to pending state. URL: /contracts/tenders/{id}/revert-contract-proposals/{carrier_id}/
     *
     * @tags contracts
     * @name ContractsTendersRevertContractProposals
     * @request POST:/api/v1/contracts/tenders/{id}/revert-contract-proposals/{carrier_id}/
     * @secure
     * @response `200` `void` No response body
     * @response `400` `Record<string,any>`
     */
    contractsTendersRevertContractProposals: (
      { carrierId, id }: ContractsTendersRevertContractProposalsParams,
      params: RequestParams = {},
    ) =>
      this.request<void, ContractsTendersRevertContractProposalsError>({
        path: `/api/v1/contracts/tenders/${id}/revert-contract-proposals/${carrierId}/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Save the fourth step of the tender creation (carriers). URL: /contracts/tenders/{id}/save-fourth-step/
     *
     * @tags contracts
     * @name ContractsTendersSaveFourthStep
     * @request POST:/api/v1/contracts/tenders/{id}/save-fourth-step/
     * @secure
     * @response `200` `TenderFourthStepCarriers`
     */
    contractsTendersSaveFourthStep: (
      { id }: ContractsTendersSaveFourthStepParams,
      data: TenderFourthStepCarriers,
      params: RequestParams = {},
    ) =>
      this.request<TenderFourthStepCarriers, any>({
        path: `/api/v1/contracts/tenders/${id}/save-fourth-step/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Save the second step of the tender creation (routes). URL: /contracts/tenders/{id}/save-second-step/
     *
     * @tags contracts
     * @name ContractsTendersSaveSecondStep
     * @request POST:/api/v1/contracts/tenders/{id}/save-second-step/
     * @secure
     * @response `200` `TenderSecondStepRoutes`
     */
    contractsTendersSaveSecondStep: (
      { id }: ContractsTendersSaveSecondStepParams,
      data: TenderSecondStepRoutes,
      params: RequestParams = {},
    ) =>
      this.request<TenderSecondStepRoutes, any>({
        path: `/api/v1/contracts/tenders/${id}/save-second-step/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Save the third step of the tender creation (pricing categories). URL: /contracts/tenders/{id}/save-third-step/
     *
     * @tags contracts
     * @name ContractsTendersSaveThirdStep
     * @request POST:/api/v1/contracts/tenders/{id}/save-third-step/
     * @secure
     * @response `200` `TenderThirdStepPricingCategories`
     */
    contractsTendersSaveThirdStep: (
      { id }: ContractsTendersSaveThirdStepParams,
      data: TenderThirdStepPricingCategories,
      params: RequestParams = {},
    ) =>
      this.request<TenderThirdStepPricingCategories, any>({
        path: `/api/v1/contracts/tenders/${id}/save-third-step/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a published (OPEN/EVALUATING) tender. URL: /contracts/tenders/{id}/update/
     *
     * @tags contracts
     * @name ContractsTendersUpdate
     * @request POST:/api/v1/contracts/tenders/{id}/update/
     * @secure
     * @response `200` `TenderDetail`
     * @response `400` `Record<string,any>`
     */
    contractsTendersUpdate: (
      { id }: ContractsTendersUpdateParams,
      data: TenderUpdate,
      params: RequestParams = {},
    ) =>
      this.request<TenderDetail, ContractsTendersUpdateError>({
        path: `/api/v1/contracts/tenders/${id}/update/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Validate whether a tender can be finished. URL: /contracts/tenders/{id}/validate-finish/
     *
     * @tags contracts
     * @name ContractsTendersValidateFinish
     * @request POST:/api/v1/contracts/tenders/{id}/validate-finish/
     * @secure
     * @response `200` `void` No response body
     * @response `400` `Record<string,any>`
     */
    contractsTendersValidateFinish: (
      { id }: ContractsTendersValidateFinishParams,
      params: RequestParams = {},
    ) =>
      this.request<void, ContractsTendersValidateFinishError>({
        path: `/api/v1/contracts/tenders/${id}/validate-finish/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Validate whether a tender is ready to be published. URL: /contracts/tenders/{id}/validate-publish/
     *
     * @tags contracts
     * @name ContractsTendersValidatePublish
     * @request POST:/api/v1/contracts/tenders/{id}/validate-publish/
     * @secure
     * @response `200` `void` No response body
     * @response `400` `Record<string,any>`
     */
    contractsTendersValidatePublish: (
      { id }: ContractsTendersValidatePublishParams,
      params: RequestParams = {},
    ) =>
      this.request<void, ContractsTendersValidatePublishError>({
        path: `/api/v1/contracts/tenders/${id}/validate-publish/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Appends a ``HasModuleQuota`` check (any-of ``required_quota_codenames``) to the view's permissions.
     *
     * @tags documents
     * @name ContractsTendersDocumentsList
     * @request GET:/api/v1/contracts/tenders/{tender_pk}/documents/
     * @secure
     * @response `200` `PaginatedDocumentList`
     */
    contractsTendersDocumentsList: (
      { tenderPk, ...query }: ContractsTendersDocumentsListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDocumentList, any>({
        path: `/api/v1/contracts/tenders/${tenderPk}/documents/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Messages for a specific tender (shipper-facing).
     *
     * @tags messages
     * @name ContractsTendersMessagesList
     * @request GET:/api/v1/contracts/tenders/{tender_pk}/messages/
     * @secure
     * @response `200` `PaginatedMessageList`
     */
    contractsTendersMessagesList: (
      { tenderPk, ...query }: ContractsTendersMessagesListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedMessageList, any>({
        path: `/api/v1/contracts/tenders/${tenderPk}/messages/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Messages for a specific tender (shipper-facing).
     *
     * @tags messages
     * @name ContractsTendersMessagesCreate
     * @request POST:/api/v1/contracts/tenders/{tender_pk}/messages/
     * @secure
     * @response `201` `Message`
     */
    contractsTendersMessagesCreate: (
      { tenderPk }: ContractsTendersMessagesCreateParams,
      data: Message,
      params: RequestParams = {},
    ) =>
      this.request<Message, any>({
        path: `/api/v1/contracts/tenders/${tenderPk}/messages/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Messages for a specific tender (shipper-facing).
     *
     * @tags messages
     * @name ContractsTendersMessagesCarriersList
     * @request GET:/api/v1/contracts/tenders/{tender_pk}/messages/carriers/
     * @secure
     * @response `200` `(TenderCarrierConversation)[]`
     */
    contractsTendersMessagesCarriersList: (
      { tenderPk, ...query }: ContractsTendersMessagesCarriersListParams,
      params: RequestParams = {},
    ) =>
      this.request<TenderCarrierConversation[], any>({
        path: `/api/v1/contracts/tenders/${tenderPk}/messages/carriers/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Messages for a specific tender (shipper-facing).
     *
     * @tags messages
     * @name ContractsTendersMessagesMarkAsReadCreate
     * @request POST:/api/v1/contracts/tenders/{tender_pk}/messages/mark-as-read/
     * @secure
     * @response `200` `MarkAsReadMessage`
     */
    contractsTendersMessagesMarkAsReadCreate: (
      { tenderPk }: ContractsTendersMessagesMarkAsReadCreateParams,
      data: MarkAsReadMessage,
      params: RequestParams = {},
    ) =>
      this.request<MarkAsReadMessage, any>({
        path: `/api/v1/contracts/tenders/${tenderPk}/messages/mark-as-read/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Messages for a specific tender (shipper-facing).
     *
     * @tags messages
     * @name ContractsTendersMessagesUnreadCountRetrieve
     * @request GET:/api/v1/contracts/tenders/{tender_pk}/messages/unread-count/
     * @secure
     * @response `200` `number`
     */
    contractsTendersMessagesUnreadCountRetrieve: (
      { tenderPk }: ContractsTendersMessagesUnreadCountRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/api/v1/contracts/tenders/${tenderPk}/messages/unread-count/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Save the first step of the tender creation. Creates a new DRAFT tender when ``tender_id`` is not provided, otherwise updates the existing DRAFT tender so re-submitting step 1 from the wizard does not produce duplicate records. URL: /contracts/tenders/save-first-step/
     *
     * @tags contracts
     * @name ContractsTendersSaveFirstStepCreate
     * @request POST:/api/v1/contracts/tenders/save-first-step/
     * @secure
     * @response `200` `TenderFirstStep`
     */
    contractsTendersSaveFirstStepCreate: (
      data: TenderFirstStep,
      params: RequestParams = {},
    ) =>
      this.request<TenderFirstStep, any>({
        path: `/api/v1/contracts/tenders/save-first-step/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  documents = {
    /**
     * No description
     *
     * @tags documents
     * @name DocumentsList
     * @request GET:/api/v1/documents/
     * @secure
     * @response `200` `PaginatedDocumentList`
     */
    documentsList: (
      query: DocumentsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDocumentList, any>({
        path: `/api/v1/documents/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents
     * @name DocumentsCreate
     * @request POST:/api/v1/documents/
     * @secure
     * @response `201` `Document`
     */
    documentsCreate: (data: DocumentCreate, params: RequestParams = {}) =>
      this.request<Document, any>({
        path: `/api/v1/documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents
     * @name DocumentsRetrieve
     * @request GET:/api/v1/documents/{id}/
     * @secure
     * @response `200` `Document`
     */
    documentsRetrieve: (
      { id }: DocumentsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<Document, any>({
        path: `/api/v1/documents/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents
     * @name DocumentsUpdate
     * @request PUT:/api/v1/documents/{id}/
     * @secure
     * @response `200` `Document`
     */
    documentsUpdate: (
      { id }: DocumentsUpdateParams,
      data: DocumentUpdate,
      params: RequestParams = {},
    ) =>
      this.request<Document, any>({
        path: `/api/v1/documents/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents
     * @name DocumentsPartialUpdate
     * @request PATCH:/api/v1/documents/{id}/
     * @secure
     * @response `200` `DocumentUpdate`
     */
    documentsPartialUpdate: (
      { id }: DocumentsPartialUpdateParams,
      data: PatchedDocumentUpdate,
      params: RequestParams = {},
    ) =>
      this.request<DocumentUpdate, any>({
        path: `/api/v1/documents/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents
     * @name DocumentsDestroy
     * @request DELETE:/api/v1/documents/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    documentsDestroy: (
      { id }: DocumentsDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/documents/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  featureFlags = {
    /**
     * No description
     *
     * @tags core
     * @name FeatureFlagsStatusRetrieve
     * @request GET:/api/v1/feature-flags/status
     * @secure
     * @response `200` `FeatureFlagsStatus`
     */
    featureFlagsStatusRetrieve: (params: RequestParams = {}) =>
      this.request<FeatureFlagsStatus, any>({
        path: `/api/v1/feature-flags/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  fieldRules = {
    /**
     * No description
     *
     * @tags field-rules
     * @name FieldRulesRetrieve
     * @request GET:/api/v1/field-rules/{target_form}/
     * @secure
     * @response `200` `FieldRulesResponse`
     * @response `404` `void` Unknown target_form
     */
    fieldRulesRetrieve: (
      { targetForm }: FieldRulesRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<FieldRulesResponse, void>({
        path: `/api/v1/field-rules/${targetForm}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  info = {
    /**
     * No description
     *
     * @tags core
     * @name InfoRetrieve
     * @request GET:/api/v1/info/
     * @secure
     * @response `200` `AppInfo`
     */
    infoRetrieve: (params: RequestParams = {}) =>
      this.request<AppInfo, any>({
        path: `/api/v1/info/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  invitations = {
    /**
     * No description
     *
     * @tags invitations
     * @name InvitationsAcceptCreate
     * @request POST:/api/v1/invitations/accept/
     * @secure
     * @response `200` `JWT`
     */
    invitationsAcceptCreate: (
      data: AcceptInvitation,
      params: RequestParams = {},
    ) =>
      this.request<JWT, any>({
        path: `/api/v1/invitations/accept/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invitations
     * @name InvitationsAcceptByUserCreate
     * @request POST:/api/v1/invitations/accept-by-user/
     * @secure
     * @response `200` `boolean`
     */
    invitationsAcceptByUserCreate: (
      data: ModifyInvitationByUser,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/invitations/accept-by-user/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invitations
     * @name InvitationsBulkInviteCreate
     * @request POST:/api/v1/invitations/bulk-invite/
     * @secure
     * @response `200` `Record<string,any>`
     */
    invitationsBulkInviteCreate: (
      data: BulkInvitation,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/invitations/bulk-invite/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invitations
     * @name InvitationsPendingList
     * @request GET:/api/v1/invitations/pending/
     * @secure
     * @response `200` `(Invitation)[]`
     */
    invitationsPendingList: (params: RequestParams = {}) =>
      this.request<Invitation[], any>({
        path: `/api/v1/invitations/pending/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invitations
     * @name InvitationsPendingByUserList
     * @request GET:/api/v1/invitations/pending-by-user/
     * @secure
     * @response `200` `(WorkspaceInvitation)[]`
     */
    invitationsPendingByUserList: (params: RequestParams = {}) =>
      this.request<WorkspaceInvitation[], any>({
        path: `/api/v1/invitations/pending-by-user/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invitations
     * @name InvitationsRejectByUserCreate
     * @request POST:/api/v1/invitations/reject-by-user/
     * @secure
     * @response `200` `boolean`
     */
    invitationsRejectByUserCreate: (
      data: ModifyInvitationByUser,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/invitations/reject-by-user/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invitations
     * @name InvitationsRemoveCreate
     * @request POST:/api/v1/invitations/remove/
     * @secure
     * @response `200` `boolean`
     */
    invitationsRemoveCreate: (
      data: InvitationsRemoveCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/invitations/remove/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  locations = {
    /**
     * No description
     *
     * @tags locations
     * @name LocationsStaticMapCreate
     * @request POST:/api/v1/locations/static-map/
     * @secure
     * @response `200` `LocationData`
     */
    locationsStaticMapCreate: (
      data: TranslateLocations,
      params: RequestParams = {},
    ) =>
      this.request<LocationData, any>({
        path: `/api/v1/locations/static-map/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags locations
     * @name LocationsTranslateCreate
     * @request POST:/api/v1/locations/translate/
     * @secure
     * @response `200` `LocationData`
     */
    locationsTranslateCreate: (
      data: TranslateLocations,
      params: RequestParams = {},
    ) =>
      this.request<LocationData, any>({
        path: `/api/v1/locations/translate/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  messages = {
    /**
     * @description List the inbox newest-first, one message per conversation (cursor paginated).
     *
     * @tags messages
     * @name MessagesList
     * @request GET:/api/v1/messages/
     * @secure
     * @response `200` `PaginatedUserMessageList`
     */
    messagesList: (
      query: MessagesListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedUserMessageList, any>({
        path: `/api/v1/messages/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Cursor-paginated cross-timeline message inbox.
     *
     * @tags messages
     * @name MessagesMarkAsReadCreate
     * @request POST:/api/v1/messages/{id}/mark_as_read/
     * @secure
     * @response `200` `void` No response body
     */
    messagesMarkAsReadCreate: (
      { id }: MessagesMarkAsReadCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/messages/${id}/mark_as_read/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Cursor-paginated cross-timeline message inbox.
     *
     * @tags messages
     * @name MessagesMarkAllAsReadCreate
     * @request POST:/api/v1/messages/mark-all-as-read/
     * @secure
     * @response `200` `string`
     */
    messagesMarkAllAsReadCreate: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/messages/mark-all-as-read/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Cursor-paginated cross-timeline message inbox.
     *
     * @tags messages
     * @name MessagesUnreadCountRetrieve
     * @request GET:/api/v1/messages/unread-count/
     * @secure
     * @response `200` `number`
     */
    messagesUnreadCountRetrieve: (params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/api/v1/messages/unread-count/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  microsoftGraph = {
    /**
     * No description
     *
     * @tags microsoft-graph
     * @name MicrosoftGraphAccessTokenCreate
     * @request POST:/api/v1/microsoft-graph/access_token/
     * @secure
     * @response `200` `MicrosoftAccessToken`
     */
    microsoftGraphAccessTokenCreate: (
      data: MicrosoftTenant,
      params: RequestParams = {},
    ) =>
      this.request<MicrosoftAccessToken, any>({
        path: `/api/v1/microsoft-graph/access_token/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags microsoft-graph
     * @name MicrosoftGraphGroupsCreate
     * @request POST:/api/v1/microsoft-graph/groups/
     * @secure
     * @response `200` `(MicrosoftGroup)[]`
     */
    microsoftGraphGroupsCreate: (
      data: MicrosoftTenant,
      params: RequestParams = {},
    ) =>
      this.request<MicrosoftGroup[], any>({
        path: `/api/v1/microsoft-graph/groups/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags microsoft-graph
     * @name MicrosoftGraphMembersCreate
     * @request POST:/api/v1/microsoft-graph/members/
     * @secure
     * @response `200` `(MicrosoftMember)[]`
     */
    microsoftGraphMembersCreate: (
      data: MicrosoftMembersRequest,
      params: RequestParams = {},
    ) =>
      this.request<MicrosoftMember[], any>({
        path: `/api/v1/microsoft-graph/members/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  notifications = {
    /**
     * @description ViewSet for listing and marking notifications as read. Returns all notifications by default. If yoy want to get read/unread notifications, use the filter `is_read`.
     *
     * @tags notifications
     * @name NotificationsList
     * @request GET:/api/v1/notifications/
     * @secure
     * @response `200` `PaginatedNotificationList`
     */
    notificationsList: (
      query: NotificationsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedNotificationList, any>({
        path: `/api/v1/notifications/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for listing and marking notifications as read. Returns all notifications by default. If yoy want to get read/unread notifications, use the filter `is_read`.
     *
     * @tags notifications
     * @name NotificationsRetrieve
     * @request GET:/api/v1/notifications/{id}/
     * @secure
     * @response `200` `Notification`
     */
    notificationsRetrieve: (
      { id }: NotificationsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<Notification, any>({
        path: `/api/v1/notifications/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for listing and marking notifications as read. Returns all notifications by default. If yoy want to get read/unread notifications, use the filter `is_read`.
     *
     * @tags notifications
     * @name NotificationsMarkAsReadCreate
     * @request POST:/api/v1/notifications/{id}/mark-as-read/
     * @secure
     * @response `200` `string`
     */
    notificationsMarkAsReadCreate: (
      { id }: NotificationsMarkAsReadCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/notifications/${id}/mark-as-read/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for listing and marking notifications as read. Returns all notifications by default. If yoy want to get read/unread notifications, use the filter `is_read`.
     *
     * @tags notifications
     * @name NotificationsMarkAllAsReadCreate
     * @request POST:/api/v1/notifications/mark-all-as-read/
     * @secure
     * @response `200` `string`
     */
    notificationsMarkAllAsReadCreate: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/notifications/mark-all-as-read/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for listing and marking notifications as read. Returns all notifications by default. If yoy want to get read/unread notifications, use the filter `is_read`.
     *
     * @tags notifications
     * @name NotificationsUserSettingsRetrieve
     * @request GET:/api/v1/notifications/user-settings/
     * @secure
     * @response `200` `UserNotificationSettings`
     */
    notificationsUserSettingsRetrieve: (params: RequestParams = {}) =>
      this.request<UserNotificationSettings, any>({
        path: `/api/v1/notifications/user-settings/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for listing and marking notifications as read. Returns all notifications by default. If yoy want to get read/unread notifications, use the filter `is_read`.
     *
     * @tags notifications
     * @name NotificationsUserSettingsCreate
     * @request POST:/api/v1/notifications/user-settings/
     * @secure
     * @response `200` `UserNotificationSettings`
     */
    notificationsUserSettingsCreate: (
      data: UserNotificationSettings,
      params: RequestParams = {},
    ) =>
      this.request<UserNotificationSettings, any>({
        path: `/api/v1/notifications/user-settings/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  options = {
    /**
     * No description
     *
     * @tags options
     * @name OptionsCargoCategoryKindsRetrieve
     * @request GET:/api/v1/options/cargo-category-kinds/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsCargoCategoryKindsRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/cargo-category-kinds/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsCargoCategoryUnitsRetrieve
     * @request GET:/api/v1/options/cargo-category-units/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsCargoCategoryUnitsRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/cargo-category-units/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsCargoLoadTypesRetrieve
     * @request GET:/api/v1/options/cargo-load-types/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsCargoLoadTypesRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/cargo-load-types/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsCargoTypesRetrieve
     * @request GET:/api/v1/options/cargo-types/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsCargoTypesRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/cargo-types/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsCountriesRetrieve
     * @request GET:/api/v1/options/countries/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsCountriesRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/countries/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsCurrenciesRetrieve
     * @request GET:/api/v1/options/currencies/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsCurrenciesRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/currencies/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsFeatureSwitchTypesList
     * @request GET:/api/v1/options/feature-switch-types/
     * @secure
     * @response `200` `(FeatureSwitch)[]`
     */
    optionsFeatureSwitchTypesList: (params: RequestParams = {}) =>
      this.request<FeatureSwitch[], any>({
        path: `/api/v1/options/feature-switch-types/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsIncotermsRetrieve
     * @request GET:/api/v1/options/incoterms/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsIncotermsRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/incoterms/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsLengthUnitRetrieve
     * @request GET:/api/v1/options/length-unit/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsLengthUnitRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/length-unit/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsMessageEventsRetrieve
     * @request GET:/api/v1/options/message-events/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsMessageEventsRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/message-events/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsPeriodicityRetrieve
     * @request GET:/api/v1/options/periodicity/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsPeriodicityRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/periodicity/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsRouteTypesRetrieve
     * @request GET:/api/v1/options/route-types/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsRouteTypesRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/route-types/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsSpecialRequirementsRetrieve
     * @request GET:/api/v1/options/special-requirements/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsSpecialRequirementsRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/special-requirements/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsStackCountRetrieve
     * @request GET:/api/v1/options/stack-count/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsStackCountRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/stack-count/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsTransportTypesRetrieve
     * @request GET:/api/v1/options/transport-types/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsTransportTypesRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/transport-types/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsTransportationModesRetrieve
     * @request GET:/api/v1/options/transportation-modes/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsTransportationModesRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/transportation-modes/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsVolumeUnitRetrieve
     * @request GET:/api/v1/options/volume-unit/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsVolumeUnitRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/volume-unit/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags options
     * @name OptionsWeightUnitRetrieve
     * @request GET:/api/v1/options/weight-unit/
     * @secure
     * @response `200` `Record<string,any>`
     */
    optionsWeightUnitRetrieve: (params: RequestParams = {}) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/options/weight-unit/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  otp = {
    /**
     * @description Create a new OTP for the given carrier's email and send it to that email
     *
     * @tags otp
     * @name OtpCreate
     * @request POST:/api/v1/otp/
     * @secure
     * @response `200` `void` No response body
     */
    otpCreate: (data: OneTimePasswordRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/otp/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Verify and retrieve the given OTP by its hash
     *
     * @tags otp
     * @name OtpRetrieve
     * @request GET:/api/v1/otp/{otp_hash}/
     * @secure
     * @response `200` `OneTimePassword`
     */
    otpRetrieve: ({ otpHash }: OtpRetrieveParams, params: RequestParams = {}) =>
      this.request<OneTimePassword, any>({
        path: `/api/v1/otp/${otpHash}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags otp
     * @name OtpSetLanguage
     * @request POST:/api/v1/otp/{otp_hash}/language/
     * @secure
     * @response `200` `OtpSetLanguage`
     */
    otpSetLanguage: (
      { otpHash }: OtpSetLanguageParams,
      data: OtpSetLanguage,
      params: RequestParams = {},
    ) =>
      this.request<OtpSetLanguage, any>({
        path: `/api/v1/otp/${otpHash}/language/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags otp
     * @name OtpUnpaidInvoicesRetrieve
     * @request GET:/api/v1/otp/{otp_hash}/unpaid-invoices/
     * @secure
     * @response `200` `UnpaidInvoices`
     */
    otpUnpaidInvoicesRetrieve: (
      { otpHash }: OtpUnpaidInvoicesRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<UnpaidInvoices, any>({
        path: `/api/v1/otp/${otpHash}/unpaid-invoices/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Invalidate the given OTP - set expires_at to now
     *
     * @tags otp
     * @name OtpExpireCreate
     * @request POST:/api/v1/otp/expire/
     * @secure
     * @response `200` `OneTimePasswordVerify`
     */
    otpExpireCreate: (
      data: OneTimePasswordVerify,
      params: RequestParams = {},
    ) =>
      this.request<OneTimePasswordVerify, any>({
        path: `/api/v1/otp/expire/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  payments = {
    /**
     * No description
     *
     * @tags payments
     * @name PaymentsCheckoutSessionCreate
     * @request POST:/api/v1/payments/checkout/session/
     * @secure
     * @response `200` `CheckoutResponseData`
     */
    paymentsCheckoutSessionCreate: (
      data: CheckoutRequestData,
      params: RequestParams = {},
    ) =>
      this.request<CheckoutResponseData, any>({
        path: `/api/v1/payments/checkout/session/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  portal = {
    /**
     * @description Get company details based on VAT ID and country code. For getting also insurance status, use `insurance_status_check=true. If Portal has not cached the status for the company, it makes an additional API call to the Coface API (which can be paid and slow).
     *
     * @tags core
     * @name PortalCompanyInfoCreate
     * @request POST:/api/v1/portal/company-info/
     * @secure
     * @response `200` `PortalCompanyInfoResponse`
     */
    portalCompanyInfoCreate: (
      data: CompanyInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<PortalCompanyInfoResponse, any>({
        path: `/api/v1/portal/company-info/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get company details based on VAT ID or company name and country code from Coface.
     *
     * @tags core
     * @name PortalExternalCompanyInfoCreate
     * @request POST:/api/v1/portal/external-company-info/
     * @secure
     * @response `200` `(CofaceCompanyInfoResponse)[]`
     */
    portalExternalCompanyInfoCreate: (
      data: CompanyInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<CofaceCompanyInfoResponse[], any>({
        path: `/api/v1/portal/external-company-info/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  privacy = {
    /**
     * No description
     *
     * @tags privacy
     * @name PrivacyConsentsRetrieve
     * @request GET:/api/v1/privacy/consents/{token}/
     * @secure
     * @response `200` `ConsentByTokenSetOutput`
     */
    privacyConsentsRetrieve: (
      { token, ...query }: PrivacyConsentsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<ConsentByTokenSetOutput, any>({
        path: `/api/v1/privacy/consents/${token}/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags privacy
     * @name PrivacyConsentsCreate
     * @request POST:/api/v1/privacy/consents/{token}/
     * @secure
     * @response `200` `ConsentByTokenSetOutput`
     */
    privacyConsentsCreate: (
      { token }: PrivacyConsentsCreateParams,
      data: PrivacyConsentsCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<ConsentByTokenSetOutput, any>({
        path: `/api/v1/privacy/consents/${token}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags privacy
     * @name PrivacyConsentsMarketingRetrieve
     * @request GET:/api/v1/privacy/consents/{token}/marketing/
     * @secure
     * @response `200` `MarketingConsentByToken`
     */
    privacyConsentsMarketingRetrieve: (
      { token }: PrivacyConsentsMarketingRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<MarketingConsentByToken, any>({
        path: `/api/v1/privacy/consents/${token}/marketing/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags privacy
     * @name PrivacyConsentsMarketingCreate
     * @request POST:/api/v1/privacy/consents/{token}/marketing/
     * @secure
     * @response `200` `MarketingConsentByToken`
     */
    privacyConsentsMarketingCreate: (
      { token }: PrivacyConsentsMarketingCreateParams,
      data: MarketingInputOutput,
      params: RequestParams = {},
    ) =>
      this.request<MarketingConsentByToken, any>({
        path: `/api/v1/privacy/consents/${token}/marketing/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags privacy
     * @name PrivacyConsentsSettingsList
     * @request GET:/api/v1/privacy/consents/{token}/settings/
     * @secure
     * @response `200` `(ConsentsSettings)[]`
     */
    privacyConsentsSettingsList: (
      { token }: PrivacyConsentsSettingsListParams,
      params: RequestParams = {},
    ) =>
      this.request<ConsentsSettings[], any>({
        path: `/api/v1/privacy/consents/${token}/settings/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags privacy
     * @name PrivacyConsentsSettingsCreate
     * @request POST:/api/v1/privacy/consents/{token}/settings/
     * @secure
     * @response `200` `(ConsentsSettings)[]`
     */
    privacyConsentsSettingsCreate: (
      { token }: PrivacyConsentsSettingsCreateParams,
      data: PrivacyConsentsSettingsCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<ConsentsSettings[], any>({
        path: `/api/v1/privacy/consents/${token}/settings/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags privacy
     * @name PrivacyConsentsTermsRetrieve
     * @request GET:/api/v1/privacy/consents/{token}/terms/
     * @secure
     * @response `200` `TermsByTokenOutput`
     */
    privacyConsentsTermsRetrieve: (
      { token }: PrivacyConsentsTermsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<TermsByTokenOutput, any>({
        path: `/api/v1/privacy/consents/${token}/terms/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags privacy
     * @name PrivacyConsentsTermsCreate
     * @request POST:/api/v1/privacy/consents/{token}/terms/
     * @secure
     * @response `200` `TermsByTokenOutput`
     */
    privacyConsentsTermsCreate: (
      { token }: PrivacyConsentsTermsCreateParams,
      data: PrivacyConsentsTermsCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<TermsByTokenOutput, any>({
        path: `/api/v1/privacy/consents/${token}/terms/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags privacy
     * @name PrivacyConsentsRequestResendCreate
     * @request POST:/api/v1/privacy/consents/request/resend/
     * @secure
     * @response `204` `any`
     * @response `400` `ConsentInfo`
     */
    privacyConsentsRequestResendCreate: (
      data: ResendConsentRequestInput,
      params: RequestParams = {},
    ) =>
      this.request<any, PrivacyConsentsRequestResendCreateError>({
        path: `/api/v1/privacy/consents/request/resend/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags privacy
     * @name PrivacyTermsAndConditionsList
     * @request GET:/api/v1/privacy/terms-and-conditions/
     * @secure
     * @response `200` `PaginatedTermsAndConditionsList`
     */
    privacyTermsAndConditionsList: (
      query: PrivacyTermsAndConditionsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedTermsAndConditionsList, any>({
        path: `/api/v1/privacy/terms-and-conditions/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags privacy
     * @name PrivacyTermsAndConditionsRetrieve
     * @request GET:/api/v1/privacy/terms-and-conditions/{id}/
     * @secure
     * @response `200` `TermsAndConditions`
     */
    privacyTermsAndConditionsRetrieve: (
      { id }: PrivacyTermsAndConditionsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<TermsAndConditions, any>({
        path: `/api/v1/privacy/terms-and-conditions/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  push = {
    /**
     * No description
     *
     * @tags push
     * @name PushAuthorizeCreate
     * @request POST:/api/v1/push/authorize/
     * @secure
     * @response `200` `PushAuthorizeResponse`
     */
    pushAuthorizeCreate: (
      data: PushAuthorizeRequest,
      params: RequestParams = {},
    ) =>
      this.request<PushAuthorizeResponse, any>({
        path: `/api/v1/push/authorize/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags push
     * @name PushAuthorizeByHashCreate
     * @request POST:/api/v1/push/authorize-by-hash/
     * @secure
     * @response `200` `PushAuthorizeResponse`
     */
    pushAuthorizeByHashCreate: (
      data: PushAuthorizeRequest,
      params: RequestParams = {},
    ) =>
      this.request<PushAuthorizeResponse, any>({
        path: `/api/v1/push/authorize-by-hash/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags push
     * @name PushAuthorizeByOtpHashCreate
     * @request POST:/api/v1/push/authorize-by-otp-hash/
     * @secure
     * @response `200` `PushAuthorizeResponse`
     */
    pushAuthorizeByOtpHashCreate: (
      data: PushAuthorizeRequest,
      params: RequestParams = {},
    ) =>
      this.request<PushAuthorizeResponse, any>({
        path: `/api/v1/push/authorize-by-otp-hash/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  roles = {
    /**
     * No description
     *
     * @tags roles
     * @name RolesList
     * @request GET:/api/v1/roles/
     * @secure
     * @response `200` `(Role)[]`
     */
    rolesList: (query: RolesListParams = {}, params: RequestParams = {}) =>
      this.request<Role[], any>({
        path: `/api/v1/roles/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags roles
     * @name RolesRetrieve
     * @request GET:/api/v1/roles/{id}/
     * @secure
     * @response `200` `Role`
     */
    rolesRetrieve: ({ id }: RolesRetrieveParams, params: RequestParams = {}) =>
      this.request<Role, any>({
        path: `/api/v1/roles/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  routeAddresses = {
    /**
     * @description ViewSet providing CRUD operations for route addresses. URL: /contracts/route-addresses/
     *
     * @tags route-addresses
     * @name RouteAddressesList
     * @request GET:/api/v1/route-addresses/
     * @secure
     * @response `200` `PaginatedRouteAddressList`
     */
    routeAddressesList: (
      query: RouteAddressesListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedRouteAddressList, any>({
        path: `/api/v1/route-addresses/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for route addresses. URL: /contracts/route-addresses/
     *
     * @tags route-addresses
     * @name RouteAddressesCreate
     * @request POST:/api/v1/route-addresses/
     * @secure
     * @response `201` `RouteAddress`
     */
    routeAddressesCreate: (data: RouteAddress, params: RequestParams = {}) =>
      this.request<RouteAddress, any>({
        path: `/api/v1/route-addresses/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for route addresses. URL: /contracts/route-addresses/
     *
     * @tags route-addresses
     * @name RouteAddressesRetrieve
     * @request GET:/api/v1/route-addresses/{id}/
     * @secure
     * @response `200` `RouteAddress`
     */
    routeAddressesRetrieve: (
      { id }: RouteAddressesRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<RouteAddress, any>({
        path: `/api/v1/route-addresses/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for route addresses. URL: /contracts/route-addresses/
     *
     * @tags route-addresses
     * @name RouteAddressesUpdate
     * @request PUT:/api/v1/route-addresses/{id}/
     * @secure
     * @response `200` `RouteAddress`
     */
    routeAddressesUpdate: (
      { id }: RouteAddressesUpdateParams,
      data: RouteAddress,
      params: RequestParams = {},
    ) =>
      this.request<RouteAddress, any>({
        path: `/api/v1/route-addresses/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for route addresses. URL: /contracts/route-addresses/
     *
     * @tags route-addresses
     * @name RouteAddressesPartialUpdate
     * @request PATCH:/api/v1/route-addresses/{id}/
     * @secure
     * @response `200` `RouteAddress`
     */
    routeAddressesPartialUpdate: (
      { id }: RouteAddressesPartialUpdateParams,
      data: PatchedRouteAddress,
      params: RequestParams = {},
    ) =>
      this.request<RouteAddress, any>({
        path: `/api/v1/route-addresses/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for route addresses. URL: /contracts/route-addresses/
     *
     * @tags route-addresses
     * @name RouteAddressesDestroy
     * @request DELETE:/api/v1/route-addresses/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    routeAddressesDestroy: (
      { id }: RouteAddressesDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/route-addresses/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  routes = {
    /**
     * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
     *
     * @tags routes
     * @name RoutesList
     * @request GET:/api/v1/routes/
     * @secure
     * @response `200` `PaginatedRouteListList`
     */
    routesList: (query: RoutesListParams = {}, params: RequestParams = {}) =>
      this.request<PaginatedRouteListList, any>({
        path: `/api/v1/routes/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a route from the provided payload. Method isn't allowed. Use bulk_create instead.
     *
     * @tags routes
     * @name RoutesCreate
     * @request POST:/api/v1/routes/
     * @secure
     * @response `201` `RouteCreate`
     */
    routesCreate: (data: RouteCreate, params: RequestParams = {}) =>
      this.request<RouteCreate, any>({
        path: `/api/v1/routes/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
     *
     * @tags routes
     * @name RoutesRetrieve
     * @request GET:/api/v1/routes/{id}/
     * @secure
     * @response `200` `RouteList`
     */
    routesRetrieve: (
      { id }: RoutesRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<RouteList, any>({
        path: `/api/v1/routes/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
     *
     * @tags routes
     * @name RoutesUpdate
     * @request PUT:/api/v1/routes/{id}/
     * @secure
     * @response `200` `RouteUpdate`
     */
    routesUpdate: (
      { id }: RoutesUpdateParams,
      data: RouteUpdate,
      params: RequestParams = {},
    ) =>
      this.request<RouteUpdate, any>({
        path: `/api/v1/routes/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
     *
     * @tags routes
     * @name RoutesPartialUpdate
     * @request PATCH:/api/v1/routes/{id}/
     * @secure
     * @response `200` `RouteUpdate`
     */
    routesPartialUpdate: (
      { id }: RoutesPartialUpdateParams,
      data: PatchedRouteUpdate,
      params: RequestParams = {},
    ) =>
      this.request<RouteUpdate, any>({
        path: `/api/v1/routes/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
     *
     * @tags routes
     * @name RoutesDestroy
     * @request DELETE:/api/v1/routes/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    routesDestroy: ({ id }: RoutesDestroyParams, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/routes/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
     *
     * @tags routes
     * @name RoutesAutocomplete
     * @request GET:/api/v1/routes/autocomplete/
     * @secure
     * @response `200` `AutocompleteResponse`
     * @response `400` `void` No response body
     */
    routesAutocomplete: (
      query: RoutesAutocompleteParams,
      params: RequestParams = {},
    ) =>
      this.request<AutocompleteResponse, void>({
        path: `/api/v1/routes/autocomplete/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates multiple routes from the provided payload. Returns only the last 5 routes.
     *
     * @tags routes
     * @name RoutesBulkCreateCreate
     * @request POST:/api/v1/routes/bulk-create/
     * @secure
     * @response `200` `RouteBulkCreate`
     */
    routesBulkCreateCreate: (
      data: RouteBulkCreate,
      params: RequestParams = {},
    ) =>
      this.request<RouteBulkCreate, any>({
        path: `/api/v1/routes/bulk-create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
     *
     * @tags routes
     * @name RoutesBulkDelete
     * @request POST:/api/v1/routes/bulk-delete/
     * @secure
     * @response `200` `RouteBulkDelete`
     */
    routesBulkDelete: (data: RouteBulkDelete, params: RequestParams = {}) =>
      this.request<RouteBulkDelete, any>({
        path: `/api/v1/routes/bulk-delete/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a route. URL: /contracts/routes/
     *
     * @tags routes
     * @name RoutesCheckDraftUsage
     * @request POST:/api/v1/routes/check-draft-usage/
     * @secure
     * @response `200` `RouteCheckDraftUsageInput`
     */
    routesCheckDraftUsage: (
      data: RouteCheckDraftUsageInput,
      params: RequestParams = {},
    ) =>
      this.request<RouteCheckDraftUsageInput, any>({
        path: `/api/v1/routes/check-draft-usage/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  schema = {
    /**
     * @description OpenApi3 schema for this API. Format can be selected via content negotiation. - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     *
     * @tags schema
     * @name SchemaRetrieve
     * @request GET:/api/v1/schema/
     * @secure
     * @response `200` `Record<string,any>`
     */
    schemaRetrieve: (
      query: SchemaRetrieveParams = {},
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/schema/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  stats = {
    /**
     * No description
     *
     * @tags stats
     * @name StatsOverviewRetrieve
     * @request GET:/api/v1/stats/overview/
     * @secure
     * @response `200` `CombinedOverviewStats`
     */
    statsOverviewRetrieve: (
      query: StatsOverviewRetrieveParams = {},
      params: RequestParams = {},
    ) =>
      this.request<CombinedOverviewStats, any>({
        path: `/api/v1/stats/overview/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags stats
     * @name StatsRoutesRetrieve
     * @request GET:/api/v1/stats/routes/
     * @secure
     * @response `200` `RoutesOverviewStats`
     */
    statsRoutesRetrieve: (
      query: StatsRoutesRetrieveParams = {},
      params: RequestParams = {},
    ) =>
      this.request<RoutesOverviewStats, any>({
        path: `/api/v1/stats/routes/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags stats
     * @name StatsTopCarriersRetrieve
     * @request GET:/api/v1/stats/top-carriers/
     * @secure
     * @response `200` `TopCarriersStats`
     */
    statsTopCarriersRetrieve: (
      query: StatsTopCarriersRetrieveParams = {},
      params: RequestParams = {},
    ) =>
      this.request<TopCarriersStats, any>({
        path: `/api/v1/stats/top-carriers/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags stats
     * @name StatsTopCountriesList
     * @request GET:/api/v1/stats/top-countries/
     * @secure
     * @response `200` `(TopCountryStats)[]`
     */
    statsTopCountriesList: (
      query: StatsTopCountriesListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<TopCountryStats[], any>({
        path: `/api/v1/stats/top-countries/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tags = {
    /**
     * No description
     *
     * @tags tags
     * @name TagsList
     * @request GET:/api/v1/tags/
     * @secure
     * @response `200` `PaginatedWorkspaceTagList`
     */
    tagsList: (query: TagsListParams = {}, params: RequestParams = {}) =>
      this.request<PaginatedWorkspaceTagList, any>({
        path: `/api/v1/tags/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tags
     * @name TagsCreate
     * @request POST:/api/v1/tags/
     * @secure
     * @response `201` `WorkspaceTag`
     */
    tagsCreate: (data: WorkspaceTag, params: RequestParams = {}) =>
      this.request<WorkspaceTag, any>({
        path: `/api/v1/tags/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tags
     * @name TagsRetrieve
     * @request GET:/api/v1/tags/{id}/
     * @secure
     * @response `200` `WorkspaceTag`
     */
    tagsRetrieve: ({ id }: TagsRetrieveParams, params: RequestParams = {}) =>
      this.request<WorkspaceTag, any>({
        path: `/api/v1/tags/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tags
     * @name TagsUpdate
     * @request PUT:/api/v1/tags/{id}/
     * @secure
     * @response `200` `WorkspaceTag`
     */
    tagsUpdate: (
      { id }: TagsUpdateParams,
      data: WorkspaceTag,
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceTag, any>({
        path: `/api/v1/tags/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tags
     * @name TagsPartialUpdate
     * @request PATCH:/api/v1/tags/{id}/
     * @secure
     * @response `200` `WorkspaceTag`
     */
    tagsPartialUpdate: (
      { id }: TagsPartialUpdateParams,
      data: PatchedWorkspaceTag,
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceTag, any>({
        path: `/api/v1/tags/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tags
     * @name TagsAllList
     * @request GET:/api/v1/tags/all/
     * @secure
     * @response `200` `(WorkspaceTag)[]`
     */
    tagsAllList: (query: TagsAllListParams = {}, params: RequestParams = {}) =>
      this.request<WorkspaceTag[], any>({
        path: `/api/v1/tags/all/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  timeslotModulePromo = {
    /**
     * @description Permanently dismiss the promo banner for the current user.
     *
     * @tags module-promo
     * @name TimeslotModulePromoDismissCreate
     * @request POST:/api/v1/timeslot-module-promo/dismiss/
     * @secure
     * @response `200` `ModulePromoState`
     */
    timeslotModulePromoDismissCreate: (params: RequestParams = {}) =>
      this.request<ModulePromoState, any>({
        path: `/api/v1/timeslot-module-promo/dismiss/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Record that the current user opened the promo modal.
     *
     * @tags module-promo
     * @name TimeslotModulePromoOpenCreate
     * @request POST:/api/v1/timeslot-module-promo/open/
     * @secure
     * @response `200` `ModulePromoState`
     */
    timeslotModulePromoOpenCreate: (params: RequestParams = {}) =>
      this.request<ModulePromoState, any>({
        path: `/api/v1/timeslot-module-promo/open/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Send a module demo inquiry to support (throttled per user).
     *
     * @tags module-promo
     * @name TimeslotModulePromoSendInquiryCreate
     * @request POST:/api/v1/timeslot-module-promo/send-inquiry/
     * @secure
     * @response `200` `ModulePromoState`
     * @response `400` `void` Throttled (inquiry sent recently), no workspace, or module already enabled.
     */
    timeslotModulePromoSendInquiryCreate: (params: RequestParams = {}) =>
      this.request<ModulePromoState, void>({
        path: `/api/v1/timeslot-module-promo/send-inquiry/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Return the module promo banner state for the current user.
     *
     * @tags module-promo
     * @name TimeslotModulePromoStateRetrieve
     * @request GET:/api/v1/timeslot-module-promo/state/
     * @secure
     * @response `200` `ModulePromoState`
     */
    timeslotModulePromoStateRetrieve: (params: RequestParams = {}) =>
      this.request<ModulePromoState, any>({
        path: `/api/v1/timeslot-module-promo/state/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  transportRequests = {
    /**
     * No description
     *
     * @tags transport-requests
     * @name TransportRequestsCreate
     * @request POST:/api/v1/transport-requests/
     * @secure
     * @response `201` `TransportRequest`
     */
    transportRequestsCreate: (
      data: TransportRequest,
      params: RequestParams = {},
    ) =>
      this.request<TransportRequest, any>({
        path: `/api/v1/transport-requests/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport-requests
     * @name TransportRequestsChangeTransportOptionCreate
     * @request POST:/api/v1/transport-requests/{id}/change-transport-option/
     * @secure
     * @response `200` `TransportRequest`
     */
    transportRequestsChangeTransportOptionCreate: (
      { id }: TransportRequestsChangeTransportOptionCreateParams,
      data: TransportRequestChangeOption,
      params: RequestParams = {},
    ) =>
      this.request<TransportRequest, any>({
        path: `/api/v1/transport-requests/${id}/change-transport-option/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport-requests
     * @name TransportRequestsUpdateCreate
     * @request POST:/api/v1/transport-requests/{id}/update/
     * @secure
     * @response `200` `TransportRequest`
     */
    transportRequestsUpdateCreate: (
      { id }: TransportRequestsUpdateCreateParams,
      data: PatchedTransportRequestUpdate,
      params: RequestParams = {},
    ) =>
      this.request<TransportRequest, any>({
        path: `/api/v1/transport-requests/${id}/update/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport-requests
     * @name TransportRequestsUpdateActiveCreate
     * @request POST:/api/v1/transport-requests/{id}/update_active/
     * @secure
     * @response `200` `TransportRequest`
     */
    transportRequestsUpdateActiveCreate: (
      { id }: TransportRequestsUpdateActiveCreateParams,
      data: PatchedTransportRequestUpdate,
      params: RequestParams = {},
    ) =>
      this.request<TransportRequest, any>({
        path: `/api/v1/transport-requests/${id}/update_active/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport-requests
     * @name TransportRequestsGetPriceFromPricerCreate
     * @request POST:/api/v1/transport-requests/get-price-from-pricer/
     * @secure
     * @response `200` `PricerResult`
     */
    transportRequestsGetPriceFromPricerCreate: (
      data: PricerRequest,
      params: RequestParams = {},
    ) =>
      this.request<PricerResult, any>({
        path: `/api/v1/transport-requests/get-price-from-pricer/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Validates the first step of a multi-step process. Parameters: request: The incoming request object. *args: Additional positional arguments. **kwargs: Additional keyword arguments. Returns: Response: A Response object containing serializer errors merged with custom one or serialized data.
     *
     * @tags transport-requests
     * @name TransportRequestsValidateFirstStepCreate
     * @request POST:/api/v1/transport-requests/validate-first-step/
     * @secure
     * @response `200` `TransportOrTransportRequestFirstStep`
     */
    transportRequestsValidateFirstStepCreate: (
      data: TransportOrTransportRequestFirstStep,
      params: RequestParams = {},
    ) =>
      this.request<TransportOrTransportRequestFirstStep, any>({
        path: `/api/v1/transport-requests/validate-first-step/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport-requests
     * @name TransportRequestsValidateFourthStepCreate
     * @request POST:/api/v1/transport-requests/validate-fourth-step/
     * @secure
     * @response `200` `TransportRequestFourthStep`
     */
    transportRequestsValidateFourthStepCreate: (
      data: TransportRequestFourthStep,
      params: RequestParams = {},
    ) =>
      this.request<TransportRequestFourthStep, any>({
        path: `/api/v1/transport-requests/validate-fourth-step/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport-requests
     * @name TransportRequestsValidateSecondStepCreate
     * @request POST:/api/v1/transport-requests/validate-second-step/
     * @secure
     * @response `200` `TransportOrTransportRequestSecondStep`
     */
    transportRequestsValidateSecondStepCreate: (
      data: TransportOrTransportRequestSecondStep,
      params: RequestParams = {},
    ) =>
      this.request<TransportOrTransportRequestSecondStep, any>({
        path: `/api/v1/transport-requests/validate-second-step/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport-requests
     * @name TransportRequestsValidateThirdStepCreate
     * @request POST:/api/v1/transport-requests/validate-third-step/
     * @secure
     * @response `200` `TransportRequestThirdStep`
     */
    transportRequestsValidateThirdStepCreate: (
      data: TransportRequestThirdStep,
      params: RequestParams = {},
    ) =>
      this.request<TransportRequestThirdStep, any>({
        path: `/api/v1/transport-requests/validate-third-step/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  transportStats = {
    /**
     * No description
     *
     * @tags transport-stats
     * @name TransportStatsOverviewRetrieve
     * @request GET:/api/v1/transport-stats/overview/
     * @secure
     * @response `200` `TransportOverviewStats`
     */
    transportStatsOverviewRetrieve: (
      query: TransportStatsOverviewRetrieveParams = {},
      params: RequestParams = {},
    ) =>
      this.request<TransportOverviewStats, any>({
        path: `/api/v1/transport-stats/overview/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  transports = {
    /**
     * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
     *
     * @tags transports
     * @name TransportsList
     * @request GET:/api/v1/transports/
     * @secure
     * @response `200` `PaginatedTransportListList`
     */
    transportsList: (
      query: TransportsListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedTransportListList, any>({
        path: `/api/v1/transports/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
     *
     * @tags transports
     * @name TransportsRetrieve
     * @request GET:/api/v1/transports/{id}/
     * @secure
     * @response `200` `TransportWithBookings`
     */
    transportsRetrieve: (
      { id }: TransportsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<TransportWithBookings, any>({
        path: `/api/v1/transports/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
     *
     * @tags transports
     * @name TransportsUpdate
     * @request PUT:/api/v1/transports/{id}/
     * @secure
     * @response `200` `Transport`
     */
    transportsUpdate: (
      { id }: TransportsUpdateParams,
      data: Transport,
      params: RequestParams = {},
    ) =>
      this.request<Transport, any>({
        path: `/api/v1/transports/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
     *
     * @tags transports
     * @name TransportsPartialUpdate
     * @request PATCH:/api/v1/transports/{id}/
     * @secure
     * @response `200` `Transport`
     */
    transportsPartialUpdate: (
      { id }: TransportsPartialUpdateParams,
      data: PatchedTransport,
      params: RequestParams = {},
    ) =>
      this.request<Transport, any>({
        path: `/api/v1/transports/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
     *
     * @tags transports
     * @name TransportsDestroy
     * @request DELETE:/api/v1/transports/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    transportsDestroy: (
      { id }: TransportsDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/transports/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Dry run of the update: the open time slot bookings the save would cancel. Saves nothing.
     *
     * @tags transports
     * @name TransportsBookingImpact
     * @request POST:/api/v1/transports/{id}/booking-impact/
     * @secure
     * @response `200` `PaginatedBookingImpactList`
     */
    transportsBookingImpact: (
      { id, ...query }: TransportsBookingImpactParams,
      data: TransportBookingImpact,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedBookingImpactList, any>({
        path: `/api/v1/transports/${id}/booking-impact/`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Contacts invited to this transport's auction — the booking wizard's dropdown.
     *
     * @tags transports
     * @name TransportsContactsList
     * @request GET:/api/v1/transports/{id}/contacts/
     * @secure
     * @response `200` `(TransportContact)[]`
     */
    transportsContactsList: (
      { id }: TransportsContactsListParams,
      params: RequestParams = {},
    ) =>
      this.request<TransportContact[], any>({
        path: `/api/v1/transports/${id}/contacts/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
     *
     * @tags transports
     * @name TransportsDownloadOrderRetrieve
     * @request GET:/api/v1/transports/{id}/download-transport-order/
     * @secure
     * @response `200` `File`
     */
    transportsDownloadOrderRetrieve: (
      { id, ...query }: TransportsDownloadOrderRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<Blob, any>({
        path: `/api/v1/transports/${id}/download-transport-order/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Answers in the detail shape: the transport detail writes this response into its page state, and its waypoint booking bars read annotations the bare row does not carry.
     *
     * @tags transports
     * @name TransportsStatusCreate
     * @request POST:/api/v1/transports/{id}/status/
     * @secure
     * @response `200` `TransportWithBookings`
     */
    transportsStatusCreate: (
      { id }: TransportsStatusCreateParams,
      data: TransportUpdateStatus,
      params: RequestParams = {},
    ) =>
      this.request<TransportWithBookings, any>({
        path: `/api/v1/transports/${id}/status/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
     *
     * @tags transport-details
     * @name TransportsTransportDetailsRetrieve
     * @request GET:/api/v1/transports/{id}/transport-details/
     * @secure
     * @response `200` `TransportDetail`
     */
    transportsTransportDetailsRetrieve: (
      { id }: TransportsTransportDetailsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<TransportDetail, any>({
        path: `/api/v1/transports/${id}/transport-details/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
     *
     * @tags transport-details
     * @name TransportsTransportDetailsCreate
     * @request POST:/api/v1/transports/{id}/transport-details/
     * @secure
     * @response `200` `TransportDetail`
     */
    transportsTransportDetailsCreate: (
      { id }: TransportsTransportDetailsCreateParams,
      data: TransportDetail,
      params: RequestParams = {},
    ) =>
      this.request<TransportDetail, any>({
        path: `/api/v1/transports/${id}/transport-details/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport, updates
     * @name TransportsBatchUpdatesList
     * @request GET:/api/v1/transports/{transport_pk}/batch-updates/
     * @secure
     * @response `200` `PaginatedTransportBatchUpdateList`
     */
    transportsBatchUpdatesList: (
      { transportPk, ...query }: TransportsBatchUpdatesListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedTransportBatchUpdateList, any>({
        path: `/api/v1/transports/${transportPk}/batch-updates/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport, updates
     * @name TransportsBatchUpdatesCreate
     * @request POST:/api/v1/transports/{transport_pk}/batch-updates/
     * @secure
     * @response `201` `TransportBatchUpdate`
     */
    transportsBatchUpdatesCreate: (
      { transportPk }: TransportsBatchUpdatesCreateParams,
      data: TransportBatchUpdate,
      params: RequestParams = {},
    ) =>
      this.request<TransportBatchUpdate, any>({
        path: `/api/v1/transports/${transportPk}/batch-updates/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags documents
     * @name TransportsDocumentsList
     * @request GET:/api/v1/transports/{transport_pk}/documents/
     * @secure
     * @response `200` `PaginatedDocumentList`
     */
    transportsDocumentsList: (
      { transportPk, ...query }: TransportsDocumentsListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDocumentList, any>({
        path: `/api/v1/transports/${transportPk}/documents/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags messages
     * @name TransportsMessagesList
     * @request GET:/api/v1/transports/{transport_pk}/messages/
     * @secure
     * @response `200` `PaginatedMessageList`
     */
    transportsMessagesList: (
      { transportPk, ...query }: TransportsMessagesListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedMessageList, any>({
        path: `/api/v1/transports/${transportPk}/messages/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags messages
     * @name TransportsMessagesCreate
     * @request POST:/api/v1/transports/{transport_pk}/messages/
     * @secure
     * @response `201` `Message`
     */
    transportsMessagesCreate: (
      { transportPk }: TransportsMessagesCreateParams,
      data: Message,
      params: RequestParams = {},
    ) =>
      this.request<Message, any>({
        path: `/api/v1/transports/${transportPk}/messages/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags messages
     * @name TransportsMessagesMarkAsReadCreate
     * @request POST:/api/v1/transports/{transport_pk}/messages/mark-as-read/
     * @secure
     * @response `200` `void` No response body
     */
    transportsMessagesMarkAsReadCreate: (
      { transportPk }: TransportsMessagesMarkAsReadCreateParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/transports/${transportPk}/messages/mark-as-read/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags messages
     * @name TransportsMessagesUnreadCountRetrieve
     * @request GET:/api/v1/transports/{transport_pk}/messages/unread-count/
     * @secure
     * @response `200` `number`
     */
    transportsMessagesUnreadCountRetrieve: (
      { transportPk }: TransportsMessagesUnreadCountRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/api/v1/transports/${transportPk}/messages/unread-count/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport, updates
     * @name TransportsUpdatesListLatestList
     * @request GET:/api/v1/transports/{transport_pk}/updates/list-latest/
     * @secure
     * @response `200` `(TransportLatestUpdate)[]`
     */
    transportsUpdatesListLatestList: (
      { transportPk, ...query }: TransportsUpdatesListLatestListParams,
      params: RequestParams = {},
    ) =>
      this.request<TransportLatestUpdate[], any>({
        path: `/api/v1/transports/${transportPk}/updates/list-latest/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
     *
     * @tags transports
     * @name TransportsExportRetrieve
     * @request GET:/api/v1/transports/export/
     * @secure
     * @response `200` `File`
     * @response `204` `void` No response body
     */
    transportsExportRetrieve: (
      query: TransportsExportRetrieveParams = {},
      params: RequestParams = {},
    ) =>
      this.request<Blob, any>({
        path: `/api/v1/transports/export/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
     *
     * @tags transports
     * @name TransportsValidateFirstStepCreate
     * @request POST:/api/v1/transports/validate-first-step/
     * @secure
     * @response `200` `TransportOrTransportRequestFirstStep`
     */
    transportsValidateFirstStepCreate: (
      data: TransportOrTransportRequestFirstStep,
      params: RequestParams = {},
    ) =>
      this.request<TransportOrTransportRequestFirstStep, any>({
        path: `/api/v1/transports/validate-first-step/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
     *
     * @tags transports
     * @name TransportsValidateSecondStepCreate
     * @request POST:/api/v1/transports/validate-second-step/
     * @secure
     * @response `200` `TransportOrTransportRequestSecondStep`
     */
    transportsValidateSecondStepCreate: (
      data: TransportOrTransportRequestSecondStep,
      params: RequestParams = {},
    ) =>
      this.request<TransportOrTransportRequestSecondStep, any>({
        path: `/api/v1/transports/validate-second-step/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet for retrieving a list of transports and retrieving a single transport. Transports are auctions which have winner - already stored in separate model.
     *
     * @tags transports
     * @name TransportsValidateThirdStepCreate
     * @request POST:/api/v1/transports/validate-third-step/
     * @secure
     * @response `200` `TransportThirdStep`
     */
    transportsValidateThirdStepCreate: (
      data: TransportThirdStep,
      params: RequestParams = {},
    ) =>
      this.request<TransportThirdStep, any>({
        path: `/api/v1/transports/validate-third-step/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @tags users
     * @name UsersList
     * @request GET:/api/v1/users/
     * @secure
     * @response `200` `PaginatedUserList`
     */
    usersList: (query: UsersListParams = {}, params: RequestParams = {}) =>
      this.request<PaginatedUserList, any>({
        path: `/api/v1/users/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UsersRetrieve
     * @request GET:/api/v1/users/{id}/
     * @secure
     * @response `200` `User`
     */
    usersRetrieve: ({ id }: UsersRetrieveParams, params: RequestParams = {}) =>
      this.request<User, any>({
        path: `/api/v1/users/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UsersUpdate
     * @request PUT:/api/v1/users/{id}/
     * @secure
     * @response `200` `User`
     */
    usersUpdate: (
      { id }: UsersUpdateParams,
      data: User,
      params: RequestParams = {},
    ) =>
      this.request<User, any>({
        path: `/api/v1/users/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UsersPartialUpdate
     * @request PATCH:/api/v1/users/{id}/
     * @secure
     * @response `200` `User`
     */
    usersPartialUpdate: (
      { id }: UsersPartialUpdateParams,
      data: PatchedUser,
      params: RequestParams = {},
    ) =>
      this.request<User, any>({
        path: `/api/v1/users/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UsersDestroy
     * @request DELETE:/api/v1/users/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    usersDestroy: ({ id }: UsersDestroyParams, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/users/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UsersPermissionsRetrieve
     * @request GET:/api/v1/users/{id}/permissions/
     * @secure
     * @response `200` `UserPermissions`
     */
    usersPermissionsRetrieve: (
      { id }: UsersPermissionsRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<UserPermissions, any>({
        path: `/api/v1/users/${id}/permissions/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UsersAllList
     * @request GET:/api/v1/users/all/
     * @secure
     * @response `200` `(UserGeneralInfo)[]`
     */
    usersAllList: (
      query: UsersAllListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<UserGeneralInfo[], any>({
        path: `/api/v1/users/all/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  vehicleTypes = {
    /**
     * @description ViewSet providing CRUD operations for a vehicle type. URL: /vehicle-types/
     *
     * @tags vehicle-types
     * @name VehicleTypesList
     * @request GET:/api/v1/vehicle-types/
     * @secure
     * @response `200` `PaginatedVehicleTypeList`
     */
    vehicleTypesList: (
      query: VehicleTypesListParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleTypeList, any>({
        path: `/api/v1/vehicle-types/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a vehicle type. URL: /vehicle-types/
     *
     * @tags vehicle-types
     * @name VehicleTypesCreate
     * @request POST:/api/v1/vehicle-types/
     * @secure
     * @response `201` `VehicleType`
     */
    vehicleTypesCreate: (data: VehicleType, params: RequestParams = {}) =>
      this.request<VehicleType, any>({
        path: `/api/v1/vehicle-types/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a vehicle type. URL: /vehicle-types/
     *
     * @tags vehicle-types
     * @name VehicleTypesRetrieve
     * @request GET:/api/v1/vehicle-types/{id}/
     * @secure
     * @response `200` `VehicleType`
     */
    vehicleTypesRetrieve: (
      { id }: VehicleTypesRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<VehicleType, any>({
        path: `/api/v1/vehicle-types/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a vehicle type. URL: /vehicle-types/
     *
     * @tags vehicle-types
     * @name VehicleTypesUpdate
     * @request PUT:/api/v1/vehicle-types/{id}/
     * @secure
     * @response `200` `VehicleType`
     */
    vehicleTypesUpdate: (
      { id }: VehicleTypesUpdateParams,
      data: VehicleType,
      params: RequestParams = {},
    ) =>
      this.request<VehicleType, any>({
        path: `/api/v1/vehicle-types/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a vehicle type. URL: /vehicle-types/
     *
     * @tags vehicle-types
     * @name VehicleTypesPartialUpdate
     * @request PATCH:/api/v1/vehicle-types/{id}/
     * @secure
     * @response `200` `VehicleType`
     */
    vehicleTypesPartialUpdate: (
      { id }: VehicleTypesPartialUpdateParams,
      data: PatchedVehicleType,
      params: RequestParams = {},
    ) =>
      this.request<VehicleType, any>({
        path: `/api/v1/vehicle-types/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ViewSet providing CRUD operations for a vehicle type. URL: /vehicle-types/
     *
     * @tags vehicle-types
     * @name VehicleTypesDestroy
     * @request DELETE:/api/v1/vehicle-types/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    vehicleTypesDestroy: (
      { id }: VehicleTypesDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicle-types/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Bulk create/update/delete vehicle types. POST /vehicle-types/bulk/
     *
     * @tags vehicle-types
     * @name VehicleTypesBulkCreate
     * @request POST:/api/v1/vehicle-types/bulk/
     * @secure
     * @response `200` `(VehicleType)[]`
     */
    vehicleTypesBulkCreate: (
      data: VehicleTypeBulk,
      params: RequestParams = {},
    ) =>
      this.request<VehicleType[], any>({
        path: `/api/v1/vehicle-types/bulk/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  waypoints = {
    /**
     * No description
     *
     * @tags waypoints
     * @name WaypointsAutocompleteCreate
     * @request POST:/api/v1/waypoints/autocomplete/
     * @secure
     * @response `200` `AutocompleteResponse`
     */
    waypointsAutocompleteCreate: (
      data: WaypointAutocompleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<AutocompleteResponse, any>({
        path: `/api/v1/waypoints/autocomplete/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  webhooks = {
    /**
     * @description Handle POST request from Brevo webhook
     *
     * @tags webhooks
     * @name WebhooksBrevoCreate
     * @request POST:/api/v1/webhooks/brevo/
     * @secure
     * @response `200` `void` No response body
     */
    webhooksBrevoCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/webhooks/brevo/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Handle POST request from Mailgun outbound webhook. This webhook receives delivery status updates for emails sent via Mailgun (accepted, delivered, opened, clicked, etc.).
     *
     * @tags webhooks
     * @name WebhooksMailgunCreate
     * @request POST:/api/v1/webhooks/mailgun/
     * @secure
     * @response `200` `void` No response body
     */
    webhooksMailgunCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/webhooks/mailgun/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Authenticate a Mailgun delivery to ws+<hash>@domain, then process it into a draft.
     *
     * @tags webhooks
     * @name WebhooksMailgunInboundCreate
     * @request POST:/api/v1/webhooks/mailgun-inbound/
     * @secure
     * @response `200` `void` No response body
     */
    webhooksMailgunInboundCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/webhooks/mailgun-inbound/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags webhooks
     * @name WebhooksStripeCreate
     * @request POST:/api/v1/webhooks/stripe/
     * @secure
     * @response `200` `void` No response body
     */
    webhooksStripeCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/webhooks/stripe/`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  workspace = {
    /**
     * No description
     *
     * @tags workspace
     * @name WorkspaceCreate
     * @request POST:/api/v1/workspace/
     * @secure
     * @response `201` `Workspace`
     */
    workspaceCreate: (data: Workspace, params: RequestParams = {}) =>
      this.request<Workspace, any>({
        path: `/api/v1/workspace/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspace
     * @name WorkspaceRetrieve
     * @request GET:/api/v1/workspace/{id}/
     * @secure
     * @response `200` `Workspace`
     */
    workspaceRetrieve: (
      { id }: WorkspaceRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/v1/workspace/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspace
     * @name WorkspaceUpdate
     * @request PUT:/api/v1/workspace/{id}/
     * @secure
     * @response `200` `Workspace`
     */
    workspaceUpdate: (
      { id }: WorkspaceUpdateParams,
      data: WorkspaceUpdate,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/v1/workspace/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspace
     * @name WorkspacePartialUpdate
     * @request PATCH:/api/v1/workspace/{id}/
     * @secure
     * @response `200` `Workspace`
     */
    workspacePartialUpdate: (
      { id }: WorkspacePartialUpdateParams,
      data: PatchedWorkspaceUpdate,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/v1/workspace/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspace
     * @name WorkspaceDownloadSampleTransportOrderRetrieve
     * @request GET:/api/v1/workspace/{id}/download-sample-transport-order/
     * @secure
     * @response `200` `File`
     */
    workspaceDownloadSampleTransportOrderRetrieve: (
      { id, ...query }: WorkspaceDownloadSampleTransportOrderRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<Blob, any>({
        path: `/api/v1/workspace/${id}/download-sample-transport-order/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspace
     * @name WorkspaceLogoutAllUsersCreate
     * @request POST:/api/v1/workspace/{id}/logout-all-users/
     * @secure
     * @response `200` `Workspace`
     */
    workspaceLogoutAllUsersCreate: (
      { id }: WorkspaceLogoutAllUsersCreateParams,
      data: ForceLogoutRequest,
      params: RequestParams = {},
    ) =>
      this.request<Workspace, any>({
        path: `/api/v1/workspace/${id}/logout-all-users/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspace
     * @name WorkspaceUploadLogoCreate
     * @request POST:/api/v1/workspace/{id}/upload-logo/
     * @secure
     * @response `200` `WorkspaceLogo`
     */
    workspaceUploadLogoCreate: (
      { id }: WorkspaceUploadLogoCreateParams,
      data: WorkspaceLogo,
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceLogo, any>({
        path: `/api/v1/workspace/${id}/upload-logo/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspace
     * @name WorkspaceScheduledTasksList
     * @request GET:/api/v1/workspace/{workspace_pk}/scheduled-tasks/
     * @secure
     * @response `200` `PaginatedScheduledUserTaskList`
     */
    workspaceScheduledTasksList: (
      { workspacePk, ...query }: WorkspaceScheduledTasksListParams,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedScheduledUserTaskList, any>({
        path: `/api/v1/workspace/${workspacePk}/scheduled-tasks/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspace
     * @name WorkspaceScheduledTasksCreate
     * @request POST:/api/v1/workspace/{workspace_pk}/scheduled-tasks/
     * @secure
     * @response `201` `ScheduledUserTask`
     */
    workspaceScheduledTasksCreate: (
      { workspacePk }: WorkspaceScheduledTasksCreateParams,
      data: ScheduledUserTask,
      params: RequestParams = {},
    ) =>
      this.request<ScheduledUserTask, any>({
        path: `/api/v1/workspace/${workspacePk}/scheduled-tasks/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspace
     * @name WorkspaceScheduledTasksRetrieve
     * @request GET:/api/v1/workspace/{workspace_pk}/scheduled-tasks/{id}/
     * @secure
     * @response `200` `ScheduledUserTask`
     */
    workspaceScheduledTasksRetrieve: (
      { id, workspacePk }: WorkspaceScheduledTasksRetrieveParams,
      params: RequestParams = {},
    ) =>
      this.request<ScheduledUserTask, any>({
        path: `/api/v1/workspace/${workspacePk}/scheduled-tasks/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspace
     * @name WorkspaceScheduledTasksUpdate
     * @request PUT:/api/v1/workspace/{workspace_pk}/scheduled-tasks/{id}/
     * @secure
     * @response `200` `ScheduledUserTask`
     */
    workspaceScheduledTasksUpdate: (
      { id, workspacePk }: WorkspaceScheduledTasksUpdateParams,
      data: ScheduledUserTask,
      params: RequestParams = {},
    ) =>
      this.request<ScheduledUserTask, any>({
        path: `/api/v1/workspace/${workspacePk}/scheduled-tasks/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspace
     * @name WorkspaceScheduledTasksPartialUpdate
     * @request PATCH:/api/v1/workspace/{workspace_pk}/scheduled-tasks/{id}/
     * @secure
     * @response `200` `ScheduledUserTask`
     */
    workspaceScheduledTasksPartialUpdate: (
      { id, workspacePk }: WorkspaceScheduledTasksPartialUpdateParams,
      data: PatchedScheduledUserTask,
      params: RequestParams = {},
    ) =>
      this.request<ScheduledUserTask, any>({
        path: `/api/v1/workspace/${workspacePk}/scheduled-tasks/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags workspace
     * @name WorkspaceScheduledTasksDestroy
     * @request DELETE:/api/v1/workspace/{workspace_pk}/scheduled-tasks/{id}/
     * @secure
     * @response `204` `void` No response body
     */
    workspaceScheduledTasksDestroy: (
      { id, workspacePk }: WorkspaceScheduledTasksDestroyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/workspace/${workspacePk}/scheduled-tasks/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
}
